export const SCHOOLS_DATA = [
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "THABO-THOKOZA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BETHLEHEM CS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "NTSU S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "NKARABENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TIISETSANG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "VOORTREKKER S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "WITTEBERG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "EE MONESE C/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MORITING WA THUTO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "WONGALETHU S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "SPRINGFONTEIN S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LEREKO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "IKAELELO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "HODISA T/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KAGISHO CS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "COMMTECH CS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ST BERNARDS S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "FICHARDTPARK S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ST ANNE T/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "VIRGINIA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "THUTO KE LESEDI T/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LIBERTY IS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BOLTON COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "JIM FOUCHé S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SAND DU PLESSIS S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "HTS LOUIS BOTHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KOPANONG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ATLEHANG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SEHUNELO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "VULAMASANGO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MOEMEDI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LEKHULONG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KAELANG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TSOSELETSO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "HEATHERDALE CS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "C&N H/MEISIESKOOL ORANJE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "NAVALSIG CS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "EUNICE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "GREY-KOLLEGE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BLOEMFONTEIN S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SENTRAAL S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "DR. BLOK S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "PETUNIA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BREBNER S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "HEADSTART HIGH SI/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ACCELERATED CHRISTIAN COLLEGE SI/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ACADEMY OF EXCELLENCE SI/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "KGOLOLOSEGO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MOPHATE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "OZIEL SELELE CS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MAMELLANG-THUTO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "NAMPO AS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "DIPHETOHO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "BOTHAVILLE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KGAUHO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LEFIKENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "POPANO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "THATO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KGORATHUTO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "REAMOHETSE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "NTEMOSENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "NTEDISENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LERATONG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SEEMAHALE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SENAKANGWEDI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "NTUMEDISENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MPATLENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LENYORA LA THUTO CS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "AKADEMIA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "REPHOLOSITSWE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "RAINBOW S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TSHEPANG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "CLOCOLAN S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "METSIMAPHODI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "ALBERTINA SISULU S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "REUTLWAHETSE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "UNICOM AS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "OLIEN S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MARALLANENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TLOTLISONG No1 S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BOITUMELO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TAUNG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "FICKSBURG CS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MJ MOHLAHLI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "IPOKELLENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "FALESIZWE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "RETSHEDISITSWE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "QALABOTJHA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "REFENG THABO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "MFUNDO THUTO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "TSEBO-ULWAZI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "ED-U-COLLEGE QQ SI/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "HARRISMITH S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "IPHONDLE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SEOTLONG AS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SASAMALA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "HARRISMITH HOëRSKOOL S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LERATO UTHANDO CS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "NEW HORIZON COLLEGE SI/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KGETHATSEBO-KHETHULWAZI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "SEDIBA-THUTO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "METSIMATLE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "PHIRITONA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "BAHALE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "HENNENMAN S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "KHELENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TIKWANE CS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "RELEKILE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "JACOBSDAL LANDBOUSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "REIKAELETSE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "KWAKWATSI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "KANANELO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "THAKAMESO CS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "DR REGINALD CINGO CS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "MOTSWELA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "PHEPHETSO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BODIBENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "NGWATHE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BRENTPARK S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "ZENITH SI/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "JSM SETILOANE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "MATLWANGTLWANG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LE RENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LADYBRAND S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SEHLABENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ITOKISETSENG BOKAMOSO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "PHUKALLA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "IKAHENG ZAKHENI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LERATSWANA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LINDLEY S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KWETLISONG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TLOKOLA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "PHEHELLO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "REARABETSWE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MOSALA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "SEQHOBONG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ELDORET S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "WESSEL MAREE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "KUTLOANONG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LA WESI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "JC MOTUMI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "PHEHELLANG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BARNARD MOLOKOANE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "YAKHISISWE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BOITLAMO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "WEIVELD AS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "PARYS SKOOL S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "IPETLENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "PHILIPPOLIS S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "BEANG TSE MOLEMO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "HENDRIK POTGIETER A/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KGOTSO-UXOLO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "THABO-VUYO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "NKGOPOLENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "IKETSETSENG CS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "LE NOTSI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "PELE-YA-PELE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "CEDAR S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "NOMSA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "AFRIKAANSE H/SKOOL SASOLBURG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "SASOLBURG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "VAALPARK ARTICON S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "HTS SASOLBURG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "REBATLA THUTO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "KAHOBOTJHA-SAKUBUSHA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "ITHABISENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "REKGOTSOFETSE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "PAUL ERASMUS S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MOROKA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MARIASDAL S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "GORONYANE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SEDITI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "CHRISTIAN LIPHOKO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "PHETOGANE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "STRYDOM S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TM SETILOANE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "RT MOKGOPA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ALBERT MOROKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TAIWE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "CONCORDIA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "TROMPSBURG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MATSERIPE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "THABANG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "REHAUHETSWE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "KGOLAGANO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "KGABARENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MAMELLO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "REATLEHILE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "HARMONIE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "HENTIE CILLIERS H/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MELODING S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MAREMATLOU S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "EVUNGWINI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "ESIZIBENI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "INTUTHUKO-KATLEHO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BONGANE-LEBOHANG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BOIPHIHLELO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "SAMUEL SEBEGO PAKI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LEBOGANG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "THOTAGAUTA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LENAKENG T/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TETO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LEPHOLA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LESEDING T/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "NANABOLELA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "WELKOM-GIMNASIUM S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "GOUDVELD S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "RIEBEECKSTAD S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "UNITAS CS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "HTS WELKOM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "WELKOM HIGH S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "WELKOM S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LETSETE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LEKGARIETSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "QIBING S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "THAPELONG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BLOEMFONTEIN SOUTH HIGH S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ITHABELENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MONYAKENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "IPHATELENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "NALEDI-YA-BOTJABELA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "IPOPENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TSEKI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LEKGULO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SEKGUTLONG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "DINARE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MOHATO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAKGABANE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KOALI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BEACON S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "NTHABISENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MANTHATISI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "METSI-MATSHO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MOHALADITWE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MOOKODI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "PHOFUNG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MASOPHA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAANANKOE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TSHOLO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "RANTSANE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MOLAPO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "HLAJOANE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SHAKHANE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MMATHABO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAMPOI S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAKABELANE CS/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "REAHOLA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "THALABODIBA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "DIKWENA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SELELEKELA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TSHIBOLLO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "THAHAMESO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "THOKOANA MAKAOTA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MOTEKA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KGOLATHUTO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "NKHOBISO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TSEBO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TLHORONG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "CLUBVIEW S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BLUEGUMBOSCH S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MORENA MOKOPELA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "LERE LA THUTO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "SAMUEL JOHNSON S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MOHLODI-THUTO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "GRASSLAND S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BOKAMOSO SI/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ADELAIDE TAMBO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "KATLEHO MPUMELELO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KHOTSO TAOLE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SELOKISA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "TUMAHOLE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "RIVERSIDE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "KGATELOPELE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TSHEPO THEMBA S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "MOHOKARE S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MASHAENG S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "NORTH HIGH S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "TRIO S/S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ABERDEEN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ADELAIDE GYMNASIUM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "AEROVILLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ALEXANDER ROAD HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SIPHO CAMAGU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ANDREW RABIE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ARCADIA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ASHERVILLE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NEWTOWN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BETHELSDORP COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BOOYSEN PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "CAREL DU TOIT HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "CHAPMAN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "CHATTY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MORNINGSIDE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "CHUBEKILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "CINGANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "COLLEGIATE GIRLS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "LINKSIDE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "COSELELANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "COWAN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DAVID LIVINGSTONE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DESPATCH HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DF MALHERBE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DOUGLAS MBOPA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "E Z KABANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BET EL CHRISTELIKE AKADEMIE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "EYABANTU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "FRAMESBY HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "GAMBLE STREET SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "GELVANDALE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GILL COLLEGE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "GREY BOYS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HANKEY SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "HEALDTOWN COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "JBAY ACADEMY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "HILLSIDE TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HOëR VOLKSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "HOëRSKOOL BRANDWAG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "HOëRSKOOL CILLIé"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BERLIN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HUMANSDORP SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "INYIBIBA PUBLIC SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ITHEMBELIHLE COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "JAMES JOLOBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "JOHN WALTON SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "JOHNSON NQONQOZA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "JEFFREYS BAY COMPREHENSIVE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "KHUMBULANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KHUTLISO DANIELS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "KHWEZI LOMSO COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ST CHRIS COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KLIPPLAAT SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "kwaZAKHELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "LAWSON BROWN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "LIMEKHAYA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LINDANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LONWABO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "LOYISO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "LUNGISA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LUNGISO PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MARY WATERS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MARYMOUNT SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MASIBAMBANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MASIPHATHISANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MASIZAKHE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "McCARTHY COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MFESANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MOLLY BLACKBURN SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MOSES MABIDA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MOTHERWELL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MZONTSUNDU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "NATHANIEL NYALUZA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NCEDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NDYEBO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NDZONDELELO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NEWELL PUBLIC HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NEWTON TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HOëRSKOOL NICO MALAN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NKULULEKO PUBLIC SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "NOMBULELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "NOMZAMO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "NQWEBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "NTSIKA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "OTTO DU PLESSIS SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "PATERSON HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "PEARSON HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "PEARSTON SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "PHAKAMISA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "PHAPHANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "QAPHELANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "QHAYIYALETHU INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SAKHISIZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SAKHULULEKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "SAMKELWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SANCTOR HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "SANDISULWAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SISONKE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SOLOMON MAHLANGU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SOPHAKAMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SOQHAYISA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "SPANDAU PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ST COLMCILLE PUBLIC SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ST JAMES (RC) SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ST THOMAS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "STRELITZIA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "T E M MRWETYANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "THANDUXOLO COMPREHENSIVE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "TINARA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "TYHILULWAZI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "UITENHAGE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "UKHANYO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "V M KWINANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "VELILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "VICTORIA GIRLS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "VICTORIA PARK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "VULUMZI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "WESTERING HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "WESTVILLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "WILLOWMORE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "WINTERBERG AGRICULTURAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "WOOLHOPE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "WALMER SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ZANOLWAZI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "THUBALETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DANIEL PIENAAR TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "PATENSIE AGRICULTURAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "THE HILL COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "kwaMAGXAKI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ETHEMBENI ENRICHMENT CENTRE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BERTRAM SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "KABEGA CHRISTELIKE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "COOKHOUSE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GLOBAL LEADERSHIP ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "A M S SITYANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "A M TAPA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ALPHENDALE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "AMABHELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "AMAZIZI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ARCHIE VELILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "B KAT SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BISHO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BREIDBACH SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BUCHULE TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BYLETTS COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "CAMBRIDGE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "CLARENDON HIGH SCHOOL FOR GIRLS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "DALE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DALUBUHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "DAVID MAMA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DILIZINTABA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "DIMBAZA CENTRAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DONDASHE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "EBENEZER MAJOMBOZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ELUKHANYISWENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "EMDENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "EMFUNDWENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "EMGWALI PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ENKWENKWEZINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ENOCH SONTONGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ERIC MNTONGA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "CANAAN ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "FORBES GRANT SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "FUNIWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GASELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "GCATO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "GEJU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GEORGE RANDELL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "GOBIZEMBE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GREENPOINT SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "GUSHIPHELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "HH MAJIZA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "HECTOR PETERSEN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "HLOKOMA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "HLUMANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "HOëRSKOOL GRENS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "HOHO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "HUDSON PARK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ACADEMY HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "IMIDUSHANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "IMINGCANGATHELO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "IMIQHAYI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "J M NDINDWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "JABAVU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "JALI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "JIM MVABAZA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "JOHN BISSEKER SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "JONGILANGA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "JONGILE NOMPONDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "JONGUHLANGA PUBLIC SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "JOSI MARELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "JULY SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KAMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KANANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KAULELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KHULANI COMMERCIAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KULILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KUSILE COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KUYASA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KWENXURA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LINGANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LINGELETHU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LINGELETHU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LOYISO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LUKHOZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LUMKO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MASIBONISANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MASIMANYANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MASIVUYISWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MASIXOLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MATOMELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MATSA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MBULELO BENEKANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "J F MATI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MDIBANISO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MGCAWEZULU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MHLAMBISO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MIZAMO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MOSES MABHIDA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MPAMBANI MZIMBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MPUMELELO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MTHWAKU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MZOKHANYO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MZOMHLE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MZOMTSHA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MZONTSUNDU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MZUXOLILE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NANGAMSO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NATHANIEL PAMLA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NCEDOLWETHU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NGANGELIZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NGWENYATHI PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NJONGOZABANTU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NOMPENDULO TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NONCEBA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "INTLANTSI CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NOSIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BUFFALO METRO INNER CITY HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NOWAWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NOZALISILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NTABENKONYANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NTSONKOTA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NYAMEKO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NZULULWAZI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "PHANDULWAZI AGRICULTURAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "PHILEMON NGCELWANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "PHILLIP MTYWAKU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "THE LIGHTHOUSE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "PORT REX TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "QAQAMBA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "QHASANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "QHAYIYA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "RABULA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "RICHARD VARHA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "S E K MQHAYI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SAKHISIZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SAKUPHUMELELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SANDISIWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SELBORNE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SIKHULULE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SILIMELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SIMZAMILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SINETHEMBA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SINETHEMBA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SINIKIWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SINOVUYO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SIPHUMEZULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SISEKO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SIYABONGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SIYAKHULA FINISHING SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SOBANTU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SOLOMON MAHLANGU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SOTININI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ST MATTHEWS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "STIRLING HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "TAMSANQA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "TEMBELANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "THEMBALABANTU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "THEMBALESIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "THOBELANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "TOISE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "TSHOLOMNQA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ULANA AGRICULTURAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "UMTIZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "UMZUVUKILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "UVIWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "VUKILE TSHWETE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "VULAMAZIBUKO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "WONGALETHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "XOLANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "Z K MATTHEWS SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZAMEKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZANEMFUNDO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZANEMPUCUKO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZANOVUYO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZINZANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZUKHANYE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZWELIMJONGILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZWELIYANDILA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SIZINGISILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ST CHARLES SOJOLA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "DUMALISILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "INKWENKWEZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "QHAMANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GOOD HOPE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SIYAZAKHA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MASIHLANGANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "IQONCE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GONUBIE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SAKHIKAMVA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "EAST LONDON SCIENCE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "UNATHI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BHONGOLETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MZWINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SOPHATISANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GRAAB EDUCATIONAL CENTRE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "VAVIKA TRAINING ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LIGHTHOUSE ACADEMY OF LEARNING"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "AMABELE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BADI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BASHEE COMPREHENSIVE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BLYTHSWOOD HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BOMELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "COLOSA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "CUNNINGHAM SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DALUHLANGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DONDASHE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "FALTEIN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ENOCH MAMBA SENIOR SECONDARY & TECH INSTITUTION"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "EZIZWENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "FORT MALAN SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GOBINAMBA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GWADANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GWELANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MTHINGWEVU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ISOLOMZI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JS SKENJANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JONGABANTU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JONGILANGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JONGILIZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KRAZUKILE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "L M MALGAS SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LANGALETHU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BULUNGULA COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MABOBOTI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MACIBE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MANGELENGELE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MATHUMBU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MDENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MGOMANZI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MIDDLE ZOLO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MSOBOMVU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MTEBELE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MTAWELANGA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NAKAZANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NDABANKULU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NDEMA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOMAKA MBEKI TECHNICAL SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOMAHEYA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGUBESIZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGWENZE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOLITA COMPREHENSIVE TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NONDWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NQABANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NQABARA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "PAKAMANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SIYABULELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TANGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TSOMO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TYALI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "THUBELIHLE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER GWADU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VULI VALLEY SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VULUHLANGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "XILINXA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "XOLILIZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZANEWONGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZAZULWANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZWELANDILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZWELIDUMILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZWELIVUMILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZWELIWELILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZWELIXOLILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VULINGCOBO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "J J NJEZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ELUKHANYISWENI COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "EZINGQAYI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "WILLOWVALE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NCEDISIZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MPOZOLO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LAMPLOUGH SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GOBE COMMERCIAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "EZINGCUKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QOMBOLO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAZIZINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "JONGIZIZWE NKWENKWEZI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SOPHAKAMA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BONKOLO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NQABISILE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DINIZULU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NDYEBO NTSALUBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MENTE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LURWAYIZO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DUMALISILE COMPREHENSIVE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "CANAAN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SINOLWAZI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BAMBILANGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BAZINDLOVU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BEKIZULU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BELE-ZINGCUKA TECHNICAL SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "CAMERON NGUDLE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "CHIEF NZ MTIRARA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "CIBENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CLARKEBURY AGRICULTURAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TYELINZIMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CWECWENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "D Z DUMEZWENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DALIBASO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DALINDYEBO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DALUHLANGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DALUKHANYO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DILIZINTABA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DOLOPHINI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DUDUMAYO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "E N SEKU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ELLIOTDALE TECHNICAL SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "EMIZAMOYETHU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ENGCOBO VILLAGE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GANIZULU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GCINUMTHETHO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GCISA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GENGQE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GENERAL MAQHUTYANA TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GOBINAMBA TECH AND COMM SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GWARUBANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GWEBITYALA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GXABA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "HLABATSHANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "HOLY CROSS SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JALAMBA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "JAMANGILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MANDELA SCHOOL OF SCIENCE AND TECHNOLOGY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JIXINI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JONGILIZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JONGINTABA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JOUBERT LUDIDI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "K T MCHASA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "WILO COMPREHENSIVE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "KHANYOLWETHU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KULANATHI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "KUYASA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LESLIE NKALA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TSOLO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LITTLE FLOWER SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LUTUKA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LUTUBENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAJALI TECHNICAL SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MANGALA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MANZANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "FRANK ZIBI AGRICULTURAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MASIKHUTHALE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MAXWELE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MBONGWENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MCOBOLOLO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MDITSHWA TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MENZIWA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GOBIZIZWE AGRICULTURAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MGUDLWA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MHLANGANISWENI COMM & TECH SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MILTON DALASILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MILTON MBEKELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MPEKO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MTENGWANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MTWENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MZIKAYISE DALASILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDAMASE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGANGOLWANDLE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGQELENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGQWALA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGUBESIZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGUBESIZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGUBEZULU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGXONGWENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GOBINAMBA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOBANGILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NQWILISO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NYANGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NYANGILIZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "PAKAMANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "PANGALELE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "PONDOLWENDLOVU COMM SECONDARY S SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "PORT ST JOHNS SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JENCA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "CHRIST THE KING COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "QINGQOLO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "QUMBU VILLAGE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SAMUEL NOMBEWU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SANDI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SANDY MAJEKE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SEA VIEW SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SEHUSHE COMMERCIAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SHAWBURY SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SIBABALE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SITOZA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SMUTS NDAMASE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SOPHONIA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ST BARTHOLOMEW'S SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ST CUTHBERT'S SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ST PATRICK'S SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SULENKAMA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TANDANANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "THOMAS NTABA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TSHONGWENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TUTOR NDAMASE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UMTATA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "UPPER CORANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UPPER MPAKO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "VAKELE TECHNICAL SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "VICTOR POTO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "VULINDLELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "WABAN SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "WELSH SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "XHENTSE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "XOLILIZWE SANGONI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZAMUKULUNGISA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZANGQELE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZANGQOLWANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZIBUNGU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZIMELE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZULU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZWELENQABA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZWELIBANGILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZWELIHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZWELIVUMILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZWELODUMO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ATTWELL MADALA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOGEMANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DALIBUNGA COMPREHENSIVE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DIMANDA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "QOKOLWENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MABALENGWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JUMBA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "DINIZULU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "REUBEN NTULI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ST JOHNS COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SOMAGUNYA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NOZUKO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SOUTHERNWOOD JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "kwaNOBUHLE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZANOKHANYO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KHANYISA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZINGISA COMPREHENSIVE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MPINDWENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DUMRANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "HOLOMISA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NOSIMO TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UPPER CULUNCA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "CHIEF HENRY BOKLENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTSHILINI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JOYI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGWAYIBANJWA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UMTATA TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGANGELIZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "UMTHAWELANGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "IKHWEZI TECHNICAL SKILL CENTRE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "QUMBU TECHNICAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KINGS COMMERCIAL COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MORNING STAR EDUCATION CENTRE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "STRATEGIE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "EXECUTIVE ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "IDUTYWA SCHOOL OF EXCELLENCE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "AV PLAATJIE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "CHRIST THE KING INTERNATIONAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MANZOLWANDLE SANDILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MASILINGANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ST MARTINS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ARTHUR NGUNGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "AZARIEL SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "BALENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BETHANIA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "AD TSHAYINGCA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "BIZANA VILLAGE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BODWENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BOTHA SIGCAU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BROOKSNEK SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BUKAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BUWA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BONXA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "COLANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DALUHLANGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DANGWANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DUMEZWENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "DUMSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DUMSI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ENQABENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ENYANISWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "KwaSHUSHU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "FLAGSTAFF SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GEBUZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "GREENVILLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "GUMZANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "HILLBROW SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "HLAMANDANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "HLANGWINI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SINAKHO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "HUKU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "BHOVULENGWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "JIBA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "JIKINDABA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "JOJO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "PHAKAMA UKHANYE KINGDOM SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "KHORONG SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MBODLENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LANGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LOYISO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUDIDI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUPINDO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUTATENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUTSHAYA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LUZIE DRIFT SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAGADLA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MAJAVU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAKAULA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAKUKHANYE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MALUTI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "KHULANGOPHONDO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MAQONGWANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MARELANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MARIAZEL SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MARINA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MASAKALA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAYIBENYE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MDATYA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MDUTSHANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MLUNGISELELI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MEYISI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MFUNDISWENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MGEZWA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MHLANGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MKOMANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "GCINISIZWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MNCEBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MNCEBA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MNCWATI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MNUKWA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ST MARKS TECHNICAL SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOIKETSI GRAVES SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOKHESENG SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOSA SIBI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOSHESH SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOTHIBISI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOUNT HARGREAVES SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MPENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MPHARANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MPHAHLALATSANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MPONDOMBINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MQIKELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOUNT AYLIFF SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOUNT FRERE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MVENYANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MXHUME JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NCURA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDALISO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NGALONKULU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TYELIMHLOPHE AGRICULTURAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGOBOZANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NGWEKAZI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NONGEKE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NONKQUBELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NTABANKULU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NTABEZULU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTAFUFU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NTSIKAYEZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NTSIZWA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NTUKAYI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NYANISO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "OLIVER TAMBO TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "OSBORN SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "PALMERTON HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOOROSI AGRICULTURAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "PHAMBILI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "PHUTHALICHABA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "QADU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "QOBO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "RALEBITSO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "RAMAFOLE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "RODE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SANGONI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SAPUKANDUKU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SENYUKELE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "SHUKUMA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LA-GRANGE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SIDINANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "SITHUKUTHEZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SIWALI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SOBABA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SONQISHE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ST GEORGES SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ST MARGARET SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SUKUDE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "THABAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "THAKABANNA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "THEMBALESIZWE COMP TECH SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "THOLANG SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "EDWARD ZIBI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TOLI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TOLWENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "VUKAYIBAMBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "VULINDLELA COMPREHENSIVE TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "VULINDLELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "WALTER CINGO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "WINNIE MANDELA COMP TECH SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZIBI MEYER SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZIBOKWANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZINYOSINI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZWELAKHE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZWELIBONGILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LEHANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "KHANYA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MHLONTLO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GWEBINDLALA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MFAZWE COMPREHENSIVE TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZWELITSHA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "TSITSANA COMPREHENSIVE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DWEBA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "CHIEF DUMILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MANZAMNYAMA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MADIKIZELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MT WHITE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BEN MALI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MPINGANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "PHUMELELE COMP TECH SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "CANGCI COMPREHENSIVE TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NOMAGQWATHEKANA COMPREHENSIVE TECHNICAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LINDELANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NDZULULWAZI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "RIVERSIDE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ADVENT COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "AM ZANTSI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ABAMBO AGRICULTURAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ALIWAL NORTH HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SIVUMELENE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BISHOP DEMONT SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BLIKANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ROYAL ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BULELANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BURGERSDORP HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "CACADU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CALA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CALA VILLAGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "COFIMVABA FINISHING SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "CRADOCK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "D M SKOSANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "EBENEZER NYATHI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ECHIBINI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "EGQILI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "EKUPHUMLENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "EKUPHUMLENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ENYANISWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ETHEMBENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "FALO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "FREEMANTLE AGRICULTURAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "FUNDA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "FUNDANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "GCINUBUZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "INYATHI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HEWU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HOëR LANDBOUSKOOL MARLOW"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HOëRSKOOL HANGKLIP"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "IKHWEZI LOKUSA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "IKWEZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "IMPUMELELO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ISIVIVANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "J A CALATA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "JOE SLOVO FREEDOM HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "JONAS GODUKA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "KHWAZA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "KOPANO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "kwaMHLONTLO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "L JENTILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LINGELIHLE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LUKHANYO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LUVUMELWANO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LUVUYO LERUMO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MALCOMESS SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MALIKHANYE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MARIA LOUW SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MASAKHANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MASIKANYISE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BATHANDWA NDONDO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MATTHEW GONIWE COMPREHENSIVE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MAZIBUKO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MBEKWENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MCEULA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MEHLOMAKULU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MICHAUSDAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MIDDELBURG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MIDDELAND SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MTIRARA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MZAMOMHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NKOSEMNTU MOTMAN SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NCUNCUZO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NDLOVUKAZI PUBLIC HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NGUBENGCUKA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NKULULEKO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NOMPUMELELO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NONKQUBELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NONKULULEKO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NTLALO PUBLIC SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NTSONKOTHA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NTUNJA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NYATELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NZIMANKULU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "PHAKAMANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "PHAMBILI MZONTSUNDU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "PHUMLANI TECHNICAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BENGU AGRICULTURAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "QUEEN'S COLLEGE BOYS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HEXAGON HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "QUEENSTOWN GIRLS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "RAYMOND MHLABA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "REX MDEBUKA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SIBONILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SIBUYELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SIFONONDILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SIYABALALA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SIYAPHAKAMA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SOSEBENZA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SOYISILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ST TERESA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "STERKSPRUIT SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "TAMBEKILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "THOZAMISA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "TLOKWENG SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "VELALANGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LAVELILANGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "VUSELELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "W B RUBUSANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ZAMOKUHLE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ZANABANTU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ZIMELENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ZOLANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ZWELEDINGA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NKWANCA PUBLIC HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "PHAKAMA-HOFMEYR SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MZOMHLE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MKAPUSI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NOMPUMELELO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ST JAMES SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SIMPHIWE KHETHWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "JOHN NOAH HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "PAKAMANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ISIKHOBA NOMBEWU TECH SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LOWER SEPLAN SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZWELANDILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ARTHUR MFEBE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SABATA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SPRINGGROOVE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "KwaKOMANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BUBELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DALIWONGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MTETUVUMILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MANZEZULU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HALA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SOVUKA SIKHANYE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MZIMVUBU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MOUNT ARTHUR GIRLS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MZAMO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "GET AHEAD COLLEGE (QUEENSTOWN)"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SADA SCHOOL OF EXCELLENCE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "DALEVIEW SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ENNERDALE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "AZARA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LENASIA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "SOUTHVIEW HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LENASIA SOUTH SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MH JOOSUB TECHNICAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "NIRVANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "TOPAZ SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "TRINITY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "GLENVISTA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "KWADEDANGENDLALE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "AURORA GIRLS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "DR BW VILAKAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "EMDENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "WILLOWMEAD SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LAVELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LENZ PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MAPETLA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "NALEDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "NGHUNGHUNYANI COMPREHENSIVE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "PRUDENS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "REASOMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "SEANA MARENA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "SEKANONTOANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "SENAOANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "TETELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "THABO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "THOMAS MOFOLO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "VUWANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "FRED NORMAN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MOSES MAREN MISSION TECHNICAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "OAKDALE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ELDOMAINE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ELDORADO PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "KLIPSPRUIT-WES SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "KLIPTOWN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LANCEA VALE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MISSOURILAAN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "SILVER OAKS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "WILLOW CRESCENT SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "FOREST HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "HOËRSKOOL DIE FAKKEL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "DIVERSITY HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "HOËRSKOOL PRESIDENT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MONDEOR HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "SIR JOHN ADAMSON HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "THE HILL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ALTMONT TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "BHUKULANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "EMSHUKANTAMBO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "IBHONGO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "JABULANI TECHNICAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LETARE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MAFORI MPHAHLELE COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MOLETSANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MUSI COMPREHENSIVE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "PHAFOGANG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "PROGRESS COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "REUTLWILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "THABA-JABULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "HORIZON INTERNATIONAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "JOHANNESBURG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KENSINGTON SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ATHLONE BOYS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ATHLONE GIRLS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BARNATO PARK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "JULES HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "GRANTLEY COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "GREENSIDE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "HELPMEKAAR KOLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "HIGHLANDS NORTH BOYS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "HOËR TEGNIESE SKOOL LANGLAAGTE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "JEPPE HIGH SCHOOL FOR BOYS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "JEPPE HIGH SCHOOL FOR GIRLS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KING DAVID SCHOOL-LINKSFIELD"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KING EDWARD VII SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MALVERN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "PARKTOWN BOYS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "PARKTOWN GIRLS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "QUEENS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "RAND MEISIESKOOL-GIRLS' SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ROOSEVELT HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SANDRINGHAM HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ST JOHN'S COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ANCHOR COMPREHENSIVE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BONA COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "DALIWONGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "THUBELIHLE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "EMADWALENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LOFENTSE GIRLS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MNCUBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MORRIS ISAACSON SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "NEWGATE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "OLYMPUS EDUCATIONAL INSTITUTE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ORLANDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ORLANDO WEST SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "PHEFENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "DR. BEYERS NAUDE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "SELELEKELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ST ENDA'S SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ST MARTIN DE PORRES HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ST MATTHEWS PRIVATE SECONDARY SCHOOL (KLIPTOWN)"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "TLHATLOGANG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "VECTOR HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "JORDAO COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "CHRIS J BOTHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "CORONATIONVILLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NOORDGESIG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "R W FICK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "RIVERLEA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "WESTBURY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "HOËRSKOOL VORENTOE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NORTHCLIFF HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BOPASENATLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "DIEPDALE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "FIDELITAS COMPREHENSIVE S."
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "FONS LUMINIS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "IMMACULATA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "KELOKITSO COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "KWA-MAHLOBO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LAMULA JUBILEE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LETSIBOGO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MADIBANE COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MATSELISO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MEADOWLANDS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MOKGOME SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NAMEDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "THUTOLORE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "TIYANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ALLANRIDGE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BRYANSTON HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "FERNDALE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "FOURWAYS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "HOËRSKOOL LINDEN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "HOËRSKOOL RANDBURG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "HYDE PARK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "KING DAVID HIGH SCHOOL (VICTORY PARK)"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MIDRAND HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "NORTHVIEW HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "RAND PARK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SANDOWN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "WAVERLEY GIRLS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "WENDYWOOD HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ALEXANDRA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "EAST BANK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ITIRELE-ZENZELE COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KWABHEKILANGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "KWENA MOLAPO COMPREHENSIVE FARM SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MINERVA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "REALO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "SEKOLO SA BOROKGO SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ST ANSGAR'S COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "UNITED SISTERHOOD MITZVAH"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "TRINITY HOUSE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ST PETER'S COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CRAWFORD PREPARATORY LONEHILL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CRAWFORD COLLEGE - SANDTON"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "CONCORD COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "OOSRAND SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "REIGER PARK NO. 2 SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "AFRIKAANSE HOËRSKOOL GERMISTON"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BEDFORDVIEW HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "BOKSBURG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "DAWNVIEW HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "DINWIDDIE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "EDENGLEN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "EDENVALE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "GERMISTON HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "HOËRSKOOL ELSPARK"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "HOËRSKOOL DR E G JANSEN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "DOWERGLEN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "HOËRSKOOL ELSBURG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "HOËRSKOOL GOUDRIF"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "HOËRSKOOL OOSTERLIG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "HOËRSKOOL VOORTREKKER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "HOËRSKOOL VRYBURGER HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "SUNWARD PARK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ERASMUS MONARENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "FRANCISCAN MATRIC PROJECT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ILLINGE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LETHULWAZI COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MASITHWALISANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "RONDEBULT SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "CLADELTON INTERNATIONAL COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "THUTO-LESEDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "VOSLOORUS COMPREHENSIVE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "FALCON EDUCATIONAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "PHINEAS XULU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "HOËRSKOOL PRIMROSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "CULTURA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "CULLINAN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HOËRSKOOL DIE WILGERS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HOËRSKOOL ELDORAIGNE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "HOËRSKOOL ERASMUS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HOËRSKOOL GARSFONTEIN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HOËRSKOOL MENLOPARK"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HOËRSKOOL UITSIG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HOËRSKOOL CENTURION"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HOËRSKOOL VOORTREKKERHOOGTE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HOËRSKOOL WATERKLOOF"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HOËRSKOOL ZWARTKOP"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LYTTELTON MANOR HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ST ALBAN'S COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SUTHERLAND HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "THE GLEN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "WILLOWRIDGE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "CHIPA-TABANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "DAN KUTUMELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "WOZANIBONE INTERM FARM SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "EERSTERUST SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PROSPERITUS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "CLAPHAM HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "HOËR TEGNOLOGIESE SKOOL JOHN VORSTER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HOËRSKOOL F H ODENDAAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "HOËRSKOOL OOS-MOOT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HOËRSKOOL SILVERTON"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "HOËRSKOOL STAATSPRESIDENT C R SWART"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "GATANG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SOLOMON MAHLANGU FREEDOM SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "J KEKANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "JAFTA MAHLANGU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MAHUBE VALLEY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LEHLABILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MAMELODI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MODIRI TECHNICAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PHATENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "STANZA BOPAPE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "RIBANE-LAKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "TSAKO THABO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "VLAKFONTEIN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "VUKANI MAWETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "LESEDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BONA LESEDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HIMALAYA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAUDIUM SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "AFRIKAANSE HOËR MEISIESKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "AFRIKAANSE HOËR SEUNSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "HILLVIEW HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "HOËR TEGNIESE SKOOL PRETORIA-TUINE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "HOËRSKOOL ELANDSPOORT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "RIETONDALE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "HOËRSKOOL HERCULES"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "HOËRSKOOL LANGENHOVEN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "HOËRSKOOL PRETORIA-WES"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "HOËRSKOOL TUINE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "HOËRSKOOL WONDERBOOM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRETORIA BOYS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRETORIA HIGH SCHOOL FOR GIRLS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRETORIA TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BOKGONI TECHNICAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "DAVID HELLEN PETA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "DR WF NKOMO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "FLAVIUS MAREKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HOFMEYR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HOLY TRINITY HIGH SCHOOL (CATHOLIC SEC.)"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MBOWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MERIDIAN COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SAULRIDGE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SESHEGONG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LOTUS GARDENS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "HOËRSKOOL AKASIA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "HOËRSKOOL GERRIT MARITZ"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "HOËRSKOOL MONTANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "HOËRSKOOL OVERKRUIN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "HOËRSKOOL PRETORIA-NOORD"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "AMOGELANG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "BOTSE-BOTSE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "CENTRAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "HLANGANANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "HLOMPHANANG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "KGADIME MATSEPE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "KGOMOTSO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LETHABONG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MAKHOSINI COMBINED SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MEMEZELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "REITUMETSE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "RUABOHLALE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "SENTHIBELE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "SOSHANGUVE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "TIYELELANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "WALLMANSTHAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "ELIZABETH MATSEMELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "AHMED TIMOL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "FLORIDA PARK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "HOËR TEGNIESE SKOOL N DIEDERICHS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "HOËRSKOOL BASTION"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "HOËRSKOOL BEKKER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "HOËRSKOOL DIE ADELAAR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "HOËRSKOOL DIE BURGER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "HOËRSKOOL FLORIDA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "HOËRSKOOL JAN DE KLERK"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "HOËRSKOOL MONUMENT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "HOËRSKOOL NOORDHEUWEL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "HOËRSKOOL ROODEPOORT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "KRUGERSDORP HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "PRINCESS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "TOWNVIEW HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "WEST RIDGE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "BOIPELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SIYABUSA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "FORTE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "GEORGE KHOSA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "KAGISO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MAGALIESBURG STATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MOSUPATSELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "PJ SIMELANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SEBETSA-O-THOLEMOPUTSO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "SG MAFAESA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "THUTO LEFA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ALLEN GLEN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MADIBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LODIRILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "HOËRSKOOL BIRCHLEIGH"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "HOËRSKOOL JEUGLAND"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "HOËRSKOOL KEMPTON PARK"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "NORKEM PARK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SIR PIERRE VAN RYNEVELD HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BOITUMELONG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BOKAMOSO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ELITE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "EQINISWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ESSELEN PARK SPORT SCHOOL OF EXCELLENCE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SPARTAN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "IKUSASA COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "INQAYIZIVELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "JIYANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MASIQHAKAZE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MASISEBENZE COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "THUTO-KE-MAATLA COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "UMQHELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ZITIKENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "RANDFONTEIN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "CARLETON JONES HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "HOËRSKOOL CARLETONVILLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "HOËRSKOOL JAN VILJOEN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "HOËRSKOOL RIEBEECKRAND"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "HOËRSKOOL WESTONARIA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "HOËRSKOOL WONDERFONTEIN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "RANDFONTEIN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "AB PHOKOMPE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "BADIRILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "KGOTHALANG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "THUTO LEHAKWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "PHAHAMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "TSWASONGU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "T M LETLHAKE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "RELEBOGILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "GELUKSDAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LIVERPOOL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "WILLIAM HILLS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BENONI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "BRAKPAN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "HOËRSKOOL DIE ANKER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "HOËRSKOOL BRANDWAG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "HOËRSKOOL HANS MOORE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "HOËRSKOOL STOFFBERG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "WILLOWMOORE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "WORDSWORTH HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "B.B. MYATAZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "EPHES MAMKELI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BENONI EDUCATIONAL COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "BUHLEBEMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "DAVEY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "DINOTO TECHNICAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "DR Harry Gwala SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ETWATWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "HB NYATHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "HULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "JE MALEPE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LEE RAND HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LESIBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MABUYA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MAMELLONG COMPREHENSIVE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "PHANDIMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "RESHOGOFADITSWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "RIVONI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "THOLULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "TSAKANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "UNITY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "CAIPHUS NYOKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "VEZUKHONO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "PETIT HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "HOËRSKOOL SUIDERLIG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "HOËRSKOOL VANDERBIJLPARK"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "BOTEBO-TSEBO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "DINOKANENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "ED MASHABANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "ESOKWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "FUNDULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "JET NTEO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "JORDAN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "KATLEHO-IMPUMELELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "KGOKARE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "KHUTLO-THARO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LAKESIDE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LEBOHANG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "MAHARENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "BEVERLY HILLS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MAXEKE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MOHALADITOE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MOPHOLOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MOQHAKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MOSHATE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "POELANO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "QEDILIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "RAMOSUKULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "RESIDENSIA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "RUTASETJHABA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "SAPPHIRE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "SEHOPOTSO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "SETJHABA-SOHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "SIZANANI THUSANANG COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "TANDUKWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "THARABOLLO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "THUSA-SETJHABA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "THUTO-TIRO COMPREHENSIVE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "TOKELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "TSHEPO-THEMBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "TSOLO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "HOËR TEGNIESE SKOOL CAREL DE WET"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "ROSHNEE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "GENERAL SMUTS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "HOËRSKOOL DR MALAN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "HOËRSKOOL DRIE RIVIERE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "HOËRSKOOL DRIEHOEK"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "HOËRSKOOL OVERVAAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "HOËRSKOOL TRANSVALIA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "VEREENIGING GIMNASIUM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "RIVERSIDE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "SUNCREST HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "THE VAAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "AHA-THUTO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LEKOA SHANDU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LESHATA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "QOQA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "RAPHELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "RUSOORD INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "THAMSANQA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "THUTO LORE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "VULANINDLELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "SAKHISIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "JABULILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "THETHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MPHETHI MAHLATSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ISIKHUMBUZO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "VUTOMI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "SIYAPHAMBILI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "MEYERTON SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "EDENPARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "PALMRIDGE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ALBERTON HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "BRACKEN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "HOËR VOLKSKOOL HEIDELBERG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "HOËRSKOOL ALBERTON"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "HOËRSKOOL DINAMIKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "PARKLANDS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "SEDAVEN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ALAFANG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "BUHLEBUZILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "EKETSANG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "FUMANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "KATLEHONG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "KUDUNG MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "KWADUKATHOLE COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LANDULWAZI COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LETHUKUTHULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MPILISWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MPONTSHENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "THUTOPELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "PHUMLANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "PONEGO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "RATANDA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "SIJABULILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "THABO NTSAKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "THOKO THABA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "TIISETSONG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "WINILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "HOËRSKOOL MARAIS VILJOEN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ALRAPARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SPRINGS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "EUREKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "HOËR TEGNIESE SKOOL SPRINGS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "HOËRSKOOL HUGENOTE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "HOËRSKOOL JOHAN JURGENS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "HOËRSKOOL JOHN VORSTER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "NIGEL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SPRINGS BOYS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SPRINGS GIRLS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ASSER MALOKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ESIBONELWESIHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "KENNETH MASEKELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LABAN MOTLHABI COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LEFA-IFA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MOM SEBONE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "NIMROD NDEBELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "NKUMBULO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "PHULONG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "TLAKULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ZIKHETHELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ZIMISELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "IVORY PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "AL-AQSA EXTENSION 10 SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BRANDCLIFF HOUSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BEAULIEU COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "ITHUTENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ITHUBA-LETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "STEVE TSWETE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRETORIA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "NELLMAPIUS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "CARPE DIEM ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "REDDAM HOUSE PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "KENILWORTH SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "GLENBRACK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BRITISH INTERNATIONAL COLLEGE INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "TSOSOLOSO YA AFRICA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "TEMBISA WEST SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "SIMUNYE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ZONKIZIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "OPRAH WINFREY LEADERSHIP ACADEMY FOR GIRLS - SOUTH AFRICA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "SAMELSON COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "PONELOPELE ORACLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "GREENFIELDS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "PHOMOLONG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "WINDMILL PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "TUKSSPORT HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "DIEPSLOOT WEST SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MAPHUTHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "QUANTUM SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "TANDI ELEANOR SIBEKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "MPUMELELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LEEDS BUSINESS SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ABBOTTS COLLEGE-NORTHCLIFF"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "COSMO CITY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "ABBOTTS COLLEGE-PRETORIA EAST"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LUKHANYO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "THUTO PELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "FUSION SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "SGODIPHOLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "PHUMULA GARDENS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LEKAMOSO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "DALPARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "THULANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "RAYMOND MHLABA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "IKUSASALETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "THATHULWAZI W.R. HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LANGAVILLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "NASHVILLE CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "KGORO YA THUTO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LEONDALE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "QALABOTJHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "WISEMAN CELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "SOSHANGUVE SOUTH SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SIYABONGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "KGATELOPELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "PROTEA GLEN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "KINGSWAY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "O.R TAMBO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "PHAKAMANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "CRYSTAL PARK HIGH"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "DASPOORT SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "IMPACT TUTORIAL CENTRE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MAHARISHI INVINCIBILITY SCHOOL OF MANAGEMENT INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "NORTHWOOD INDEPENDENT HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "CHARTER INDEPENDENT COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "TSHWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "DUO EDU SENIORONAFHANKLIKE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "AFRICAN LEARDERSHIP ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "LEAP SCIENCE AND MATHS SCHOOL (INDEPENDENT)"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "BRIDGEWAY CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "GREENLANE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRETORIA INSTITUTE OF LEARNING"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "JEPPE EDUCATION CENTRE - VEREENIGING"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "EXCELSIOR ACADEMIC COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "BOITUMELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "REPHAFOGILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRETORIA CENTRAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "WATERSRAND SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KAALFONTEIN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MBOWA ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "BOPHELONG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "GREENACRES PRIVATE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "NOORDWYK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ST THOMAS INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ST AQUINAS COLLEGE-ALEXANDRA CAMPUS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "AMANDASIG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "SOSHANGUVE EAST SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BLUE EAGLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "FINE TOWN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "HAMMANSKRAAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "AMOS MAPHANGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "TSWELOPELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "J.B. MATABANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ABBOTTS COLLEGE-JOHANNESBURG SOUTH"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "STEVE BIKOVILLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "DIEPSLOOT SECONDARY SCHOOL NO. 2"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LAWLEY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "CURRO HAZELDEAN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ROSTEC TECHNICAL COLLEGE-JHB"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ROSTEC TECHNICAL COLLEGE- PTA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ST CHRISTOPHER'S ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ISRAEL CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "OLIEVENHOUTBOSCH SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MADRESSAH AYESHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SEDCO COLLEGE-PRETORIA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "EXCELSIOR ROOIHUISKRAAL AKADEMIE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "STEMRIDGE DISHON SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "UNIHIGH INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "WINNIE MANDELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "ZITHOBENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "SUNRISE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ORANGE FARM SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "TSHEPO YA RONA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "WINIFRED NOMZAMO MANDELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "NEW EERSTERUST SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LEHWELERENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "THUTO BOHLALE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "DAVID MAKHUBO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "FREEDOM PARK SECONDARY SCHOOL NO 1"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "VILLA LISA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "DENVER SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "EDEN-RIDGE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SEEKERS PRIVATE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "KIBLER PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "FAR NORTH SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "PHOENIX SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "NEW HOPE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LONEHILL INTERNATIONAL ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ROYAL COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "CHIEF A. LUTHULI PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NORTH RIDING SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "MOUNTAIN VIEW HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LEAP SCIENCE AND MATHS SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LEAP SCIENCE AND MATHS SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ANDREWS ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "CHARLOTTE MAXEKE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "RUST-TER-VAAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "PALMRIDGE EXT. 6 SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "TSAKANE EXT.8 SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "GLEN AUSTIN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "THE BRITISH ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "OCEANS PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "FOCHVILLE SECONDARY SCHOOL NO 2"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "CENTRAL COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "INSTITUTE FOR QUALITY COLLEGIATE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BRITISH INTERNATIONAL COLLEGE-PRETORIA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ABBOTTS COLLEGE-CENTURION"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LUFHERENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "THORNRIDGE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "TZURIA LEARNING CENTRE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NORTHSIDE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "BUHLE PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "THE BOOST CENTRE GLENHAZEL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "IMPERIAL LONDON PRIVATE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "TSHWANE CITY COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "FAIR RIDGE PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "HIRSCH LYONS GIRLS SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "HIRSCH LYONS BOYS SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "PROTEA SECONDARY SCHOOL NO.2"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "DR MOLEFI OLIPHANT SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "CENTURION SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SILVER OAKS INTERNATIONAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ALBERTON MATRIC PROJECT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ROYAL MOUNT COLLEGE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "RADFORD HOUSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "3D CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "EDUPLEX HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "RADLEY PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SCHOOL OF MERIT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "MELWOOD INSTITUTE OF TECHNOLOGY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "CONCORD COLLEGE MULBURTON"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "CURRO JEWEL CITY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "CURRO KRUGERSDORP HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "BETHELHOUSE TECHNICAL COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "BESA LEADERSHIP ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "ABEL MOTSHOANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "ADAM MASEBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "BOITSHEPO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "BOKAMOSO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "DR. A.T. MOREOSELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "GALEBOE MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "HL SETLALENTOA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "HANS KEKANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "HOLY TRINITY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "HOSEA KEKANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "I. R. LESOLANG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "KGETSE-YA-TSIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "KGATOENTLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LETHAMAGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LETLOTLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "M. H. BALOYI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "MABOPANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MADISONG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MAKGETSE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "MAPENANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MODILATI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "MODIRI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MODITELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "NICK MPSHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "NGAKA MASEKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "NTSWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "NM TSUENE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "P.H.L MORAKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "PELOTONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "RAKGOTSO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "RANTAILANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "RATSHEPO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "SETUMO - KHIBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "TIPFUXENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "TSWAING SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "WINTERVELDT HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "SIKHULULEKILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "SEAGENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "FR. SMANGALISO MKHATSHWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "DR. MOTSUENYANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "EKANGALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "LINGITJHUDU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "SITJHEJIWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "MAHLENGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "STRAUSS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "HOËRSKOOL FOCHVILLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "THUTO KITSO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "WEDELA TECHNICAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "IMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOHUMI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOTSHUEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KGOLAKALELEME"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAMERIRI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MODIKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "HOERSKOOL BEN VORSTER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MERENSKY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TSANENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAMOSALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUSINA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "HOERSKOOL ERIC LOUW"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LUPHAI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HAWUKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HOERSKOOL FRANS DU TOIT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "DITHEBELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAPHUTHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RALEKWALANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "CAPRICORN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KUSCHKE AGRICULTURAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "HOERSKOOL NOORDERLAND"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "HOERSKOOL PIETERSBURG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "TOM NAUDE TECHNICAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMATSHIPI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOTSE MARIA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PAX"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NORTHERN ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "WESTENBURG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "FLORAPARK COMPREHENSIVE HIGH"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAMPHOKU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MACHAKA ROBERT MAMABOLO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEOLWANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKOME"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "TAXILA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "VHUDZANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "ONGEDACHT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LOUIS TRICHARDT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MARUDE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RIVUBYE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MICHAEL DENGA RAMABULANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NTHABISENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "FHATUWANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "XIMUNWANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "TIELELO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MOEPEL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "TSHIRELETSO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "HOERSKOOL HANS STRIJDOM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "HOERSKOOL PIET POTGIETER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "JOHN PETRO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEPELLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MOKHARI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "WATERBERG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MAKHUTJISHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "HARRY OPPENHEIMER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "HOERSKOOL NYLSTROOM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MEETSETSHEHLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MOHLAKAMOTALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MOSHIA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "PHAGAMENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LESEDING"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "BAITSWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "HOERSKOOL ELLISRAS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "PHEGELELO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "RABODITSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "THEKGANANG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "HOERSKOOL FRIKKIE MEYER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MABOGOPEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "GROENVLEI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "BELA-BELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "HOERSKOOL WARMBAD"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MAOPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "RAELENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "SETTLERS AGRICULTURAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "NORTHAM COMPREHENSIVE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "JULIUS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SHINGWEDZI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SHIRILELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "E.P.P. MHINGA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "P.P. HLUNGWANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MALAMULELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NKATINI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GEORGE SONTO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "BASOPA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "JIM CHAVANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MADADZHE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NWANATI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RIPAMBETA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SHIKUNDU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "ADOLF MHINGA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MPHAMBO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "KHATISA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "JIM YINGWANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NGHEZIMANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GIDJANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DLAMANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GOVHU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SHITLHANGOMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MTITITI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MATIMBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MADONSI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NTLHAVENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "PHOTANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RHABELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SHIGAMANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "FRANCE SOMBHANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HLALUKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAHUNTSI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MBHANYELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HUMULA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HLALUKWENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MBHEDLHE-MABASA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NGULA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "THAMBISA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "JOHANNES RAMAVHOYA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MATSAMBU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LEMANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "ELIM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "H.S. PHILLIPS MEMORIAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "HANYANI NKUZANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "AKANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "DUVULA MAHUNTSI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "HLUVUKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KHOMANANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "FRANK MAHATLANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAHLORI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MARHOLENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MARHORHWANI-MALALI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MARIMANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MSENGI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MASIZA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NWAMAVIMBI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NWAMALOBYE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RUSSEL BUNGENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SHINGUWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "YINGWANI-RIBUNGWANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "ROTTERDAM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUTSETWENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MALOVHANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NOBLEHOEK"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "JAJI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "GIDELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TIYANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOLOMAHLAPI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LEBEKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LEPATO M."
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAKIKELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAPHOKWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MATOME-MALATJI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RELEBOGILE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SEBALAMAKGOLO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "VUXENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "GIVA-MAHLATHI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MATOME MODIKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "B. MKHABELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "BANKUNA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "CATA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "CHARLES MATHONSI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "D.Z.J. MTEBULE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "GWAMBENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "HUDSON NTSANWISI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LEFARA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LWANDLAMUNI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAGOZA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAHWAHWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAKHANYA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOLABOSANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAPHETO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MBHEKWANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MUGWAZENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MARK SHOPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "PETANENGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "PHANGASASA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "PROFESSOR MUHLAVA SHILUVANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SCOTCH MABOKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SEDAN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SEVENGWANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TIAKENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "XIBUKULANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "ZIVUKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "STANFORD LAKE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "DUMELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LEBITSO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MATIMU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MATLHARI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MPUMULANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "PHEREHLA-MAAKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "BURGHERSDORP"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NWARIDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "CHAMETI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "DUMAZI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "EDWARD HOMU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "FAMANDHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "GAWULA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "GIJA NGOVE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "GIYANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HANYANI THOMO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HATLANI MUYEXE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HLOVANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HOLA-PONDO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "JIM RHANGANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHETO NXUMAYO AGRICULTURAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHOMANI MBHALATI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MACEMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAHUMANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAKOVONGO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MALENGA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MANGHEZI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAPHUSHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAVALANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MBHANGAZEKI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MUHAWU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MUKULA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NDENGEZA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NDINDANI-HLOMELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NHLUVUKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NKAMI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NYANISI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "PHAYIZANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RISINGA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RITHLAVILE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SEMENDHE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SIKHUNYANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "TLAKULANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "VUTLHARI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NTSAKOMATSAKALI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HIVUYERIWILE COMMERCIAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAFUMANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HASANI MNINGINISI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NWAKHADA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAKHETO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MASIZA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "BAMBENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAGULASAVI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NDHAMBI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NGHONYAMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NYUMBANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SASEKANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SHIHLOMULE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MASASWIVONA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NTSHUXEKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "ZAVA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NKATEKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAJEJE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HINKHESILE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "BARANUKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "ABEL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "BOKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "BOLOTSWI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KELEKESE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KGAPANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KGWEKGWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KHESETHWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHUBUDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAGOLETSA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAKOBO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAKOMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MALOTI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MANONYANENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAOLWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MASALANABO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MASELEKWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MASHAO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MASHOORO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MASOPHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MATOKANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MATSEKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MODIPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MODUBATSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MODUMAANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOHLATLEGO MACHABA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MOKOPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MOKOTO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MOLAI JUBILEE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOPYE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MORWATSHEHLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MOTSIPA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MPHIRI-O-TEE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "FOBENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "PULANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "R.S.B. MOTSINONI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "STANLEY MOPAI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RAMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RAMABOLELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RAMAOLWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RAMOTSHINYADI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RETHUSHEGILE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SEKGWARE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SEKHUKHUMELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SEMARELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SENWABAKGOLOLO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "TSHWENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MATARAPANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MANWAGAE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAMODING"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOOKGO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MPAPATLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHATHOLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHEALE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHEODI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "GEORGE MSWAZI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NTLAGENE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAKGOPELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RAMMILA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "REALEDISHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "TSEANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAMPEULE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MOLATE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MOKUTU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MODISHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAKHAKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MMABA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MDINGAZI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOTLALAOHLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAMPO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEALE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LEPHAI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAMOKUTUPI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MASEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MASHAHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOKOMENE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEFOLOKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TIDIMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAKGATO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGARAHARA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "LETHEBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KOLOBETONA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAHUDU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MANGOAKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MARUATONA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MATHIBADIFATE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MPHUMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NAHAKWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "PELO YA KGOMO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "FEDILE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MACHEPELELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RASEMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "ST. BRENDAN'S CATHOLIC"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAKALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHUDUGANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SELAMOLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BATAUNG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "DIKOLOI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "GEORGE TLADI TECHNICAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGALUSHI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGOKWANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGOLOUTHWANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGOPUDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "LEHAIWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MABEA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MABOTHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAHADIKANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAHLASE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MALEBOHO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MALUSI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAMMOKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAMODUWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MANKGAKGATLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MANOE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMANTSHAKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MARUMOFASE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MASOKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MATHIPA MAKGATO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MATSUOKWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MATSWAKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMALOTLO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMATSELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOSHOKOA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MPATAPATA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MPHELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MPHENGWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MY DARLING"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NAKEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NTSOSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PHAGAMANG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PHALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RADIKGOBETHE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RADIRA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAMATEMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAMOHLAKANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAMOTSHABI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAPETSWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAPHATLHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SCHOONGEZICHT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEIKGONI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEIPHI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEKELEKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TEMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TLOU-MATOME"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TSHENYANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TUMAKGOLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "V.P. MANTHATA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOLOKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KETUDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NGWAKWANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MALEBO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "ALLDAYS SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RASEKGALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "THOKAMPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "BATLHALERWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "DIAMMONA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "DIMPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MAJADIBODU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MANANYE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MATHULASERA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MATSHWARA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MATSIABABA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MAZWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MOKONENKWENOKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MORAKOLO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MOTLHAJWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MPHARI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "SEOKETSENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SEPHUTHI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "SETHULA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "THABANG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "RADINONG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "RASERITE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LETUPU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "KODUPO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MPEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MMAY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "BEN HLOGWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "D.G. TSEBE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "EBENEZER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "E.D.L. RAMPOLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "GOJELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "GWENANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGABA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGATI YA MOSHATE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "LANGALIBALELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "LEKWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MADIKWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAKGENENE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MALEYA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAPANOLLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MASERUNYANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MASODI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MATANTA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MATSIBE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "M.C. LANGA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MMANTUTULE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MMATEDU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MMOLAWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MPHUNYE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MPIRWABIRWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NTATA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NKAKABIDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RAMOGABUDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SEKOBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SERITARITA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SOMAVUGHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "TETEMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "TJITJILA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "ALFRED B. MAKAPAN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "GOBELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "FRED LEDWABA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "STERKRIVIER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MMADIKANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "BATHOKWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "DENNIS MATLHABA II"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGOKARI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MALEMOCHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MASHAMAITE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MATOPA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MATSOGELLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAWELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NAKONKWETLOU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NKGORU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NKUBE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RAKUDUBANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RAMOLLWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SIYAKHELENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "TLOU MATLALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SESHOATLHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "LEPHADIMISHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "GEORGE LANGA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "PHAHLAPHAHLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MASHUBASHUBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "GEORGE MASIBE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "CHARLES MARAKALALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAFASA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NTHUBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "PALEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SEWELABATHO COMMERCIAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGABEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "PIRWANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGAKGATHU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SEGOBOKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RALELEDU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MOOKAMEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "LEMETJA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGOLODI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MATHULAMISHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MATATANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KOLOBE RAMASOBANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGAUBOTLHALE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "BAKENBERG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MMAMOPI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SEREMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "PT MATLALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SENWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "CHITA KEKANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KGAKALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEHWELERE MATLALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MACK SEMEKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAFSIAKGOMO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAJATLADI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKGWADING"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAMPOTJANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MANKHOLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAROBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MATLADI PROJECT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOHLOPHENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOREMOTSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOROPA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NGWANABAHLALERWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PHALAKGORO MOTHOA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PIET N. APHANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RAMABELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "REHOLEGILE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEBITJA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SECHICHI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEGAENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SERUTLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SETHWETHWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SETUKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "TUBAKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MADIBO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KUBUSHE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MPHOKENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "CHAMANDU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MASHOBELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIKHUTHULA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BODIELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGOKONYANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MADIKWENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MODUMELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SERIPA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SHAKOLENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BOETSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BOKAMOSO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BOTSIKANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DR. A.M.S. MAKUNYANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "DR. M.J. MADIBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "GEORGE MORAGULA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "JAWEJAWE LEDWABA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "J.H. MOLOTO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGABO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGOLOKGOTLHA LEDWABA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KHAISO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKGOFE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAMOLEMANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MASEDIBU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MASEROLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MATHABATHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "M.E. MAKGATO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMAKGABO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MMAMARAMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MMANARE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MMAPHUTI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGAKOA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOSHUBABA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MPHATLALATSANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NARE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "O.R. MABOTJA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEIPONE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEKGOPETJANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SESHIGO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TLAKALE MASHASHANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MONYONG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOLAUTSI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PETER NCHABELENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOHLAPETSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PHALATLOU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "B.K. MATLALA COMMERCIAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BOSAKGO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "CHECHEMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "CHIKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "IPOPENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KABELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KARABI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KEDISHI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGOKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KHWINANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAHLABELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAHOAI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAOWANENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOSHIDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMAMOLOPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOCHEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MODUMO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOSONYA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MOTJERE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NGAKANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PHUTI SEOPA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SELAMODI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEMANENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEOKENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TLOU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BOTSHOLLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NCHELELENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NKGOPOLENG BAKONE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMAMEHLABE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMANKOGAEDUPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TSHUKUTSWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NGWANALLELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOTLISHI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BAPHUTHENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BOSHEGO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "CHAKGA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DOASHO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "GERSON NTJIE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "HWITI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KLAAS MOTHAPO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LEKOTA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MADIPOANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAFOLOFOLO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAGOGO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKGOBAKETSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKGOKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKGONGOANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MALATSWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAMABUDUSHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAMODIKELENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MANKOENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MANOSHI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAPELOANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAROBATHOTHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MASOBE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MATHUKANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MMAPADI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOKWATEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOLOISI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MORUTWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOTHIMAKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOUNTAINVIEW"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "M.P. MAMABOLO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MPHETSEBE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NGWANALAKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NGWANASEALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NKOSHILO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PHOMOLONG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PHUNYAKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RAMABU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RAMAKANYANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RAMOSHOBOHLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RAMATHOPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RANTI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "ST. BEDE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "TSELA CHUEU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "TSHEBELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "ZOETFONTEIN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DITLALEMESO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LERULENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAGAEDISHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAISHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BJATLADI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BOIKHUTSONG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "CHUEUE KGOLO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DEREK KOBE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DINAO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DITSEPU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "J.K. TABANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KGADIMO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KGAGATLOU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KGALEMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KGWADIAMOLEKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LEHLAGA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KOPANO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KGWARATLOU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LEBOWA KGOMO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LESHIKISHIKI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAHLOGEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAHWIBITSWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAMAGOGO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MASHIANYANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MATHOMOMAYO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MATIME 2"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MATSIMELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOGAPUTJI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOSEPEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MPHACHUE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NGOATOTLOU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NGWANA MOHUBE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NOKOTLOU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PHASOANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PHOSANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PHUTLO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RADIKGOMO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEDIMOTHOLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEHLOLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEKATE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "S.J. VAN DER MERWE TECHNICAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "TAUPHUTI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "THAGAETALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "THOGOA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "TSHEHLO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "REKHUTJITJE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEGOPOTJE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEGASHIFE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATSHELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKOPOLE I"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MODIPA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "BOPEDIBAPEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "DIPHALE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KGAHLANAMORULANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KGOSHIMOROANGOATO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KGOTSWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEGALETLWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEHWELERE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEKHINE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEKOKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEOKENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LETEBELE MARISHANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEWALEMOLOMO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MABODIBENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MADIKALEPUDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAGALE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAHWETSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAKWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAKWETLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MALEKUTU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAPURU TSEKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MANGOLWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MANTLATLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MANTLHANYANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAPHADIME"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MARETELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MASEMOLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MASERUMULE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATHUME"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATLEBJOANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATSHUMANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MMAKOPI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MMAMOKGOKOLUSHI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOHLODI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOKGERETLI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOKGAPI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOKGUBI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOLEBELEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOLOMOTOATAU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOLWETSI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MONYAKU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOREKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MORITI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOTEANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOTSWALEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOTUBATSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MPHEGOLLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MPHELE A MPHELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NAMUDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NGALE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NGOATOANAPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NGWANAMASHILE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NGWANATSHWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NKGONYELETSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NTSHEBELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PHATAMETSANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PHIRIAGAE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PHOROANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PONTI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RANTOBENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "REBONE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SEOPO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SEPHEU MOLEKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TENYANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TSEKEMARISHANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TSHEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MODIPADI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAKHATO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THAKGUDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MMAUWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PHUTI-KWENA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "GUARDIAN ANGELS COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MPOLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "ABRAHAM SEROTE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "BOLEU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KOPA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAHLONTEBE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MANG-LE-MANG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MONAMODI MATSEPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOSHATE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NALEDI-YA-MESO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOGUDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MPHAHLELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "A.M. MASHEGO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "GOODHOPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "IZIKHALI ZEMFUNDO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LOBOLI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAGUKUBJANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MPHEZULU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SEGOLOLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "ST. PAUL'S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "ZAMA ZAMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "ZAMOKUHLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KOTOLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOGADIME"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOKGOMA MATLALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAHLARE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MANYAKU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEKALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MARESELENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PHOKANOKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NGULU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "HLANGANANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NDENDEKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NAPE A NGWATO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAMADI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOTJEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NGWANAKWENA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "HUTUTU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOKONEAMABULA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAJANE MATLALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "HLABI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOTODI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOLEPANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NGWANAMATLANG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOHLAKANENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SHORWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DITHOTHWANENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEKENTLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKELEPENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOEPADIRA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOHWADUBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MPHELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TLOU NARE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "FRANK MASHILE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "HANS KOMANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NGWANAMALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DINAKANYANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "FETAKGOMO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOHLALETSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOKHINE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PEU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PHUTAKWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MADITHAME"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOHLOTLWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOROKALEBOLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PHUTITLOU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SELEBALO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "BAROKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "BATAU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DIKOTOPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DINKWANYANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KANAMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KGAOLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KWELEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEAGATHOKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEHLABA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEHLABILE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEOLO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LETAU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MADIKOLOSHE MALEPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAGATAGABOTSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKIDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKHWESE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAMOLOBELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MANOKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAOKENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAREMISHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MASHAKWANENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MATHAFENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MATSHAILE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MMIDITSI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOGOHLWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOHLAKENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOHLATSENGWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOTLAILANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOUKANGOE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NTABANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NTIBANENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PAEPAE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PHAAHLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEDIBENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEMORIRI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SOGANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TAUNG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TSHABELANG DINOKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOGOLO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NKOTA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOHLARUTSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "GANGADZA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEFAKGOMO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LESAILANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEPHENYE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MABORAGANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MALENGINE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOSEGO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "POTLAKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TLOUPHUTI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DIHLABAKELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAPUTLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAROLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOHLALAMORUDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOSEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NAKGWADI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PHUTINARE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TEKANANG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TSHIHLO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKUANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MANAWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MMUTLANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOGOLAHLOGO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOILA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOTLOULELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "POTOKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SHAKUNG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KGOKODIBENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKGAMATHU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKOPI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAMOGEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOKWADIBE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NKGOMELENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "RATANANG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEHLAKU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KGOLANE -1"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MODIADIE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MORWASWI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOSEKI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NTWAMPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NYAKU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PHAFANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "POO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SELATOLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEROKOLO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEROLETSHIDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "BAPHADIMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KGALATLOU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MONAMOLEDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KGOLOKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LAMDZANDVO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEGARE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEHUTJWANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LOBAMBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKGWALE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MASHEGO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MASHUPJE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MATSEBONG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOLESHATLOU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MPILO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NGWAABE COMPREHENSIVE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NGWANANGWATO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NKOTWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PHUTLOTAU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "RAMPHELANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEBASE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEFOGOLE SEPEKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SENGANGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEOKGOME"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SERAKI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TSHABADIETLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TSHEHLWANENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKOPOLE II"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKATANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LENGAMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "GOBETSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "ST. MARK'S COMPREHENSIVE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "BESSIE MAAKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "BOKGAGA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "DIPONE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KGWANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KHATAZA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KHUDU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LEOMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LEPONO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAAHLEMELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAALOBANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MABUSHE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MADIE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAFUTSANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAHLANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAKGWAHLENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MANTSOBELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MMALESIBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOKHAPA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOKWANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOSIBUDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "NAPSADI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "NARENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "NGWANAMAKHUTSWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "PHUSELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RAKGOLOKWANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RAMATAU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RAMOBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SEAGOTLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SEBOYE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SEKABA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SERURUBELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SEKGALABJANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "NELSON RAMODIKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "CALAIS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "NAPSCOM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MPHEPHU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NKONENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHILOGONI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUSHAATHONI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIFHENA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "DZATA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NNDITSHENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MULENGA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "VELELAMBEU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "GEORGE MBULAHENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NNGWENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "DIMBANYIKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "JONATHAN MUSHAATHAMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "PATRICK RAMAANO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "VHULAUDZI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSWIME"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "HUMBELANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LUATAME"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHAMAKWATINI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "FRANK RAVELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SOLOMON MAELULA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "JONATHAN THIFULUFHELWI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "JOHANNES MULAMBILU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RAVHUHALI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MATHEDE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SINUGANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MALUTA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIANANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUDIMELI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RAMABULANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MASERENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAMVUKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SINTHUMULE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MANELEDZI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MMILIGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIUNGULELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KUTAMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LUVHIVHINI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SWOBANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIRULULUNI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LITSHOVHU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAGONI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SWONGOZWI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NIANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HANYANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RATSHISASE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIKUNDAMALEMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "FHETANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DYELAMANAVHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RATSHIBVUMO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUBALANGANYI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NYADZANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "KHANGALE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUTSHUTSHU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TOMBOLAGOLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LUNWANNGWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "ROBERT MBULUNGENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MALILELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAMPHODO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MATAVHELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "PHOPHI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RATSHILUMELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIWANGAMATEMBELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TODANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "THENGWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "VELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DZIMAULI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DAVID MUTSHINYALO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RAMBUDA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KHAKHU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAKUYA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SUMBANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NDARIENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "THATHE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LUCAS RATSHALINGWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "VHUTAVHATSINDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MPHALALENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LWANDANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NDAEDZO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DIMANI AGRICULTURAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAGALANNGWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "THAMBATSHIRA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SHAYANDIMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUTHAMARO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LIGEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHILAVHUTUME"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAKAKAVHALE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "KHWEVHA COMMERCIAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MASWIE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LUVHAIVHAI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIEMUEMU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "GWAMASENGA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LWAMONDO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "ANDRIES MUGAGULI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NNDAMULELENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIPETANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAVHUNGU ANDRIES"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RATSHIKWEKWETE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KOLOKOSHANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUTHURWANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUGOIDWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MATODZI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIMBUPFE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DAVHANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "EDISON NESENGANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "JOHN MUTHEIWANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LWENZHE TECHNICAL HIGH"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIPAKONI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHINAVHE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUDINANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RAMAUBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "VHAFAMADI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RADZAMBO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KHWARA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MALIGANA WILSON"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "PHIRIPHIRI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NNDWELENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RAMASHIA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "JACK LAVHENGWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "VHUSENDEKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MIRIYAVHAVHA TEC"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "THUSALUSHAKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIVHIDZO MASIAGWALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "THOHOYANDOU TECHNICAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "THOHOYANDOU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MPFARISENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "AZWIFARWI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GOLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUKHWANTHELI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUVHAVHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SAM MAVHINA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "THASE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHILALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "THIVHILAELI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "BABABA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUHANELWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUKULA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RALUVHIMBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SILEMALE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "THINASHAKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIDIMBINI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DENGENYA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DENGA TSHIVHASE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DZWABONI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GUVHUKUVHU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MBILWI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MPHAPHULI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NTHETSHELESENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "PHASWANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RALUSWIELO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RALSON TSHINANNE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "WILLIAM THEMELI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "FRANS RASIMPHI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUHUYUWATHOMBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHADAMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIVHASE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GUMANI TECHNICAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "ZWITHUZWAVHUDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "FUNZWANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MPANDELI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MILTON MPFUMEDZENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LIMBEDZI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NTEVHEDZENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NTODENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "VUVUMUTSHENA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NTSEDZENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RANNDOGWANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TONDALUSHAKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MOVHE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "OZIAS DAVHANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIAWELO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "WATERVAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "DAVID LUVHIMBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "DENGA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAINGANYA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "THWALIMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "VHALUVHU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NAMADZAVHO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MULIMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NDALAMO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RALUOMBE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHINANGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIITWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LUMUKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LISHAVHANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MOYANENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "PHALADINGOE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RAOWELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KUBELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MABALANE-SELEKA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "HARDEKOOL ACADEMY FOR CVO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "ROOSEVELT ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "SOLOMON MAHLANGU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "ADVANCED COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "ITIRELENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "VINGERKRAAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "BATHOPELE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MATAMELA RAMAPHOSA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "DENDRON"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEKETE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MATHEW PHOSA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAKGARI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "ROYAL AGRICULTURAL AND CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RADIPITSI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAKGETHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKGALE PHASHE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "FRANS MOHLALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAMOCHOKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MPHETHANTSHA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KABELO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MORULENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "JEPPE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "VERITAS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MMABULEPU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOREBENG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "VUSWAYI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "S.D.W. NXUMALO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "JILONGO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "ALTEIN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "JOSEPH RHANGANI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "ALFRED NNGWEDZENI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LWAPHUNGU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SEKGOSESE (SCIENCE & TECHNOLOGY)"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RASILA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIKOTA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAKHADO COMPREHENSIVE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RIDGEWAY COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RENAISSANCE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HLOMELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NYUKANI EDUCATION CENTRE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "GIYANI COLLEGE OF TECHN AND MANAGEMENT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAKHWIVIRINI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SEUNANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RALERUMO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MANDELA BARLOWORLD AGRICULTURAL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MBHETSA ACADEMY OF SCIENCE MATHS AND TECHNOLOGY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SOLANI SAMSON N'WAMITWA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "HELMEG ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RAMASETE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "HOERSKOOL HOEDSPRUIT HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MPHELA 'A MARUMO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "RAY OF LIGHT CHRISTIAN MODEL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOGALE WA BAGALE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "HIGHLANDS HIGH"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "REFILWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MPHAGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MABOA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAGOBANYE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LOWVELD ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEAP"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KGAHLANONG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOHLAREKOMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "DYNAMIQUE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATAILANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SKHOSANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LERIANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TJETJE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "HOËRSKOOL BEN VILJOEN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "ESTHER MALEKA COMPREHENSIVE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "DIBATHUTO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "DITHAMAGA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SEBAKANAGA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RAMATSHAGALALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "ST JOSEFS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOHLABETSI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THLAKO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THEJANE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "REITOMETJE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAILANKONONO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "OR TAMBO COMPREHENSIVE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOHLAMME"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NGWATO-A-MPHELA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KGOTHALA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RAMOGOSETSI MAGANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PEZUNGA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAHLAKODISHE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TLHAKANANG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MABAKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "REKHUDITSE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SEBJALEBJALE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "REFILWE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KGAGA TLOU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "REPHAFOGILE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TSHIKANOSHI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NTSHIBA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ALLENDALE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ALPHEUS D NKOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BANTFWABETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BEESTEPAN AGRICULTURAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BHEKISWAKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BINGWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SKHILA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BONGINHLANHLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BONGINHLANHLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BONGINSIMBI COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BONGUMUSA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BOTLENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BUHLEBESIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CAMALAZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIYIFUNILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CEBISA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CHIEF CHARLES SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CHIEF JERRY NKOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CHIEF S W NHLAPHO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CHIEF T D NKOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "CIBILIZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CYRIL CLARKE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "DLAMADODA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "DLOMODLOMO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KHETSALWATI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "DUDUZILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "DUMELENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "FUNDINJOBO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LOMAHASHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EJ SINGWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EKULINDENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EKWAZINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ELANGWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ELUKHANYISWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EMJINDINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EMPUCUKWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ENKHANINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ENTOKOZWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "HILLARIA MTHETHWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EXTENSION K SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MATHEWS PHOSA COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "GEBHUZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "GEDLEMBANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "GOBOLIBI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "GUDUZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HTS LIGBRON"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HTS MIDDELBURG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HTS WITBANK"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LETHABONG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HIGHVELD PARK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HIGHVELD SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HLABANGEMEHLO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HLALAKAHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HLANGANANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "HLANGANANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MANDLESIVE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HLOMANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HLONIPHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HLUZINGQONDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SUNDRA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HOLMDENE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "IM MANCHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "HOËRSKOOL BARBERTON"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "HOËRSKOOL BERGVLAM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HOËRSKOOL DELMAS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HOËRSKOOL ERMELO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HOËRSKOOL EVANDER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HOËRSKOOL GENERAAL HERTZOG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HOËRSKOOL HOOGENHOUT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HOËRSKOOL KANONKOP"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HOËRSKOOL KRIEL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HOËRSKOOL LYDENBURG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HOËRSKOOL MIDDELBURG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "HOËRSKOOL NELSPRUIT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HOËRSKOOL OOSTERLAND"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HOËRSKOOL PATRIOT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HOËRSKOOL PIET RETIEF"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HOËRSKOOL REYNOPARK"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "HOËRSKOOL ROB FERREIRA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HOËRSKOOL SECUNDA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HOËRSKOOL STANDERTON"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HOËRSKOOL SYBRAND VAN NIEKERK"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HOËRSKOOL VOLKSRUST"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ILANGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "IMEMEZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KHUZULWANDE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "INKOMAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "INKUNZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "INSIKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "INTUTHUKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ISIFISOSETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ITHAFA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "JACOB MDLULI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "JANDRELL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "JERUSALEM SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KAMHOLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PHUMELELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KHALIPHANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KHAMANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KHANYISANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KHAYALAMI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KHULA SAKHILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KHULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KHUMBULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KIRIYATSWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KOPANANG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KUSASALETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KHUTSALANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KWAMANALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KWAMHLANGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KWASHUKU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KWAZAMOKUHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAKE CHRISSIE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LAMBALATI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CHIEF AMPIE MAYISA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LEHLABILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LEKAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KHUNJULIWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LIGUGU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LIHAWU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LILANGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LINDILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LITHO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LITJELEMBUBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LOVUNYWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LOWVELD HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LUBOMBO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LUGEBHUTA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LUNGISANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LUSUSHWANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MABANDE COMPREHENSIVE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MABUSABESALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MADLAYEDWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MADODA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAFU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MAGOTSHWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAHLATSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAHUSHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MALATSE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MALEBO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAMBANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MANDLETHU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MANOKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "IKHETHELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MANZOLWANDLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "OSIZWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MASHISHING SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MASITAKHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MASIZAKHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KT TWALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MAYFLOWER SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAYIBUYE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAYISHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MBALENHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MBALENHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MBAMBISO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MBHUDULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MBHUNU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MBULAWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MBUYANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MDZABU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MEHLOBOVU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MEHLWANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MEMEZILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "METHULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MGUDLWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MJOKWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MKHEPHULI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MKOLISHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MMAMETLHAKE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MMASHADI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MNTUNGWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOEPI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOGOBOSHENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOKEBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MPHALALI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MPHANAMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MPULUZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MPUMELELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MSHADZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MSINYANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MTHOMBO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MUSA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MZIMHLOPHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MZINONI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NALITHUBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NANSINDLELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NCAKINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NDLELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NDZUNDZA MABHOKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NGANANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NGILANDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NGODINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NTHOROANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NTIYI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PHAMBILI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "PHAMBILI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PHAPHAMANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PHATFWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PHILLIP NDIMANDE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PHUMULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PHUMZILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PUNGUTSHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "QEDELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "QONDULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "RAMOSHIDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "RATLHAHANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "REV SA NKOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SAKHILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SAMORA MACHEL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SEABE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SEME SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SENZANGAKHONA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SERUANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SETSHENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SHINYUKANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIBHULO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIBONGAMANDLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIBUKOSETFU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIBUSISIWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIDLAMAFA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIDLASOKE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIDUNGENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIGWEJE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIHLENGIWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIKHULILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIKHWAHLANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SILAMBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SILIGANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SINCOBILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SINETHEMBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SISUKUMILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SITFOKOTILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SITHENJISIWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SITINTILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIVUMELENE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIYABONGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIYATHOKOZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIZWAKELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SOBANTU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SOFUNDA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SOMKHAHLEKWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SOMSUSWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SOSHANGANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SOVETJHEZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SOZAMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "STEELCREST HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SUIKERLAND SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "TAKHENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "THEMBEKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THOBELANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THOLULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THOMAS NHLABATHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THOMAS PERCY SILILO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THUFANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THUTO-THEBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TIKHONTELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TIKHUNI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TINHLONHLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "TSHWENYANE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "TSIKI NALEDI ENGLISH MEDIUM SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "UBUHLE BOLWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VEZILWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "VUKUBONE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "VUKUQHAKAZE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VUKUZAME SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VUKUZENZELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "VULINDLELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VUMABESALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "WAVERLEY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "WITBANK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ZB KUNENE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ZACHEUS MALAZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ZENZELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ZIDOBHELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ZIKHETHELENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ZINIKELENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MDZILI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NJEYEZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MKHUTSHWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MARHAGI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HOLEKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MP MAGAGULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ENGABEZWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HLONG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "KADISHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LM KGANANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAKUKE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SEKWAI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PILGRIMS REST CITY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BEE MASEKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "REGGIE MASUKU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MABOTHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "STEENBOK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "DD MABUZA COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LD MOETANALO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAFA MAX MOTLOUNG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "TONTELDOOS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ZIPHAKAMISENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KING MAKHOSONKE II SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "UTHAKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "UPLANDS COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NELSPRUIT PRIVATE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NQOBANGOLWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CEFUPS ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MTIMANDZE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "AMADLELO ALUHLAZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ACEK ACADEMY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NJ MAHLANGU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LEONARD NTSHUNTSHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SABANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ZAKHENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PANORAMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "IDLANGEMABALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIPHUMELELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "JOSEPH MATSEBULA SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MHLUME SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SICELOSETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CHIEF FUNWAKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOTSAOSELE DM SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIPHOKUHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CHIEF C J NKOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PHOLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SHABALALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NDLELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NGAZI NDHLOVU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "CORONATION SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "CAMBRIDGE ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LANGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MACHAYE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MANUKUSE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAWEWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MZILA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NYAMANDE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "XANTHIA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "XIMOYI KHOSA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LEKETE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LETHIPELE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAAKERE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MARIPE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MOHOLOHOLO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "N.P. MATHABELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PULEDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "ALFRED MATSHINE COMMERCIAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BEN MATLOSHE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BEN W MASHEGO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "KELEDI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAKATA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MATHUKWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MOSETERATA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MOSIPA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "RETI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BABINATAU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MADIZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MASINGITANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MHLANGANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MOSES MNISI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PHENDULANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SEHLAKABJE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "THEPANG CHILOANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "TLADISHI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "FREDDY SITHOLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "KUFAKWEZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MASANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MASILELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MKHWEYANTABA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MZANGEDWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NDLAMAKHOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "QOKISO SENOIR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SOSHANGANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "ACORNHOEK ACADEMY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "GERMANS CHILOANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAGWAGWAZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAHASHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAPHUTHADITSHABA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NKOTOBONA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SHOBIYANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HOBO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HOYOHOYO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "JAMES KHOSA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MATHIBELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MCHAKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MOGOROSHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SHANKE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "TAMAJANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "DAYIMANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "DLUMANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "FRANK MAGHINYANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAHLALE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MANYANGANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MDLULI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MUGENA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NYAMAZANE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SOKISI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BAKUTSWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HALEMELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "L.M. MOKOENA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LAMULELANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MALAVUTELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MARCIA MOKOENA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MATHIPE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MMABATHO MOKOENA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "RINDZANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SKAPANDODA MASHABIYA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BUSHBUCKRIDGE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "DIWITI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAGABOTSE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NGWARITSANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "CHAYAZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "DUMISANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "GEZINGQONDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "M.L. NKUNA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MADZUMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAKHOSANA MANZINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MANDONDO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MBHANDULE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MKHUKHUMBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "DITAU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "E.S. MALELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LEHLASEDI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LETSHELE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MMASEKOBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SEKHUKHUSA SENIOR SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SERISHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BOMBANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "ERIC NXUMALO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "GODIDE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAFEMANI NXUMALO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAGIGWANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAHUVO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MALAMULE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NGHUNGHUNYANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MZIMBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "ORHOVELANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BONDZENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BUNNY KHOSA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HLOMANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "IAN MACKENZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LUKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MABARHULE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MADIBA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MADLALA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PHULANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LANGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ROYAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ZIKODZE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NHANYANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PORTIA SHABANGU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MONAREDIRA PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HOEDSPRUIT INDEPENDENT COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HLELIMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MPHUMELOMUHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "HAZYVIEW PRIVATE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KWADELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "ST GEORGE COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EDGEVIEW ACADEMY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "ACORN - OAKS COMPREHENSIVE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NETHERLAND PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "WATERSHED SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "INQUBEKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "UBUHLE BUZILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "F.H. MKHABELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "TLHAVEKISA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "KURHULA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "THE OASIS COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MKHUHLU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PHUZA-ULWAZI ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "DESTINY PRIVATE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "WEM SCHOOL NAAS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "WESLAAN SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "TSWELOPELE SECONDARY SCHOOL (Matla-a-Kitso)"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "EMMANUEL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "GREENPOINT HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "ROODEPAN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "BANKSDRIF SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "FLOORS HIGH SCHOOL NR 2"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "VALSPAN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "NOUPOORT CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "PROTEA HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "KGOMOTSO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "PAMPIERSTAD SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BANKHARA BODULONG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "HOËRSKOOL ALEXANDERBAAI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "PORT NOLLOTH HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "CONCORDIA SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "NABABEEP GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "STEINKOPF SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "OKIEP HOËR SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "HOËRSKOOL NAMAKWALAND"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "SA VAN WYK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "ST ANNA SEKONDÊRE PRIVAATSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "HOËRSKOOL GARIES"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "BRANDVLEI INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "HOËRSKOOL CALVINIA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "HANTAM SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "LOERIESFONTEIN HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "FRASERBURG GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "SUTHERLAND COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "GEKOMBINEERDESKOOL WILLISTON"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "HOËRSKOOL AGGENEYS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "HOËRSKOOL BOESMANLAND"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "UMSO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "ENOCH MTHETHO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "VERITAS SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "ORION SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "HOËRSKOOL THERON"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "HOËRSKOOL DE AAR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "PHAKAMISANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "MONWABISI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "CARNARVON HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "PETRUSVILLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "PHILLIPSTOWN HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "HOËRSKOOL RICHMOND"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "HOËRSKOOL STEYNVILLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "GARIEP HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "KARRIKAMA HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "HOËRSKOOL MARTIN OOSTHUIZEN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "KAKAMAS INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "HOËRSKOOL ORANJEZICHT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "PABALLELO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "SC KEARNS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "HOËRSKOOL UPINGTON"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "SAUL DAMON SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "HOËRSKOOL DUINEVELD"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "AJ FERREIRA SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "CARLTON VAN HEERDEN SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "HOËRSKOOL GROBLERSHOOP"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "RATANG-THUTO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "LANGBERG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "BLINKKLIP SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "HOËRSKOOL POSTMASBURG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "KUILSVILLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "TSHIRELECO SECONDARY PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "FLOORS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "VUYOLWETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "DR EP LEKHELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "ST BONIFACE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "THABANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "TETLANYO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "EMANG MMOGO COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "KIMBERLEY GIRLS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "HOËR TEGNIESE SKOOL KIMBERLEY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "HOËRSKOOL DIAMANTVELD"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "KIMBERLEY BOYS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "HOËRSKOOL NOORD-KAAP"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "HOËRSKOOL ADAMANTIA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "WILLIAM PESCOD SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "RIETVALE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "PESCODIA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "HOMEVALE SECONDARY SCHOOL NR 1"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "REAKANTSWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "BORESETSE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "DIKGATLONG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "MOGOMOTSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "HOËRSKOOL WARRENTON"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GAMAGARA HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "HOËRSKOOL KATHU"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "HOËRSKOOL KALAHARI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "HOËRSKOOL WRENCHVILLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "HOËRSKOOL HARTSWATER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "TLHWAHALANG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "HOËRSKOOL VAALHARTS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BA GA LOTLHARE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "HOËR LANDBOUSKOOL NOORD-KAAPLAND"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "ITOTLENG COMMERCIAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "SEGOPOTSO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MOSHAWENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "RESOLOFETSE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KS SHUPING SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BA-GA PHADIMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BOTHITHONG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "PAKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "NAMETSEGANG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "IKAKANYENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MOEDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KEGOMODITSWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "PITSO JANTJIE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "DIBOTSWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MARUMO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "LESEDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KP TOTO TECHNICAL AND COMMERCIAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MAKGOLOKWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KHIBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "REMMOGO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "LEBANG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "PHAKANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BAITIREDI TECH & COM SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BATLHARO TLHAPING SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GALALETSANG SCIENCE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "REKGARATLHILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "HOËRSKOOL BERGVESTING"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SUNRIDGE CIRCLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MFULENI TECHNICAL ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "FAIRDALE NO.2 HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BOTHASIG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "FISANTEKRAAL NO.2 HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "NEW VREDENBURG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SILVERMINE ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CLAREMONT HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "CEDERBERG ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "NORTHPINE TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "DELFT TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MELKBOS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "FISANTEKRAAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "LOUWVILLE HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SILIKAMVA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "AL-AZHAR HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BRANDVLEI YOUTH CENTRE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "CONCORDIA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "A.Z. BERMAN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SONEIKE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "UMYEZO WAMA APILE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "STONEFOUNTAIN COLLEGE - BELLVILLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "STONEFOUNTAIN COLLEGE - KENILWORTH"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "NOMZAMO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HEATHERLANDS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "PROTEA HEIGHTS ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "THE LEADERSHIP COLLEGE (OBSERVATORY)"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "KINGSWAY COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "JAKES GERWEL TECHNICAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "PROTEA HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ZWELETHEMBA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "SOMERSET HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MOUNTAIN VIEW ACADEMY - MONTE VISTA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "APEX HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "CALLING EDUCATION NPC TRADING AS CALLING ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "BALCO COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "THE ACADEMY HOUT BAY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "KRAAIFONTEIN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "JONGA STREET SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "FAIRDALE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "DELFT HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MITCHELL'S PLAIN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "DIVINE HERITAGE CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BEST COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CURRO FORESHORE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "LAMBERTS BAY HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "CURRO DELFT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PEAK ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "IQRA EDUCATION MANAGEMENT COMPANY NPC T/A IQRA ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BELLVILLE HOËR TEGNIESE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BELLVILLE HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "D.F. MALAN HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "DURBANVILLE HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "EBEN DONGES HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "FAIRMONT HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MONUMENT PARK HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PAROW HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "THE SETTLERS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "TYGERBERG HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "STELLENBERG HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SCOTTSDENE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BELLVILLE-SUID SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "FLORIDA SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BELHAR SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "KASSELSVLEI KOMPREHENSIEWE HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "EXCELSIOR SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "RAVENSMEAD SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SCOTTSVILLE SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SYMPHONY SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BERNADINO HEIGHTS SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PERSEVERANCE SEK"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "IKAMVALETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "LANGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ISILIMELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "KULANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BOSMANSDAM HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "GOODWOOD KOLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "EDGEMEAD HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "FAIRBAIRN COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "J.G. MEIRING HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "PINELANDS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PRESIDENT HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ESANGWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ARCADIA SENIOR SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BEAUVALLON SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BISHOP LAVIS SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BONTEHEUWEL SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ELSIESRIVIER SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ELSWOOD SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "JOHN RAMSAY HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "MODDERDAM SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "RANGE SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "VALHALLA SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ST. ANDREW'S SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ZOLA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MARIAN RC SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HOLY CROSS HIGH SCHOOL (MAITLAND)"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "Y2K COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BLOUBERGRANT SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "CAPE TOWN STUDIES AND TOURS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "OUDE MOLEN HTS."
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GARDENS COMMERCIAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BUREN HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CAPE TOWN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GOOD HOPE SEMINARY HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "JAN VAN RIEBEECK HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MILNERTON HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "QUEENS PARK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SEA POINT HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "TABLE VIEW HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CAMPS BAY HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ZONNEBLOEM NEST SENIOR SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "WALMER SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "TRAFALGAR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HAROLD CRESSY HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "VISTA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SALT RIVER SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MASIBAMBISANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "THEMBELIHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "KENSINGTON SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "MAITLAND HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "WINDERMERE SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "Harry Gwala SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "USASAZO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SINENJONGO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "INKWENKWEZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MUIZENBERG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "OCEAN VIEW SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "FISH HOEK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MASIPHUMELELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ABBOTT'S COLLEGE (CLAREMONT)"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ROSEBANK PROGRESS COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ST. JOSEPH'S COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "LEAP SCIENCE AND MATHS SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "PREMIER COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SILVERSANDS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ORACLE SENIOR SECONDARY SCHOOL (NPC)"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "THANDOKHULU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PELICAN PARK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "RYLANDS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "BERGVLIET HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GROOTE SCHUUR HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "NORMAN HENSHILWOOD HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PLUMSTEAD HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "RHODES HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "RONDEBOSCH BOYS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "RUSTENBURG GIRLS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "S.A. COLLEGE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SANS SOUCI GIRLS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "VOORTREKKER HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "WESTERFORD HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "WINDSOR HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WYNBERG BOYS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WYNBERG GIRLS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ZWAANSWYK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SIBELIUS HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "LIVINGSTONE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SOUTH PENINSULA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "GRASSY PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WITTEBOME HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "OAKLANDS SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "HEATHFIELD HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "STEENBERG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "CRESTWAY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CRYSTAL SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "MOUNT VIEW SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "LAVENDER HILL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WYNBERG SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "FAIRMOUNT SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "GRASSDALE HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ZEEKOEVLEI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HOUTBAAI SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "IMMACULATA RK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ALEXANDER SINTON SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ATHLONE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BELGRAVIA SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BRIDGETOWN SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CATHKIN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GARLANDALE SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GROENVLEI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HEIDEVELD SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "MANENBERG SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "PHOENIX SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "NED DOMAN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "PEAK VIEW SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SPES BONA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SILVERSTREAM SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "CAPE ACADEMY FOR MATHS, SCIENCE AND TECHNOLOGY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "LOTUS SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SOPHUMELELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ZISUKHANYO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PHANDULWAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "CENTRE OF SCIENCE AND TECHNOLOGY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PHILLIPI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "LUHLAZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MATTHEW GONIWE MEMORIAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MASIYILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BULUMKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "JOE SLOVO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SINETHEMBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "INTLANGANISO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "CHRIS HANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "UXOLO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "VUYISEKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SITHEMBELE MATISO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "INTSHUKUMO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "FEZEKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "OSCAR MPETHA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "I. D. MKIZE SEN SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "DR. NELSON R. MANDELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PHAKAMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "KWAMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SIZIMISELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "INTSEBENZISWANO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SIPHAMANDLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "IQHAYIYA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MANYANO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ALOE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "BEACON HILL SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "CEDAR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MONDALE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PORTLAND SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ROCKLANDS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "LENTEGEUR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "STRANDFONTEIN SEKONDER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "TAFELSIG SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SPINE ROAD HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "GLENDALE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WESTRIDGE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WOODLANDS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PRINCETON SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "OVAL NORTH SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "NEW EISLEBEN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SIMUNYE SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BLOEKOMBOS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "LEIDEN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "WALLACEDENE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MFULENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "WESTERN CAPE SPORT SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "HINDLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BARDALE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BRACKENFELL HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "DE KUILEN HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ROSENDAAL SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "HECTOR PETERSON SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "TUSCANY GLEN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "KLEINVLEI SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SAREPTA SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MALIBU SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "VOORBRUG SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "FOREST HEIGHTS HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "EERSTERIVIER SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BLACKHEATH SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "KUILS RIVER TECHNICAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "WEST BANK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MASIBAMBANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BOLAND LANDBOUSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "HOËRSKOOL GIMNASIUM PAARL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "HOËR JONGENSKOOL PAARL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "LA ROCHELLE MEISIES HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "LABORI HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "KLEIN NEDERBURG SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "NEW ORLEANS SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "NOORDER-PAARL SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "PAULUS JOUBERT SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "CHARLESTON HILL SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "KYLEMORE SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "GROENDAL SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "KAYAMANDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BLOEMHOF HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "PAUL ROOS GIMNASIUM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "RHENISH GIRLS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "STELLENBOSCH HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "STELLENZICHT SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "LUCKHOFF SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "CLOETESVILLE HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MAKUPULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "HELDERBERG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SINAKO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "VALSBAAI HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "HOTTENTOTS-HOLLAND HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "PAREL VALLEI HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "GORDON SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MACASSAR SEK"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ZANDVLIET HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MADRASATUR RAJAA STRAND HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "STRAND HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SIMANYENE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "STRAND SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "RUSTHOF SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "KHANYOLWETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "HUGENOTE HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BERGRIVIER SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WELTEVREDE SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WELLINGTON SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "BREDASDORP HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "ALBERT MYBURGH SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "DE VILLIERS GRAAFF HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "OVERBERG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "VILLIERSDORP SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "EMIL WEDER SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "SWARTBERG SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "GROENBERG SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "GANSBAAI ACADEMIA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "HERMANUS HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "HAWSTON SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "QHAYIYA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KAIROS SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "SWELLENDAM HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "SWELLENDAM SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "IMIZAMO YETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "EDEN TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "OUTENIQUA HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "YORK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "GEORGE SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "PACALTSDORP SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "PARKDENE SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "THEMBALETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "PERCY MDALA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KNYSNA HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KNYSNA SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "MURRAY HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "PLETTENBERGBAAI SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "INDWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "PUNT HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "SAO BRAS SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HILLCREST SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "OAKDALE LANDBOUSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "LANGENHOVEN HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "GERRIT DU PLESSIS SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "LADISMITH SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "AURIAL COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "FEZEKILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "LANGENHOVEN GIMNASIUM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "OUDTSHOORN HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "MORESTER SEK"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "BRIDGTON SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "DYSSELSDORP SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "DE RUST SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "IINGCINGA ZETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "CHARLIE HOFMEYR HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "CERES SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BELLA VISTA HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MONTAGU HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ASHTON SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ROBERTSON HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "LANGEBERG SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ROODEZANDT SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WOLSELEY SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "IHLUMELO JUNOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "VUSISIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DESMOND MPILO TUTU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DROSTDY HTS."
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WORCESTER GIMNASIUM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MONTANA HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ESSELENPARK SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BREËRIVIER HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WORCESTER SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DE KRUINE SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "HEXVALLEI SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "SWARTLAND HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "WESBANK SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ATLANTIS SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SAXONSEA SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PROTEUS SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "SCHOONSPRUIT SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ROBINVALE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "ILINGELETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "STEYNVILLE SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "VREDENBURG HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "DIAZVILLE HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "WESTON SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "DIRKIE UYS HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "CLANWILLIAM SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "VREDENDAL HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "VREDENDAL SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "MANDLENKOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "SENTRAAL HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "BEAUFORT-WES SEKONDÊR"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "BASTIAANSE SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "LAINGSBURG HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "MURRAYSBURG HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ZWARTBERG HOËRSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MANZOMTHOMBO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Academy for Christian Education"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Akademie Vir Christelik Volks Eie Onderwys Derby"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ALABAMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Alfred Maubane High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ARE- FADIMEHENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BADIBANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Badumedi Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bafedile Middle school"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bafokeng High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BAITSHOKI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BAKOLOBENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bakwena Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Batleng Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BATLHAPING HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BATLOUNG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BATSWANA COMMERCIAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BETHEL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BODIBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BOGOSING HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Boikagong Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BOITHAOPO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BOITSEANAPE TECHNICAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BOITSHOKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BOITSHOKO MIDDLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RAKGWEDI BOKANG SEC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BOPAGANANG PUBLIC SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BOPHIRIMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BORAKANELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BORE MIDDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BOSCHPOORT COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Botlhabelo High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BOTOKA COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BRAY INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "C. N LEKALAKE MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Charora High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "CHOSENG MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "CHRIS HANI SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "GEKOMBINEERDE SKOOL CHRISTIANA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "COCEKANI COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "HIGH SCHOOL COLIGNY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "COLINDA SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "CVO SCHOOL LICHTENBURG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DANVILLLE SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "DIRANG KA NATLA COMP HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "DITEHO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "EDUCATORS PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Eletsa Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Fields College"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "F.M.RAMABOA COMMERCIAL&TECHNICAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Fumane Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "G.S.PHOI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "GABOBIDIWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Gabonewe Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GABORONE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "GAENTHONE SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GAETSHO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GAKOLOGELWANG MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "GAOPALELWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Gaopotlake Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Gaotime Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Gaseitsiwe High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "GATELAPELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Swartruggens Gekombineerde Skool"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BLOEMHOF GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GEYSDORP SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GOTHATA SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Grenville High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Hendrick Makapan High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Herman Thebe Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "HF Tlou High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "HOËR TEGNIESE SKOOL POTCHEFSTROOM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Hoër Tegniese Skool"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "HOËR VOLKSKOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "HOËRSKOOL SCHWEIZER-RENEKE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bergsig Akademie/Academy"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Hoërskool Brits"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Grenswag Hoërskool"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Hartbeespoort High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Hoërskool Rustenburg"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Die Hoërskool Wagpos"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Holy Family Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "HOËRSKOOL FERDINAND POSTHMA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "HUHUDI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "IKAGELENG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ikaneng High school"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ikatisong Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Iketleetso Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "IKOPANYENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "IPELEGENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ithuteng High school"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "ITSHOLETSENG MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "ITSHUPENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Itumeleng Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "J.M. LEKGETHA COMMERCIAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "JANGJO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "JERRY MAHURA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Jethro Pelle High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "JM Ntsime Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Johane Mokolobetsi Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "JOHN FRYLINCK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "JOSEPH SAKU SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KAGISO BAROLONG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kalafi Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KANANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kele Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Keledi Secondary"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kgalatlowe Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kgamanyane Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kgaphamadi Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kgatsheng-Thabiso Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KGONONYANE SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KGOSI SHOPE GET BAND"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kgosibodiba Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KGOSIETSILE LETHOLA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KGOSITHEBE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Khayalethu Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KISMET COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KITLANANG MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KLERKSDORP SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "HOËRSKOOL KLERKSDORP"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "HOËR TEGNIESE SKOOL KLERKSDORP"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Klipgat Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KOPANELO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KROMELLENBOOG COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KUTLWANO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kwena Tlase Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Langa La Sembo Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LAPOLOGANG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LE-RONA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "N.R.MANDELA COMMERCIAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LERETLETSE-LESEDI SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lerome Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lerothodi High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LERUNTSE-LESEDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LERUNTSE LESEDI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lesele Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LESHOBO MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LETEANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Letlhabile Middle School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Letlape Middle School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LETLHASEDI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LETSATSING SCIENCE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "HOERSKOOL LICHTENBURG"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Loalane High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lobang High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LOFDAL COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lot Mashiane Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAATLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Machadam Combined School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MADIBA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAFIKENG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAJENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOKGOJWA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Makoba Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Makuka Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Malatse Motsepe High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Malefo High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAMORATWA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Manamakgotha Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MANKUROANE TECHNICAL & COMMERCIAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Marikana Combined School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Maruatona Dikobe Secondary"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MARUBISING SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Matale Middle School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Matetenene Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Matlaisane Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MATLHALENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Matlhare Mokautu Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MATLOSANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Matsukubyane Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MATTHEWS MANGOPE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Micha-kgasi Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MILNER HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MMABATHO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MMAJANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmakaunyane Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MMAKGAJE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mamodibo High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmamogwai Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmanape High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmankala Technical And Commercial Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmanotshe Moduane Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MMOLEDI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MMOKENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mochudi Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOCOCE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Modise Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MODISE KANONO MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Moefi Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MOFATLHOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOGAKOLODI-MASIBI COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mogale Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOGAWANE COMMERCIAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOKGAKALA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOKGARENG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Molebatsi Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Molotlegi Middle School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MONCHUSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Morare High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Moratwe Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MORE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MORERI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOSEKAPHOFU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOSIKARE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOTHELESI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOTHIBINYANE SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mothotlung High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Motlhaputseng Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOTSAALORE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOTSEMME SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Motshegoa Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Hebron Technical And Commercial High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Motswatemeng High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOTSWEDI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOTUBA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mphe-Bana High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mphela Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MPOLOKANG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Naauwpoort Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Nchaupe Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "NGOTWANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "NKANG- MAHLALE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Nkobong Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "NOTO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "NTEBOGANG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "NTLATSANG MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "NTLATSENG COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ntolo High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "NTSHIDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Nur Ul Iman Muslim School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "OBANG SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "OGODISENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Olefile Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "HOËRSKOOL ORKNEY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "P H MOEKETSI AGRICULTURAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LODIRILE TSWAING HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "PHAKEDI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "PHAKELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "PHATLHOSO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "PHATSIMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "PHIRI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "PICA PAU COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "PINAGARE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "PITSO LETLHOGILE SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "POELANO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "POTCHEFSTROOM HIGH SCHOOL FOR BOYS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "POTCHEFSTROOM GIMNASIUM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "THE HIGH SCHOOL FOR GIRLS POTCHEFSTROOM"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "POTCHEFSTROOM SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "President Mangope Technical and Commercial High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "PROMOSA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "PUDUMONG HIGH SCHOOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "PULE LEEUW COMPREHENSIVE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Puo-Phaa Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "R.A. KOBUE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rakgatla Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rakoko Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RAMATU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RAMOKONYANE MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RAMOTSHERE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ramotshodi Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Raphurele Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rauwane Sepeng High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "REABONA SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REARABILWE SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REDIBONE MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Reebone Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "REEMEKATHATA MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REGOLOTSWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "REGOROGILE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "REIKAGILE MIDDLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Reipuseng High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "REIVILO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "REIVILO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rekopantswe Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "RELEMOGILE MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "RESOLOFETSE SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rethusegile Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rustenburg Educational College"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "S.C. KGOBOKOE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SAANE MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SAKALENGWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "HOËRSKOOL SANNIESHOF"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "HOËRSKOOL SCHOONSPRUIT"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SEBETWANE SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SEBOPIWA MOLEMA MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sedibelo Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sefutswelo Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "SEIPHEMELO PUBLIC SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SEJANKABO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sekete High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sekitla Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SELEJE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Semetsa Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sempapa Middle School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SEOLESENG MIDDLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SETSWAKGOSING SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SETUMO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sewagodimo Technical And Commercial High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Shadrack F Zibi High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "St Annes High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "ST PAUL`S HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "St Teresa High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "ST MARY`S SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "HOËRSKOOL STELLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "HOëRSKOOL STILFONTEIN"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TASMAN MIDDLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TAU RAPULANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TETLANO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Thaba Morula Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "THABASIKWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "THAKUNG MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "THAPAMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "THATE MOLATLHWA MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Thebe Ya Tlhajwa Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Thethe Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Thulare High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "THUSO-THEBE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "THUSOETSILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "THUTO-BOSWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THUTO KE MAATLA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "THUTO-THEBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "THUTO-TSEBO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tidimane Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TIEGO TAWANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TIGER KLOOF COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TIRAGALO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlhabane Technical & Commercial High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TLHAOLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TLHOAFALO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TLOKWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TLOTLANG -THUTO SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TONG COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TOTONYANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TSAMMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TSELAATHUTO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tshaile Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TSHEBEDISANO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TSHEDIMOSETSO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tshepagalang Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tshomankane Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tshukudu High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tsogo Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tswaidi Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TSWELELOPELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "UTLWANANG BAROLONG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Utsane High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "VAAL REEFS TECHNICAL HIGH"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "VAALOEWER COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "VRYBURG HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "VUYANIMAWETHU PRIMARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "WALTER LETSIE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "HOëRSKOOL WESVALIA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "HOËRSKOOL WOLMARANSSTAD"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "HOËRSKOOL ZEERUST"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Zinniaville Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "ZM SEATLHOLO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Moedwil Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "THUTOLORE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "RADITSHANE MIDDLE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MARUAPULA SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KEBONANG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TSHIPIETSILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Thuto-Pele High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Central Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lighthouse Christian College"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KGOKE LESABE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mojagedi Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAANO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAMPHO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Michael Modisakeng Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MASELWANYANE SEC. SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MADIBOGO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rabboni Christian School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "The Mountain Cambridge School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GAKHUNWANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "AL HUDA MUSLIM COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Selly Park Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REALEKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "ONKABETSE- THUTO"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MMABATHO LIVING FAITH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SOL PLAATJE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "NATANJA PRIVATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "OVERVAAL PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SETLOPO SCIENCE AND COMMERCIAL SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "ONKGOPOTSE TIRO COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "REABETSWE PUBLIC SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "NEW VISION SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REBONEILWE SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Geelhoutpark Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Boitekong Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KOPANELO SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GOLF VIEW COMBINED"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "ZEERUST COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Freedom Park Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAMMUTLA SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "B.A. SEOBI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MAITEMOGELO COMP SEC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Itsoseng Combined School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SEABO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TIRISANO HIGH"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Meriti Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Eagle Christian College"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOLELWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Madiba-A-Toloane Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Zacharia Mankgatleng Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "REKGARATLHILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sunrise View Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Thuto-Kitso Secondary"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "WHITE STONE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Meridian Rustenburg Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "New Covenant Academy"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LICHTENBURG ENGLISH SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SETILO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "CURRO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmadikete Lion Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Diphetogo Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "PRESTIGE SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "JAN MASIBI SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RAMAINA A PHETLHU SECONDARY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SEKATE BOIJANE MAHURA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "NATANJA CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Noble Palms Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Platinum Village Secondary"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REKGONNE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TSHIDI BAROLONG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LETLHOGILE INTERMEDIATE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "CITY OF LIFE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Boitekong II Secondary"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KGOSI KEBALEPILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "NQUNDE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "TSHOLOFELO TECHNICAL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KABELO MASHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MAQUASSI HILLS ENGLISH SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "MOGWASE TECHNICAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "AREAGANENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "ST ATHANASIUS ORTHODOX CHRISTIAN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "KITSONG INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REFENTSE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "LEOKENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "WATERKLOOF HILLS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "MPHEBANA II SECONNDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SABUYAZE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "AJ MWELASE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ABANTUNGWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ABAQULUSI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ALBINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ALEXANDRA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "A.M. MOOLLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "AMADADA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "AMAHLUBI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "AMAKHOLWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "AMANDLA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "AMANDLETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "AMANGWANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "AMANGWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "AMANZIMTOTI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "AMAPHISI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "AMAPHUPHESIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "AMAPHUTHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "AMATIGULU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "AMATSHEZULU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "AMAZABEKO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "AMAZIZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "AMAZULU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "APOLLO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ARENA PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ASANDE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ASIBEMUNYE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ASIPHIKELELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ASOKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "AVOCA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "AVONFORD SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BAGIBILE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BALONDO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BAMBANANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKOSI BAMBAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKOSI BANGANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BANQOBILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ST. LEWIS BERTRAND'S HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BANTUBANINGI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BANZANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BATHEMBU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BATLOKOA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BATSHAZWAYO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BECHET HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BELVERTON SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "BETHAMOYA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BHANDE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BHAQALWESIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BHEKABATHEMBU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BHEKAMANDELU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BHEKATHINA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BHEKESHOWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BHEKIFA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BHEKIKUSASA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BHEKINDLELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PRINCE BHEKINTINTA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BHEKINTUTHUKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BHEKISISA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BHEKUXIMBA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BHEVULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BHILIBANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PRINCE BHOKWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BHUKWANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BHUNGANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "INKOSI USISHAKUZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BIZIMALI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BONELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BONGINHLANHLA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BONGOKUHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BONGUDUNGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BONGUZWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BONOKUHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BRETTONWOOD HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BRINDHAVAN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BUFFELSDALE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BUHLEBETHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "BUHLEBOMZINYATHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BUHLEBUYEZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BUKIMVELO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BUNYEBETHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BUSANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BUTHATHUBUNYE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "CABANGOKUHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "CACAMEZELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "CANDABUTHULE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "CARL MALCOMESS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CARTER HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "CEBISA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "CELUMUSA SEC. SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CENTENARY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "CENTOCOW HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "CHARLES HLENGWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CHARLES SABELO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CHATSWORTH SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CHESTERVILLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CLAIRWOOD SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CROSSMOOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CRYSTAL POINT SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "CWAKEME SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DABEKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DALEVIEW SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DANVILLE PARK GIRLS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DARNALL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DASSEHOEK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "DEDANGIFUNDE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DICK NDLOVU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "DIKANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DILIZELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "DINGEKA TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "DINGUKWAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DURBAN ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DLABESUTHE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "DLAMVUZO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "DLANGEZWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "DLEMUDLEMU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DLOKO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "DONDOTHA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DR A.D.LAZARUS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DR NEMBULA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "DRAKENSBERG COMPREHENSIVE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "DRAKENSBERG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DUBANDLELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "DUCK PONDS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "DUMABEZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "DUMEZWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DUMEHLEZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MATAMZANA-DUBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "Dundee High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DUNDEE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "DUNVERIA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "HUNT ROAD SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Durban Girls' High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DURBAN GIRLS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DURBAN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DWALALESIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "DWALENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "DWENGU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EARLINGTON SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EASTBURY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "Eastwood Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EDENDALE TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CHRISTIAN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EFFINGHAM SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EKUCABANGENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EKUDUBEKENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EKUPHELENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EKUPHOLENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EKWALUSENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EKWAZINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ELANGENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ELWAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMANONO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMBETHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMBIZENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EMBIZWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "EMFUNDWENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMHLWANENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EMINYEZANENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMKHOMBE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMONDINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMOYENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMPANGENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMPILWENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMTHONJENIWOLWAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EKUKHULENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMTHULASIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMTHUNGWENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMTSHEZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EMZAMWENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ENALENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENCUTSHINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ENDAKANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ENDLOVUKAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ENGQONDWENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENHLANGWINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENTEMBENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ENTONJENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EQAKWINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ESHOWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ESIKHUMBUZWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ESIPHONDWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ESIQHOQHWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ESIQIWINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ESOKHENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ESTCOURT HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ESTCOURT SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ESTCOURT SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ESTHER PAYNE SMITH SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EZAKHELENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EZAKHENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EZIBUKWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EZIFUNDENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EZIGQIZWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EZINQOLENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EZITHABENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EZWENILETHU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Fairvale Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "FALAZA COMPREHENSIVE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "Ferrum High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "FILIDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "FOLWENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "FORESTHAVEN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "FUNDOKUHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "FUNDOKUHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "FUNDUKHALIPHE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "FUNULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "FUNUNDU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GABANGEZWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ECEKEZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "GABIGABI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GAJU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GALENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GAMALAKHE COMMERCIAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GANGES SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GAWOZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GCEWU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "GCINIMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "GCOTOI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GELEKEDLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GEORGE CAMPBELL TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GEORGETOWN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GIJIMANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "GLENHAVEN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GLENOVER SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GLENWOOD HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GOBINDLOVU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GOBIZEMBE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GOBUME HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GODIDE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "GODLOZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "GORDON MEMORIAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GQOKINSIMBI COMPREHENSIVE TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GQOKUBUKHOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "GREENBURY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "GREYTOWN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GROSVENOR BOYS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GROSVENOR GIRLS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "GROUTVILLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "GROVE-END SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GUDU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GUGULESIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "HAFULENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HAMBANGENDLELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "HAMBISANANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "HAMILTON MAKHANYA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HAMU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GOLOZELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "HARVEST COMBINED SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HAVENPARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HAYTHORNE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HEATHER SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HESHE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HILLCREST HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "HILLGROVE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HILTON COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HLAHLINDLELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "HLAKANIPHANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "HLALANATHI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "HLAMVANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "HLANGABEZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HLANGANANIMAZULU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "HLATHIKHULU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "HLENGIWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "HLOKOZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "HLONIPHANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "HLONONO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "HLUBI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "HLUMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "Howick High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HOWICK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "HOYE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LENEHA-TUMISI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HUBA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "IDLAMADODA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "IGAGASI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "IHAWULETHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "IKHETHELO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "IKUSASALETHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ILANGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "IMBEKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "IMBILANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "IMPALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "IMPANDE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "IMPIYAMANDLA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "IMPOLWANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "IMPOQABULUNGU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "IMPUMELELO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "IMPUNGA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "IMVUNULO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INANDA NEWTOWN COMPREHENSIVE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KHETHOKUHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NHLANHLAYETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INANDA SEMINARY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "IKHWEZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "INCAPHAYI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INCINJANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "INDLOZANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "INDONSA TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "INDUKWENTSHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "IDUNDUBALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "INGABADE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "INGOBAMAKHOSI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INGQAYIZIVELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INGQUNGQULU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INGQWANGELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INGULA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "INGWAVUMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INGWEMABALA COMPREHENSIVE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INHLAKANIPHO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INHLANHLAYABEBHUZE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "INHLOKOZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INJOLOBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INKAMANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INKUMANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INQOLOBANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INSIKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INTANDOYESIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INTSHISEKELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INYONEMHLOPHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "INZULULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ISIBANISEZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ISIBONELO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ISIBUKO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ISIBUKOSEZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ISICELOSETHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ISIFISOSETHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ISIHLAHLASENKOSI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ISIKHALASENKOSI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ISIKHALISEZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ISIKHWEBEZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ISINAMUVA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ISINYABUSI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ISIPHEPHELO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ISIPHOSETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ISIPINGO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ISISUSA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ISIZINDA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ISMONT HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ISOLEMAMBA HIGH SCHOOL."
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ISOLESIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ISOLOMUZI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ITHALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ITSHOBHANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "IVUNA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "IVUNGU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "IXOPO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "J E NDLOVU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "JAJILE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "JAMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "JAMES NXUMALO AGRICULTURAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "IGUGULESIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "JOBE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "JOHN ROSS COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "JOLWAYO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "JONASE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KANYEKANYE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KEARSNEY COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KHABAZELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KHAMANGWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KHANDALESIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KHANDIMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THOLULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KHANYA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KHANYANJALO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KHANYISA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KHANYISELUZULU SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KHARINA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KHARWASTAN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KHATHI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KHAYELIHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KHETHIMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KHOMBINDLELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KHOZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KHULA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KHULUMELUZULU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KING BHEKUZULU COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KING CETSHWAYO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KING DINUZULU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KINGSWAY HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KITAKITA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "DR JOSEPH SHABALALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "Kloof High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KOKSTAD COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KRANSKOP HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KUFANELESIBONGE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KUFEZEKILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KUHLEKONKE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWAGXABA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWAJABULA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWANXUSA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KWABAZOTHINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWA-BHAVU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWABULAWAYO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BUHLEBEMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWADENGE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KWADLAMINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWADOMBA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWAFICA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWAGIBA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWA HLUZINGQONDO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KWAMAKHUTHA COMPREHENSIVE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWAMASOSHA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KWAMATHANDA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KWAMGAGA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KWAMNCANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAMNYAYIZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "IKUSASELIHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KWAMVIMBELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAMZIWENTSHA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KWANDUNGE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWANOTSHELWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KWANTATSHANA PUBLIC SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KWANTEBENI COMPREHENSIVE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KWAPATA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KWAPHAYIKENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWAPHIKAZIWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWASA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KWASANTI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KING SHAKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KWATHATHANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KWAVUSUMUZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KWAZENZELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAZWIDE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KWESETHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DR. J.L. DUBE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "LADUMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "LADYSMITH HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "LADYSMITH SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "LAKEHAVEN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "LAMONTVILLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LANDOKWAKHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "LANGALAKHE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "LANGALIBOMVU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LANGAZELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "LANGELIHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "LENAREA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "LENGOLA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "LENKASI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "LETHUXOLO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "LIFALETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "LIHLITHEMBA TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "LIMEHILL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "LINCOLN HEIGHTS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "LINDINKOSI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "LINPARK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "LOCKHAT HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "LUGAJU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "LUGOBE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "LUKHASA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "LUPHAPHE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "LUSHABA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LUSIBALUKHULU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LUSWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "LUTHANDO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "LUTHAYI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "LUTHULI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "M.L SULTAN GLENCOE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "M.L. SULTAN (PMB) SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MABANDLENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MABAYANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MABIZELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MABUTHELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MACAPHUNA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MACHANCA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MADLANYOKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MADUDULA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MADWALENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MAFAHLENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MAFU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MAFUMBUKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAFUNDA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAGQAMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAGUBULUNDU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MAGUDWINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAGUTSHWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MAGWABABA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MAHELANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAHLABATHINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MAHLAHLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MAHLUBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MAKHANDA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAKHASA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAKHEDAMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAKHOSONKE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MAKHUMBUZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MALABELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MALAMBULE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MALANDELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MANDADLA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MANDLENKOSI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MANDLEZIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MANGCENGEZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MANGENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MANGQUZUKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MANGWAZANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MANKAYANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MANQAMU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MANXELE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MANZIMHLOPHE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MAPHINDA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAPHOVELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAQHINGA MEMORIAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAQHINGENDODA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MAQOQA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MARBURG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MARGOT FONTEYN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MARIANNHILL SECONDARY INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MARITZBURG COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MARKLANDS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MASAKHANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MASHALAZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MASHANANDANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MASHINGA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MASHINGIZELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MASHIYAMAHLE H. SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MASHUSHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MASIBHEKANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MASIBONISANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MASIBUMBANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MASIJABULE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MASIMDUMISE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MATATANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MATHOLAMNYAMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MATHOLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MATHUBESIZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MATHUNJWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MATSHITSHOLO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAVELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MAVUMBUKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAVUMENGWANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAVUSO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAWENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAWOMBE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MAYIYANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MAYIZEKANYE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MAZWENDODA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MASHESHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MBAMBANGALO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MBAMBANGWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MBAMBI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MBATSHAZWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MBHEKWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MBHEKAPHANSI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MBIZWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MBONGENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MBONWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MBOPHA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MBUSI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MBUSOWABATHETHWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MBUYISELO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MBUYISENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MCABANGO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MCHITHEKI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MCONJWANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MCOSELELI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MCOTHOYI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MDEPHA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MDINGI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MDLADLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MDLANGASWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MDLANGATHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MDONSWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MDUKU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MDULASHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MDUMELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MDUMISENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MEADOWLANDS TECHNICAL HIGH SCHOOL."
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MDUNGANDLOVU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MEHLOKAZULU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MEHLOKUBHEKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MEHLOMLUNGU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MENYEZWAYO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MENZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MEREBANK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MEVAMHLOPHE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MEYAMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MFINYELI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MGAMULE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MGANDENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MGAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MGEZENI TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MGIDLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MGITSHWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MGUDLWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MGWAZENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MHAWU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MHLAKOTHI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MHLAMBANSILA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MHLANGEZULU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MHLUPHEKI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MHUBHENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MJELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MJINDI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "IGUGULABASHA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MKHALIPHI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MKHOBENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MKHOMBISI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MKHONTO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MLANDOWETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MLOKOTHWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MLOMOKAZULU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MLONDE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MLUNGISI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MMEMEZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MMISO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MNGANIWAKHE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MNQANDI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MNTANENKOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MNTONJANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MUNTONOKUDLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MNTWANUNGAMIZIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MNYAKANYA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MNYAMANA MEMORIAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MNYAMANDE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MNYAMENI ZENEX SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MONDLO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MONTARENA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MOSES ZIKHALI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "Mt Currie Senior Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MOUNTVIEW SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MOWAT PARK HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MPANDE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MPEPHOSE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MPHAHLENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MPHELANDABA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MPHEMBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PRINCE MPIKANINA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MPIKAYIZEKANYE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MPINDISO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MPIYAKHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MPOFINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MPOLWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MPOPHOMENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MPUNGAMHLOPHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MQAMATHI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MQEDANDABA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MQHAKAMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MQHAWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MQINISENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MSHANELOWESIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MSHANGUZANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MSHIYANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MSHWESHWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MSIMBU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MSIMUDE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MSINGA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MSIYANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MTHENDESECONDARYSCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MTHENGENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MTHIYAQHWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MTHOLANGQONDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MTHOMBOWESIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MTHONGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MTHUNZIWOXOLO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MTHUSI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MTSHAKELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MTSHEKULA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MTUMASELI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MTHUNZINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MTHWALUME HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MUNDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MUNTU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MUZIKAWUTHANDWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MUZIWENGQONDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MUZIWEPHAHLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MUZOKHANYAYO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MVABA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MVUTHULUKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MVUTSHINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MVUZINI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MYEKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MZAMO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MZILANKATHA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MZINGEZWI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MZIWAMANDLA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MZIWETHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MZONIWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MZUVELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NAMANENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NATHANIEL SABELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ST CHAD'S HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NCIYA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MLOTSHWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NCOMANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NDABAKAZIBUZWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NDABEZIPHEZULU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NDABISEKHAYA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PRINCE NDABUKO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NDALELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NDAMKANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NDELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NDENGETHO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NDESHENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NDEYA-ZENEX SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NDIMANDE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NDLABEYILANDULA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NDLANGAMANDLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NDLOLOTHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NDLONGOLWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NDLOVANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NDLUYESILO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NDONDAKUSUKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NDUKWENHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NDUMO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NETHEZEKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NEW FOREST HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ST. JOSEPH'S SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NEW WEST SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "NEWCASTLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NEWHAVEN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NEWLANDS EAST SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGALI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NGANGEZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NGAZINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NGCEDOMHLOPHE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NGCONGANGCONGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NGCOLOSI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CONGCO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NGCONGCOSI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NGEBEZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGEBHUZANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NGIBONGELENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NGONO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NGONYAMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGOTSHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NGOZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGQENGELELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NGQOKWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NGUNGWINI S.S. SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NGWEKAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NGWENYA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NHLALAKAHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NHLAMBANYATHI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NHLANHLAYETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NHLATHIMBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NHLIZIYO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "NHLOSOKUHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NHLOYANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NHLUNGWANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NJINGILI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NJUBANJUBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NKALAKUTHABA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NKANDLA TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NKANYISO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THANDULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NKODIBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NKONKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NKOSANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NKOSIBOMVU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NKOSINATHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NKOSITHANDILE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NKOWANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NKWENKWEZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NOBAMBA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NOBIYA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NOBOMI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NODINEKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NOGIDA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NOGUNJWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NOKHALELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NOKWEJA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NOMAFU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UMZIKAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NOMATHIYA TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NOMAVIMBELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ISULOMPHAKATHI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NOMAZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NOMBIKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NOMBUSO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NOMYACA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NOMZIMANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NOMZINTO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NONDENISA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NONDUMISO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NOMDUMO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NONGAMLANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NONGWELEZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NONHLEVU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NONKWENKWANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NORTHBURY PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NORTHLANDS GIRLS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NORTHMEAD SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Northwood School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NOTHANDO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NQABAKAZULU COMPREHENSIVE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NQABAYEMBUBE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NQAKATHELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NQUMIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NSABEKHULUMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NSALAMANGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NSIKAKAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NSIKAYENDLU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NSONGENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTABANTUZUMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NTABASUKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NTABENDE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NTABINAMAFUTHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTALANTALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NTAMINEMIDWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NTATHAKUSA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NTEE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTONGANDE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "THEO-HLALANATHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NTSINDE COMMERCIAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NTWASAHLOBO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NTWENHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NWABI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NYONITHWELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NYONIYEZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NZUZA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "OBUKA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "OGWINI COMPREHENSIVE TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "OKUMHLOPHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "OLD MILL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "OLWANDLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ONGOYE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "OPHOFINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "OPHONGOLO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "OSIZWENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "OUR LADY OF THE ROSARY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "OVERPORT SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "P R PATHER SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PALMVIEW SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PARKHILL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "PHAKATHWAYO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PHAMBILI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "PHATHAKAHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "PHATHIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PHATHWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "PHAYIPHINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PHEMBELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PHEMBISIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "PHENDUKANI FULL SERVICE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "PHEZUKOMKHONO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PHEZULU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PHIKWASE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PHINDAVELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PHINDIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "PHINDOKUHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PHINDULIMI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "PHIWAMANDLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BROOKDALE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "TRENANCE MANOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PHOENIX SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "PHOLELA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "PHOWENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PHUMANYOVA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PHUMOSIZINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "PHUMULANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KING PHUMZUZULU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "PHUNGAZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "PIETERMARITZBURG GIRLS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PINETOWN BOYS' HIGH SCHOOL 2017"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PINETOWN GIRLS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HOËRSKOOL PIONIER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NILGIRI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PORT SHEPSTONE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PORT SHEPSTONE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PRINCE MNYAYIZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PRINCE SILWANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PROTEA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "QALAKAHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "QANTAYI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "QHAKAZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "QHAMUKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "QHILIKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "QHINQA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "QHOZO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "QHUBINYATHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "QIKO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "QINISANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "QONDINDLELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "QOPHINDLELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "QOQISIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "QOQULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "QUEENSBURGH HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Queensburgh Girls' High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "QWABE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "RAISETHORPE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "RESERVOIR HILLS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "REUNION SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "RICHARDS BAY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "HOËRSKOOL RICHARDSBAAI"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "RIDGE PARK COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "RISECLIFF SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "RIVERDENE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ROSEVILLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ROSSBURGH HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "RUSSELL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "RYDAL PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "DR. S. J. BALOYI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SABELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SACRED HEART SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SAHLUMBE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SAKHELWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SAKHISENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SAKHISIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SAPHUMULA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "HOËRSKOOL SAREL CILLIERS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SASTRI COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SASTRI PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIBEKEZELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SCOTTBURGH HIGH SCHOOL - 2017"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SEA COW LAKE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SEBENZAKANZIMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SEBENZAKUSAKHANYA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SEKETHWAYO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SEKUSILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SENZAKAHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SENZAKAHLE JUNOIR SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KING SENZANGAKHONA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SENZOSABASHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SESIYABONGA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NORTH COAST AGRICULTURAL COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SHALLCROSS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SHAYABANTU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SHAYINA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SHEKEMBULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SHENGEZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SHIBILIKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SHIYANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SHUMAYELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MASIBAMBANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIBANESIHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIBANISAKHE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIBHAKUZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIBHAMU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIBONGIMFUNDO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIBONGUMFEKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIBONGUMUSA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIBONOKUHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIBUMBENE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SIBUSISIWE COMPREHENSIVE TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIBUSISO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIBUYILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SICELOKUHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SICELUKUKHANYA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SIDELILE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIGQAMISE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIGWEJE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIKANISWENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SIKHETHUXOLO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIKHULILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIKHULULIWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SIKHUTHELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SIKHWAMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SILINDOKUHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SILVER HEIGHTS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIMINZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SIMUNYE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SINGELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SINKONKONKO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SINQOBILE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIPHAPHEME HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SIPHEPHELE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIPHEPHILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SIPHESIHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SIPHESIHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIPHIMFUNDO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SIPHINHLANHLA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SIPHIWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIPHOKUHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIPHOSABADLETSHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIPHOSINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIPHOSO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIQALUKUBONA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SIQHOZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIQONGWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SISEBENZILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SISHOSONKE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SITHABILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SITHANDUXOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SITHEKU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SITHENGILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SITHOKOZILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SITHOLINHLANHLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SITHUTHUKILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SIVANADA TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIVELILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIVUKILE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SIYABONGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIYABONGA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIYAHLOMULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SIYAJABULA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIYALUNGELWA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIYAMUKELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIYANDA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIYANGEMPUMELELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIYAPHAKAMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIYAPHAMBILI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SIYAPHUMULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIYAQALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SIYATHUTHUKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIYAZAMA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIYELULAMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIZAKAHLE PUBLIC SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIZANANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIZATHINA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIZIMELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SIZISIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIZOPHUMELELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SKOFILL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SMERO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SOBABILI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SOBANTU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SOBONAKHONA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SOGADUZELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PRINCE SOJIYISA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SOKESIMBONE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SOLVISTA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SOMASHI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SOMFULA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SOMILE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SOMSHOKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SONYONGWANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SOTOBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THE RACING AND EQUESTRIAN ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SOUTHLANDSSECONDARYSCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SOZABE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SOZAMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SPARKS ESTATE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SPRINGLAKE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THUTHUKISA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ST JAMES COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ST OSWALDS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ST VICTOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "STANGER HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "STANGER M.L. SULTAN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "STANGER MANOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "STANGER SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "STANGER SOUTH SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "STANMORE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "STAR OF THE SEA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "STEADVILLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SITHOKOZILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "STRELITZIA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SUKAMUVA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SUKUMA COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SULEMAN PATEL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SUNNYDALE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SWAYIMANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SWELIHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "TABHANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "TEMPLE VALLEY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THABELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "THALANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THANDAZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "THANDUYISE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "THATHUNYAWO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "THEKELISULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "THELAMUVA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "THEMBALENTSHA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THEMBELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "THEMBUZULU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "THOBIGUNYA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THOKOZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THOKOZAMNGANGA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THOKOZWAYO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "THOLIMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THOLITHEMBA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "THOLOKUHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THOLUKUKHANYA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ZIMISELENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "THONGWANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THUBALETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "THUBELIHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "THUKELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "THULASIBONE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THULWANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "TISAND TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PRINCE TOKOTOKO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "TONGAAT SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "TRENANCE PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "TSHANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKOSI TSHANIBEZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "TSHELAMANZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "TSHELENKOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "TSHUTSHUTSHU SEC. SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "TUGELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UBAMBISWANO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "UBUHLEBESIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "UDUMO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "OHLANGE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "UKHAHLAMBA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "UKHALI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UKUSA SENOIR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "UKUTHULA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKOSI UMBANGO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "UMBELEBELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Umbilo Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UMBIYA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "UMBONJE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UMDLAMFE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "UMFOLOZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "UMFOLOZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "UMHLOLUTHINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "UMKHUMBI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "UMKOMAAS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Umlazi Commercial High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Umlazi COMTECH HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Umlazi SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "UMLULAMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UMQHELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UMTAPHO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "UMTHENTE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "UMTHOMBO SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "UMTHOQOTHO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "UMVOTI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "UMZINTO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GEORGE MBHELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "UMZWANGEDWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "UNOBHALA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UPHINDO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "UQWEQWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BUSEKHAYA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "USIZO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "UXOLO NOKUZWANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UYAYA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UYENGO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "UYIKHULU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "VELABAHLEKE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "VELAMUVA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "VELANGAYE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "VELANGEZWI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "VELAPHANSI H. SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "VELAPHI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "VERULAM SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "VIKINGOZI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HOëRSKOOL VOORTREKKER"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VRYHEID COMPREHENSIVE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "Hoërskool Vryheid High School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HOËR LANDBOUSKOOL VRYHEID"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "VUKANI -BANTWANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VUKANIMAZULU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "VUKASEKUSILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "VUKILE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VUKUZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "VUKUZAKHE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "VUMANDABA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "VUMELETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "VUYISWA MTOLO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WATERLOO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "WELABASHA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "WELBEDENE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "WEMBEZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Wentworth Secondary School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "WESTCLIFF SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WESTHAM SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "WESTON AGRICULTURAL COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WESTVILLE BOYS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WESTVILLE GILRS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "WETSIE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "WINDSOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "WINGEN HEIGHTS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "WITTEKLIP SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "WOODHURST SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "WOODLANDS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WOODVIEW SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "WOSIYANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WOZAMOYA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WYEBANK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "XOLANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "YAMELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "YANGUYE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ZAKHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ZAKHEKAHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ZAMAKAHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZAMANGOTHANDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ZAMAZULU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ZANDLAZETHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ZANKOSHENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZASHUKE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ZENZELENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ZEPH DHLOMO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ZEPHANIA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ZIBAMBELENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PRINCE ZIBHEBHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ZIBONELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ZIBUKEZULU TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ZIFIKELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ZIKODE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ZIMEME HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ZINDLALELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ZINQOBELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ZIPHAKAMISENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ZIPHATHELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ZIPHEMBELENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ZIPHOZONKE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ZITHOKOZISE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PRINCE ZITHUME HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ZOMBANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ZOMBIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ZONYAMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ZUZICEBO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ZUZULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ZUZUMQHELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ZWELETHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ZWELIBANZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ZWELIHLE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ZWELITHINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZWELONKE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HILLVIEW SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SIKHONJWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MAGQIBAGQIBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "UKUKHANYAKWEZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MANZINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "PHUZULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "UZWANO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KHONDLO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MUZIWESIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "TATANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NKONZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "HLABANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NJEZA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THUBELISHA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MDOLOMBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWABHANYA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THOLIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MPHATHESITHA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KHOBONGO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "FUNDINDUKU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MASAKHANENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ADAMS COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MATHINTA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ZWELINJANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ST. JULIUS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MAQHUTSHANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BHEKUKWAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GCWALULWAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KHANYISELISIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAJIYA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MNINGI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NKOSIKAYINGANGATHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SHIYINKOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIBONGASONKE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIZAKAHLE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UMPHEZENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "VEZOBALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ZENZELENI MASHAMASE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MNCINDO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ALBERT SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "DLANGANI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MASAMENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MAVANGANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "RALPHHARDINGHAM HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NTABANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SOMELULWAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MTHIMUDE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SIHAYO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "AMAZONDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MLOYISWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "QHOBO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MABHIDLA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAZONKE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ZICOLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NQAMANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SENZELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWABAMBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MSHUDU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MALOBENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MANHLENGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NYAMANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MANKENKE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MADLAKA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NHLANHLIVELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "QOSHAMA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ISIVUNGUVUNGU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NTSHINGWAYO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INTONGA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "VULAKWENILE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "AMANDLETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "JIKIJELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "JUSTICE NXUMALO TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ESIGEDENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NQOBIZITHA COMMERCIAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ZIZAMELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MATHEKU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NOMAQONI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LETHUKUHLAKANIPHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MSUNDUZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INDALA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "THANDAYIPHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "IMBALI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MATOMELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SUKASAMBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MLINGO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MANDLOSUTHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EZINHLABENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GWEBUSHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ZAMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NOMASWAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KHABA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MCUSHWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMKHAYIDENI TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PHANGIFA COMTECH HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "FRANKLIN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MADLANGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NOGABISELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ISANDLWANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIHUBELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "AQUADENE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BONGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MFANISO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "GILONKI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GALA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "HHASHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "BANGUNI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "LETHITHEMBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "IMBUYISELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "UBONGUMENZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BHAMU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAGQEZULANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SENZOKUHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MATHANGETSHITSHI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "VEZUBUHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "GINYANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MHLABUHLANGENE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MTHALENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INKOSI UMDIBANISO COMPREHENSIVE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "DINGIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SINEVUSO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "THOMAS MBHELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KHETHUKUTHULA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "THEMBUNYAWO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NDLELANHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SENZOKWETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "GIJIMANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SINENHLANHLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MZOBANZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MQUNGEBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "INKONJANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MANGCENGEZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MTHULI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MASOYI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MZIMELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THORNWOOD SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SILETHUKUKHANYA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NOQANDELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "CHARLESTOWN HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ROBERT HLONGWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SANDLASENKOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ZWILENKOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MANTINTI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SIBONGINHLANHLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NTABABOMVU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MATHUKULULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MARITZBURG MUSLIM SCHOOL FOR GIRLS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NQOBIZAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MASIPHULA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GQOKAMANDLA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NDUKENDE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "LIZWI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NOJU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MANDLAKAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MACEBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "UMHLAHLANDLELA JS"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "POTSHINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "UBULINGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MTSHELEKWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "JEVU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIKHIYE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MTHANTI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NTABABUSUKU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ISIPHOSEMVELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "THOLISU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "HLAZAZANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LANGA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MBHEKI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THINTWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SILOKOZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MASHOBANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "HLOPHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKOSI UTATAZELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SINOMUSA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DUMANE COMMERCIAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MANABA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "CHIEF NGONYAMA TECHNICAL SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "PHAKATHWAYO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "UKUZAMAKWETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAGWEGWANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NDABAZAMANINA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MALUSI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BHEKI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MTHINGANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "PHUZUKUBONA PUBLIC SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MQULELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LESHMAN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NSIKAYETHU COMPREHENSIVE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MSIMBITHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MANQOBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MALANGENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BEKEZELANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "WIGGINS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BHAMU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MANDLAKHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CRAWFORD COLLEGE LA LUCIA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "GAMULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SANYWANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SIYANDA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "KHETHUKUTHULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ENKOMOKAZINI TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MAYVILLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UXOLOPHAMBILI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAGEMFANE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SITHEMBINHLANHLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NHLANGE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "FELIFA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "OAKRIDGE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BHAMBATHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BATSHAZWAYO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ESIZIBENI COMPREHENSIVE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "UMKHUMBANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIPHOSETHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "COPESVILLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIZATHINA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MERLEWOOD SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIZABONKE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAZIPHETHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "JOKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ENHLANHLENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BHEKISIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EBRAHIM LOCKHAT SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "UMZILIKAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EMGANGENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UMKHOSI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MJABULISENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ZIMELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DUDUZILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "USETHUBENI YOUTH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MANDLEMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "J. G. ZUMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DUMAPHANSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MHLWAZINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MPUMELELO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MABASO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAHLOKOHLOKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MTHONJANENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "CLYDESDALE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "DRC SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "DUMAKUDE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMAUS SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ENGWAQA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ENTSIKENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "GINYIQHINGA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "IBISI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "JOZANA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LADAM SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LOURDES HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MABANDLA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MSUDUKENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MTHWANE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NOMPUMELELO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "RIETVLEI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SINGISI COMP TECH HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KHAILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZWELINZIMA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EBUNGUNI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIBUTHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MARGATE MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ICESA MATRIC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "IZAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "PHUMELELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MHAYISE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MTHAMBALALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "IMPALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "LUBELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MZIBULI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "PHUMLANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ZAMINTUTHUKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ZIMELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIYAKHULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "HHOYE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MVUZOMUHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMTSHIBENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PORTSHEPSTONE INTERNATIONAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "AFRICAN VISION SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KHULANGOLWAZI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DUMISANI MAKHAYE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "INKOSI ALBERT LUTHULI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WESTMEAD SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "DLILANGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MTUBATUBA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NKOMBOSE HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "GUZANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KWANGOZA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "UMVUZO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "WESBURY COLLEGE OF SCIENCE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ISLAMIC DAWAH COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZANGATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BHEVU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SITHANDIMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KHINDI JOBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "PHUTHINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MASIBONGE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ENKANGALA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "QEDIPHIKA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MVALO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "GOODHOME SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PRINCESS LANGAZANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIYAPHAMBILI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NKANYISO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "LUBHOKO HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "TSHANIBEZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAJUBA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MACINGWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BHEKABANTU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SAKHISIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LBZ BUTHELEZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SIYABONGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "KADWA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "INDAWANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "INTUITION COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DURBAN MATRIC AND FET ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BIRDSWOOD SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SHAYAMOYA AREA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ANCHORLITE COLLEGE SA"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "VUMA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "RICHEM SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NHLOKWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THABANI ISAAC GASA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DESTINY LIFE ACADEMY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ISIBANI ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DURBAN COMMERCIAL COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BIRDSVIEW ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NKOMOSE COMPREHENSIVE HGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MZWANDILE MBONGWA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ST JOHN PAUL II HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "AMAKHUZE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ERIC MTSHALI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MARTIN NXUMALO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "THEMBALETHU H"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "QALAKABUSHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NTULABAKAYISE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "UJIKELELE HIGH"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KHANYISA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "IKUSASALENTSHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "EKUSENI SECONDARY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INHLOSENHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THOLIMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SIZWE-SITHOLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DLULUMUZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "OBED MLABA TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "VUMANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SIKULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MANDLA MTHETHWA COMP HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "UMINATHI COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ULOVU HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EHAWINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIDINGIMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CURRO HILCREST HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NSIMBINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWAMBONAMBI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "INKOSI ZWELAKHE NGWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "St. THOMAS RESIDENTIAL COLLEGE - KOKSTAD"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ONDINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SINOTHANDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIPHUMELELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMADUNGENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "HIGH PERFORMANCE ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LIFE CHANGING CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ANTON LEMBEDE MATHEMATIC SCIENCE AND TECHNOLOGY ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SICEBENGOLWAZI S"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GRACE COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EPWORTH SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "LINDOKUHLE ACADERMY OF LEARNING"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ICESA MATRIC"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INTUITION COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "OXFORD INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MICHAELHOUSE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "TREVERTON COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ST ANNES COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NDIDAKHABAZELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "Victory Leadership Senior Academy"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GADRA MATRIC SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ST ANDREW'S COLLEGE"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "THE GEM PROJECT YOUTH ACADEMY"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "Amathole West",
      "School_Name": "City of Light Private School"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "AMITEK BUSINESS HIGH SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "OR TAMBO COASTAL",
      "School_Name": "LUZUKOLWAKHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "SECONDARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "CRADOCK CORRECTIONAL CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "IMPUCUKO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "THABANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "UTOPIA PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "ARRAN PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "DIHLABENG CHRISTIAN PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "HELENA SLABBERTS PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MOTSHEPUWA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "IMPUMELELO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "REABOKA PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "DUIKFONTEIN PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MATSWATHAKA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "YEDDO PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BOHLOKWA PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "NTHUTE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TOKOLOHO PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SEKOKO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "DIPELANENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SPITSKRANS PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LOCH LOMOND PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BOHLOKONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "CLARENS P/S (Town)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "GRAANVELD P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "JORDANIA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TRUIDA KESTELL P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "SPRINGFONTEIN P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "LEPHOI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "WILLIAMSVILLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LESEDI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "WILLIAMSTRIP PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ARBEIDSGENOT PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MABOLELA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SEMAJAN PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "DALUXOLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TEBELELO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KGATO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KGABANE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TSHOLOHELO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "NZAME P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TOKA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ST MARY'S P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MABOLOKA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BLOEMFONTEIN-OOS P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BOCHABELA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MARANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BOTLEHADI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "RELEBELETSE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "WILLOWS PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "GONYANE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ST PATRICK'S PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "VISTA JUNIOR ACADEMY PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "VOLUIT P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ST ANNE PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "THUTO KE TSEBO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "KAINOS CAMPUS PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "CALEB MOTSHABI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ACADEMY OF EXCELLENCE PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ANCHOR ACADEMY IP/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "THE BEEHIVE IP/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "LINOMTHA IP/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BETHLEHEM AKADEMIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "JABULANI IP/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KINGDOM KIDS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "OLIVE RIDGE IP/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "FAUNA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "FICHARDTPARK P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "JIM FOUCHé P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KOOT NIEMANN P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "PRESIDENT BRAND P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SAND DU PLESSIS P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ONZE RUST P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "UNIVERSITAS P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ROSEVIEW P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "WILGEHOF P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "POLOKEHONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "UNITY P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ATANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "PHUTHANANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "REKGONNE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TJHEBELOPELE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "NOZALA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "RUTANANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KARABELO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MONYATSI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "IHOBE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MOTHUSI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TSHOLETSANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "DITLATSE PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "PHAHAMISANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MANGAUNG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BATHO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MORAFE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "EERSTELING PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "WATERBRON P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "C&N P/MEISIESKOOL ORANJE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "EUNICE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BRANDWAG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "DR CF VISSER P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "GREY-KOLLEGE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BLOEMFONTEIN P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KRUITBERG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SENTRAAL P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "WILLEM POSTMA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "CREDENCE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "HEIDE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "JOE SOLOMON P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "OLYMPIA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BREBNER P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KHAKHAU P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "DEOTREFES CHRISTIAN PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "KEGOMODITSWE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TSHOMARELO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "DEALESVILLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "BOSHOF P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "SAAMWERK P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LETLOTLO NALEDI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TSHEHETSO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TSHEDISEHANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TJANTJELLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "IKEMISETSENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "BOIKUTLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "HLABOLOHA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "BOTHAVILLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "EBEN DöNGES P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "HUMANSVLAKTE PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LOSKUIL PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "KLEINBROEK PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LEROLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "FADIMEHANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "REKOPANE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SANKATANE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TLOTLISANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "REFIHLILE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "PHALLANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "AMOHELANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "THATOHATSI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "HOHLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "DITHOLWANA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "PHANO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LEBELO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "THABO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MPOLOKENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "RAOHANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MAHLOHONOLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MMUSAPELO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BOLOKEHANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "THARI YA TSHEPE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "RETSAMAILE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "NTATELENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "DIBENGSATSEBO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "PONTSHENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BATJHA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SEROKI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "REENTSENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MAKGULO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SEMOMOTELA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MABELA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "NTHAPELLENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SEBABATSO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SEITHATI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "NKGOTHATSENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KHOTHATSO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "DR BETHUEL SETAI PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MAHLATSWETSA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "SACSONIA PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MOKGWABONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MONAMODI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "WSM MALOTLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "VERKEERDEVLEI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "SUMMERVILLE PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "IKGWANTLELLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MATIMA-LENYORA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MAGAKAJANE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "NTUTHUZELO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KGUTLISO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "HLOHLOLWANE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "REAMOHETSWE PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "CLOCOLAN LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "NKGODISE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KATISO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "EDENHOOGTE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "BOTLE BA THUTO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "DAWIESVILLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TWEESPRUIT P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "UNICOM P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "THABA PATCHOA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "TSWARAGANANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "LUCKHOFF P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "VOORUITSIG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "ST JOSEPHS PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BORIBENG PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "FRANSHOEK PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MASALENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "VAILIMA PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "QHOWANENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MEQHELENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BAREND V RENSBURG PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "FICKSBURG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "CALEDONPARK P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MEHOPUNG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAUTSE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MASHAYENG PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "PHAPHAMA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MEYNELL PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "GUGULETHU P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "PHOMELLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "THUTO-KE-TSELA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "MEDUWANENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "ZAMALEKA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "TSHEDISO XOLANI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "POELANO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "MOHLAKENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "ED-U-COLLEGE QQ PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "VULINDLELA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "ITLHAHANELENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SOBA PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "HLOMISA PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SENTEBALE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "QHUBEKA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BOIPOPO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "NEXUS P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "PULAMADIBOHO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "WARDEN P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "HARRISMITH P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TSEBONG-OLWAZINI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "NEW HORIZON COLLEGE PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "DIPKRAAL PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "KRAANVOëLVLAKTE PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "PHIRIHADI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BHEKILANGA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "KEARABETSWE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BOITUMELONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "PHITSHANA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "METSIMAHOLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "ORANJEVILLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MOSO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "KWEETSA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "PHOMOLONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "HENNENMAN P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "REIKETSEDITSE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LETHOLA PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "RABONIE PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "THORISO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TLAMANANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "PHAMBILI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "JACOBSDAL P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "ST LAWRENCE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "LERETHLABETSE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "IPATLELENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "DIBASEHOLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "NTHA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "MOEPENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "RELEBOHILE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "LOVEDALE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "REAITUMELA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BOIKEMISETSO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "DORRINGTON MATSEPE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "SHS MOFUBE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "MAOKENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "SEEISOVILLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "LIKUBU P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "PHULENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "PHOMOLONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BOITEKO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "KROON P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "VOORWAARTS P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BRENTVALE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "JOHANNES MB MAROKANE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MANYATSENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ASSISI PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LADYBRAND P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BODIBENG-BA-THUTO PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "NEW VALE PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ST BENEDICT P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LE ROUX P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BEISANG MABEWANA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "COENRAAD SNYMAN P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LADYBRAND P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "HERMANA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ST GABRIEL'S PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "UNIVERSITAS HOSPITAL P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "PELONOMI HOSPITAL P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LERAPO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAMAFUBEDU P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "THUTO TSEBO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "FATENG SA THUTO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "THEBE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "JA MALHERBE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LINDLEY P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "THAROLLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MOEMANENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BELLONA PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "ITEMOHENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "ICHTUS ACADEMY MARQUARD PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "INPOCUKO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MAROBE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TS MATLALETSA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MOHOBO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "KHOTSONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TSHIRELETSO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ITUMELENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MALEBALEBA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "DIHWAI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ICOSENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "THUSANONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ALLANRIDGE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "BRANDWAG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ODENSIA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "SA MOKGOTHU P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BOTJHABA-TSATSI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "SELOGILWE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "SINDEKILE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "NTSHWEPHEPA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "LISTER SKOSANA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "AHA SETJHABA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "AM LEMBEDE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "PARYS P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "INOSENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "PHILIPPOLIS P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "ITEMELENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "PHINDUZAME P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KLEINWATER PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "PETSANA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "JB TYU P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "ROUXVILLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "MALAKABENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BOFULA TSHEPE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "ISAAC MHLAMBI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BOKANTSHO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "THEHA SETJHABA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "NELSON MANDELA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "LEHUTSO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "JJ KUBHEKA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "REFENGKGOTSO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "TSATSI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "TAAIBOS P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "AJ JACOBS P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "DENEYSVILLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "FONTEINE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "LEEUWSPRUIT P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "NOORD/NORTH P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "LUMIèRE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "VAALPARK P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "TJHABA TSOHLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "RORISANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MOHALATLALI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MATWABENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MIMOSA PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SENEKAL P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TUMISANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "MOFULATSHEPE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "SMITHFIELD P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TAWANA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ERESKULD P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ST AUGUSTINES P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MOTLATLA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MATELENA PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SEROPE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "FENYANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MORAGO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TOBA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TLHABAKI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MOKWENA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MODUTUNG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "RATAU P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ROOIBULT P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "POONYANE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "NGAKANTSI'SPOORT PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "RAMAHUTSHE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SETLOGELO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ST PAUL'S P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KOBUE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BOTSIME P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TSHIPINARE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SELOSESHA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "NAMANYANE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SEIPHEMO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KHUNE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MOKAE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "RAMOSHOANE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MOIPONE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "THUBISI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "EMANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MOUTLOATSI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MOKITLANE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MOIPOLAI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "REFENTSE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "KHOTSO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "STILTE PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LOBONENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "BOLIBA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "RESEAMOHETSE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "MADIKGETLA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "TROMPSBURG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ECCO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "KGAUHELO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "NTSOANATSATSI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "MAHLABATHENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TIDOR PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "RENYAKALLETSE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "ADELINE MEJE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "DR SELLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "EVERGREEN PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "KALKVLAKTE PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "IKAHENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TIKWE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "BOITEKONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "HARMONY P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LAKEVIEW P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "SAAIPLAAS P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "HARMONIE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "BOASE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "PHAHAMISANANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "DIEKETSENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "THEMBIMFUNDO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "VREDE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "ZAMANI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MEMEL P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "NTSWANATSATSI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "TATAISO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "MOKWALLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "VREDEFORT P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TSWELOPELE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "HLOLOHELO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "POLOKONG/OUMA TSOPO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "DIRISANANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LENYORA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "BOFIHLA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MOJAHO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "SEABO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MOREMAPHOFU P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "EMBONISWENI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "DALUVUYO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TSAKANI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LEHAKWE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MMANTSHEBO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "THEMBEKILE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "THABONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "IKEMISETSENG (MINE) P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "WESTERN HOLDINGS P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "PABALLONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "AURORA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "BEDELIA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "DAGBREEK P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "NAUDEVILLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "REITZPARK P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "RIEBEECKSTAD P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ST HELENA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "KOPPIE ALLEEN P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "WELKOM PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "WELKOM VOLKSKOOL P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "BRONVILLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "GOLDEN PARK P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "SETSHABELO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "DR MG MNGOMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "PRESIDENT BRAND P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LEMOTSO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TLOTLISO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MOTSEKUWA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "MOOIFONTEIN PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "KATOLOSO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "LETSIBOLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MIDDELPAN PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "NELSDRIF P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TATAISO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MMABANA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MAKELEKETLA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "TLONGKGANYENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LEBOHANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAFIKA-DITSHIU P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "ITLOTLISENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LIBE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAKHALOANENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "NAKA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "PABALLONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "NAMOHA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TABOLA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "THEBE-YA-KGOMO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "THEJANA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SENTINEL P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "WITSIESHOEK P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TSHITSO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KATLEHO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAKENENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAKGETHENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SEKGOMPEPE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SEKGOTHADI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SELEBALO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MACHAEA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MIRI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "NTEBOHISENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KGOLEDI YA MANKA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SEDIBENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TEBOHO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SHOESHOE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "THABA-BOSIU P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TSESENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LERATO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BOITELO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAJWENG PF/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "JWALA BOHOLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BOIKETLONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "DIPHAKWENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "ITEBOHELENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MABEWANA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MATSIENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MOJATSOHLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAMELLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SEPHOKONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TIISETSO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LETSHA-LE-MADUKE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "NAMAHADI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "NEO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "QIBI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "QWABI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MOLIBELI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KGOPJANE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LETOTOLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MEHLODING P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LEPANYA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "PHAMONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SELEMELA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LETSIBOLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BODIBENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "CLUBVIEW P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "JUSTICE LEFUMA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LETLOTLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MATSIKENG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TATAISONG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "ZR MAHABANE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "ZAMA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "ZASTRON P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "EBENEZER CHRISTIAN ACADEMY PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MATLA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "EDUPLUS PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "PARYS CHRISTIAN PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "KOPANELANG THUTO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "GRASSLAND P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "RUANG TSEBO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SILINDUKUHLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KAMOHELO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "HANI PARK P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "PEREZ CHRISTIAN ACADEMY PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MORENA TSHOHISI MOLOI II P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "REHOPOTSWE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "THEMBALIHLE P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TLHOLO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "WINDOW OF HOPE PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "UMCEBO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "GM POLORI P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ARIELGATE CHRISTIAN ACADEMY PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "BEKEZELA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LEHLOMELA P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MISSIO DEI PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "DOME P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MALEBOGO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "WILLOW ACHERS ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MATLAFALANG P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SEDIBENG SA THUTO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "CLOCOLAN PI/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "GARIEP CHRISTIAN IP/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "TRIO P/S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "A V BUKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "AARON GQADU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ABERDEEN PRIMARY PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ABRAHAM LEVY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ADDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BLESSINGS CHRISTIAN PRIMARY LEARNING ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ADELAIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ADENDORP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ADOLPH SCHAUDER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ALEX JAYIYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ALEXANDRIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ALPHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ALTONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "AMANZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ANKERVAS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ARCADIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ASHTON GONTSHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ASTRA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "B J MNYANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "BATHURST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BAYVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BELMONT FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BEN NYATI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BEN SINUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BETHELSDORP ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BETHVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "BHONGWENI PUBLIC FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BLUEWATER BAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "BODKER PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "BONGOLETHU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "BONTRUG SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BOOYSEN PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "BOPLAAS NGK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BOUNDARY HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "BRAAMRIVIER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "BRACEFIELD (UCC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "BRANDOVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "BRONVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SOLID FOUNDATION ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "C M VELLEM JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "C W HENDRICKSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "CANZIBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "CARITAS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "CARLISLE BRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "GOLDWATER PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "CEBELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "CEDARBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "CHARLES DUNA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "CHARLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "CHIGWELL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "CLARENDON PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "COEGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "COLCHESTER (UCC)PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "COLLEGE HILL PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "COLLEGIATE JUNIOR SCHOOL FOR GIRLS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "COOKHOUSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "COTSWOLD PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "COWIE BUSH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "D D SIWISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "DALEVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DALROSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DALUXOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DANIELS PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DAVID VUKU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DE VOS MALAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DESPATCH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DESPATCH PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DIAS FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DIAZ PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DIE HEUWEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DIETRICH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DR A W HABELGAARN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "AFRICAN ANGELS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DR VILJOEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DUMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "DUNBRODY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "EBONGWENI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SINDAWONYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ELMOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ELUFEFENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ELUKHOLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ELUNDINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "EMAFINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "EMFUNDWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "EMPUMALANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "EMSENGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "EMZOMNCANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ENKWENKWEZINI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ENQILENI INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ERICA GIRLS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ESITIYENI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "FERNWOOD PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "FIKIZOLO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "FONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HERMITAGE HOUSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "FORT BROWN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "FRANK JOUBERT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "FUMISUKOMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "FUNIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "G J LOUW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BONZAI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GEELHOUTBOOM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "GELVAN PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "GELVANDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GEORGE DICKERSON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GEORGE JACQUES JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "GERTRUDE SHOPE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GILBERT XUZA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LAERSKOOL GILL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GLENTANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GOOD SHEPHERD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GRAAFF-REINET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GRAHAMSTOWN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GRAHAMSTOWN SDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GRASLAAGTE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "GREENVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "GREENWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "GREY BOYS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "HEATHERBANK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GUSTAV REICHEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "THE CAPSTONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "HANDHAAF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HANKEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "JBAY ACADEMY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "HELENVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "K K NCWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "HERBERT HURD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "HILLCREST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KINGS COLLEGE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HOBSON KHANYISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "RAINBOW CENTRE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "HOMBAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "IKHWEZELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ILINGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ILINGELABANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ILITHA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "IMBASA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "IMVISISWANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "INKQUBELA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ISAAC BOOI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ISIBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "J K ZONDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "J N TULWANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "JAMES NDULULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "JAMES NTUNGWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "JANSENVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "JARVIS GQAMLANA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "JEFFREYS BAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "JOHAN HUS (MOR) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "JOHN MASIZA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "JUBILEE PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "KABEGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "KAMA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "UBUNTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KAMDEBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "KAYSER NGXWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KENTON ON SEA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KHAYAKHULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KHOBONQABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "KHULILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KHWEZILESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ST CHRIS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KINKELBOS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KLEINPLAAS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SUNNYRIDGE PRIVATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KLEINPOORT (UCC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KLIPFONTEIN DRC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KOMMADAGGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "KRONEBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KROONVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KRUISFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "KRUISRIVIER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "kwaNOXOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "kwaQAKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LA TROBE (MOR) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LAER VOLKSKOOL GRAAFF-REINET"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "LAERSKOOL ALBERTYN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "LAERSKOOL EXCELSIOR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "FRANS CONRADIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GAMTOOSVALLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HANKEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "LAERSKOOL INNES"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MOREWAG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "PIET RETIEF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "LAERSKOOL SETLAARSPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LAERSKOOL VISRIVIER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "LAMANI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LETTIE DE KLERK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LINGCOM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "LITTLE FLOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "LORRAINE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "LOVEMORE PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LOWER BLINKWATER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LUCEBISO FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LUKHANYISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MACHIU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MAGQABI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MAKANA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MAKUKHANYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MALABAR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MALMAISON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MANLEY FLATS MISSION SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MASAKHANE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MASISEBENZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SIPHO HASHE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MBONISELO PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MDENGENTONGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MDENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MELISIZWE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MELUMZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MIDDLEWATER (DRC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MILLHOLME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MISSIONVALE (UCC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MISTKRAAL RC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MJULENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MNGCUNUBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MNQOPHISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MOLEFE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MONDPLAAS (DRC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MOREGROVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MORESON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MOUNT PLEASANT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MQHAYI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MSOBOMVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MTHONJENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MTYOBO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MZIMHLOPHE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MZINGISI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MZOMTSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "N V CEWU PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "NARSINGSTREET PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NASRUDDIN ISLAMIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MASAKHANE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NEW BRIGHTON SDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NEWTON PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NGCWENGXA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "NOJOLI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NOKWEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NOMATHAMSANQA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NONYAMEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "NONZWAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "NOOITGEDACHT(DRC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NOSIPHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NOTHONTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NQABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "NTABA MARIA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NTLAMA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NTLEMEZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NTYATYAMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NXANELWIMFUNDO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NXUKHWEBE HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "OATLANDS PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "PALMIETRIVIER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "PAPENKUIL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "PARKSIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "PARSONS HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "PATENSIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "PEARSTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "PELLSRUS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "PENDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "PHAKAMA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "PHAKAMILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "PHILLIP NIKIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "PHINDUBUYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "PHUMLILE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "QHAYIYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "QUAGGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "R H GODLO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "REDHOUSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "REPUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "RICHARD MSUTHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "RIETBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ROSE COTTAGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ROWALLAN PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "RUFANE DONKIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "RWANTSANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "RYNEVELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SAMUEL NONGOGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "SAMUEL NTLEBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "SAMUEL NTSIKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SANCTOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "SANDWATER FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SAPPHIRE ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "SEA VISTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SEAGULL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SEYISI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "SHAW PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "SHENSTONE FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "SIDBURY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SIKHOTHINA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SITHEMBILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SIVUYISENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SIYAPHAMBILI PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LAERSKOOL SOMERSET'S GIFT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SONOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SOUTPAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SOWETO-ON-SEA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SPENCER MABIJA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ST AUGUSTINES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ST GEORGE'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ST IGNATIUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ST JOSEPH'S (RC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ST JOSEPH'S (RC) SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ST MARY'S RC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ST PATRICK'S (EC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ST REGINALDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ST TERESA'S (RC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ST TERESA'S RC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "STEPHEN MAZUNGULA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "STEPHEN NKOMO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "STORMSRIVIER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "STRELITZIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "STULTING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SUMMERWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "SUNDAYS RIVER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SUNRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SUSANNAH FOURIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SWARTKOPS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SYDENHAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "TANTYI PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "THEMBALESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "TINIS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "TOEKOMST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "TOM KASIBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "TRIOMF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "TSITSIKAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "UITENHAGE CONVENT RC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "UITENHAGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "UITVLUCHT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "UNION PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "VAN DER KEMP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "VAN STADENS RESERVE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "VéRITé JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "VERKENNER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "VEZUBUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "VICTORIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "VICTORIA PARK GREY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "VUBA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "VUKANIBANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "VULINDLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "W B TSHUME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "W G OLIVIER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "WALMER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "WALMER WEST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "WEST END PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "WESTERING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "WEZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "WILLIAM OATES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LAERSKOOL WILLOWMORE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "WINTERBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "WITMOS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "WOODLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "YOUNG PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ZAAIMANSHOEK (UCC) JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ZAMUKUKHANYA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ZANOXOLO PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ZUURANYS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MAQOMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "DAMBUZA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "TJAART VAN DER WALT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "GARRETT PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NKUTHALO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HOLY CROSS SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DOWER PRACTISING SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "FORT BEAUFORT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MHLOPHEKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "VUSUMZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KIDIO PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "KUYGA PUBLIC JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "THE SCHOOL OF MODERN MONTESORI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "EBENEZER JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "CALEDON PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NONINZI LUZIPHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "JOE SLOVO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "KLEINSKOOL COMMUNITY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NASRUDDIN ISLAMIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LITTLE ANGELS PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ST FRANCIS COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NORMOYLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ALFONSO ARRIES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "A W BARNES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LAERSKOOL GRENS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ALICE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "AMAKHUZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "AMALINDE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "AMATHOLE BASIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ANDILE NTSEPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ANNSHAW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "AQUA VISTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ASPIRANZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ATHENKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "AUCKLAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "AYABULELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "AYLIFF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BALASI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BALFOUR HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BALFOUR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BALURA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BEBULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BERLIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BHALITI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BHELE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BHONGWELIHLE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BINFIELD PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BISHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BIZOKHULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BLAIR HELEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BODIAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BOLO FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BONGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BONKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BRAESIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BREIDBACH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BROWNLEE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BUFFALO FLATS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BULELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BULEMBU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BULUGHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BULUMKO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BUMBANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BURNSHILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BUTHISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BUXTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "CAESAR MLUMBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "CALDERWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "CAMBRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "CELETYUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "CENTRAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "CENYU PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "CHUMA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "CILDARA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "CINTSA EAST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "CISIRA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "CLARENDON GIRLS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "CLARENDON PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "COVE RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "CRAB BUSH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "CRANBERRY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "CREWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "CUMMING MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "CWALA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "CWARU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MARANATHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "DALE COLLEGE BOYS' PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BRIDGEWAYS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "DALUKUKHANYA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DANINGE L/H PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DAWUWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DEBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DEBE MARELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DEBE VALLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "DICKSON DYANI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DIKENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DIKIDIKANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "DIMBAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DISH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "DONGWE COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DOUGLAS ROSS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DUBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "DUBU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DUMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "DUNCAN VILLAGE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "EAST LONDON RC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "EBHOTWE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "EKUPHUMLENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ELETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ELIJAH MGIJIMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ELY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "EMABALENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "EMAJWARENI PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "EMDIZENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "EMMANGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "EMMANUEL JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "EMNCOTSHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ENCOTSHENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ENTILINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "EQULENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "EXTENSIONS FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "EZIKWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "EZINGCUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "FAIRBAIRN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "FANTI GAQA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "FENI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "FERNDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "FESTILE SOGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "FEZEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "FEZIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "FIKILE BENSON GAUSHE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "FLORADALE FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "FORT GREY PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "FORT MURRAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "FORT WARWICK FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "FUNEKA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "FUNULWAZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "GAGA HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "GANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GCOBANI INTERMEDIATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GCOBANI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GEORGE RANDELL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "GILTON COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GODIDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GONUBIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "GOPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GQALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "GQUMAHASHE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "GRANTVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "GUBEVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GUGULETHU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "GWALI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "HAMBURG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "HAMILTON-UMZAMOMHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "HARPERTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "HECKEL PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "EMHLANGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "HERTZOG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "HESHANGOPHONDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "HLOSINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "HORTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "HUDSON PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "IKHWILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "IMIGUDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "IMVISISWANO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "INGWENYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "INKQUBELA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "INYATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ISIBANE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ISIBANE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ISIDENGE/THEMBELIHLE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ISITHSABA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "JAFTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "JEAN MASALA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "JEANET MAHONGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "JITYAZA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "JOJWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "JUBISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KALANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KATBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KAYSER'S BEACH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KHANYISA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KHAYALABANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KHAYALETHU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KHAYELITSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KIDD'S BEACH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KING WILLIAMS TOWN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KINGS MISSION PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KIWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KNOX PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KOLELE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KOMGA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KOTI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KUHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KUNI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KUSILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SESETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KWANDULWAZI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KWASA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KWELEGHA PUBLIC COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KWEZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "L M YAKO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LAERSKOOL KUSWAG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LAERSKOOL NAHOON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LANGALIVELILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LANGELITSHA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LENYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LONDOLOZANI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LOWER EMNYAMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LOWER GXULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LOWER MGWALANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LOWER SHESHEGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LUJIKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LUJIZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LUJIZA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LUKHANYO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LUMANYANO PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LUNGA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LUNGELOLETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LUNGISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LUSASA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MZAMOMHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LUYTEVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LUZUKO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LWANDISA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MAASDORP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MABANDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MABEFU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MACFARLAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MACIBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MADAKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MADLIKI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MADUBELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MAJALI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MAKHAZI PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MAKINANA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MAKUNGA MVALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MAMATA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MANANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MANDLAKAPHELI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MANEZI HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MANGQUKELA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MANYANO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MASAKHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MASELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MASIBAMBISANE COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MASIBULELE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MASIJONGANE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MASIPHATHISANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MASIPHUMLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MASIVUYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MASONWABE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MAVUSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MBAMBO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MBANYAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MBIZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MBOMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MBOVANE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MBULELO PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ALICE CHRIST THE KING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MDANTSANE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MDISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MDIZENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MDOLOMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MEMELA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "METELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MFIKI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MFUNALWAZI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MFUNDISO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MFUNDO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MGWALANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MGXOTYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MIMOSA PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MLAKALAKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MLUNGISI PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MNANDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MNGQESHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MNQABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MOOIPLAAS PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MORGENSTER JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MPEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MPENDULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MPONGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MQWASHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MSUNDULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MTATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "CHILD'S WORLD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MTHONJENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MTUNZI TSOLEKILE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MTYANA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MTYOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "L F MAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MXHALANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MXUMBU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MZANTSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MZIMKULU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MZINGISI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MZINTSHANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MZOMNCANE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MZONKESHE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MZOXOLO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GRAAB EDUCATION CENTRE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NANGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NCALA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NCEMERA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NCERA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NCERA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NCEREZANTSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NGCABASA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NDAKANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NDEVANA HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NDILEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NDINDWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NDLAMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NDLOVINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NDLOVURA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NDUKUMBANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NDWAYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NGCAMAMA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NGELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NGOBOZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NGQELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NGQIKA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NGQOLOWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NGQOWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NGQUMEYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NGWABENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NGWANGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NGXAMNGXA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NGXINGXOLO PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NGXWALANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NJWAXA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NKANGELEKO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NKULULEKO HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NKWEZANA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NOBANTU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NOBHOTWE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NOBUMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NOBUTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NOJOLI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NOKUZOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NOKWANDA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NOMATHEMBA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "IMFUNEKO YELITHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NOMGWADLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NOMHLE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NOMPUMELELO PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NONCAMPA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NONDIKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NONGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NONIBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NONKQUBELA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NONKUNDLA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NONTOMBI MATTA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NONTSIKELELO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NONTUTHUZELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NONYAMEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NYIBIBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BUFFALO METRO INNER CITY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NOTHENGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NOWONGA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NOXOLO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NQONQWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NQWENERANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NQWILISO TYALI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NTLANGANWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NTLOKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NTONGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NTSASA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NTSELAMANZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NTULIKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NTYATYAMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NXARUNI PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NXAWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NYANISO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NYARA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NZALISEKO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NZONDELELO HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NZUZO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "OAKDENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "OVERTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "PAKAMISA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "PARKSIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "PEELTON HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "PEFFERVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "EAST LONDON MONTESSORI SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "PEULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "PHAKAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "PHAKAMILE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "PHAMBILI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "PHOZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "PHUMELELANI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "PICARDY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "PIRIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "QAMDOBOWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "QANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "QAQAMBA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "QAUKENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "QETO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "QHURU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "QIBIRA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "QINGQA MNTWANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "QONGQOTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "QUGQWALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "RALA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "RAYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "READSDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "RIPPLEMEAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ROXENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "RURA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SABANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SAKHILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SAKI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SAMKELE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SANDILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SANDISIWE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SCHORNVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SELBORNE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KING'S COLLEGE MTSOTSO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SEYMOUR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SHAD MASHOLOGU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SHWELE SHWELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SIFIKILE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SIKHULULE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SILATSHA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SINAKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SINOMONDE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MATTHEW GONIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SIPHUMILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SISONKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SITYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SIVIWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SIVUYILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SIVUYISIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SIYANDA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SIYAQALA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SKOBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SOBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SOMPONDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SONWABILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SONWABILE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SOSEBENZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SOUTHERNWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SPRUELL PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ST JOHN'S ROAD JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ST LUKES PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ST MATTHEWS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "STIRLING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "AMATOLAVILLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "TAMARA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "TATSHANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "THANDISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "THANDULWAZI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "THANDUXOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "THEMBA SEVENTH DAY ADVENTIST SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "THEMBALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "THEMBANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "THEMBEKA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "THOBOSHANA FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "THULISILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "TILDIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "TOLOFIYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "TOM PANYANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "TOM'S PLACE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "TSABA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "TSHABO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SAKHINGOMSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "TUWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "TWECWANA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "TYARA HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "TYATA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "TYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "TYITYABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "LOVEDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "TYUSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "TYUTYU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "TYUTYUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "UMQWASHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "UPPER CATA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "UPPER GQUMASHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "UPPER GXULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "VANANI FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "VOORPOS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "VULINGQONDO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "VULUMZI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "W M MTYEKU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "WARTBURG PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "WASHINGTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "WESLEYVILLE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "WHITEVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "WOLF RIVER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "WOODLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "XHAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZABALAZA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZALARA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZALAZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZAMANI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZAMUKHANYO FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZAMUKUKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZAMULWAZI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZANETHEMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZANOKUKHANYA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZANOLWAZI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZANOXOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZANYOKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZIGODLO COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZIHLAHLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZIKHALINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZIKHOVA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZIKWABA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZIMASA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZIMASILE ANTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZIMBABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZIXINENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZONDEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZOZO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZUKILE COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZUKISA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZUZILE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZWELANDILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZWELIHLE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZWELITSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "YAMALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "CWENGCWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "TSHATSHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GINSBERG SEVENTH DAY ADVENTIST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "FORT COX PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NKOSINATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ZANOKHANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "MANCAZANA (UCC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "R H GODLO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SAKHEKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "PRESIDENT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ZWELEMFUNDO PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "VUTHONDABA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "E Z PONDO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "CHUMANI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NONTO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "EMBEKWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SOPHUMELELA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NEW GENERATIONS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LUZUKO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ISAIAH 58 PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LUKHANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SIVIWE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KINGS COLLEGE INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ARISING LITTLE ANGELS CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "A B SIWENDU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "A M BAM JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "AMABHELENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ANTA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "B SANDILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BANGISO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BANGWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BAWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BAWANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DAZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BEKINKOSI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BEKIZULU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BELENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BENAI SILINGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BENGU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BIKANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BIYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BLYTHSWOOD JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BOJENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BOLANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BOLOTWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BONDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GOOD SHEPHERD CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BONGOLETHU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BONGOLETU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BONUS SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BOTTOMAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BUSILA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "C M BIKITSHA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "CEGCUANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KENTANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "CERU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "CIKO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "CILO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DALIBANGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DALUKUKHANYA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DAYIMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DE VILLIERS MPANGELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DIKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DINGISWAYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DIYA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DUMALISILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DLEPU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DOUGLAS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DUFF JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DUMEZWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "EAST BANK JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "EAST UPPER QOMBOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "CAMSHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ELUXOLWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ENTILINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ESIGUBUDWINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ESINGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "EWING JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "EZIFLETINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "EZOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ROBY'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "FORT MALAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JOY ENGLISH MEDIUM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "FUNDISA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "G S MAGOBIANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GANGATHA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GAQELO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GCINGCA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GIRDWOOD JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GODIDI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GOJELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GONTSHI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GOSANI'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GQOGQORA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GUBEVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GUDLA'S JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GUGULETHU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GUGULETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GWADANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GXARA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GXWALUBOMVU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "HADIS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "HANGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "HEBE HEBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "HERMANUS SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "HLAKOTI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "HLANGANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "HLOBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "HLOKOMILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "HOKISI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "IMIDANGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ISIGANGALA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ISIGINGQINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "IZAGWITYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "J F MTSHIKI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "J M BOLOTINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JADEZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JAN NOMJANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JERICHO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JOJWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JOJWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JOJWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JONGIBANDLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JONGIKWEZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "JONGIMISHINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JONGINTABA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JONGISIZWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JUJURA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KABAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KALTOM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KANYISA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KEDAMA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KHAYALETHU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KIEVIET SUKWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KOBODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KOKOLO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KOTANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KULOKHALA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KULO-MBOMBO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KULOZULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KUNENE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KUYASA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KUYASA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "kwaTAYI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "KWEBULANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KWEZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LAMBATA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LAMPTA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LANGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LAPHUMILANGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LENCANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LESLIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LINGELETHU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LINGELETHU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LINGELIHLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LOWER DADAMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LOWER GOQO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LOWER GQOGQORA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LOWER GWADU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZITHULELE INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LOWER NDAKANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LOWER NDUKU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LOWER NOFOTYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LOWER QUTSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LOWER TSOJANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LUBOMVINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LUKANYO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LUKANYO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LUKHANYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LUKHOZANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LUPHINDWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LURWAYIZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LUSIZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LUSUNGULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LUVUNDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MABENTSENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MACIBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MACLAY SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MADUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAGABA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAGIQWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAGODLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAGWAZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MAHLATINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAHLEZANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAHLUBINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAKHOSONKE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAKUKHANYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MALONGWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MANDENDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MANDLUNTSHA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MANKIHLANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MANQULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MANYANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAQELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAQOMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MASAKANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MASELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MASIZAKHE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MASIZAME JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MATHOLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MATOLWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAVUSO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MAWUSHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAXHAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MAXAMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "QUMANCO GREAT PLACE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAYIBONGWE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAZIZINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MBELO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MBHASHE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MBIZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MBOYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MBULUKWEZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MCITWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MDUNYISWA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MEME SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MENDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MENDWANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MEVANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MFAMZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MFEZEKO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MGCAWEZULU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MGOBOZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MGOMANZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MGWEBI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MGXABAKAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MGXOBOZWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MHALA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MHLABULUNGILE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MHLAHLANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MHUKU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MIDDLE GQOGQORA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MIDDLE QUTSA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ALBERTINA SISULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MIRRLEES JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MKWINTI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MLONDLENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MMANGOBOMVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MNGCANGCATHELO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MNTLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MNTUYEDWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MNYAKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MORRISON JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MOZWENI JUNIOR SECONDARY & TECHNICAL INSTITUTE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MPAHLENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MPENDUZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MPETA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MPOZOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MPOZOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MPUKANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MPUMALANGA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MPUME JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MPUMLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MPUTI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MQAMBELI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MQOTWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MRWAQA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MSENDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MSENGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MSIKITI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MTHETHO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MTHWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MTINTSILANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MTSHABE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MTSHANYANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MTSHOTSHISA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MTWAKU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MVELASE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MWELI'S JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MXAKA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MZANTSI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MZAZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MZITENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MZOMTSHA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NCEDANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NCENJANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NCERANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NCINCINIKWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NCISININDE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NCWANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NDABANKULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NDAKANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NDENXA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NDEVUZIBOMVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NDOQA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NDOTSHANGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NDUKU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGADLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGANGENDLOVU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGCEZA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGOMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGONYAMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGQANDA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGQEZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGQWARA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGUBEZULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGUNIKAZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGWANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGWEYESIZWE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NIMROD JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NJEMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NJINGINI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NKANGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NKELEKETE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NKENTE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NKONJANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NKONKWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NKQUBELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NKULULEKO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOJONGILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOKATANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOKHANYO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOLITA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NOLUSAPHO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOMAHEYA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOMAWAKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOMBULELO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NOMPENDULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOMPUMELELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOMTANDAZO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NOMZAMO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NONCEBA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NONKQUBELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NONKQUBELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NONKQUBELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NONTLOKO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NONTUTHUZELO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOSAPHO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOXHAKAZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOZIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOZULU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NQABANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NQABARA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NONCEDO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NQADU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGQUSI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NQUTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NTABITSOLO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOMPUMELELO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NTLABANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NTLEBI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NTSESHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NTSIMBAKAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NTSUME'S JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NTUBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NTWASHU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NYAKATA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NYANISWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NYIDLANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NYILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NYITYABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NYOKANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NYULULA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NYUMAGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NZANZANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "PAKAMILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "PAPAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "PETER QONGO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "PHATHILIZWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "PHILEMON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "PONANA LUBISI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "PUMLANI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QAKAZANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QHAYIYALETU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QHAMILE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QIMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QINA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QOBO-QOBO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QOLIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QOLORA FENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QOMBOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QUMBULWANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QWANINGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "RAMRA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "REVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SAJINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SAUTANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SEKU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SHIXINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SICAM SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SIQITHINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SISEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SIVANXA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SIYANDA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SOGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SOKAPASE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SOMANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SOPAKAMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "T S MATSILIZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TAMSANQA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TANDA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TEKO FIHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TEKO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TEMBANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TEMBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "THE SPRINGS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "THEMBELIHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "THULANI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TIMANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TOLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TOM SOPETE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TONGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TSHAWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TSHAZIBANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TSOJANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TSOMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TSWELELITYE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TYHOLOMI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TYWAKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER BAWA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER BOLOTWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER CERU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER CIKO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER COLOSA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER DADAMBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "UPPER GQOGQORA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER MGOMANZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER NGXUTYANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "UPPER NQOLOSA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER NYWARA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER QORA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER TOBOTSHANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "UPPER XUME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VELDMAN'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VININDWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VUKANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VUSANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "WEZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "WILI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "WILLOWVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "WILSON MAYEKISO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "WONGALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "XAXASHIMBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "XEGOLENTAKA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "XILINXA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "XOBANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ILITHALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "XONYENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "XUME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZAKHELE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZAMUXOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZANEMVULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZANENQABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZANEWONGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZANOHLANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZANOZUKO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZAZINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZENZELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZENZELE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZIBHITYOLO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZIDLEKAYA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZIKHOVANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZIQORANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZITULELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZIVUKELE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZONWABELE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZWELAKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZWELAKHE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZWELANDILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZWELILUNGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZWELINZIMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZWELITHOBILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZWELIXOLILE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SALAKUPHATHWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MTUNZI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "AMAMBALU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BURU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VUYOLWETHU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LOWER CEGCUANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MASIBAMBANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "EZITHENJINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DALUKANYO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TYINIRA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KANYISA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BULUBE'S JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "HOLOLOSHE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QORA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGUBEZULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SONKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DYANTYI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LITHA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "FAIRVIEW JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BETHEL JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BLY NGCONGOLO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MANTANJENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "JONGINTSIZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NQOLOSA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GOTYIBENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KOBONQABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGXUTYANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAMPONDWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VUYO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ENGILANE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NXAXO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MBULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LUBOMVINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CAMPBELL MNYHILA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "QWILI QWILI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LUFUKUFU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CABA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LUXOMO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GOBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MSENTO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NONYEMBEZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MPENTSA'S JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SISEKO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "PIET MLANDU'S JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LINDSAY JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MACIBINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MATOLWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NTSHINGENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "CANDU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MQIKELA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SIYIBANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER GWADU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MENTE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MANGELENGELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LOWER MBANGCOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GWABE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MTSHAZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GOOD SHEPHERD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAGONTSINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ALBERT LUDIDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ALL SAINTS SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ASHTON NKALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BALASI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BALIZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BAMBILANGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BAVUMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BAVUMELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BAVUMELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BAZINDLOVU PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BAZIYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BEKILENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BELEKENCE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BEYELE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BHEKAMEVA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BITYI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BOJANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BOTSABELO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BUHLEBELIZWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BUNENE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BUNGU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "STONE HOUSE PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "CABA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CACA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "CANDULWANDLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CATUZA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CEFANE HOEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CEFANE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "CEKWAYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "CEZU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "CHEBENCA JUNIOR SECONDARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CIKICWAYO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "CINGCO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CLARKEBURY JUNIOR PRACTISING SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ST BEDES CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "COBOSI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "COFFEEBAY JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "COKOMFENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "CORANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CWECWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "CWELE PUBLIC JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DABULINGWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DALIBANGO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DALIBANGO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DALINDYEBO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DALISOKA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DALUKHANYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DALUXOLO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DALUXOLO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DEBERA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DELITYALA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DETYANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DIDWAYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DIKISO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DLUKULWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DOKODELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DUBULINGQANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DUMANINONKE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DUMASI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DUMBA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "EAGERTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "EBUNTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ULOYISO CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "EMARAMBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "EMAWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "EMGWALANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "EMKANZI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "EMPEHLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TSHATSHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ENGCOBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ESIDWADWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ESIKOBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ESIKOBENI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ESIQUNGQWINI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ESITANGAMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ETHEMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ETWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "EXHIBENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "FAIRFIELD JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ESETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "FEZEKILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "FUDUMELE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "FULINZIMA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GANDANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GANGATA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GANYA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GCINIZIZWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "GENGANCWAZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GENGQE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GINYINDABA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GOBINAMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GOBIZEMBE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GOBIZIZWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GOBIZIZWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GODZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GCINIBANDLA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GOMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GONGQOZAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GOSO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GOTYIBENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GOTYIBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "GQAQHALA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GQUKUNQA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GQUNU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GQUTYINI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GQWESA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GQWEZA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GRIFFITHS SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GUNGUBELE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GUNGULULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GUNJANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GUNYENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GURA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GWENTESHE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GXWALIBOMVU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "HAJI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "HAKO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "HARGREAVES PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "HAYENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "HIGHBURY JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "HILLVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "HLABATSHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "HLANGANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "HLATHIKULU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "HLOPHEKAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "HOBE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ET THABANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "IKHWEZI COMMUNITY JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "INDWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JENCA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JERSEY FARM JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "JOëLSHOEK FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "JOJWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JONGIMIZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "JONGIMPUMA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JONGINGWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JONGINKUNDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "JONGINTABA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JONGISIZWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "JONGIZULU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "JONGUBUHLE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JONGUHLANGA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JULUKUQU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "KALINYANGA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KAMBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KANYALANGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "KANYE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DALUKULUNGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KIMBILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KONKABI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KONQENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KOSANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KOTYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KRANCOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KUYASA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KWAM JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "kwaNGXABANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KwaNTABANKULU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "kwa-PAYNE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KWENXURA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KWEZILETHU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LABRY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LADUMIZULU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LALENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LANDSEND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LANGALAKHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LANGENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LAPHUMIKWEZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LEPPAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LINDUBUHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LINGELIHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LITTLE FLOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LIWALAPHAKADE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LONG HOPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LOTANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LOWER BUFUMBA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LOWER CULUNCA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LOWER GOQWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LOWER GQAGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LOWER MALAHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LOWER MALEPE-LEPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LOWER MATEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LOWER MDUMBI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LOWER MNGAMNYE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LOWER MPAKO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LOWER NGCOLOKENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LOWER NTLAZA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LOWER RAINY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LOWER ROZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LOWER SITOLEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LOWER TYIRA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LUCINGWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUDEKE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUGASWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUKUNI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZIMBANE VALLEY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LUMKWANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LUNDA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LUNDI PUBLIC JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUNGISANI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LUQOLWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LURASINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUTAMBO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LUTUBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LUTHUTHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LUZINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LWANDLANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LYNDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MABEHANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MABHELENI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MACHAMTSHOLO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MACLEAR METHODIST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MACOSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MADAKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MADUMELWANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MADWALENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DREAMLAND PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MADWALENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAFULAYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAGILA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAGOMBENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MAGWAXAZA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAHAHANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MAHLUNGULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MAHOBE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MAJOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MAKAULA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MAKUKANYE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MALADINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MALAHLE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MALAMLELA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MALEPE-LEPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MALIZOLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MALUSI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MANDEBE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MANDELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MANDELA PARK JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MANDULUKA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MANGQUKWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SCHOOL OF CHAMPION PRIMARY SCHOOL IN CHRIST"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MANYOSANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MANZANA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MANZEZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MANZIMAHLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MANZINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAPIKI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MAQANYENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MAQANYENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAQEBEVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAQOLO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MARUBENI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MASIBAMBISANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MASONWABE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MATANZIMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MATISO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MATIYASE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MATSHONGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MATYEBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAVUBEZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MAWELENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MBABALANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MBAMBENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MBAMBISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MBANANGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MBANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MBASHE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MBEKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MBEKWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MBIDLANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MBILINI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MBOBELENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MBOKOTWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MBOKOTWANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MBOZISA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MBOZWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MBUQE EXTENSION SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MBUQE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MBUTYE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MCELWANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MCHATU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MCHENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MCONCO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MCOTAMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MCUTU PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MCWAKUMBANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MDABUKA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MDANJELWA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MDAVUZA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MDEDELWA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MDENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MDENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MDINA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MELIBUWA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MELITAFA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MFABANTU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MFUNDWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MGCOTYELWA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MGUDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "CHABASA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MHLABATHI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MHLABUNZIMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MHLAHLANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MHLAKULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MHLAKULO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MHLANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MHLOPHEKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MIDDLE TYIRA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MILANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MJIKELWANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MJONGILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MKAMBENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MKATINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MKWEZO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MLATHA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MLOTSANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MMANGONKONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MNCWASA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MNGCELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MNQANDANTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MNTONINTSHI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MNTUNTLONI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MOSHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MOUNT NICHOLAS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "FOREST RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MPANTAKA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MPATISWA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MPEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MPIKWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MPIMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MPINDWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MPOZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MPUTI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MQABO PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MQEKEZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MQOKOLWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MSINGATI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZINGISILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MSOBOMVU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MSOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MT PACKARD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MTAWELANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MTHONYAMENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MTIKA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MTONDELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MTONJENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "HOLY WORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MVELELO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MVULANKULU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MVUME SPRINGS SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MVUMELWANO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "RIVER JORDAAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MWEZENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MXAMBULI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MZAMO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MZINGISI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MZIWODUMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MZOBOSHE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MZUZANTO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NABILEYO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "THE EAGLE ACADEMY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NCAMBELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NCEKANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NCEMBU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NCEMENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NCITSHANE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NCOTI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDABANKULU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NDALATA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NDASANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NDLELANTLE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDLOVAYIPHATHWA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDLUZULA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NDOBE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NDUMNGELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NDWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZANEBANDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDZULUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NESSIE KNIGHT HOSPITAL SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGANGENYATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGCENDESE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGCOLOKENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGCONGCO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGCWALA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGINZA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGONYAMA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGONYAMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGOSWANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGQINIKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGQUBUSINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGUBENGCUKA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGUBENYATI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGUBERHAMBA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGUBESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGUBEZULU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGWEMNYAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGWEVANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NJUQWANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NKAHLULO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NKANGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NKANGALA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NKANTI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NKANTSINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NKINTSHANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NKONKONI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NKONKWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NKQWILISO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NKUNZIMBINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NKWALINI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NKWILINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NO-MOSCOW SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NO-OFISI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NOGAYA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NOGWAZA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOKULUNGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NOMBIZO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NOMZAMO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "THE KINKAID PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NONKQUBELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NONTATYANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NONYIKILA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "CHRISSEM COMPREHESIVE CHRISTION SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NORWOOD JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GOOD SHEPHERD ENGLISH SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NOTA'S PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NOTINARA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOTSOLO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NOTSWELEBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NOXOLO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOXOVA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NQADU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NQAKAMATYE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NQEKETO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NQENCU PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NQUTYANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NTABENI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NTABENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NTABEZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NTLALUKANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NTLUKUHLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NTSELENI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NTSHABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NTSHELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NTSHETU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NTSHIQO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NTSHOZWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NTSIMBA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NTSINGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NTSONYANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NXANXADI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NXAXA GORGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NXEKO MTIKRAKRA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NXOTWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NYANISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NYIKIMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NYWARA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ORANGE GROVE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "PAKAMISA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "PAMBILI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "PELANDABA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "PINGILILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "POKOLOSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "PONDOLWENDLOVU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "PONGOMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "PONI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "PORT ST JOHNS COMMUNITY SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "WINTERBERG COMMUNITY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "PUMLANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "QAKA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QAMATA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "QAMBA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "QANQU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "QEBEYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "QENGQELEKA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "QHOBOSHENDLINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "QINGQOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QINGANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "QIYA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "QOBA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "QOLOMBANE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "QOTIRA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "QULUQU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOAH CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "QUNU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "RAFUZA MNTUYEDWA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "RASMENI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "RICHARD SAMELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "RIVERVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ROZA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SAMSON SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SANGONI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SANGQU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SANKOBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SARILI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SEA VIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SENTUBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SHAWBURY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SIDANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SIGUBUDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SILIMELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SILO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SINQUMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SIPENDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SITEBE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SITHA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SIVIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SIXHONKXWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SIXUZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SIYAHLANGULA PUBLIC JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SIZWE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SKOBENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SOBUZA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SOMPA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SOMPA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SONATA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SPEFUNDEVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SPRINGVALE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ST ALBANS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ST JOSEPHS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ST PATRICK'S JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SULENKAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TABASE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TAFA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TALENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TAMSANQA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TANDOKAZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "TAUNG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TEMBENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TEMBENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TEMBENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TEMBALETU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "THEMBELIHLE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TIKI-TIKI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TIMOTHY SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TINA FALLS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TINTWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TIPINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TOLIKANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TRANSKEI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TSAZO PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TSHAKA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TSHATSHATSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "TSHIKITSHA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TSHONTINI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TUKELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TUNGWINI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TWALIKULU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "CASTLE ACADEMY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TYELINZIMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TYITYANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TYUMBU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UPPER CULUNCA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "UPPER ENDUKU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UPPER LOTANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "UPPER MBANGE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "UPPER MNGAMNYE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UPPER NTLANGAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "UPPER NXAXA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UPPER TABASE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UPPER TYIRA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UPPER XONGORA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "VELALANGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "VIEDGESVILLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "VOYIZANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "VUKANI KUSILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "VUKANI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "VUKANI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "VUKUKHANYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "VULINDLELA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "VULINDLELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "VULINKETE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "VULINKUNDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "VUSUKHANYO PUBLIC JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "VUYANI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VUYISILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "W M RANUGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "WATERFALL PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "WATHA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "WILO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "XABADIYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "XABANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "XEZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "XONYA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "XONYENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "XUGXWALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "XWILI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "YAWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZABASA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZADUNGENI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZAMIWONGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZAMUKULUNGISA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZAMUKULUNGISA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZANDISE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZANEMVULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZANOKANYO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZANOKHANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZANOXOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZELE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZIBUNGU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZIBUTE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZIKO-LOKOTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZILANDANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZILIMBOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZILINYAMA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZIMBENGWINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZOLA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZONNEBLOM JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZWELAKHE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZWELANDILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZWELEBANGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZWELEBANGO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZWELENQABA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZWELI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZWELICACILE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZWELIJONGILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZWELINZIMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZWELITSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NEW COVENANT CHRISTIAN COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZWELIVUMILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZWELONKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZWELOXOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MAGUTYWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAGGIE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MAGUMBINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "EMTHWAKU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LUGONGQOZO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZAMUXOLO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAGOXO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LANGELIHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DRC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SIDANDA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NKALWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GQIRA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DOBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DUMILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "FUNDANI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BOMVINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NKWENKWEZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SOBANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LUVUYWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MVEZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GWEGWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "UPPER GQOBONCO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MANYOSINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MCWANGELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZITULELE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ZWELIDUMILE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LOWER XONGORA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NJEMLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "kwaGORA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DUMALISILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DINGILIZWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZIBUZELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KIDLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "QOKOLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NDIBELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "EMJIKWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MBINJA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MACLEAR PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "CANDILANGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "E W PEARCE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JONGUHLANGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NOLUFEFE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LUMKWANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "THEMBELANI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JAMES KOBI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "QWE QWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MOKOLWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TABASE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NOBANTU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NCISE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DALUKHANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GQEYANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MZIMVUBU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SITETO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NONTANGANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "UPPER CORANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MPHUMAZE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NDLUNKULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZIBODLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NOBUBELE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "H2 PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOBUHLE INTERNATIONAL SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SOS VILLAGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "QUMBU COMMUNITY SCHOOLS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ST MARTINS PRIVATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "FAITH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JOEL ENGLISH MEDIUM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "VUKANI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LITTLE WILLOW FOUNDATION SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NCORA PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MYOLWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "OASIS COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ANTIOCH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BABANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BABHEKE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BAKUBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BALETYENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BAPHATHE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BARKERVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BAVUMILE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BEKABANTU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "BEKAMEVA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "BEKELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BELFORT JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BETHANIA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BETHEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BETHESDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BETHLEHEM SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BETSHWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BHAYI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BISI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NTUNJENI PREPARATORY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BLACK DIAMOND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BIOTHATELO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "BOKUVENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "BONDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZENITH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BONXA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BUBESI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "CABANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "CABAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "CAIPHUS KHOAPA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "CAMAGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "CAMBALALA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "CANCELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "CANDULWANDLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "CEDERVILLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "CELINKUNGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "CIBINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "COLANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "CRITCHLOW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "CWAKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "CWALINKUNGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "CWEBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DABULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DABULAMANZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DAKANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DAKHILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DALIBHUNGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DALINDYEBO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DAMANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DAMBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DAMBENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "DANGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DANGWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "DENGWANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "DIDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DINGANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DINGEZWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "DLANGEZWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DLEPU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "DLUNGWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DUBA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DUMAKUDE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "DUMILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DUMISA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DUMSI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DUTYINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "EBLORWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "EDOLOPINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ELUKHANYISWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ELUKHOLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ELUNCEDWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ELUTHULINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "EMAXHEGWINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "EMAZIZINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "EMAZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "EMBANDANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "EMBIZENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "EMBOBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "EMGODINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "EMHLANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "EMITSHATSHANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "EMPENDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "EMTHONJENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ESINYAMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ESITOFINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ESSEK JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ETALENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ETYENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "EVUNGENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "EZINGONYAMENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "FARVIEW JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "FAMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "FIHLANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "FIKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SACRED HEART CATHOLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "FOBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "FREE METHODIST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "GABENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "GALILEE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SIKITINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GCINISIZWE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "GCINISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "GCINISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GCUMA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "GECELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "GILLESPIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDIMBANENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GINYINDLOVU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "GOBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "GOGELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "GOVALELE NOMAKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "GOXE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GQINA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "GREENVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "GUBUZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "GUDLINTABA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "GUGU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "GUGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GUNYENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "GUQA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "GWADANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "GWALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GWEXINTABA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "GXWALENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "HEBRON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "HENRY VALTYN SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "HLABATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BUCKLEY FINIZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "HLANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "HLANKOMO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "HOLY CROSS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "HOTOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "IKAHENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ILINGELETHU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ILITHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ISILINDINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "KINGS HARVEST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "IZIBANZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "IZWELETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "JAKUJA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "JALI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "JAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "JILIZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "JOLOBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JONGIKAYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "JONGISIZWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "KABINGELE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "KANYISA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "KHALATSU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "KHALENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "KHOARAI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "KHONJWAYO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "KHOTSHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KOLISAVILLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "KOLONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "KOPANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "KOVOTI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "KU-BHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "KUTLOANONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "KUYASA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "kwaMATAMBO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "kwaGUQA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "kwaMBENYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "kwaMLINDAZWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "kwaNDELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "kwaNDUMISO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "kwaNONDUDUMO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "kwaNTIKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "KwaQONDA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "KwaVELILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "kwaZWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LALATSHE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LALENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LEHANA'S PASS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LEKHAHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LEKHALONG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LEKOENTLANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LEPHEANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LERATO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LIHASENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LIKHETLANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LANGALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LINGELETHU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LINGELETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LINOTSING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LOKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LOWER BROOKSNEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LOWER EMTUMASI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NTLANEZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LOWER MKEMANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LOWER MNYAMANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LOWER MT HOREB SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LOWER MVENYANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NQALWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LOWER QOQO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LOWER ROLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUBALA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUBALEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LUBISINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUCINGWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ST GEORGES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUFAFA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUFEFENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUGADA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUGALAKAXA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUHLEKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUKHAHLAMBENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LUKHOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LUNA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LUPHANDLASI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUPONDO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUQOLWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LUSINDISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUTATENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUTHAMBEKO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "FLAGSTAFF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUXWESA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LUZIE POORT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LWANDLANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MABALENGWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MABHELENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "HILLBROW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MABOBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MABUDU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MADADIYELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MADLALISA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MADUBA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MAFADOBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAFIKALISIU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAFU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAFUBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAGADLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAGEMA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAGONTSINI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MAGUBUNGELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAGWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAGWANYA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAGXENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAGXENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAHLUBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MAJAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAJUBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAKANDA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAKHOBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAKHOSINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MAKHULENG SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MAKOSONKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAKOSONKE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAKWALENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MALIWA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MALONGWE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAMVENYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MANALENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MANASE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MANDILENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MANDLOBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MANGENA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MANGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MANQILO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MANZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAPAKAMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MAPAKATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAPHINDELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAQULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MARIALINDEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MASIZAKHE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MASOBUZA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MALIZE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MATANDELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MATANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MATSHANENG JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MATSHEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MATSOANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MATWEBU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAVELA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAVUNDLENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAWONGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAZAKHELE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAZAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MBABAZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MBADANGO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MBAMBENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MBANGWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MBEKWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MBIBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MBIZENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MBIZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MBIZWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MBODLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MBOMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MBONDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MBONGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MBONO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MBUMBAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MBUNGWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MDAKENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MDATYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MDENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MDENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MDIKISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MECHACHANENG SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MEHLOLOANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MEJE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MELISIZWE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MFUNDAMBINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MFUNELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MGANU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MGODI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MGOMANZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MGQUMANGWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MGUNGUNDLOVU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MGWILI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MHLABUVELILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MHLONYANENI HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MHLOTSHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MHLUTA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MHLUZINI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MIKA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MJELWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MJIKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MJILA'S RIDGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MJOBO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MJOLI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MKAMBATI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MKAMELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MKHOMANZI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MKILWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MKIWANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MKUMENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MLAMBONDABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MLINDAZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MMANGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MNCEBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MNDINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MNELISWA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MNGCISANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MNGENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MNGENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MNQWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MNTWANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MNXEKAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOALOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOEANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOHLAKOANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MOHOABATSANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MOKHALONG JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOLIKO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MONTI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MORITING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MORULANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOWA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MPAMBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MPENKULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MPETSHWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MPINDWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MPOLA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MPOLOSA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MPOZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MPUMALANGA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MPUNGUTYANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MPUNZI DRIFT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MPUTEKANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MQATYENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MQEKEZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MQHOKWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MQHUME SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MRWABO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MSUKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MT FLETCHER VILLAGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOUNT HARGREAVES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOUNT HOREB PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOUNT WHITE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MTAYISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MTHOMBOLWAZI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MTONJENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MTONTSASA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MTSHAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MTSILA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MTWAKU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MVENYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MVUBU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MVUMVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MVUZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MWACA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MYENGWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MZAMENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MZAMO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MZAWUTHETHI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MZIMHLOPHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MZINTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MZONGWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MZONTSUNDU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MZUZILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NATLANE SEKONYELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NAZARETH SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NCAPAI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NCENJANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NCOME JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NDAKANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NDAKENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NDARALA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NDAYINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDINDINDI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NDINOMNTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NDLANTAKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NDLOVIMILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NDUMNDUM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDWALANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NDWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NDZONDWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NDZONGISENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZITHOBILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGCUNGENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NGELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGIBE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NGOJANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NGONYAMENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NGOZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NGQANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NGQINIBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGQONGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NGQONGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NGQWASHU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NGUBELANGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGWAYIBANJWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NGWEGWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NIYONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NJIJINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NKALWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NKAMANI'S SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MKAMBATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NKANJI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NKASELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NKAU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NKOSIBOMVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NKULISA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NKUNDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NOBAMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NOBUSA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NOKATSHILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NOLUTHANDO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NOMKOLOKOTO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NONJONJO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NONKQUBELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NOWALALA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOZAYI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NQABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NQABENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NQALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NTABANKULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NTABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NTIBANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTLAMVUKAZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NTLAVINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NTLOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NTOKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NTOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTONTELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NTSHAMANZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NTSHANGASE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NTSHELENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NTSHENTSHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NTSINTSANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NTUTA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NYANDA DIKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NYATHINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NYOSINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ONGELUK'S NEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "OSBORN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "OUTSPAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "PABALLONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "PAMLAVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "PANGISA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "PATEKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "PELE-PELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "PEPENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "PHALLANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "PHANDAPHANTSI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "PHAPHAMA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "PHARAMAKHULO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "PHUTHING SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "POLILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "POLOKOE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "PONDOMISE RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "POPOPO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "PROSPECT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "QADU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "QAIZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "QAMANGWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "QANQU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "QHIPHU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "QHOBOSHEANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "QOQA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "QUEENS MERCY JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "QUMRA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "QUNGEBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "QUNUBENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "QWIDLANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "R V MANTSHULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "RAMOHLAKOANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "RAVENSCROFT JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ROCKVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "RODE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "RWANTSANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SAHLULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SAHLULO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SAMARIA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SANDLULUBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SANTOMBE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SAPUKANDUKU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SEKHUTLONG SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "JABAVU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SEMONKONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SEQHOBONG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIBONGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIBOZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIDAKENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIDAKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "SIDANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIFOLWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIGAGANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SIGCAU PRACTISING SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIHLAHLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "SIJADU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIJIKA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIJOKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "SILANGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SILASVILLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SILINDINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIMEKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SINGEMBENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIPEPETO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIPHOLA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIPOLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIQHINGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIRHUDLWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SITHINTENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SITIYWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SIVUKILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIYAYA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SIYAZAMA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SIYOYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SIZWE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SKETLANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SOBHEDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SODLADLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SOLOMON GAGANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "SOMTSEU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SONDABA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "SONTSELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ST MARGARET JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ST MARKS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ST MATTHEWS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ST MATTHEWS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ST PETERS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "STANFORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SUNRISE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "SWANE RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TALENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "TANDABANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TEMBENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TEMBISA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TEMBUKAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "THABA-CHICHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "THABA-KHUBELU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "THABANG JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "THABATHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "THEMBALETHU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "THEMBALETHU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "THEMBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "THEMBENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "THEMBILE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "THOKOZANI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "TINANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TLALI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TLHAKANELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "TLOKOENG JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TLOPO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TOBINTETHO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "TOKOZANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TOLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TOLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "TOPOZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TRAMORE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "TSEKONG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TSEKONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TSEPISONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TSEWU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TSHANTSHALA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TSHISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TSHISANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TSHONISWA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TSIBIYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TSIKARONG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TSITSONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "TSWELOPELE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TUMSE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TWAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TYONGWANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ULUNDI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "UMZIMVUBU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "UPPER CABAZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "UPPER DUNGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "UPPER MANDILENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "UPPER MKEMANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "UPPER MNTWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "UPPER MNYAMANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "UPPER MTUMASI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "UPPER MVENYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "UPPER NXOTSHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "UPPER QOQO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "UPPER ROLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "UPPER THOKOANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "VALIPATWA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "VAYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "VOVENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "VUKAZAKHE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "VULINDLELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "VUMINDABA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "YANGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ZAMILIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZAMILIZWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZAMUKULUNGISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ZAMUXOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZANOKANYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZANOKANYO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ZANOKHANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZANOKHANYO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZIBI MEYER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZIGADINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZIMELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZIMISELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ZININI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZINYOSINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZIZAMELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZOKO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZOLA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZWELABANTU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZWELAKHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZWELEDINGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ELLIOT NDABANKULU MAKAULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZWELIDUMILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZWELIHLANGENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZWELIJIKILE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZWELISILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZWELITSHA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZWELIXOLILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MZIWOXOLO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "EZADUNGENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "SIGIDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "KHANYA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LOWER MKHOMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "CLAUDE MAKENG SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUTSHIKINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NALEDI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BULUMKO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZAMEKILE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MHLOPHEKAZI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LUNDINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAQHATSENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MJOKANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIGIDINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MADADANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NQANTOSI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LONGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MZAMBANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LUKHANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "KHANYISANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NTAMONDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NGCOZANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTANZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DALUXOLO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "PHUNGULELWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LIPHOFUNG SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MLENZE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MNAMA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "PHANDULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LAPUMILANGA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZWELIKHANYILE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ST PATRICK'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "PHAKAMISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MQHOKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SAKHISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BRENVAL JACK AND JILL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SPRINGFIELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BULTFONTEIN GIP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "CEDARVILLE GIP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "KENNERSLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOLISANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BOKAMOSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ST THERESA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "kwaRHOLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDENGANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "THEMBA MZIZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ARISE AND SHINE KINGDOM PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ITHUBA WILDCOAST COMMUNITY COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "A B ZAMBODLA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "VUSELELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ABRAHAM VANQA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ALHEIT VAN DER MERWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ALIWAL NORTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "AMAQWATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "AMAVUNDLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ANAKO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "B A MBAM JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BAKANENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BALMORAL GIRLS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BARKLEY EAST (DRC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BARODA D R C PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BELMORE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BENSONVALE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BILATYE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BOLOTWA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NKOSEMNTU MOTMAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BONGOLETHU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BONISWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BOWDEN JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BRAAMSPRUIT FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "VICTORIUS KINDERGARTEN AND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BULHOEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CALA COMMUNITY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CALA PASS PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "CARINUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "CATHCART (RC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "CEBANO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "CHIEF MALEFANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "CHRIS HANI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "CIMEZILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "COFIMVABA VILLAGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "COVERSIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "CRADOCK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "THE ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "CUBE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "D G COSSIE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DABULAMANZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "DALASILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DALIWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "DALUBUZWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "DALUVUYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "DANGER'S HOEK JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "DE HOOP SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "DR PALLO JORDAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "DUM-DUM SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "DYOBUDAKA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "E MACEMBE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "EARDLEY JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "EDELWEISS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "EDLELWENI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "EKUZOLENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ELINUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ELLEN OLIVIER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ELUTHUTHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "EMDENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "EMFULENI LHP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "EMJIKELWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "EMMET MAHONGA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "EMPUMELELWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ENGOTINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ERA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ESETHU PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "EVENDALE FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "EZINTATYANENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "AMOS MLUNGWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GCINA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GOBINAMBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "GOSHEN PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "GREYSPAN JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SIBUYELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GUATA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "GUBA HOEK JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GUNGUBELE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GUSI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HACKNEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "CHRIST THE KING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "GET AHEAD PROJECT QUEENSTOWN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "FLAMINGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HELUSHE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "HEUKILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "HILLSIDE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HINANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HLALETHEMBENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HLATHIKHULU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "HLATIKULU PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HOFMEYR (DRC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "HOLY CROSS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NEW HORIZON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HUKUWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "IKAMVA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "INDWANA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "INDWE (METH) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "INTLANGANO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LAMPLIGHT CHILDREN MINISTRIES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "IXHADI LABANTWANA HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "J A NCACA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "JONGINAMBA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "JONGULWANDLE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "JOVELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "JULIUS MBALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "JUMBA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "KAREEFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "KAREL THERON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "KAULELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "KEIBRIDGE FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "KHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "KHAYAMNANDI PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "KHULUSOMELELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "KLEINBOOI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "KOMANA'S JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "KUDE KWALAPHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "kwaGCINA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "KWABABA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "KWEZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "KWINANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "L M SILINGELA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LAERSKOOL UNIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LAMPLOUGH JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LEHMANS DRIFT SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LESEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LESSEYTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LINGELETHU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LONWABO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LONWABO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LOUIS REX PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LOWER CALA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LOWER DIDIMANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LOWER LUFUTA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LOWER SEPLAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LUKHANJI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "W R SONDLO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LUNGILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LUQOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LUSINDISO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LUTUTU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LUVUYO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LUXA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MACKAYSKOP FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MADWALENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MAGUMBU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MAHLATINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MAIN JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MAJUBA NEK JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MAKHETHA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MALETSWAI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MANZIMDAKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MANZOLWANDLE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MAQASHU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MAQOMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MAQUBELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MARSHMOOR FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MASAKANE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MASAKHANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MASIZAKHE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MBEWULA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MBIHLI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MBODLANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MBONISWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MCEULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MCEULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MDIBANISO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MICHAUSDAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MIDDELPOS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MILNER FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MINAH T SOGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MKHITHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MKUNYAZO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MNXE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MPENDULO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MPOKI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MPOMVANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MPUMELELO MFUNDISI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MPUMELELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MROBONGWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MTEBELE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MTETUVUMILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MTHABISA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MTHAWELANGA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MTHOMBOWESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MTHONYAMA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MTINGWEVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MTWAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MZAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MZAMOMHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NANISO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NCALUKENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NCEBA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NCHAFATSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NDIMANGENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NDINGISHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NDLANGISA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NDUNGUNYA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NDZONDELELO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NEW HOPE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NGANGAMANZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NGOGODOVILLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGOJINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NGQANDA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGQWASHU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGXUMZA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NJOMBELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NKOSIYAKHE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NKULULEKO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NOBANDLA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NOBUBELE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NOBUNTU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NOGATE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NOKWANDA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NOLUKANYO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NOMADAMBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NOMONDE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NOMPUCUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NOMPUMELELO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NOMVUYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NONESI PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NONESI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NONKUNZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NONTEMBISO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NONYANISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NONZWAKAZI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NOWISILE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NOZUKO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NQININGANA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NTABANKULU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NTABELANGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NTLALONTLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NXASANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NXUBA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NYALABANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NYALASA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NYANISO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "OPENSIDE FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "OVISTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "PAKAMANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "PELOMOSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "PENHOEK SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "PHAHAMENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "PHAKAMISA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "PHAKAMISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "PHUMLANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "PIETERSRUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "PLATKOP JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "POPLAR GROVE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "QHEMEGHA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "QIBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "QUEEN'S COLLEGE BOYS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "QUMANCO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "QUMBU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "QUTUBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "QWABI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "REBEL'S KLOOF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "RIETSPRUIT SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ROMANSLAAGTE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ROSMEAD (DRC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ROSMEAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "RWANTSANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "RWANTSANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SADA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SAMEKOMS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SCHOOMBEE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SHASHA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SHILOH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SIDAKENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SIFONONDILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SIGWELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SINGENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SIYABULELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SIYAKHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SIYAKONWABA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SIZAMILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SIZAMULWAZI PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SIZWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MASIKHULE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SOLOMON AKENA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SOUTHEYVILLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ST AUGUSTINES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ST BEDES PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ST BONIFACE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ST CYPRIANS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ST MARK'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ST MARY'S SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ST MICHAEL'S JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ST PETER'S ON INDWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ST THERESA'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "STONEHENGE FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "STONY CROFT JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "TAFENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "TARKASTAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "TEMBANI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "TEMBEKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "TEMBELIHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "TEMBILIHLE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "TEVIOT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "THANDISIZWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "THE WILLOWS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "THEMBELIHLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "THEMBISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "THORNVALE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "THREE CROWNS SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "TLHAKONG SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TSAKANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "TSAWULAYO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "TSEMBEYI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TSENGIWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TSHATSHU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "TSITSIKAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "UITKYK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "UMHLANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "UMLAMLI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "UPPER CALA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "UPPER INDWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "UPPER LAHLANGUBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "UPPER LANGANCI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "UPPER LUFUTA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "UPPER MTINGWEVU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "UPPER NCUNCUZO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "USENATHI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "VAN COLLER PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "VAN DER MERWE MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "VOLMOED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "VOYIZANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "VUKUKHANYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "VULAMAZIBUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "VULINDLELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "VUMILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "VUYOLWETHU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "W Z TOFILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "WAAYPLAATZ PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "WARTRAIL FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "WHITTLESEA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "WITTEBERGEN COLLEGE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "WODEHOUSE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "XUMABOKWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "YONDA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ZAMICEBO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ZAMAKULUNGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ZAVA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZENZILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ZINGISA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZINGQUTU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZITOBILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ZULUMEMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZWELIBANZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZWELIHLANGENE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZWELIXOLILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ZWELIXOLILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SOUTHBOURNE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "DORDRECHT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "KAMASTONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "CLAREMONT JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LAERSKOOL BURGERSDORP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MARUPING PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ISIKHOBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TEMBILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NOBUZWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "PHAKAMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "TSEKANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MVUMELWANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MTWAKU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MZAMOMHLE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MASIVUYE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MKAPUSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "AGNES SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "DALUBUZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NYONGWANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "CRADOCK PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MATAFENI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "KULONGQAYI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZIGUDU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DALISIZWE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NTSHINGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TALENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HANGKLIP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "TRANSWILGER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NOLITHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LAHLANGUBO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DYOFILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NDLUNKULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "HOYANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MASIZAKHE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MELISIZWE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NXALESA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "RODANA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "EMAZIMENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "TABATA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DWAYI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DAMANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "KHULILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SIYAVUYA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "UNATHI MKEFA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "STEPPING STONE JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NKOSI SIKELELE PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "CHRIST THE KING JUNIOR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ROYAL CAPITAL EDUCATION CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "JACK AND JILL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "KINGDOM COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ABUNDANT LIFE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BHOLANI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DEDENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MTHAWELANGA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HEBRON CHRISTIAN INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LAER NANAGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "St PAUL HILTON PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MASIKHANYISE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "OCEANVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "STEPPING STONE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "DE HOOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HAMBAKUHLE FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LUSHOF STATE AIDED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "BAVIAANS KOUGA ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "EKUPHUMLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "2MORROW LEADERS PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "Gemrock Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "Glen Hill Private Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "Lighthouse Christian Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "Michiefield Primary"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "Playways Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "Seven Star Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "Dayspring Primary"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "St. Joseph Primary"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "Our Saviour Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MARANATHA ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ETORA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "OR TAMBO COASTAL",
      "School_Name": "DILIZINTABA JUNIOR PRIMARY SHCOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "OR TAMBO INLAND",
      "School_Name": "SIYAVUYA SENIOR PRIMARY SCHOOL (USATHETHA)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "OR TAMBO COASTAL",
      "School_Name": "EL Shadaai PS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "OR TAMBO INLAND",
      "School_Name": "Apollo Progressive School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "OR TAMBO INLAND",
      "School_Name": "Pink and Blue Kindergate Primary"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "OR TAMBO INLAND",
      "School_Name": "Smiley Tots Academy"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "Sikelelwen Adventist Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "Chris Hani West",
      "School_Name": "Riverside Christian Academy"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "Chris Hani West",
      "School_Name": "Oakwood Junior Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "JIM-JIM INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LAWLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "POSEIDON ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ALPHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "APEX PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ALOE RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "FLAMINGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "GREYVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "HARMONY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "IMPALA CRESCENT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LENASIA MODEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "SIERRA NEVADA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "KIASHA PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LANCASTER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MADIBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LIBRA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "PARKSIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "PENTAROSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "PROGRESS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "SHARICREST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ZODIAC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "GLENANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "HARVEST CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LAERSKOOL DANIE THERON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MONDEOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MULBARTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ATAMELANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "BAFIKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "BASANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "BUSISIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "DIKGABANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "DIODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "EBUHLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ELSIE NGIDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "EMAWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "EMSENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ENKANYEZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ESITHEBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "EZIBUKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "GAZANKULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "HITEKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "IKEMELENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "INDYEBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ISU'LIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ITEMOGELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "KARABO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "KGATELOPELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "KHAUHELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "KHOTSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "KHUTHALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "KING ZWELITHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LEITSHIBOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "THUTHUKANI-TSWELOPELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LETHABO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LO ITEKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LUMELANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LUYOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MAMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "FINETOWN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MARA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MEGATONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MERAFE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MONTSHIWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MORITING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MOTSANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MVELEDZANDIVHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "NHLUVUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "PHUMUZILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "PUTALUSHAKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "PROTEA SOUTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "REBONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "SEDIBATHUTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "SIBONGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "SIVULELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "THABA TSHEHLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "THATHANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "THULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "TIAKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "TSHILIDZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "IMPUMELELO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "VUSISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ZIBAMBELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ZOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "OLIFANTSVLEI PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "DAXINA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MID-ENNERDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ODINPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "SPECTRUM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "SAINT GEORGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "BUYANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "AL-AQSA SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "THOLIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "BOEKENHOUT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "CAVENDISHSTRAAT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "DELRADO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ELDOCREST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ELDORADO PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ELDRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "EW HOBBS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "FIRETHORN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "FLORIDALAAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "GOUDPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "HEERENGRACHT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "KLIPTOWN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MCBAIN CHARLES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MILNERTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "NANCEFIELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "PARKDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ST IVES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "FOREST HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "HIGHVELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LAERSKOOL DALMONDEOR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LAERSKOOL SUIDHEUWELS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MONTANUS LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LAERSKOOL THEO WASSENAAR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "TURFFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LAERSKOOL VOORBRAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LAERSKOOL W H COETZER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MEREDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "NATURENA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "PARK JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "PARK SENIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "REGENTS PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "REWLATCH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ROBERTSHAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ROSETTENVILLE CENTRAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "CRESTVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "TOWNSVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "WINCHESTER RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BATSOGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "DIKWANKWETLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "EKUPHUMELELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "EMADLELWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "EMATHAFENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ENTANDWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "FARESANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "HLAKANIPHANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ISAACSON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ISIPHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "JABAVU-OOS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "KHANDUBUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "KHOLWANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LEIHLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LILYDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LULAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MDELWA HLONGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MOCHOCHONONO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MOLALATLADI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MOTJOLI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MXOLISI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NKHOLI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "NONTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "PAUL MOSAKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "PHAKAMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "PIMVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "SEFIKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "SEKWATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "SIYAVUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ST PETER CLAVER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "THEMBU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "THUSANANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "TLHOLOHELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "TSHEBEDISANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "USINDISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "WELIZIBUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "WINNIE-NGWEKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "WISANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LAKEVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ELDORADO PARK MUSLIM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "FEED MY LAMBS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "CROSBY ACADEMIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "AUCKLAND PARK PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BERTRAMS JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CYRILDENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "EP BAUMAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "EASTGATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "EMMARENTIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "FAIRSAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "FAIRVIEW JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "GREENSIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BEREA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "HILLCREST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "HOUGHTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "I H HARRIS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "JEPPE HIGH PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "JOHANNESBURG GIRLS' PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "JOHN MITCHELL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KENSINGTON RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KING EDWARD V11 PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ORCHARDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LAERSKOOL JAN CELLIERS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "LAERSKOOL KENSINGTON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "LEICESTER ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "LINKSFIELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MALVERN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MAYFAIR CONVENT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MELPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "YESHIVA COLLEGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "NORWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "OBSERVATORY EAST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "OBSERVATORY GIRLS' PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ORANGE GROVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "PARKVIEW JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "PARKVIEW SENIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "PATERSON PARK SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "HESPERUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ASTERI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ROSENEATH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SAXONWOLD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SIR EDMUND HILLARY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ST JOHN'S PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ST KATHARINE'S PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SUMMERWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "THE RIDGE PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "TROYEVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "YEOVILLE BOYS' PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "YEOVILLE COMMUNITY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "AB XUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MBUYISA MAKHUBU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "DITAU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "DITAWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "DONALDSON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "EMISEBENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "IGUGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "IKWEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ISISEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ITEKENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "LEKANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LERATONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LERESCHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LUKHOLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MOETAPELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MOHLODING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MOKOROTLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MOLAETSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MOLEMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MZAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "NKA THUTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ORLANDO SDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "RUTEGANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SAPEBUSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "SELOPE-THEMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "MAKOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "SHALOM-MANNE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SHOMANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "SIZANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ST JOHN BERCHMANS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ST MATTHEWS PRIVATE PRIMARY SCHOOL (KLIPTOWN)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "THABANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "THABISANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "THEMBALIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BREE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "PROGRESSIVE BRIDGING SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "TSHEBELISANONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "TSHEDIMOSHO-MEHLALENG PRIM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "VEZOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "VUKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "VUKAZENZELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ZAKHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ZITHATHELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "CROWN REEF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "FERREIRA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "FORDSBURG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KING DAVID PRIMARY SCHOOL LINKSFIELD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "UVUYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "CROWN REEF PRIMARY MINE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "PARKTOWN PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "RADFORD HOUSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ST JAMES PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BERNARD ISAACS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BOSMONT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "GR HARRIS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NOORDGESIG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "RIVERLEA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ST THERESA'S CONVENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "CLIFFVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LAERSKOOL CLAREMONT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LAERSKOOL ESPERANZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LAERSKOOL FAIRLAND"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LAERSKOOL GENERAAL CHRISTIAAN DE WET"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LAERSKOOL JIM FOUCHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LAERSKOOL PIET VAN VUUREN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NORTHCLIFF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BAPEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BOEPAKITSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BOPANANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "DUMEZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "DZATA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "EMPUMALANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "EMZIMVUBU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "GIYANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "HLABANGANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "IKANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "INKWENKWEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "IPOLOKENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "JS MPANZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "KHOMANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "KWA-PHALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LEJOELEPUTSOA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LIVHUWANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LOURDES PRIMARY PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MANGWELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MASEKHENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MAWILA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "TSIETSI MASHININI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MORUTA THUTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NANDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "PALESA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "QHOBOSHEANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "REBONGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "RISHILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "SALVAZIONE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MEADOWLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SIVELILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "THABISILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "THOBEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "TIYIMISENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "TOTOMENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "TSHIRELETSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "TSOGANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "TSUMBEDZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "TSWELELANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "TUMANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "TUMELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "WK MAPONYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "WEST RAND SDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "T C ESTERHUYSEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NEWCLARE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "DOWLINGLAAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "WILHELMINA HOSKINS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "EVEREST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "WESTBURY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "THEMBALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NORTH WEST CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BLAIRGOWRIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BORDEAUX PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BRAMLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BRYANDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BRYANSTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BRYNEVEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BUCCLEUCH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CRAIGHALL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "FAIRWAYS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "FRANKLIN D ROOSEVELT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "GLENHAZEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "GRAYSTON PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "H A JACK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "I R GRIFFITH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KING DAVID PRIMARY (SANDTON) SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "KING DAVID PRIMARY (VICTORY PARK) SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BOSKOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BRYANSTON PARALLEL MEDIUM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LAERSKOOL FONTAINEBLEAU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "LAERSKOOL HALFWAY HOUSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LAERSKOOL LOUW GELDENHUYS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LAERSKOOL UNIKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "LYNDHURST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MIDRAND ENGLISH MEDIUM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MONTROSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "PARKHURST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "PRIDWIN PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "RAND PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "REMBRANDT PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "RISIDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "RIVONIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ROBIN HILLS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ROSEBANK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "SHARONLEA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ST PETER'S PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "VULEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "WENDYWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BLAIR ATHOLL PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BOVET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CARTER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "DR KNAK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "EKUKHANYISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "EMFUNDISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "GORDON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "IKAGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MASAKHANE-TSWELELOPELE FS-EX IMPUMELELO-ZANDSPRUIT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "IPHUTHENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ITHUTE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "KINGSWAY CENTRE OF CONCERN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "M.C. WEILER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "RIVERSANDS PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SEFIKENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SKEEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "WITKOPPEN COMBINED FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ZENZELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MUZOMUHLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BEAULIEU PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CRAWFORD PREPARATORY SANDTON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "TRINITY HOUSE PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "CRAWFORD PREPARATORY FOURWAYS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MARIA MONTESSORI HOUSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "INKANYEZI WALDORF CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KYALAMI PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MUSENGA VHADZIMU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "DROMMEDARIS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "EKURHULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "GOEDE HOOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAKESIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "REIGER PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "VILLA LIZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BEDFORDVIEW CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BEDFORDVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "COLIN MANN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "DINWIDDIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "DUNVEGAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "EASTLEIGH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "EDENGLEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "FREEWAY PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "GERMISTON SOUTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "HURLYVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "KLOPPERPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAERSKOOL BAANBREKER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAERSKOOL CONCORDIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAERSKOOL DELVILLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL DIE PRESIDENT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAERSKOOL ELANDIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAERSKOOL ELSBURG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAERSKOOL ELSPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAERSKOOL GERMISTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAERSKOOL GOUDRAND"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAERSKOOL LEONDALE PARALLEL MEDIUM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL M W DE WET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL OOSTERKRUIN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAERSKOOL VAN DYK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL WESTWOOD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAERSKOOL WITFIELD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ALSTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MARTIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "PARKDENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "PARKRAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "GALWAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LEEUWPORT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "PRIMROSE HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "PRIMROSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SUMMERFIELDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SUNNYRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "WIT DEEP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "WYCHWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ABINALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "BOPANG-KGOTSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "FORTUNE KUNENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "INDIVIDUAL TEACHING COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "THEMBIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "KHAYELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "KUTLOANONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MTHIMKHULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "NAGENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "NDLELENHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "NEW COMET PRIMARY MINE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "POLOKEGONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "REBONTSHENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "THABANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ZIMELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ST MICHAEL'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "THULASIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MAMPUDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "DAWN PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "WINDMILL PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "PHUMULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SCHOOL OF MERIT PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ORHOVELANI EDUCATION CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "ONVERWACHT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "BRONKHORSTSPRUIT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BROOKLYN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "GLENSTANTIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "IRENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL ANTON VAN WOUW"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL BAKENKOP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL CONSTANTIAPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL DORINGKLOOF"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "LAERSKOOL DU PREEZ VAN WYK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL ELARDUSPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL FLEUR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL GARSFONTEIN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL LOUIS LEIPOLDT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL LYNNWOOD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL MENLOPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL MONUMENTPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "OLIFANTSFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL PARATUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "LAERSKOOL RAYTON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL ROOIHUISKRAAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL SWARTKOP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "LAERSKOOL TYGERPOORT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL UITSIG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "VHALLIESPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL WIERDAPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "LAERSKOOL WITPOORT NR 224"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LYNNWOOD RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LYTTELTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SPRINGVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ST PAULUS LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "VALHALLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "WATERKLOOF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BEKEKAYO PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "BOSCHKOP PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "EMATSHENI PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "IRENE MIDDLE FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "FOXTROT PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "KGORO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "RETHABISENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "SEDIBENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "VEZULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL HENNOPSPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "JABULANI JUNIOR PRIMARY PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRETORIA PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "CHOKOE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "WALTER SISULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "FRED MAGARDIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "NANTES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "NORRIDGE PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "P S FOURIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "GEREFORMEERDE LAERSKOOL JOHANNES CALVYN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL DERDEPOORT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL LINDOPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL MEYERSPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL NELLIE SWART"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL RIETFONTEIN-NOORD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL SILVERTON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL SKUILKRANS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL TOTIUSDAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL VILLIERIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL QUEENSWOOD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL VOORPOS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LORETO SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "AGNES CHIDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BAJABULILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BALEBOGENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BOHLABATSATSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BOIKGANTSHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BULA-DIKGORO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "DR IM MONARE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "EMASANGWENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "EMTHUNZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "EZAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "KOOS MATLI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "KUTUMELA-MOLEFI INTM. FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MOGALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MONONONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MORAKOMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MORETELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MOTHEO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MVELEDZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "N'WA-VANGANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "NDIMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "F.F. RIBEIRO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PHELADI-NAKENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PULA-DIFATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "REFENTSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "RETHAKGETSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SHIRINDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SINDAWONYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SIKHANYISELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "TLAKUKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "TSHIMOLLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "UMTHOMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "UOANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ZAKHELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ZAMINTUTHUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LA MONTAGNE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MAHLASEDI - MASANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LEGORA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "NELLMAPIUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "RAMAHLALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "GOTTFRIED CHRISTELIKE PRIVAAT SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MEETSE-A-BOPHELO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "JAN KOTLOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PFUNZO NDI TSHEDZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "VUKAUZENZELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ANDREW ANTHONY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HILLSIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "JACARANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAUDIUM HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAUDIUM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "OMAR H.S.EBRAHIM LOTUS GARDENS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ARCADIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BURGHER RIGHT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "CAPITAL PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HAMILTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL BERGSIG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL BOEREFORT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL BOOYSENS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL BROEDERSTROOM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL WESTERLIG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL DIE HEUWEL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL EBEN SWEMMER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL EENDRACHT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ERASMIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL GENERAAL BEYERS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL GENERAAL JACQUES PIENAAR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL GENERAAL NICOLAAS SMIT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL HERMANSTAD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL JOPIE FOURIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL KAMEELDRIFT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL KWAGGASRAND"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL MAYVILLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL OOST-EIND"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "LAERSKOOL PRESDA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL PRETORIA-OOS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "RIVIERA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL SAAMSPAN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL SIMON BEKKER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL TUINE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL TUINRAND"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL WESPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL WONDERBOOM-SUID"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "RIETONDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "ROBERT HICKS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SUNNYSIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "WATERKLOOF HOUSE PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BANARENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BATHABILE PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BATHOKWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BUD MBELLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ESIKHISINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "CONFIDENCE COLLEGE (GOOD SAMARITAN)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ISAAC MORE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "JJ DE JONG PRIMARY SHCOOL SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "KGABO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MABAFENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MAHLAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SEFAKO MAPOGO MAKGATHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MAKGWARANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MAREMATLOU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MASIZANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MATSEKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MOTSWEDING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "N'WA MHINGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "PARADISE BEND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PATOGENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PEPPS MOTHEONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PHILENA MIDDLE FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SEAPARANKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ST ANNES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "THOHO-YA-NDOU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "WALTON JAMESON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL PIERNEEF"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAERSKOOL HENNOPSRIVIER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PHUTHADITSHABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "BRINDHAVEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "ASSUMPTION CONVENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL AKASIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL DANIE MALAN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL HAAKDOORN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "LAERSKOOL KLIPDRIFT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL MAGALIESKRUIN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL RACHEL DE BEER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL STEPHANUS ROOS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL THERESAPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL UNIEFEES"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL VISSERSHOEK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LAERSKOOL VOORTREKKER-EEUFEES"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LAERSKOOL WONDERBOOM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "NORTHRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "A RE THABENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "AYANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "BAXOXELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "DITHABANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "ENTOKOZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "RETHABILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "ST FRANCIS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "IKHWEZILETHEMBA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "KGOTLELELANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "KHENSANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "KODUMELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "KUTUNG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "LEEUWFONTEIN PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LESEDI POTLANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LINDELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MAFUMBUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "MATHAGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "MEETSENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MMABANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MOKONYAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MZIMUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "NCHUNCHEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "NTSHA PEU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "ONDERSTEPOORT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "PADISAGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "PHAKAMONOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "PHUMZILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "PHUTHANANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "DIMAKATSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "PULAMADIBOGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "RAIKANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "REDIBONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "REFITHLILE PELE PRIMARY SCHOOL NO 1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "RODNEY MOKOENA PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "RIVONINGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "RS MALULEKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "SEDIBA-SA-TSEBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "SEETSA-SA-KGWEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "TIAMOKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "TIPFUXENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "TLAMAGANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "TSAROGA-PHOKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "UBUHLE-BEZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "UTHANDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "VUKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "VUKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "PRINCESS PARK COLLEGE ROSSLYN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "LAERSKOOL KAMEELFONTEIN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "LAERSKOOL DIE POORT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "SHALOM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "SINQOBILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "ITUMELENG MADIBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "BOKAMOSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "REABETSWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LESEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "GONTSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "DR YUSUF DADOO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ARTHUR MATTHEWS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "C.V.O. SKOOL WESRAND"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "CONSTANTIA KLOOF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "DISCOVERY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "FLORIDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "HORIZON VIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "KRUGERSDORP TOWN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL BEKKER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LAERSKOOL CULEMBEECK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LAERSKOOL DIE RUITER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LAERSKOOL DR HAVINGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL EBENHAESER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "UNITY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LAERSKOOL FLORIDA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LAERSKOOL GENERAAL DE LA REY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LAERSKOOL GUSTAV PRELLER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL HEKPOORT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LAERSKOOL HELDERKRUIN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LAERSKOOL HORISON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LAERSKOOL JOZUA NAUDE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL KENMARE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL KRUGERSDORP-NOORD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL MULDERSDRIF"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL NOOITGEDACHT NR 88"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL PAARDEKRAAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL PROTEARIF"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LAERSKOOL ROODEBEECK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LAERSKOOL ROODEKRANS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MONUMENT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "PANORAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "PRINCESS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "RIDGEVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "SILVERFIELDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "WELTEVREDEN PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "ATLHOLANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "BOIKANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "BONAMELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "BOSELE PUBLIC INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "DIE POORT PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "DIPHALANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "DSJ PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "DURBAN DEEP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ENKOLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "ENTUTHUKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ITHEMBALIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "KHASELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "KHULULEKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "KWAGGAFONTEIN PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LENGAU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LODIRILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MAKHOARANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MALONEYS EYE PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MARGARET GWELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MATLHASEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LESEGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "PHATUDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "RAND GOLD PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SAMUEL MANGALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "SANDILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SENYAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "SETLOLAMATHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ST ANGELAS PRIMARY PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "TARLTON PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "THABANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "THATHEZAKHO L.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "THEMBILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "THUSONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MAYIBUYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "TSAKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "TSHOLETSEGA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "HECTOR PETERSON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "WD OLIPHANT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "WEST RAND PRIMARY MINE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ROODEPOORT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MPHE-THUTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "THUTHUZEKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "KID MAPONYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "KLIP VALLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LEWISHAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "TSHEPISONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "FARANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "PATRICK MASHEGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL MILLENIUM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ASTON MANOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BIRCH ACRES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BONAERO PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "CRESSLAWN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "EDLEEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "KEMPTON PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL BIRCHLEIGH"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL BREDELL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "CHLOORKOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL EDLEEN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL IMPALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL JEUGPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL KEMPTON PARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL KREFT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL KRUINSIG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL MOOIFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL NOBEL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL VAN RIEBEECKPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "NORKEM PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "WESTSIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BOJELONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BONWELONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BUZY BEE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "EBOMINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "EMMANGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ENDULWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ENTSHONALANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "GAHLANSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "P.S. TSOSANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "PHOMOLONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "INXIWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "IPONTSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ISEKELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ISIZIBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "IVORY PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "KHATLAMPING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "KHULA SIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MARHULANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MASHEMONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MEHLARENG COMBINED FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MIKATEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MODUOPO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "REBONWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MORITING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MVELAPHANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "NYIKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "PHUTHUMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SAFFOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SEDIBENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SEOTLOANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SHUKUMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SIPHIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ST GEMMAS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ST MATTHEWS PRIMARY SCHOOL (KEMPTON PARK)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "THUTHUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "TLAMATLAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "TLHAKANANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "TSHEPISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "UMTHAMBEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "WELOMLAMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "REAGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "EBONY PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KANANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SOLID FOUNDATIONS PRIVATE SCHOOLS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "HARTZSTRAAT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "TOEKOMSRUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAER GEDENKSKOOL DANIE THERON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL WESTGOLD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL BLYVOORUITSIG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL DAGBREEK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL DE BEER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL GERRIT MARITZ"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL JONGSPAN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL AVANTE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL MODDERFONTEIN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL OOS-DRIEFONTEIN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL RANDFONTEIN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL RAPPORTRYER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "THUTO BOKAMOSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL VENTERSPOS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "RANDFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "ROCKLAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "WESTFIELDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "WESTONARIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "BRANDVLEI PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "BULELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "FJL WELLS PRIMARY MINE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "HLANGABEZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "IPELENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "ISIQALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MABLOMONG INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MALERATO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MAPUTLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MATLAPANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MOHLAKANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MOHLAKENG PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "NAYABOSWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "PHANDULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "SEATILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "SEDIMOSANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "SETHOLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "TSWELELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "KAMOGELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "HLANGANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "GELUKSDAL PRIMERE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ACTONVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BENONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "PIONEER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "RYNSOORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ANZAC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ARBOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BENONI JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BENONI WEST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "BRENTHURST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "CRYSTAL PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "FARRARMERE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LAERSKOOL BRAKPAN-OOS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL BRENTWOODPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LAERSKOOL DALVIEW"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LAERSKOOL KOMMANDO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LAERSKOOL MOREWAG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL NORTHMEAD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LAERSKOOL DIE AREND"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL PUTFONTEIN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL RYNFIELD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LAERSKOOL VERKENNER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "BRAKPAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "DALPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "RYNFIELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ST COLUMBA'S SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "TOM NEWBY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "BAFO CHIKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "BAIKAGETSE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BHEKIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "DAN PHARASI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "DAVEYTON INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "DUMEHLEZI INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "EKUKHANYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "EMAROMENI PRIMARY PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ENKANGALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "FUNUKUKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "GEORGE MBILASE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "GUGULESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "INKATHA KA ZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ISAAC MAKAU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "JS MALAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "KATLEGO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "KGALEMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "KGOTHALONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "KHOMBINDLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "KUZIMISELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LEBONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LERUTLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LESABE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LETSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LETSIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "THEMBELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MADINGOANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MAGALELAGASE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MANDLETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MANGOSUTHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MELODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MICHAEL ZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MOSHOESHOE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "NCHABELENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "NQUBELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "NTSIKANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "PHUMLANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ROLIHLAHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SHADRACK MBAMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SIBONELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SIPHETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SIPHUMELELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SOLOMON MOTLANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "THOPODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "THUTHUKANISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "TSAKANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "TSHIPI-NOTO INTERMEDIATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "UMNYEZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "VUYANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "KINGSWAY INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "WJ MPENGESI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LEE RAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "KGOLAGANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ZAMUKHANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SAZAKHELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LANGAVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "DALPARK PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LAERSKOOL FRIKKIE MEYER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LAERSKOOL HENDRIK VAN DER BIJL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LAERSKOOL NOORDHOEK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LAERSKOOL OOSPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LAERSKOOL PARKSIG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LAERSKOOL TOTIUS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LAERSKOOL VAALRIVIER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "OLIVER LODGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "AHANANG INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "ATLEHANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "BAFOKENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "BARRAGE PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "BATLOUNG INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "BOPHELONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "BOTLEHADI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "BULA TSELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "BULADITSHABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "DR NHLAPO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "EKUJULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "ELITE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "EMANZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "FADIMEHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "FUKAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "IKOKOBETSENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "IMFUNDO MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "IPHAHLOLLENG INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "ITOKISETSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "ITSEBENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "JABULANI THABANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "KHUNOANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "KITSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LEFIKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LESEDI-LA-THUTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LETSEMENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LETSHEGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LINDISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MABOELLENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MAGASELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MAKAPANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MAKGETHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "EVATON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MFUNDO-MTOTI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MOGOGODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MOJALA-THUTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MOLOANTOA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MONTSOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MOSIOA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MOTLOTLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MOTSEWAPELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MQINISWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "MTHOMBOLWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "NTSELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "PHAHAMANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "PHAMEHLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "PHEHELLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "PHEPANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "PHUTHULLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "PITSENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "POHOPEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "QHOWENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LETSEMA-ILIMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "QWELANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "RADIPEU PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "SEEISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "SETLABOTJHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "SIVIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "SIVUSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "THABENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "TJHABATSATSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "TLHOLO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "TSHEMEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "TSHEDISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "TSHIRELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "TSHITSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "TSOARANANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "TSOKOLIBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "UBUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "ZITHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "ZITHULELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "DINOKENG PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "RUST-TER-VAAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "ROSHNEE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "ARCON PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "BROADLANDS SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LAERSKOOL D F MALHERBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LAERSKOOL DE DEUR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LAERSKOOL MIDVAAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LAERSKOOL DRIE RIVIERE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LAERSKOOL EMFULENIPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LAERSKOOL HANDHAWER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "RANDVAAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LAERSKOOL KOLLEGEPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LAERSKOOL REPUBLIEK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LAERSKOOL RISIVILLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LAERSKOOL SONLANDPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LAERSKOOL SUIKERBOS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LAERSKOOL UNITASPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "ELIGWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LAERSKOOL VOORWAARTS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LAERSKOOL VRYHEIDSMONUMENT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "MEYERTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "MILTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "PARK RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "PINEDENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "SANCTA MARIA JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "SELBORNE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "AMSAI PRIVATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LESEDI LA KRESTE ANGLICAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "ASSUMPTA PRIMARY PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "EMMANUEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ITEMOHENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "KGOMOCO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LEBOWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LEHLASEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MADUME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "MATSIE STEYN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "MICHAEL RUA INTERMEDIATE FARM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MOYISELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "NOMINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "PANFONTEIN INTERMEDIATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "PUDUMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "QHAKAZANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "QOQISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "RADIPABI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "RATASETJHABA PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "REAMOHETSOE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "REFALLETSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "REKGUTLILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "SEIPONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "SELIBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "THOMAS NHLAPO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "TSHEPANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "TSOELOPELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "VUKUZAKHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "VULINDLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "VUYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ZONKIZIZWE PRIMARY SCHOOL ORANGE FARM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "VAAL TRIANGLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "INTLONIPHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LAUS DEO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ORANGE FARM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "TIISETSO-BEKEZELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "STRETFORD EXT 8 PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "REITUMETSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "GOVAN MBEKI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "EDENPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "OPELWEG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "STONERIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "SHALIMAR RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ALBERTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ALBERVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "BRACKENHURST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "GLENVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "HEIDELBERG PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "KENTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LAER VOLKSKOOL HEIDELBERG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LAERSKOOL A.G.VISSER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAERSKOOL GENERAAL ALBERTS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAERSKOOL ORION"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAERSKOOL PRESIDENT STEYN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAERSKOOL RANDHART"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "SEDAVEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ABRAM HLOPHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "M.M MOEKETSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "CATHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "CHIVIRIKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "DE BRUYN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ENCOCHOYINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "FOUNTAIN FIVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "HLEZIPHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "IGAGASI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "INTOKOZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "IZIBUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "KABELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "KEKETSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "KHEHLEKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "KUMALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LERATADIMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LUNGISANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MAITJIBULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MAPHANZELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MATSEDISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MOGOBENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MOHAUNG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MOHLODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MONDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MONTIC PRIMARY FACTORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MOROJANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MUTINGATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "NOKULUNGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "NQUBELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "NTUTHUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "PHEASANT FOLLY PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MAGAGULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "REAHILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MANZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "SAKHILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "SEKGUTLONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "SETSING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "SIMUNYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "SITHOKOMELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "SONQOBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "THABOTONA PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "THOKOZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "THULISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "TIKELO PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "TSHABALALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "TSHWARAGANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "UKHANYISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "UMKHATHIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "UMTHOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "UMZAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "VUMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ZONKIZIZWE PRIMARY SCHOOL KATLEHONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "THEMBALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "TAMAHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "RATANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "GREENFIELDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "COSMO PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "REALEBOHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ALRAPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ENDICOTT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LAERSKOOL CHRISTIAAN BEYERS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LAERSKOOL DUNNOTTAR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LAERSKOOL HANNES VISAGIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LAERSKOOL JAN VAN RIEBEECK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LAERSKOOL MORESTER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LAERSKOOL P A M BRINK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LAERSKOOL SELECTIONPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LAERSKOOL TINI VORSTER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LAERSKOOL WELGEDAG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "LAERSKOOL WERDA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "NIGEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "PINEGROVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SELCOURT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SELPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "STRUBENVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "BONGANI PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "EFFORT PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "DAN RADEBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "DUDUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "EDALINCEBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "EMZIMKHULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "FRED HABEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "GOROGANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "HAPPINESS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "IPHAHAMISENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "JAMES NKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "JOB MASEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "KHANGEZILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "KWA-THEMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MASIMINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MMUSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MUZOMSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "NKABINDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "NOMNEKANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "NTOKOZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "QEDUSIZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "REDUMELETSWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ROSEVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SAKHELWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SECHABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SIBONISIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SITHEMBISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SIZWESETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "THAKGALANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "THEMBALIKAZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "THEO-TWALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "TSIMONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "UMSOBOMVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ZAKHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ZAMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ZITHEMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "VUKUCINGE PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ROYAL CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "EMFULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "NELLMAPIUS EXT. 1 PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "AL AQSA SCHOOL EXT ONE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MOTHEO-FOUNDATION PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "CHIEF BAMBATA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SEEKERS PRIVATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MONTESSORI PRIVATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "AGAPE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "BAKERTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LESEDI LA DITSHABA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "COTSWOLD MONTESSORI SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MAYIBUYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "STEVE BIKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KAALFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MPUMELELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "DR MATHOLE MOTSHEKGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "BRAAMFISCHERVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "FREEDOM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "INKULULEKO YESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LANGALIBALELE DUBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "MSHULUZANE MAYISELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "CHARTER HOUSE PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "AGAPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "CREATIVE EDUCATION CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "REA RUTA PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "IGUGULETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "LEEMA-MOKOTULI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "JULIUS SEBOLAI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MOSES KOTANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "NKONE MARUPING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "OBED MOSIANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "Harry Gwala PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "SATHYA SAI PRIMARY SCHOOL LENASIA SOUTH"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "NEW DAY CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "JUBILATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "VILLAGE MONTESSORI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LAKESIDE ESTATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "SK MOSENEKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MORDEN MONTESSORI SCHOOL - LINBRO PARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "HAMMANSKRAAL ELITE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "GAUTENG COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "BEULAH INDEPENDENT PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "WOODLAND PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MONTESSORI AFRICA JUNIOR PREP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "COSMO CITY PRIMARY NO 1 SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "COSMO CITY JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "ABC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "THE VILLAGE WALDORF INDEPENDENT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "LIFESTYLE MONTESSORI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "BOIKETLONG CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "JABULANE CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "AURORA PRIMARY INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "RONDEBULT INDEPENDENT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "THEMBEKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "SOMELULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "DRAKE KOKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "HAMMANSKRAAL WEST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LEHAE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "TIRISANO - MMOGO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "COSMO CITY WEST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "JB MARKS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MICHAEL MKHWANAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "VINEYARD CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "NEW CREATION LEARNING ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MENZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "WINNIE MANDELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "RESHOMILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "BUHLE PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "CHIEF LUTHULI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "KALEIDERSCOPE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "CENTURION CHRISTELIKE LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MULBARTON REMEDIAL SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "APPLETON COLLEGE INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "BILAL COLLEGE INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "RAINBOW EDUCATION CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "SIBEKIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "CITY KIDZ PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "BARCELONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRETORIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "WELRIDGE ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MODERN CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "CURRO HAZELDEAN PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "KINGFISHER LEARNING CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BUCCHLEUCH MONTESSORI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ELTURION INDEPENDENT CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "HARTFORD COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "COOPER COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MARY HELP OF CHRISTIANS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "RONDEBULT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "ORCHARDS PRIMARY SCHOOL (TW)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "OLIEVENHOUTBOSCH PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ST JOHN THE BAPTIST CATHOLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SPRINGFIELD PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ORBAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "COGHLAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "SWAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "SANDTON MONTESSORI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "PETER ZONGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BRIGHT START INDEPENDENT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "KATLEHONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "GOLD REEF PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ARCHERS COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ALBERT STREET SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MASHUDU PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "THE MOSSIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "OR TAMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ALBERTINA SISULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "DOORNPOORT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SEDI LAKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SIZUZILE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "POLOKONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "OUR LADY OF LEBANON MARONITE CATHOLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "DUNAMIS CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "CHRISTIAN TEACHING CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "RAINBOW'S PROMISE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "KERSTEN COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SANDTON AFRIKAANSE AKADEMIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "PADDINGTON'S EDUCARE CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LION PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ZANDSPRUIT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "DIEPSLOOT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BATELEUR COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "APPELTON COLLEGE - RUIMSIG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "TAMBOTIE PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "UBUHLE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "FUNANANI CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "WESTWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "SOLWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "LITTLE CREATIONS NURSERY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "TEACH-TO-PASS-COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ALBERTON REMEDIAL SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CRAWFORD PREPARATORY LONEHILL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "RAINBOW LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ORA ET LABORA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ROYAL MOUNT PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "RIETVLEI AKADEMIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "DIE KRANS CHRISTELIK ONAFHANLIKE PRIMERE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "CHILD ACADEMY PROGRAMMES"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "SUFFAH LEARNING INSTITUTE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "GELUKSDAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SEDIBA SA THUTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MAHUBE VALLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "RIETVALLEI EXTENSION 3 PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "THORNTREE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "KHULA-NOLWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "GLENRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "DULCIE SEPTEMBER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "PAYNEVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "KWANELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "IKUSASALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "EDEN-RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "SICELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "DENVER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "SILVEROAKS MONTESSORI SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CARLSWALD HOUSE PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAEZONIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "KHUTSONG SOUTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KIDS MILESTONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "JONG LEERLING AKADEMIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "BAGALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "MATLAPENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "FLEURHOF PRIMARY SCHOOL NO. 1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ONKGOPOTSE TIRO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LUFHERENG PRIMARY SCHOOL NO. 1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "OREFILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SHEIK ANTA DIOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "RUIMSIG ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BENTLEY PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "RAINBOW HILL CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "VELAMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "FOUNDATION LEARNING ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "EL-SHADAI MINISTRIES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "NEW LESEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "THE WILLOWS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MALUSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "BASA PROTEA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PURE HOPE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "JACARANDA COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "HILLTOP MONTESSORI SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "DON BOSCO EDUCATIONAL PROJECTS-LAURA VICUNA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "AKANI METMAR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "CORNERSTONE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "EADVANCE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "VERITAS AKADEMIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "GREENFIELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BRIXTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SLOVOVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "SOFUNDA CRECHE AND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "IMPENDULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "REGIO CENTURION ONAFHANKLIKE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BRITISH INTERNATIONAL PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "NOORDWYK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "VULEKA SCHOOL-WELTEVREDEN PARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "TJOKKERLAND ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LAWLEY PRIMARY SCHOOL NO.2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "ROSSLYN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LETHABO SIYANQOBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LA ROCHELLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "EVATON WEST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "SWEEP ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "THE LEARNING PATH"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "RAINBOW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "VULEKA SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "FAITH ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SANDHURST PREPARATORY COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "CHARTWELL LEADERSHIP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MIRACLE EDEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "STRATFORD PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "SIPHIWE MONTESSORI SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "KWASA COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LYN HARRIS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "EADVANCE SPARK CRESTA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LINMEYER MONTESSORI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "THE MUSTARD SEED PRE PRIMARY AND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "EASTSIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "THARI-IMBELEKO CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BROOKLYN MONTESSORI SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "NEW LESEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "WEST VIEW COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "EVEREST ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "VULEKA SCHOOL-NORTHRIDING"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LYNNWOOD MANOR PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "FAERY GLEN THERAPY CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "AVENIR PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "NELLMAPIUS EXT.6 PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "IKETLENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MUNSIEVILLE EXT.4 PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "KANANA PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MIDSTREAM RIDGE COLLEGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SANDTON SINAI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "GOZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "NATURENA PRIMARY SCHOOL NO.2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "EAST RAND ACADEMY OF EXCELLENCE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ELANDSPARK PRIVATE ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "PELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "RATANDA BERTHA GXOWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "GLENVISTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "REV. A. MAPHETO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ORMONDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MOKGOBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ENDERUN COLLEGE (FOR BOYS)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "WIERDAPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SPARK BRAMLEY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MERAFONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "FLORIDA ISLAMIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ZA BANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "LEARNMORE INSTITUTE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "HATFIELD NORTH CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "ORIAH PRE AND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SANDTON JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "TSHEDZA PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "NKANYISO MM COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "PALMRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "CONTANTIA KLOOF MONTESSORI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "HEAVENLY FLOWERS PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "UMDALI CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "THE VALLEY PRE AND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MIDRAND AFRIKAANSE AKADEMIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "BIRNEL COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "GREENHILL GB PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "YOUNITIATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LUX COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SANDTON JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "HIS WILLS SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "MAMOSA EDUCATIONAL INSTITUTE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "THE GOAL CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "RISING SUN MONTESSORI SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "VAAL TRIANGLE ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "NOMZAMO MADIKIZELA MANDELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "PROTEA GLEN PRIMARY SCHOOL NO.2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "CHIEF ALBERT LUTHULI PRIMARY SCHOOL NO.2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SPARK RYNFIELD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SPARK MIDRAND"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ESPOIR ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SPARK CENTURION"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "VULEKA ST. JOSEPH'S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "GA-RANKUWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "TSHEPISO EXT. 3 PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "TSAKANE EXT. 22 PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "TSHEPONG EXT.1 PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "SINENHLANHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LEGENDS ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "HAPPYNEST GRADES"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BUILDING BLOCKS PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "CP CHRISTIAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "LAMBTON CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "CENTURION MONTESSORI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "LIVING MONTESSORI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LAKEWOOD COLLEGE OF SOUTH AFRICA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ISIBONISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "PLG SPRINGS ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "WORD CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "HOERNLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MAYFIELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SPARK CARLSWALD SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "RIDGEWOOD COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "NOVA PIONEER PAULSHOF"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "RANDPARK RIDGE MONTESSORI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BRADFORD PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "PIONEER ACADEMY JACKAL CREEK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "CORNERSTONE PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "GOLDEN GARDENS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SCHOOL FOR YOUNG ENTREPRENEURS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SUPERIORITA ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "IYANA ENGLISH PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "NEHEMIAH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "SPARK RANDPARK RIDGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "NOVA PIONEER BOKSBURG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LCK ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "SAGAN CENTRE (ACADEMY)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MORNING STAR MONTESSORI SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "VIVA VILLAGE INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BROADACRES ACADEMY AND FARM NURSERY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "THANDIMFUNDO ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MOOT AKADEMIE PRETORIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "FOUNTAIN PARK EDUCATIONAL INSTITUTE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "FUNDAMENTAL FACULTY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "WINNIVAL ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BRIGHT STARS ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MARYVALE COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "DREAMHILL INTERNATIONAL SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "KHANYANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "VERITAS COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KGOLOLO ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "CHRISTELIKE LAESKOOL ELOFFSDAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "CREATIVE KIDZ SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "RIETVLEI AKADEMIE-LYTTELTON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "WHIZZKIDZ"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BEREA CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "AA ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ST BENEDICT'S JUNIOR PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "VALBONNE COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "AYANDA JUNIOR ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "THUTO PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "CULLINAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MONAGHAN MONTESSORI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "PLAYSCHOOL ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "NEW LESEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "VALLEY VIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LAMBTON CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ECOKIDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BOKAMOSO STARS ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "NOKUPHILA SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SPARK WELTEVREDEN PARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "EXCEL EDU CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "THANDIMFUNDO PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "WINNIE THE POOH CRECHE AND JUNIOR COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "CURRO DOUGLASDALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "CURRO OAKDENE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "EPIGNOSIS CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "PRIDE JUNIOR ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "HEIDELBERG ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "HANNIEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "NOVA PIONEER RUIMSIG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "REITUMETSE ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "RUACH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CARSWALD MONTESSORI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NORTHCLIFF MUSLIM ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "FIRST STEPS ELEMENTARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BABY STEPS EARLY LEARNING CENTRE LINBRO PARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "PARADISE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "CUBE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MIDRAND INNOVATIVE LEARNING CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BRYANSTON GRADE NOUGHT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "POSH MINIONS MONTESSORI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "SANELICH ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "DIVINE COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CAMDEN PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BABY STEPS EARLY LEARNING CENTRE BEDFORDVIEW"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "BODUBELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "BOIKANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "BOTSALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "DIKAGO DINTLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "DIKGAKOLOGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "DITSHABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "EDWIN MOALUSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "EMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "FATLHOGANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "IKAGENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "IKELENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "ITIRELENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "ITSENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "KEKANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "TOKYO SEXWALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "KGOMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "KOPA DILALELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "KUDUBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "KULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LEBELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LEBOGANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LEBONENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LEFOFA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LEKGALONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LESEGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LESOLANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "LORATONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LOWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MABU-A-TLOU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "MAHLWARENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "MANAMELONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MAROKOLONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "MAROPENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MAROTOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "MARULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "MERAFENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "MLOKOTWA DUBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MMAMOTSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MMATSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "MODISELLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MOLEFE MOOKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "MORULA VIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MOSALEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MOTJIBOSANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MOTSHEGOFADIWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "REKOPANTSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "NAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "NONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "PHALESANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "PHILEMON MONTSHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "RADINEO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "RAKALE THABONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "RAPELEGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "REFALOTSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "REFILWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "REFITLHILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "REIMOLOTSWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "RENEILWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "RETLILEPELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "REDIRILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "SEKAMPANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "SELANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "PATRICK MOLOTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "SEROTO MATSHEHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "SIAMISANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "SOSHANGAAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "ST CAMILLUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "SUNVALLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "TANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "THABA MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "TIDIMALONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "TLOTLOMPHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "TIM MODISE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MASAKHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "RAMOTSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "MAKGAKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "BUSY BEE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "REATLEGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "BACHANA MOKWENA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "REFENTSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "BAWEZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "MANDLOMSOBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "MKHAMBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "SIKHULISILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "HLABELELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "HLOLISISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "SIHLUZIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "ZIVUSENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "FOCHVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "GREENSPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "KOKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LOSBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "REAKGONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "WEDELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "XHOBANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "RETLILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MANTSHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MALADUMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LEBOWAGANYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAKHABENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOTSEKETLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SEKGOPO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MATSWIDIKANYE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MABOKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "BOLLANOTO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LAERSKOOL DUIWELSKLOOF"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "PLATLAND"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LORETTO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MANORVLEI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "POLITSI FACTORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SILWERSEE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "THE JUNCTION"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LAERSKOOL TZANEEN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LAERSKOOL DR. ANNECKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "UNICORN PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "THAPOLA-A-NKONA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "ALLERGRAINE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "CRAIGHEAD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KRANENBURG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "HOPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RIXILE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAKUSHU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LAERSKOOL MESSINA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "BONWA UDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "GATEWAY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MARTIN DE PORREZ"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "FAUNA PARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LAERSKOOL DRAKENSIG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "GRAVELOTTE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LAERSKOOL MARIEPSKOP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LAERSKOOL PHALABORWA SUID"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LAERSKOOL PHALABORWA NOORD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NWA RISENGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SCHIETTOCHT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "DENDRON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MACHABA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAMOLELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DOORNSPRUIT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "CHRIS HOFMEYR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LAERSKOOL PIETERSBURG NOORD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PIET HUGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PIETERSBURG LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LAERSKOOL PIETERSBURG OOS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PAPKUIL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PAXANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NORTHERN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PIETERSBURG COMPREHENSIVE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PIETERSBURG ENGLISH MEDIUM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LAERSKOOL IVYPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "LESEDI WALDORF CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "TLHOTLHONYA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "TLOUKOLOBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "HAENERTSBURG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "GLENSHIEL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RARANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MPHOME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "DRIEHOEK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MUNNIK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "EDUCARE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MASALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHITAVHADULU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LAERSKOOL LEVUBU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HANANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MASHAU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KURULEN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LAERSKOOL SOUTPANSBERG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TANGANEDZWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NKHENSA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "VALDEZIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KETLANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "ELTIVILLAS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MASEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "FHEMBELEDZANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "HAROLD RUDZANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LAERSKOOL LOUIS TRICHARDT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHAKANDE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KILETSA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "ITSHOMELENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HOJI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MASHIYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOROPE-MATLALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "BALTIMORE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RALEHUMANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "REABILWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MARKEN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL UNITAS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "RAMAKWAPENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "B.B. MATLAILA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "BLINKWATER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "DIKUBU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "EILAND"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "ELANDSKRAAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "IMMERPAN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KAALLEEGTE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "LAERSKOOL KRUGERPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL BYSONDERHEID"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL EUGENE N. MARAIS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "LAERSKOOL POTGIETERSRUS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "LUXEMBURG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MACHIKIRI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MADIPHATLO KGOMO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MORARELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "POTGIETERSRUS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KALAKENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "POTGIETERSRUS COMPREHENSIVE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "HAM NO 1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MODIKWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LAERSKOOL ZEBEDIELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "INDIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MODIMOLLE -2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "DITHEKU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "SKUINSKLOOF"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "REAHLAHLWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "BOSCHDRAAI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "DAGBREEK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "E.A. DAVIDSON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL ALMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL EENHEID"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL NYLSTROOM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL TUINPLAAS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL VAALWATER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LEKKERBREEK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MELKRIVIER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "NYLSTROOM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL DOORNFONTEIN 839"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MAHLASEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "ALBERT LITHULI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "BOSVELD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL ELLISRAS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MOTLHASEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "NELSONSKOP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "IKITSENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "PIPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "CHROME MINE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "DEO GLORIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "HEUNINGVLEI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "ISTORES"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "KESARONA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "KRAUSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL DWAALBOOM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL KOEDOESKOP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL NORTHAM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL VAN WYKSKRAAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL PLATINA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "RABUGALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "REENPAN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "VAALPENSKRAAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "YSTERBERG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL THABAZIMBI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MODIMOLLE -1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "BLAAUWBOSCHKUIL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "HLEKETANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "KHABELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL WARMBAD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LAERSKOOL LEEUPOORT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LORD MILNER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MALEBONE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MMAMAKWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MMAMPATILE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MODDERSPRUIT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "PIENAARSRIVIER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "RHENOSTERKLOOF"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "THABAKHIBIDU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "SPA PARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "JINNAH PARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MAOKENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MOKOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NYAANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DZWERANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HASANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MBHALATI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "PFUNEKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HANGALAKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "FUMANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NGHOMUNGHOMU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SHIKATSA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "PHATIMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SHIGOMBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NYAVANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NXANGUYINTSHWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SHILUME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TINYIKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TIVONELENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIKIWANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MASHOBYE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MERWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NKANDZIYI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GOVHU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HISEKELANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAKHASA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAGONA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "KHODOBI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIKONELO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MATIYANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAYEKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MHINGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MPHAKATI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NKHAVI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TLHELANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RHANGANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "XIMIXONI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SHILUNGWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SUNDUZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "BOTSOLENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "BOXAHUKU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GONANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "JOAS PHAHLELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MADZIKUSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAGOMANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAHLOHLWANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAKAHLULE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAKULEKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MALEDZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAPHOPHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MASHAKADZI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GUWELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HASANI LAWRENCE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HLAWULEKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MACHELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAHLEFUNYE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAVUYISI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RISANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MHEHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUDABULA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUKHOMI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MULAMULA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUSWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NHOMBELANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "PHAPHAZELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TLANGELANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TWANANANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHAMANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHAMISEKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "CHANYELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "VONGANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RIPINDZI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SHIGALO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "XIHLOVO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSUNDZUKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TIYISELANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TITIRHELENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LANGUTANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SHIMAMBANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SHIBANGWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MDANISI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAPAPILA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GEORGE HASANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "KHANANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "KHUPUKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAGANGENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAGODA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAHONISI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAKHAPULE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAKUMEKE L H"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MANAVELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAVAMBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TIVANANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NKURI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "TIRHANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "ZAMANI -1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MASUNGULO-1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SHIRLEY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "ELIM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SHIHLOBYENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SETSEKANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "BUNGENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "CALEDON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "CHAVANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "DUMANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "GIJA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "GOZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HAAKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "JOE MABEDLHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KHAMANYANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KULANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MADOBI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAHATLANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAHOCHOMBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAHUNTSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAJOSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAPHANYI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MASUNGI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MBOKOTA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MHLURI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUHUNGUTI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NDLHAVHEYA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NJAKANJAKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NJHINGHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NKANYANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NKUZANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KHAPAKHAPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NWA MHANDZI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NWAXINYAMANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NYELETI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "PEMBELANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "PEMBUNUKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "PFUMELANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RIVONINGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SITHUMANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SKHOSANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "VULANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "VUNGELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "XILUMANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "XIMUWINI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SHITACHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "BEREA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUSANDIWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "GAZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KGOPSANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MABINE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MADJADJI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAKHUSHANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MASEKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MASHISHIMALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MHALAMHALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MODUME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NAMAKGALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "PHALABORWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "REFILOE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RETHABILE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RETHUSITSWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SELWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "FOSKOR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LESEDING"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MASHAVELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIDUMBI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BOSHATOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MMATJATJI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "VASASELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "BANANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "BOMBELENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "DAN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "DUDUDU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "FAVASI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "FOFOZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "GAVAZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TITO MBOWENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "JACK MASHAMBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAFARANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAHLABEZULU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAKHANANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MALUBANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MALWANDLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MANYUNYU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MARITO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MARIVENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAVELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAVABAZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAVUMBHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MBANGWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MHANGWENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MLUNGHISI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MPENYISI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MUSHOTI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "NHLENGELETI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "NKAMBAKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "NWAJAHENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "NWAXINDZHELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "NYANTSHIRI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "NYAVANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RITA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RITAVI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RUNNYMEDE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TOTWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TSAKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "VHULAKANJHANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "XIHOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "AKANANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MBETANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KHOPO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "NWAMUNGOLOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "NKOWANKOWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SEBONE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "BORDEAUX"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "HOVHENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "JOSEPH MAENETJA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KHUJWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MARGRET SHILUVANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOLATI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "NTWANANO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "PHEPENE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "PONANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RHULANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TIMANGENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TINGHITSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TINGWAZI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SHIKHATI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOHLABA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAAKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "FRANK MUKHASWAKULE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "ANDERSON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "BABANGU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "BALENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "BENSON SHIVITI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "BVUMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "DINGAMANZI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "FUYATHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HATSHAMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HIPAMBUKILE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HLAKHETO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HLANEKI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HLAYISINANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "FAZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KAYANENE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHAKHALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHEYI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHOMISANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHUNGULU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHWEZU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KUTSAKENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LAERSKOOL KREMETART"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LANGUTELANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LELENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MADZIVI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAGOME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MASHENGANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MASWANGANYI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MBHURENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MEHLEKETO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MHLANGANISWENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "M.K. KHAMBANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MUNGHONGHOMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MUNINGINISI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MUSHIYANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MUSWANAMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MUYEXE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NDZALAMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NGHALALUME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NGHATSANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NGHILAZI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NHLALALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NKOMO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NGCECHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "PFUNANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "PFUXETANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RHIDA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RIRHANDZU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RISENGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SAMSON SHIVITI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SIYANDHANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SOLANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SUKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "TANANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "THOMO -1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "TLHARIHANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "TSHEMBHANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "TSHOVANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "VAHLAVE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "VUHEHLI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "VURHONGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "VUSIZI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "VUYANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "XIKUKWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "THANDABANTU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "GIYANI COMPREHENSIVE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAFANELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "ST. PATRICK MATHIBELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "ALBERT MABE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "CHARLIE RHANGANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "DZUMERI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "GOVANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KATEKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MABUNDA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAKHUVA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MATSOTSOSELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAYEPHU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MHITLWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MIZUZWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MZILELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NDZHOVELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NYIKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "PHADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "UKUTHULA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "XITLAKATI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "CHUCHEKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "EHLEKETANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LULEKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NWASORINI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "PHULANIBYIHOLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "PONDO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SHIPHAMELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "VATSWATSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "XITLHANGU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "BOLOBEDU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "BORELETSANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "BOTLUDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "FEMANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KGOBAKANANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHEKHUTINI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KHEOPENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KHETHAPOYE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHUMELONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHUTSONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LEAKHALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LEKUKELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LEKGWARENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LERALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LETSEKU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MABJE-A-KGORO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MABJEPILONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAHEKGWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAKGOPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAKHEALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MALEMATSHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MALEMELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MALOBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAMATLEPA KGASHANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAPAANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAPITLULA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAPULA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MIRAGOMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MASEFORA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MASEKWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MASOKISI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MATSHWI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAULOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MEDINGEN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "METSI-A-PHEPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MMANKOPANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOHALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MOHOKONE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOKGADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOKGWATHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOKUTUPI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MOKWASELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOLEKETLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOLOKWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MORAPALALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MORUTSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MOSHAKGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOTHOMENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOTUPAKGOMO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MPEPULE -2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "OOGHOEK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NORTHAMPTON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "PHOLOAHLABA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MADUMANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RAMAKHUMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RAMAROKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RATHAGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SARA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RATSEKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SEFAHONE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SEKGOTHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SENAKWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SENOPELWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SERIPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SETHONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SETLOUMANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SHOTONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TAULOME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "THABISONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "THAPANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TLHAPEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TLHOTLHOKWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TSOGANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "TUMEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "VALLAMBROSA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "W.M. KGATLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAMANYOHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "TLHABELENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MOTHOBEKHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "DULANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "JAMELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KUBUNE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LEBAKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "M.R. MAMAILA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAMOKGADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAUFOTA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NAKAMPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NOKANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RAMATIMANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RAMOLLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SEHONWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "PHAKENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MPAPALATI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MHLAVASI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "XIRHULURHULU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MANKOPANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "THUNE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SEPHUKUBJE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SEBELAOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RAMAITE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "PHETOLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NKEI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MOTSOKOTSA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MASEHLONE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAMAILA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KOPANANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BOTLOKWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAPALEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAMOTHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MALEBALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAKWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "IKAGELENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BODUMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEPHALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RATHOMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAMOTLHALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "PHEEHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "TSHANGWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MANKETE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SENWAMOKGOPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "ITIELENE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGWADU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KHUNWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "LEFATANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "LEPHALALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MABEBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MABYANENE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAMOTHIBI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAMOTSHANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MASWAHLANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAUTSWI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOLEMOLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOSIMA -1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PULEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEKITI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SHAPO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SOKA LEHOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TLADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "THABANATSHWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUROGOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NAMATSABO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RABATSWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "TSEKERE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BODIROA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BOIKHUTSO -1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BORWALATHOTO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BOTSHWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "DIKGOALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "DITATSU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "HOSEA MOCHEMI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "JOHN MOLOKOMME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KAWENE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGEBETLI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGOTLOANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KOBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "LEBOHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "LETLHOEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "LETSWATLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MABOI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAIMELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAKALANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAKGAFELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAKGARI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAKGOTLHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAKHUTLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MALENKWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MALOLOANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAMOSHIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAMOYAHABO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAMPOTE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MANAKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MANGWATO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MANTSHABE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAPOTLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MASEALELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MASENWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MASHIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MATHEKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MATHUWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MATOME-A-MOSIMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMAKGOMO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMAKGOMOTSHWEU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMANTOTOLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MODULATHOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOHLABI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOKIDIANE MORUKHU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOKUMURU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MONYEBODI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MONYEMATHULA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MONYESEBODU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOPHAMAMONA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MORONGWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MPEBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MPHOKANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NANEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NONYANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NTLHODUMELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PETER HERMANS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "POKANONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "POTOKELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAMAAHLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAMARULA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAMMUTLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RANKHUMANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAPHOTOLOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAPOHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RASEASALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RASEBILU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RASEKGALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEANEHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEFIHLAMPYANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEFOTWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEKHWIDITSANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SELAELO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SELELO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEMETSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SENWABARWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEPANYA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SESALONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SETHUNYA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TEFU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "THABANTSHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TLHONA SEDIMONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TLHAKAUMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TSWATSANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEFOTO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "DINOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PHUTI -1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MATJEKETLANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RASEKHUTA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MASHILOMPANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DIOPONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MASETE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "ABBOTSPOORT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "BAKGALAKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "BANGALONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "BAPHOTING"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "BORUTLA MOSIMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "JACOB LANGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "KGOMO-MOKGALO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "KITTY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "KLIPSPRUIT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LETLAMORENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MADIBANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MAETELETJA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MAKHURUMULA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MASWIKANANOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MATSETSENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MFAKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MOABI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MOCHEKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MOKWELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MOROE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MORUKHURUKHUNG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MOSIMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "NKU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "OLIFANTSDRIFT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "POULOS MOSIMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "RADIBAKI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "RAMOJAPUDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "SEFITLHOGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "SEGALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "SELEKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "SHONGOANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "TSHEESEBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "TSHUKUDU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "TSHELAMMAKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MONALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGOBUKI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RANOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "ALFRED MASIBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "CHUMANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "CORNELIUS MASIBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "DUMAZI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "GODWIN MASIBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "HANS MASIBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "ITHUTENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "JACOB PUKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "JAKAMENE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "JAN MALEBANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "JOHANNES MASIBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGABETLI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGATABELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGWATHELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "LESHOBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "LIMBURG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MABUELA-RAMORULANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MADIKOTI PUTSOA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAGEME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAKGUBUKETJA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAMAGOLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAPELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAPUSO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MARCUS MASIBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MATLHABA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MMAMANGINA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MMOPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MOSESANE BALOYI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MOSHIBUDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MOSHUPSA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MOTSHITSHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "N.D. MOKONYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NOMALEMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "PODILE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RAPHELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SEBILOANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SEGOOA KGALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SEPEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SETJOAMADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SOKGEDLWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "TLAKANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "VAALTYN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NKGODI SIPHUNGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "PEPPS MOKOPANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGABAGARE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGOPEDINOTA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "ABIOT KOLOBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MABETHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "DIRETSANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "DITLOU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGAKGALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGOKOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGOMOSHIAKWENA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGOTSORO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "LECHABA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "LENKWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "LESODI MOTLANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "LEUBANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MABUSELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAGALAKWINSTROOM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAHLOMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAHLORA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MALAPILE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MALOKONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MANGWEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAPITIKAMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MOSHIRA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MOTLARE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MUSHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NKIDIKITLANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NKONTLHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RAMELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RAMOKGAKGELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RANTJIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RAWESHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SEGOLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SERUPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "THUTLANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "TSELAPEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "GALAKWINSTROOM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SEKANEKAMOYI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "TLHAKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MPHAKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NELLY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MATLOU MEMORIAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NTEBELELENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAKOBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RABASOTHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NAKEDI-KOBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MOROBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "BOHLAPA KOLOBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAGOBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MATHEKGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MONENE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NGWANAKWADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SUSWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SEPOBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MASHOSHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RATINKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RAMOTLHATSWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "BOKWIDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "GIVEN MANGOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "K.K. MONARE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SUPI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MASHAO MABUSHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NKGAKGAUTHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAPALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MANTLHAKANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGOKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGOPEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BOLAHLAKGOMO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DIPOFUNG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DITLHAKANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "GAUTA JONATHAN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KHURENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LETJATJI PRESIDENTIAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MADIKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAGATLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MATSHUMU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAMOGOASHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MANAILENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAPATJAKENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MARAGANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MATOME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MMAMMATI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MMUDI NAREADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOGOLOGOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOGOTO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOHLAHLANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOKONE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOLEMO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOSHODO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MASHIGOANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOTSOFALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MPELEGENG MATLALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NGWANA MOKWENA KEKANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NKGOSO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PHALALONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PHISHOANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RAKGOATHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RAMAKGOTHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RAMASODI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RAMOLOKOANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "REGAE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEKGOPHOKGOPHONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEKUTUPU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SELLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEULA MMAKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SHIKOANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SHUPENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "TINTELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "THADUKU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOTSERERENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MABOPA-ABO-MPUWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MAHLWARENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "RAMASHILO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "TSHERANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "THOKGWANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HANYANYANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MODISHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MASHEGOANYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BOSELAKGAKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BRUSSELS NGOAKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KANANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGOBOKANANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KODUMELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MABETWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MADIKANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAMADISHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MASEBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAUPYE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMARATHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOGOHLONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NAPE TLADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NKOANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PHUTI MOKWENA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RADIBOLOTJE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SADU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEOBI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEPHAOWENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SESHANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "WITLIG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MATUNTUNYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "ABRAM SIBASA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "ALF MAKALENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "APRIL MAKGAKGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BAILAFURI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BOIKETLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "CHOKWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "CM SEHLAPELO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DOROTHY LANGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "ERNEST MATLOU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "HLABANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "HOSEA NTSOANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "JOHN NRIMBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "JONAS LESETJA LEDWABA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KAPUTLA NKOANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGWAREDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KOMAPE-MOLAPO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "LEETETJA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "LETLAKANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LETLOTLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MACHEMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAHLODUMELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKGWARENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MATSIRI MOKGOKONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MALEMA -2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MALOKANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MALOPENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAMOLOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MANAMELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MANKGAKISHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAPANGULA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MARIPHU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MASEGELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MASHASHANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MASHIANOKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MASHUPYE TLADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MATOLO KHALO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MATSHELANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MATUMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAUNE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMATLOU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOCHOCHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOHWIBIDU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOKATI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOKGOBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOLALAHARE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MORELEBAKGANYAGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOREMI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MORUPAHALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MORWASETHULA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOSHASHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOTSIRI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MPHARENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MPONEGELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NAPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NAPO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NGWAKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NNATILE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NTSODI BAMBO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PEAKANYO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PHISHEGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PHUTI MAKIBELO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAMOGOBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAMONGWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RANTSHU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "REV M.P. MALATJIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SAMUEL THEMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEBOKELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEBUSHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEHLAGANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEHLARE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEOKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SNELL PHOSHOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SOLOMON MARABA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "THAKGALANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TUTWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "UTJANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "VENUS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DAVID NKOANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "ESAU MOSEDAME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RALEMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "FLORAPARK COMPREHENSIVE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NGWANAMPHAHLELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PRENORA ENGLISH MEDIUM PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "AURORA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BORUME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "CERES"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "CRACOUW"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "DIAKGANYA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "DIBENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "HAKALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGOMONTSWERE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGOPODI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGOROSHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KOKAMI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "LEKGORONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "LEKHURENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "LEKWALAKWALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "LETLHOTLHONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "LEWENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MABITSELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MADIETANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MADUMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAFIFING"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAGOSHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MANCHIMUDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MASHILO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMADITSHIKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMAKGABO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMASEHLONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NKHUMISHE MMUSHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MODIENYANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOGALADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NKGELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOSHIBI-MOKOBODI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NAREMOHLALERWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "NONG MODIKWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PELABELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PHAUDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PHEHLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PHOFFU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PITSI A MASHILO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PUDUTJE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PULA SEOPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RACHEBOLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAMALAPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAMETLOANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAMPURU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RAPITSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEETLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEFATALADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEKGWARI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEMORISHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SETLHAKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TAU-KWENA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TSOGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "WINGFIELD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "LEOKANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "CHLOE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KONKOTI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOETAGARE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAPHUTHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "TIBANEFONTEIN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "IKAGELENG MAKOBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMAPHEKGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "AMBERGATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "PROSPECT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NGWANAMAGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BADIMONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BOSHEGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DIHLOPANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DIKGOPHENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DIKOLOBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DIKWATA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DIPUWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KATANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KGALAKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KGOTLHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KONOTO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KOTANKWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LAASTE HOOP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MABOYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAGATOLLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAHLANHLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKATA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKEKETELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKGEFOLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKGWADIBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKOTOPONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MALESA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MALESELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAMABOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAMAHLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAMOTHALO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAMPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MANANGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MMANANYA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MANKGAILE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MMANTHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MANTHEDING"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAREDI -1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MARIBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAROBALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MASEBODILA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MASEKWAMENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MATSHELANE MOTHAPO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MEGORING"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MMAPHOTLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MODIBONE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOEFADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOGABANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOGANO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOLAMO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOLEPO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MORARO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MORIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MORITING"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOSEBO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOTHAPO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOTHIBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOTHOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NTJI MOTHAPO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PHUTI -2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "POGUTI MARIBULLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PULA-MADIBOGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RAKOPI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RAMPHERI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEBAYENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEHLALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEHLOMOLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEKGWENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SESOAI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SIONE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SOLOMONDALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SUBIACO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "THABA DORA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "THABAKGONE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "THOMO -2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "TJATJANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "TORONTO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAPUDITHOMO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KOKONA DIKGALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAPHUTO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LESHOANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "ITIRELENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAPHEFO -1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BOGALENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BOKGOBELO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BOLOPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BOSCHPLAATS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BYLDRIFT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DIKGEU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DITHABANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "DR. DIXON MPHAHLELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "EUREKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "FEKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "HLAGATSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "HUELERENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KGAGANOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KGAMPI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KGETSA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KOMANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LAFATA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LEGOBOLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LENTING"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LESETSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LITTLE BEDFORDVIEW"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MADISEI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAFEFE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MPHAKANYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAHLATJANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAIJANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKGOATHANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKURUNG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MALEKAPANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MALEMATI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAMAOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MANEENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MANGAKANELERATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MARATAPELO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MARETLWANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MASHABASHABA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MASHITE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MATALANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MATHABE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MATSOBANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOGODI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOGODUMO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOKHOPO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOKOLOBANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOLAPOMATEBELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOLEKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOLOTOADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MORORE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOROTSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOUPO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MUTLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NDLOVU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NTSEEKGOPU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PATOGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PITSENG YA THUTO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RAMATSEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SAMPSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SCHEIDING"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEALANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEFALAOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEKURWANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEROBANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEROKOLOSENYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SOPHONIACHUENE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "THAMAGANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "THOKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "TJIANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "TLOUATIBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BASELOANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "HILLSIDE PARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BOREDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RAKGOADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MASHILE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKANYE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MATSHELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATSEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RAMPHELANE MABOOE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAKANTANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOENYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "STRYDKRAAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "S. M. NKOANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "AREIKHULENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "BAITHUDI MOHLAHLEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "DIKWETSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEHLAGARE MARISHANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "EKELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "GAMMALEBESE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "GEORGE CLIFFORD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "HLABJE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "HOPEFIELD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KATANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KATISI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KATUDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KEDIKETSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KGALADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KGARUTHUTHU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KGOOGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KGOPOLO E BOTSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KHUDU TSEKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KOPANONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KOPJENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KWENATSHWENE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEDIITSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEHLAKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEHLAKONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LESHALABE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LOBETHAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MACHELANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAFETATSUBELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAFOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAHLAKANASELENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAHLOELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAHLOLWANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAKGATSIKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAKGOABE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAKGOPHENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAKUBARATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MALOPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAMPANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAMORITHING"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MANOTONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MANNYETHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAPALAGADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAPOGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAREI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MARISHANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAROTOBALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MASHABELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATOBULE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MMAKADIKWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MMESHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOGAILE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOGALATLADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOGALETLWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOHWELERE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOKALAPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOKGOMA PHOKOANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOKGOSHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOLEIJANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOOMANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MORULANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOTLOKWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOTSEMOGOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MPELEGENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NGWANABEKANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NGWANAMASHILE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NGWANASENANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NKGARI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NTETELENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PETLOANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PHASWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PATANTSHWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PHOTO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PHOTOHLOGOANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RANONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SEBJANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SEDIKWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SEKALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SEKWATI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SEKWENA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SEROKOLOANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SHUSHU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SWIKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TEME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THABAMPHSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THABANAPITSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THABONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THINGWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THOLONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THOTANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THOTO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THUTLWAMAKWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TIITSANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TISANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TLAME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TSHWAANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TSHWATLHAKGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TSOATAGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "BOHWELABATHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MMAKUBU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAMAKGATLAPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MODISHANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THABADIPHIRI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOTSATSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MABOOE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOHLAHLEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "DIKGALAOPENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "DIPAKAPAKENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "GOSHETSENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "IKAGENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "JACOB SEFAKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAFATO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAKAEPEA -2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAMORAKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAMPHOKGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MONTSOSABOSEGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOTHEONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATSEPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KENNETH MASEKELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MMATHOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RAMMUPUDU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RITE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "QHUBANI MAHLOGOTLOU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KAWUSIME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAROBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATHULA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MNINWAMAHLANGU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOGANETSWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOTSEPHIRI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "ONANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PHAPHAMANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SINDILE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SOKALI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SOMAKATA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEGADIMANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAMASEGARE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MASOGANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEKGOLANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MABITSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOSHEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "IKHUTSENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "BAFALADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "BONANG BONANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "HLOPHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LUCKAU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAKEKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MALESE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATSITSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MZIMHLOPHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NJOMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "ZWANANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THOKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TSIMANYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PHAKGAMANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOILANONG MATSEPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "HLAKUDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "JACK MORARE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "JAFTA-BANTABETHU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NKOANA WILLY MADITSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NTSHOENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEKOMETSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATHUNG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "BAKOPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOGALATSANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DIKGABJE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MONAPANAPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "GWARA-GWARA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOSHIANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "JACOB MARWAE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAESELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PHUKUBJANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "THOBEHLALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TLAKALE NCHABELENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TSEKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DINOTSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAILA -1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAMOLOBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAPHALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MATHIBENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MMOTONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MODIPADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MPHANAMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PEBETSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PHEPANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "RADIMELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAMPURU-THULARE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MANKOPODI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAPHUTHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MASEHLENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MASHILABELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MATLEU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOLETSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOROAMOCHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEROKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TSHWEELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KGOEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAPHOTLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MPHAANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NKOTSANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NKWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PELANGWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MABOE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEGANABATHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LERAJANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAEBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAFENE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOLOKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PAKENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "BANARENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "BOGWASHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DIPITSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "ITIRELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KGOBALALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KGOMATAU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KGOTLOPONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEBOENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEGABENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEGOLENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEKUBOSHAI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAATSEREPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MABOTSHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MADINOGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAFEMANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAHLAGAUME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAHLAHLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAHLASHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKGALANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKOPUNG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKWALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MALEKGOBO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAMOGOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MANKELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MANTOPI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAPITI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAREOLOGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAROTA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOISELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOKGABUDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOKOBOLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOKUTUNG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOOKOTSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MORABA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MORETHUSHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOREWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MORWAKGWADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOTSHANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NTEPANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NTLAISHENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PENGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PITSANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "RIBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "ROTOLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEGORONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEHLOI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEKABATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEKAKATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEKIBIDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TANTANYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TUBATSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "THABANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "THOROMETSANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TSWENYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TSWETLANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TSWELOPELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MATLABONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KOBOTI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "ITSOSENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KABISHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DJATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "HLAPOGADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MANOTWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAFISE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAHUDU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAMOKGALAKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MNYAMANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MONAMETSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MONAMPANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOTLAMOTSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOTSATSANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOTSEPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PHOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "RAMOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEJADIPUDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SELEPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "BONWANKWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DIKETEPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "HLONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LESIBE PRMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MABOELETSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAFETE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAROGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MASEBUDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MATHOLENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOLAKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOROKADIETA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MORULADILEPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NTOSHANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PHOGOLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "RATAU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEFUFULE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SETLOPONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TSWAKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SETLAMORAGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TELEKI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "THOKWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TSWERENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KWATA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LETOLWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MABU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAHLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKOFANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MALEGODI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MASETE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MASENYELETJE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MATSIRI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOHLALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOHLOPING"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOLOPO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOROLENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MPHOGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PATANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SHAI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "BACHABANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "GOWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "HLAHLANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAJOE A KGORO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAFOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MALELENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MASHISHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MANYAKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOHLOPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "RASUPI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "ROOTSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEBOPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SELALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "THIBEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TUMISHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "BOGALATLADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DIPHALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KGAGUDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KWANO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEDINGWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAEPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKGALANOTO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKGOPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MALEGASE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MANKU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MATIANYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOGALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOROKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MPETJE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEOKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LAERSKOOL ATOKIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOGOBELALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOKGOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "BAFEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "BAROPODI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "BONEGA MADIKUBUNG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DIKANKATLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DIKGAGENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DLAMINI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KGOBISE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KGOBOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LEGAPANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MADIBONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MADIETE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MADIKANONO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAGOMARELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAKGANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MALAKENG-SEROTELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MALEGALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MALEKANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MALOKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAMPURU -1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAMPURU -2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MANCHAKGATHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MANGANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MANTE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MANTIMO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAPHOOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAPHOPHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAREMELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAROTA MAKGANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MASERALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MASHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MATIME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MEFOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MMATHABENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MODIKETSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOGASHOA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOKALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOOKWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MORETSELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NGWANATHEKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NGWANATHULARE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NKOKOANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NOKOMEETSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NTAKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NTSHITSHIMALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PAPONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PITSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SCHOONOORD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEBOENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SEMASHEGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "THULARE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TIBAMOSHITO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TSATANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "PAAPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MORIPANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KALAFONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "HONOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "ARETHABENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MASAGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "FREDDY MOKGABUDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MASELESELENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "ST. MARK'S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SHILUVANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "BALLOON MANTJANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "BUTSHWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "DIPHUTI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KGAHARA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KGOPONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "KOBJANAME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LEFOKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LEKGOLO MAAKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LEKANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LENYENYE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LEPELLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LEPHEPANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LESEKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LORRAINE BANARENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAANGWAKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAATLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAGAINGWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOGOBOYA RAMODIKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOGOBOYA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAHUPJE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAJE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAKGAUNG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MMAKGOTLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MALEBALONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAMETJA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAMOKAILE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAMPSHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAROBONI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MARUMOFASE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MATSHANGWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MATSIKINYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "METZ"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MMAKAU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MMAPHAI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MODUPI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOGABE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOGAPENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOHLODUMELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOIME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOLALANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOLALATLADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MONTSHENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOTLOLATSOKU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RAMALEMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RANKAGELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RASEMANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SEKOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SEKORORO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SEMANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SEPEKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "THABENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "THABINA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TIMAMOGOLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TJALATJALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TOURS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAPONYA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MMALAHLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MASEKANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SEKOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MALALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MADIMBO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "PFUMBADA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MANDIWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MPHAILA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHITHUTHUNI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHABVUMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SENDEDZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIKOMBANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIRENZHENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SHURA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUTUWAFHETHU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MANDALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "DZANANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIENDEULU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "VHUTUWANGADZEBU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SILOAM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TONDANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LIVHUWANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUNGOMANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUTITITI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NANGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHITUNI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIKUWI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAANGANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KOKWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MALEMA -1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAULUMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RABALI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHILUWI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MATSA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RALIPHASWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RADZILANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAPAKOPHELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MARANIKWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAKUMBWI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "DIVHANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "BALALILA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAVHUNGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIROLWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MATANDA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LUDANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "BELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NYATEMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAGUADA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MADOMBIDZHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIFHIRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAGAU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "PETAMUKANDA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KHUNDA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIKHWANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIKWARANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MATSHAVHAWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAKWATAMBANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUFONGODI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SIKHWIVHILU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MANGWELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUSEKWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LANGANANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MITUMBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KHOMELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MANYII"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LIPHAKHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAPANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUDZINGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUGORORWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUUNGADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MADODONGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUDULUNI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MMBEREGENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "DANIEL MUBVA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAEBANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "PHARANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MADABANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MANAVHELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MATITIVHALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KHOGONYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MMBABADA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "GOGOBOLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHILWAVHUSIKU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUNAU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KHARIVHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MBODI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUSWODI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DAMBALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHOKOTSHOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MATSHENA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHAPINDA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GUMBU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIRUNZINI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MATATANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIPISE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUKUNUNDE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIUNGANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MALINGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MASISI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MADANGANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHENZHELANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DOMBONI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAPAKONI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUKOVHABALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIVHONGWENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MADIFHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIKUYU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DOVHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SIGONDE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MANENZHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "FOLOVHODWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MARAMANZHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "BALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MASEA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LUVHONE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAGILEDZHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "B.R. NEMULODI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIAKHATHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIDONGOLOLWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LADZANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUTSHENZHENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MIANZWI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MARAXWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIOMBO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SAMBANDOU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NDIDIVHANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "VHUTALU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUDZIDZIDZI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RAVHURA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MBAHELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUKONDENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHANZHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GUYUNI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DZAMBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "BASHASHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "FEFE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GOGOGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GUNDANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LUHENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LUKAU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MABILA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAFUKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MBONENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUSUNDA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NGALAVHANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NWANEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SHAKADZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SHESHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHAMULUNGWI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHANDAMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHAVHADINDA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIKOSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHITANDANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIXWADZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "PILE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAVHODE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHAPASHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MANGAYA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSILAWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAKAVHINI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIAVHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUILADI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HLENGANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUTELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MADAVHILA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TAKALANI NYAWEDZENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAHOLONI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "KAREL NGIGIDENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LAVHURALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "VHURIVHURI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUKOMAWABANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIKALANGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LAMVI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIKONDENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "KHAVHAMBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAVUNDE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSWERA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUHUYU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAHUNGUHWI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MATANGARI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "THENZHENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAKWARANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHILUNGWI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIDZIVHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MADATSHITSHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "BELEMU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LURENZHENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MATHITHIVHALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUTHUNDINNE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIVHALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIVHAMBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "AWELANI CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MANAMANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUTENDE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAPATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAHEMATSHENA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAKUMBANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DZINDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHISAHULU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "THIVHULAWI RUDZANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MASHILA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIWEDZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LUVHALANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIMBILUNI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RALUTHAGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAFHARALALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAPHUPHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "HAMUTSHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MANGOMANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIFHUMULO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "DZONDO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MULANGAPHUMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "GANYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAFHUMULELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIFULANANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MBOSWOBENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MATAVHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHAKHUMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIFHANDE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUTANGWA-MANUGU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NNDWAMMBI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NANDONI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "EDWARD MPFUNENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NDAENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHISEVHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MPHENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MATAMELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NNGWEKHULU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MALINDINI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MPOFU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RASIVHETSHELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIVHULANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHINO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHITAMBAMUNWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NZWELULE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIVHAZWAULU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SIGWAVHULIMU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SUNDANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIAWELO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "DE HOOP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAVHINA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MASHAA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MPHAGANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SHANDUKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "THOMAS NTSHAVHENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MATHOTHWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUNWAI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "AVHATONDWI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LUPEDZE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MATSINDEVHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MARIADZE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIRUNZANANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "VHANGANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "PHINIMINI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIVHADE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SIWADAWADA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MATSILA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MANZERE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RATSHIEDANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUHUVHOYA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUUNGAMUNWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUTSHIPISI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIKURUKURU -2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MASUVHELELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIHENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "GILBERT MULONDO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KHALAVHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUDUNUNGU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIKOVHANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "ADZIMMBAMBI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MADALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "FONDWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIPANGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MILABONI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "THONONDA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SHAVHANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "DZUMBULUWANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIVHILIDULU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GOOLDVILLE MISSION SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "VONDWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHISELUSELU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIPAKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIKAMBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIFHATANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TAKALANI -2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RAMUSHASHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NYAHANELANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUTAVHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MPHATHELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MBULU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MASIKHWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAKONDE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LONDOLANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "KHUBVI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "JIM MASINDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GILBERT NNDANGANENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GEORGENHOLTZ"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GALANANZHELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DAMANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIULUNGOMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHINETISE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHILIVHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIKHUDINI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NTSUMBEDZENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUVHI TSHIKOVHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MASHAWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MURAGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MANGONDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MANIINI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAMATHIELEDZHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAKANYU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAHWASANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LUKWARANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LUFULE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "JIM TSHIVHONELO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DIDIDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DZIVHANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSWINGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHISHONGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHILUVHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHAMAVHUDZI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "THIFHURIWI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NWELI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HILMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MBAHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAUNGANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MATSIKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MALAMANGWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHANOWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "KHALILALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MABILU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAKHUVHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MATONDONI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MBULAHENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MPHIGALALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUKUMBANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MURANGONI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUTSHALINGANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MIKOSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NDIKANDAFHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NGUDZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "PFANO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHADZUME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHILAPFENE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIMEDZWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHITEREKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIVHUNGULULU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "VHUFULI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "BEUSTER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LUKUNDE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LUKHAIMANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAFENYA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LAERSKOOL BERGVLAM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DZINGAHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "JOHN MARUBINI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "KONANANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LUTANDALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAMALI SIKHWIVHILU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MBALENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MBILWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MMBARA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NGWENANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "PHIPHIDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RATSHITANGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIFIFI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHILAMBUVHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIVHULANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAKWARELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIVHILWI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SIAMBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MVUDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "CHRIST THE KING"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SUDZULUSANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MULAMULI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHEDZA COMPREHENSIVE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIDZINI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHAULU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIFUDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MANGHENA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "BEGWA TSHITUMBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DENZHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DUVHULEDZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GABA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MULENZHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUTOTI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MASETONI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GONELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "GUNDA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LAMBANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LUKALO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAHAGALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MANZEMBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHAMUTSHEDZI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MMBOFHENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUBVUMONI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUSHIRU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUTHULI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUTSHETSHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NYAMULIWANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "THOMANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUTSHENA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TOVHOWANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "KHAKHANWA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HITEKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MABUDUGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RAMALIGELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUTHUHADINI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "DJUNANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIISAPHUNGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MASINDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "HLALELANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIMONELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUNZHEDZI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAANDAMAHULU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MADABUDE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MADADZHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MADIHADZULI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LOTAVHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TUWANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIILAHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "THONZWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "ST. SCHOLASTICA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NTHABALALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUWAWENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUISE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUILA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUDIKHOMU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MASETHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MANKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LEKGOLO -1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAILA -2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "LEKGOLO -2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LUPENYO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "EDZISANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "VARI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LOTSHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MASAKONA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MASEKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MASHAMBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAWELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUFEBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MULINDATHAVHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUVIMBI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "REMBULUWANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "RIVERPLAATS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHITANGULE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIVHUYUNI -1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "WAYENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIVHUYUNI -2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MATOANZIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUFULWI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "R.S.B. DITLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGATELOPELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KHUTJANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MARUDA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MOKOPANE-SOUTH"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "EUPHORBIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MOOKGOPHONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "PARADISE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "KGAMANYANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "CHRIS HANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SUNRISE SUPERKIDS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "THORNTREE PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "ORTLOFF PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MECS JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "TSHUKUDU 1"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LEPHALALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "HARDEKOOL ACADEMY FOR CVO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MARLOTHII LEARNING ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "THABO MBEKI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "MMERA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "ROOSEVELT ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "HECTOR PETERSON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "CRADLE ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "CAPE TO CAIRO CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "ADVANCED COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "ALLDAYS PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "RASELAELO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "BOTHANANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MAPHETSA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "T.P SEAKAMELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SELOWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOGOSHI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KGABO PARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOLETJANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "GOOD CHOICE SCHOOL OF MORALITY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MAKGALAPANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MONGWANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEGORENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PEPPS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MOSHABI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BODUTLULO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "KOROSO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "THE SHOWERS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "GOOD SHEPHERD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MABOKELELE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MMASERA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NORTHVIEW CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "GOOD HOPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "ELICA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MARIA MONTESSORI CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "WONDERLAND"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NIRVANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "GREENSIDE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NEW LOOK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "BET-SHALOM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NIRVANA LEARNING ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MMASESHA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MARARA CYNTHIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MACHAKA LEARNING ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "APPLE SEEDS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "FOUNTAIN OF SOLACE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "KINDERWOOD PARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MABAYENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "REBIRTH CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "JOHN XIKUNDU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MKHACANI MZAMANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "PHAWENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MZAMANI THOMAS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAHLAMBANDLOPFU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "ST MARY'S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIDAVHUMU LEARNING CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "THASULULO CHRISTIAN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "TSHAMISEKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "JACOB ZUMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MAKELLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TRUE LIFE CHRISTIAN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "CONFIDENCE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "GRACE PARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MVELEDZISO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NWAMBEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "DZIVHALANOMBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KNOWLEDGE OF GRACE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MULWELI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSAKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "DEMONTFORT CATHOLIC"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "KHAVHATONDIWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "BEITBRIDGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "REHOSHEBAH INDEPENDENT ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "BRAAMBOS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "CHAMPIONS ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUGIDANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LIVING GOSPEL WORLD MISSION"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MURATHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "PROGRESSIVE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "JR TSHIKALANGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LITTLE FLOWER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "AMARILLO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "IT-TODAY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "DAMBALWASHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "OCEANS PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIKHOVHOKHOVHO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TSHIVHAZWAULU CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MISSION"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MUNYANGANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NYUKANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "BEST FUTURE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "BRIGHT STAR CHRISTIAN LEARNING CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "ORCHID"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "STARLIGHT ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "N'WAMANKENA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KULANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NINAKHULU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "B.N. NTSANWISI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KURHULA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "PHALABORWA ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "VAXADZI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "REFENTSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "BETHSAIDA CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "LIGHTHOUSE ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RELELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAUPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "PFUNANANI ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAKHOSANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MOHLABANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MUGEJWANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "CELESTE ACADEMY OF EXCELLENCE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MOKWAPE BETHUEL MAMPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MASUNGULO-2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "BRIGHT MORNING STAR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SUNSHINE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SHONGANI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "UNITY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "WOLKBERG AKADEMIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RADICAL SCHOOL OF ENTREPRENEURSHIP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "POWER MEMORIAL CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SANTENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "HOLY SPIRIT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "VUNZA TEDDY BEAR LEARNING ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MOGEGI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "ROB-ORPHILIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MARAKABELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LAERSKOOL BURGERSFORT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "IKHWEZI LOKUSA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "WATERVAL LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "BATUBATSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "HIGHLANDS COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LAERSKOOL OHRIGSTAD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAEPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MANGABANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAGAKANTSHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MOSEBU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NTHAME"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THOBELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "BOPANANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "ELIAS MASANGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "ONISMUS MOGAFE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RAMANARE-MAGAMPA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "FLAG-BOSHIELO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MMAZWI A NAPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "STUNDU SIMANGO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "HLAKANANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "BABINA KGOMO SOCIETY ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "LESEDI-SEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THABANASWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MADINOGE KGOLOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SISABONGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MADIBENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "SHOPIANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LAERSKOOL ROOSSENEKAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAELEBE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "KOPI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DITHAMAGA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "DIHLABANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "ZAAIPLAAS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "YEGUGULETHU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MUTSI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LAERSKOOL TOITSKRAAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MABHANDE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MADIKOTI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LAERSKOOL MARBLE-HALL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RAKEDIWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "REHLAHLILWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SEHLAKWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LAERSKOOL JULIAN MULLER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "CVO MARMER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "DYNAMIQUE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RAMONOKANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOHLAKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "REBONE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAGATE LEOPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NKADIMENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MPHELENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOTETI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RAHLAGANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEHLAGARE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RAMATSETSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SLOVO PARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SUPATSELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LUSAKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "BATAU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LIGHT OF GOD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PALEDI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NJINGA SINDANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THABAKHUBEDU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SIBISI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "BANTWANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KAU-MAGANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MARAPONG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAPULA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PHOOKO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TAGANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SEETSENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "UMTHOMBO WEMFUNDO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "EKUCATHULENI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATLALA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATATADIBENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATABANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MASHUNG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAKALAKANYE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATLEREKENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KGOMOTLOU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "EPHRAIM MOGALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TAU-TLOU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAMANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "CON ROUX"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MABULE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RATHOKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "REKGONNE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "METSANANGWANA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MMAKOLA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOKGWANENG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MORE-O-MOSO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "BABINATLOU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MARBLE HALL ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SITANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ALLAN MAKHUNGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "AMANDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "AMANZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ANDISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ANDRIES MASHILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BESILINDILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ARBOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ARNOT COLLIERY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAMINZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LETSAKUTFULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BALFOUR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BAMBANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MOUNTAIN VIEW SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BASHELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BAWOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BAZANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BEKETELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BEKEZELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BELFAST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BENZANGANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BERBICE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BERGPLAAS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BETHAMOYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BHAMBATHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BHEKIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BLESBOKSPRUIT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BLINKPAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BLOEMENDAHL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BONANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BONGAMLAMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BONGANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BONGANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BONGINHLANHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BONGOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BONGUMKHWANAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BONUKUKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BOROLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BOSCHRAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BUHLEBUYETA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BUKHOSIBETFU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BUYANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CABANGANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CANGASA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CATFULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CHAKAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CHIEF MAKUNYULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CHWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "CLEWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CABANGANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CLIFTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "COPHETSHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CROCODILE VALLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "D & C COMPREHENSIVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "DAGGAKRAAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "DELFKOM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "DERBY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "DIPERE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "DIPOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "DITLHOKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "DRIEPAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "DUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "DUMELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "DUMEZIZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "DUMISANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "DUNBAR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "DUVHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EBHUDLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EBUHLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EDWALENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EDWARD MATYEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KHULUNOLWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EKHIYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EKUCATHUZENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EKUJABULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EKUKHANYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EKUPHAKAMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EKUPHUMULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EKUTFOKOTENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EKWENZENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ELUKWATINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ELUSINDISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ELUYENGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EMATJENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EMBONISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EMFUNDWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EMONENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EMSENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EMTHONJENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ENDLUNKULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ENDOTSHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ENKHOKHOKHWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ENON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ENTOKOZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ENZANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ERMELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ESITHEMBISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ETHEMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ETHEMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EVERGREEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EVIMBILANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EZENZELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EZINDONGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EZWENILETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "FAIRVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "FATHER CHARLES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "FUNDAWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "FUDUQHUBEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "FUNINDLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "GEBHUNDLOVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "GEORGE MHAULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "GIJAMPHEZENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "GIJIMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "GOBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "GOEBRAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "GOGOMHLANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "GLORY HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "GROOTBOOM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "GUGULETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "GUTJWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HAMBANATSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HENDRINA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HIGHVELD RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HLAKANIPHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HLALANIKAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HLALISANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HLALISANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HLANGU PHALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ZWELISHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HLEZIKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BHEKITHEMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HLOBISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "C V O AMAJUBA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HLONIPHANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BENJAMIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "HOECHST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PHUMALANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOTSWEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HOLDESHEIM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HOUTENBEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "HOYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "IFALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "IGUGULABASHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "IKAGELENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "IMBEKEZELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "IMPILO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "INJABULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "INJUBUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "INKABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "INKHAMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "INKHANYETI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "INKOSINATSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "INKULULEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LETSAKUTHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MBUZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "INTFUTFUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "INYETI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "IPANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ISABELLADALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ISIBANISEZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ISIFISOSETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ISU ELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ITHOLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ITIRELENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "JOHANNES KANANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "JABULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "JABULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "JEREMIA MDAKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "JOHN MDLULI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MATSULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KAAPVALLEI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KABENZIWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KABETE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KADUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KAGISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KALKOENKRANS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EMATJEKETJENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KATJIBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KGOPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KHANGELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KHANYISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KHANYISILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KHAYALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KHOBONGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KHOMBINDLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KHONZAKAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KHULA-MLAMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KHULANGELWATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KHULANGELWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KHULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KHULUFUNDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KHUPHUKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KHUPHUKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KHUTHALANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KHUTSALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KHUTSONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KINROSS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KLEIN VRYSTAAT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "CARISSA PRIMARY SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KLIPSPRINGER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KLIPSTAPEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KOBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KOME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KROMDRAAI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KUSILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KWA-JELUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KWAGGALAAGTE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KWAGUQA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KWAKWARI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KWALODAKADA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KWAMATSHAMHLOPHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KWANALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KWANDISAMFUYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL AMERSFOORT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL AMSTERDAM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL BADPLAAS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL BALMORAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LAERSKOOL BARBERTON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LAERSKOOL BERGLAND"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BREYTEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL CHRISSIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LAERSKOOL CLIVIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL DAVEL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL DELMAS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL DENNESIG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "DIEPGEZET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL DUVHAPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL ELOFF"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL ERMELO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL GOEDEHOOP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "GRASKOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL GREYLINGSTAD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL GROOTVLEI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL H M SWART"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL HOËVELD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL JJ VAN DER MERWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL JEUGKRAG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KAAPMUIDEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL KALIE DE HAAS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL KANONKOP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL KINROSS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL KLIPFONTEIN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL KOORNFONTEIN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL KRAGBRON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL KRAGVELD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL KRIELPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL KRUINPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LAERSKOOL LAEVELD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL LEANDRA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL LOTHAIR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LAERSKOOL LYDENBURG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL MACHADO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LAERSKOOL MALELANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL MARIETJIE VAN NIEKERK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL MIDDELBURG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LAERSKOOL NELSPRUIT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LAERSKOOL NUMBI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL ONVERWACHT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL OOSTERLIJN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL ORANJEGLOED"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL PANORAMA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL PIET RETIEF"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL PIONIER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL REYNORIF"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL RIETKUIL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LAERSKOOL SABIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL SECUNDA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LAERSKOOL SKUKUZA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL STAATSPRESIDENT C R SWART"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL STANDERTON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL SUNDRA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL TAALFEES"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL TASBETPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL TRICHARDT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL UITKYK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LAERSKOOL WITRIVIER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAERSKOOL WITTENBERG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAMAGADLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LANGELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LEFISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LEFISWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LEGOGOTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LELENGAYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LEPESI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LESODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LIBHABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LIFALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LIGUGULETFU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LIKHWETI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LINDANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LINDANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LINDILANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LINDOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LINDZALOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LOBHENGULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LOCHIEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LODING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LOMATIDRAAI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "DUMEZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LOTHAIR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LOTI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LUBHAQA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LUGEDLANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LUNGISANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LUTHANGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LUVOLWETFU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LWALENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MABHOKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MABOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MABOMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MADIBOANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MADOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MADZANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAGADUZELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAGEWU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAGODONGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAGOGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MAHAMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAJEMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAJIKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAKERANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAKHAHLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MAKHOSONKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAKOKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAKOPANONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MALEKUTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MALIBONGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MALOKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MALONTONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LIVELETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MANGADISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "C V O SKOOL BETHAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MANTLOLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MANTONGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MANTWANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MANYANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MANYAZELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MANZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAPHAKAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAPONDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAQAMELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAQHEKEZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MAQUBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MARAMBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MARELENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MARIFAAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MASANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MAPHALA-GULUBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MASIBEKELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MASIBONISANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MASIZAKHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MASOBYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MASUKU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MATALAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MATEMPULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MATHETHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MATJENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MATSAFENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MATSAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MKHANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BATLAGAE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAVULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAWEWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BHEKOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MBALENHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MBAZIMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MBOKODO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MBONGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIYATHEMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MDLADLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MLONDOZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MDUMISENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MDUMISENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MDZIMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MEHLWEMAMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MERLIN PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MFULAMUDZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MGCOBANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MGIBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MGWENYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MHLATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MHLOSHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MHLUZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MHOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MHOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MHWAYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MIDDELBURG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MISPAH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MJEJANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MKHOMAZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MKHOMAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MLAMBONGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MLAMLANKUNZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MLILO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MMADIMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MMAMOGASWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOTOANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MNYAMANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOCHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOEKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOGALITWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOHLATSENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOKIBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOLOTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "S.A. MAKAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MVUZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MORUTI MAKUSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOUTSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MPAKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MPHEPHETHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MPHILONHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MPHOTI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MPUMELELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MPUMELELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MSOGWABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MSWATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MTHAYIZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MTHOMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MTHUNZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MUZIMUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MVANGATINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MZINTI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NANCY SHIBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NCIKINYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NDAYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NDINDINDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NDLAPHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NDLAVELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NDLEMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NELSON NGUBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NELSPRUIT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NGEMA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NGONINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NHLAZATSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NJOMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NKOKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NKOSABO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NKOSIPHILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NKOTOLANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NKUKHUNDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NOBUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NOKUTHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NQOBILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NSIZWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NTABABOMVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NTABANHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NTESENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NYALUNGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NYANDENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "OKHELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LYDENBURG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "OTHANDWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PATRICK MANKOLANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PILGRIMS REST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "PETRUS MAZIYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PHAKAMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PHAKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PHAKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PHAKGAMANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PHAMBANISA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PHELWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "PHEMBINDLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "PHEZUKWENTABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PHINDELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PHIVA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PHOLANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PHOPOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "PHUMULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "PHUMULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PHUTHUMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "PHUZAMANZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "PIETER MABUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "POTSANYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PRIMÊRE SKOOL KELLYSVILLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PRINCE SJ PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "QALABOCHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "QALANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "QAMBEKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "QEDUDLAME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "QHUBEKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "QHUBEKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "RADIJOKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "RAMABALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "RAMABIFI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "RAMANCHAANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "RAMANTSHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "RAMODIEGI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "RAMOKGELETSANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "RANKAILA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "REATLEGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "REDHILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "REKWELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "RETANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "RETHABILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "RETSEBILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "RIETKOL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "RING KINK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ROBERT CARRUTHERS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SABATHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HARMONY HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SAKHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SAKHILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SAKHISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SALUBINDZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SAMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "PHUMELELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SANDZILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SANGQOTHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SASOLIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BLACKHILL SCHOONGEZICHT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SCHULZENDAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SEHLULILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SEHOKHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SEKUSILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SHAPEVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SHISHILA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIBIS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIBONGANGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIBONGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIBONGIMPUMELELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIBONGINDAWO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIBOSHWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIBUKOSETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIBUYILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIDINGULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIDLOKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIFIKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIFUNDAKHONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIFUNDISE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIFUNINDLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIHLANGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIHLEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIJABULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIJABULILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SILINDZILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SINDZAWONYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SINETJHUDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SINQOBILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIPHENDULWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIPHUMULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SISINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SITHABILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SITHEMBISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SITHUTHUKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIYABUSWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIYACATHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIYAFUNDZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIYAKHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIYANCOBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIYAPHAMBILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIYAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIYETA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIYEZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIZABANTWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIZAKELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIZAKHELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIZANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIZENZELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIZIMISELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIZISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SIZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIZOFUNDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIZUZILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SOBHUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SOGASA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SOHLAZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SOKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SOMABEDLANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SOMAROBOGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SOMCUBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SOMLINGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SOMLOKOTHWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SOMTSHONGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HAMBANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SPRINGVALLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ST ANDREWS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ST PETERS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "STANDERTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "STEYNSDORP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SUKUMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SUKUMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SUNDUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAKHOSOKEI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SWELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SYDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "TP STRATTEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "TABANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TAKHELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TEKWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TENTELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "TETEMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TFOLINHLANHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THABONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "THAMBOKHULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "THANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THANDANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THANDEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THANDULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "THANDULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THATHUKUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THE FRIEDMAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THEKISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THEMBALIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THEMBEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THEU THEU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THOLUKWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THORISONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THUBELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "THULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THULASIZWE LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THUSHANANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THUTHUKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THUTHUKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THWAHLELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TIBONELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TIGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "TIMELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TINDZALENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TIPHEMBELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "TJAKASTAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "TJEBISSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "TJHIDELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "TLHAME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "TORBANITE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TSANDZANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "TSATSELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "TSATSIMFUNDVO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TSEMBALETFU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "TSEMBEKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "UKHWEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "UKUPHUMULAKWESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "UMBHEJEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "UMKONYAAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "UMLAMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "UMPILUSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "UMPOPOLI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "UMSEBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "UMTULWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "UPLANDS PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VAMUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "VAN STADENSDAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VELANGEZWI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VERENA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "VOLKSRUST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "VUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "VUKASAMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VUKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "VUKUZITHATHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "VULANDHLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "VULAMASANGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VULINDLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "VUSUMUZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "VUTSELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "WAKKERSTROOM COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "WEEBER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "WESLEY MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "WETTERAU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "YEDWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "YELLOWSTONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ZAKHELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ZAMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ZAMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ZAMINTUTHUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ZAMOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ZANDILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ZENZELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ZIBOKWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ZIKUPHULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ZIMISELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ZITHATHELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ZITHOBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ZITHOBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ZITHULELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ZITHUTHUKISENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ZIZAMELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "JIKANTATHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KHAYELITJHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "WELGEVOND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIBONIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MHLUTSHWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ZAKHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIDLEMU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "DIENTJIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "KOBENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LL MOGANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MOKOKWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PITAS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SHAKWANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MATIBIDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "C V O SKOOL ERMELO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "FUTURE ACHIEVER'S ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SS MSHAYISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "IMIZAMOYETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIYATHOKOZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ZWIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EDUCODE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EKUPHUMULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CARPE DIEM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIZAMILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "REFITIHILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HABILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BLESSING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "CHIEF LUTHULI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIFUNDZEKHAYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MIDDELBURG CHRISTIAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EDUCODE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BARBERTON ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SUMMERHILL PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "WESSELTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAGCEKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SONDLOVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ETSHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "S'BONGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "STANDERTON CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SAKHISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "AA KHUMALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "FOUNTAIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BETHAL INDEPENDENT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EDUCARE PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "UBUHLE LEARNING CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LITTLE ANGEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TONGA VIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LAERSKOOL NESHER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SUNRISE ACADEMY OF LEARNING"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MBONGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ALEX MANABENG MAMPANA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KAMHLUSHWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SALLEM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SHAYINDLOVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BUHLEBUYEZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "PHAPHAMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "IKHWEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "GRACE CHRISTIAN PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EKUPHILENI ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIBANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "YINHLELENTFO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EDUCODE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "FAIRVIEW ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EUREKA ENGLISH MEDIUM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIBAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SHAMMAH EAST COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "IMBONDVO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "DELPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NORDEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ELOHIM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ZIWELILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIYAMUKELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KWACHIBIKHULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MATIMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ALPHA AND OMEGA SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HLUVUKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HOKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "KHAYELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAHLAHLUVANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MANYAMOODIESKATANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MATSAVANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NDIMANDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NKULUNGWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "QCETYWAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "WELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "ZIGODE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "APLOS CHILOANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "ARTHURSEAT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "CHUEU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "CRAIGIEBURN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "GREEN VALLEY LOWER & HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HLOALA CHILOANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAKWETSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAPATELETSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MOKGOMANA LOWER & HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MOREI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MOTLAMOGATSANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PHATSEDI LOWER AND HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SENIANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SENONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "TSHOKOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "CASTEEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "KENNEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LEBADISHANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LEKANANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LEKEDI LH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "M.O. MASHEGO LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAHUBAHUBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAMOSEBO LOWER AND HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAMOSODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAOLOSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MATLUSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MOKGAWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MOTLAMOGALE LOWER AND HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "ANDOVER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "ECKSON MASOTJA CHILOANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "JAMEYANA HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "KHOKHOVELA HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LETSAMAILE CHILOANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MABONWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MADILE LOWER HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAKGAHLISHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAWUVANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MORAGE LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MPHAKU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MPISI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PANYANA SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "POWERLINE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SEBOSEGOLO SA MAPULANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SESETE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SIHLEKISI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BENG BA LONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BUYISONTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "D.G. MASHEGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "ESSELMAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HLAMALANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAJEMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MASWAMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MATHAMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MPISANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NKOTHASI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NKWENKWEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SAILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SASELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SIMBAMBAYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "TWALAKULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "XINGALA-MAKAMU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BERETTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "CHAYIWE LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "FUNJWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "KGWADITIBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LUMUKISA PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAPALANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MASENYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MUGIDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NDABENI H PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PAULOS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SEGANYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SETLHARE HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "TIMBAVATI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "WEM SCHOOL - ACORNHOEK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "ALEXANDRIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "CUNNINGMOORE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HLANGALEZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HOKISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "KHULONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "KWETSE LOWER AND HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAGASHULE LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAPETEKOANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MHLAVA-KHOSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MOTSELENG SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NTSHOENYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "OAKLEY HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PLAATJIE LOWER AND HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SARINGWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "TIYIMELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "VANDAMA LOWER AND HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HANANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HLALAKAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LUDLOW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAHLATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAHLEKISANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MALWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MANYELETI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MATIKINYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MTEMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MUCHUCHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MUNYAMANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NWAMACINGELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NXALATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SALANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SAMSON SIBUYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SHIVITI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "TSUVUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "WELVERDIEND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "XINYEKETI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BANTOMU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "EMFULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HLULANI HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "KWANANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LAPISHE LOWER AND HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "M.P. MOKOENA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MADUKULUSHE LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAKOROMPANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MALENGEZA HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MARONGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MATHUPA LOWER AND HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MOGOLANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NWA MAHUMANA LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SHATLENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BARNEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "DILAYI LOWER AND HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "DIPHASWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAVILJAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NTSIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PUGISHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "S.H. NYALUNGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BHEJANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HOMUZEYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LONDHINDHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAPALENI HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MATIKWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAVIMBELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MBATINI LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MKHUMBINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MVUYAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NJANJI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PENSELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PHAPHAMA LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SHALAMUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "THULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "THWASANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BOIKHUTSO PRIMARY-2 SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "FAREL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LESEDI LOWER AND HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MATHULE PRIMARY-1 SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MATLALONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MATLOLANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MORATISENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NARISHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NGWARELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NTSOELEMOLODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "RELANE LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SEDIBENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SHATALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "THABAKGOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "CHARLEY MBHUNGELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "EZROM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "FLORAPHOPHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HUMULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAHLAMBANDLOPFU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAVANDLA HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MPIKANISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MZILIKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NDWANDWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SABEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SONGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SONIYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "THULAMAHASHE LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "WISANI HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "XILONGANA-MALAMULELE LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "ZWIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BABATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "DYONDZEKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HIBEMANDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HLANGANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HUNDZUKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "J.J. MATSANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "JAN RIKHOTSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "JONGILANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MAGUDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MHLAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MKETSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NEMBE MHLABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NJONJELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NWANKUPANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "RHANDZEKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "TIYANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "VUYELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "DANIYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "GAVAZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "HLAVATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VEZIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "COME TOGETHER CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "VIOLET JIYANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "TOKOLOHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MTFOPHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "AMON NKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PETER MOKABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SEDIBA-SA-THUTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MOTHAILENG MASHEGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SAMUEL MHLANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BADLANGAYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NDUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "JB KHOZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "KAHLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "EZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "GREEN LIGHT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "INSIGHT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MORITING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NTSHUXEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "IMBALI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "AERORAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "A PETIT PAS INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "HOSIOS CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "NHLENGELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MASWENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LEHLOGONOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ROROBHANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VEZIKGONO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "HAZYVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BRIGHT STAR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MIDDELBURG PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOSES MAGAGULA CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "WISDOM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SUMMERFIELDS PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "WISDOM OF GRACE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PLASTON ACADEMY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SICELALWATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "VOLKSRUST SCHOOL OF HOPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "TIDIMALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "INNER HEALING MISSION CHRISTIAN SCHOOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BOPHELONG COMMUNITY INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "COUNTRY COLLEGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "STANDERTON AKADEMIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SUDEFI COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIYATHUTHUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PRINCE HR NKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "RIVER VALLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EXTENTION 24 PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MONAREDIRA PRIVATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MUSAWENKOSI CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LINGITJHUDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "NEW PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "HARTSWATER CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KURUMAN MONTESSORI TREE COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "ISAGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "KIMBERLEY ISLAMIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "RYVA ACADEMY OF LEARNING"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "OREL PRIVATE ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "SUNSET PRIMARY COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "SHEKINAH INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "JAN KEMPDORP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "ORANJE DIAMANT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "JOHN ROSSOUW PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "HANOVER DESTINY ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "LEPELSFONTEIN RK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "FRASERBURG ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "WITBANK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "TNJ VAN DER WALT KOLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "SLIMBEGIN ONDERRIGSENTRUM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "WILLISTON JUNIOR KOLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "FANIE MALAN LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "PHILANDERSBRON PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "VREDESVALLEI PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "PABALLELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "AUGRABIES AKADEMIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "KAKAMAS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "RE FENTSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "AGANG-THUTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BANKHARE-BODILONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "CUM LAUDE ONAFHANKLIKE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GAEGAKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "WRENCHVILLE NEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "BONTLENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "GAOSHUPE MAKODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "H SAANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "KGONO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "MOOKI-LOBELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "OREEDITSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "PABALELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "SIMON MEDUPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "LAERSKOOL GAFFIE MAREE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "STEPHEN MALHERBE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "ELIZABETH WIMMER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "PORT NOLLOTH LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "DRYFSAND PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "JOHAN HEIN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "CAROLUSBERG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "CONCORDIA PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "SACRED HEART (RK) PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "ST CYPRIANS INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "BULLETRAP PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "ROOIWAL (VGK) PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "VIOOLSDRIF PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "BUFFELSRIVIER VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "SPRINGBOK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "GOODHOUSE NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "OKIEP LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "DR IZAK VAN NIEKERK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "FERDINAND BRECHER PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "JJ LAMBERT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "MARAIS GEDENK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "LAERSKOOL DE AAR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "KLIPFONTEIN MET PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "KAMIESKROON PRIMÊR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "SOEBATSFONTEIN NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "SPOEGRIVIER MET PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "TWEERIVIER METODISTE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "PAULSHOEK MET PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "KHEIS MET PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "LELIEFONTEIN INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "NOURIVIER MET PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "NORAP MET PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "LAERSKOOL BRANDVLEI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "LAERSKOOL CALVINIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "HANTAM PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "DIEPDRIFT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "MIDDELPOS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "LOERIESFONTEIN LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "PROTEA LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "MALHERBE HUMAN INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "ROGGEVELD INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "NICO BEKKER INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "AGGENEYS LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "ST ANNES PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "FRANCOIS VISSER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "JJ BOOYSEN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "BENNIE GROENEWALD PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "IKHAYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "DOMBIETERSFONTEIN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "HUTCHINSON PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "MELTON WOLD PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "PAMPOENPOORT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "VAN DER WALTSPOORT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "SS MADIKANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "COLESBERG PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "IKHWEZI LOKUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "KAREEVILLE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "ST JOHNS (RC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "WILLIE THERON PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "ALPHA PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "VAN RENSBURG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "DE AAR JUNIOR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "HAYES PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "LUVUYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "HANOVER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "EMTHANJENI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "ZINGISANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "CARNARVON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "DELTA PRIMARY SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "PHILIPSTOWN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "PETRUSVILLE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "PHILIPVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "VISISANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "KEURTJIEKLOOF PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "PRIESKA PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "JJ DREYER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "RD WILLIAMS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "BLOUKRANS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "VAAL-ORANJE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "BONGANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "ANDERSON PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "KELEMOGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "BUCKLANDS (NGK) PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "SALT LAKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "GRANGE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "VAALLUS (NGK) PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "GROOT MIER (VGK) PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "KLEIN MIER (VGK) PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "WELKOM PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "LOUBOS (VGK) PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "ALHEIT (NGK) PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "ASSUMPTA (RK) PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "BLOEMSMOND PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "LAERSKOOL CURRIESCAMP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "MCTAGGARTSKAMP (RK) PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "SOVERBY PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "VORSTER EILAND PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "VYEBOS-EILAND PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "ST MARIA GORETTI (RC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "LAERSKOOL SENTRAAL KAKAMAS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "ORANJE-SUID PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "KENHARDT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "LOXTONVALE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "PERDE-EILAND (NGK) PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "VAALKOPPIES (NGK) PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "CORNELIUS JANSEN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "VELA-LANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "LUKHANYISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "SWARTHMORE (DRC) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "OP DIE VOORPOS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "OLYVENHOUTSDRIFT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "SIMBRUNER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "LAERSKOOL ORANJE-NOORD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "WESTERKIM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "GARIEPWATER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "UITSIG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "LAERSKOOL WILGENHOUTSDRIF"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "LAERSKOOL GROBLERSHOOP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "ASSMANG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "HTT BIDI MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "KHOSIS (MET) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "NOORD-KAAP PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "LAERSKOOL POSTMASBURG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "ASMANDIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "POSTDENE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MAIKAELELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "SHA-LEJE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "KGOTATSANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "FINSCH (SSKV) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "LIME ACRES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "SOL PLAATJIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "MONTSHIWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "BOITSHOKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "RENEILWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "LETSHEGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "TSHIAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "ST PETERS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "KIM KGOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "MANKURWANE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "MASIZA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "MOLEHABANGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "PESCODIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "BEACON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "NEWTON PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "DU TOITSPAN LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "LAERSKOOL DIAMANTVELD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "FLOORS NORTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "PROGRESS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "ENDEAVOUR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "OLYMPIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "GROENPUNT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "LAERSKOOL EUREKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "HERLEAR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "STAATS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "FLAMINGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "HOMEVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "VENUS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "LAERSKOOL VOORUITSIG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "KIMBERLEY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "KEVIN NKOANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "KGABANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "RIETRIVIER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "LUCRETIA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "WEST END PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "WATERWORKS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "TSHWARELELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "ROODEPAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "BARKLY WES PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "PNIEL-LANDGOED PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "BARKLY WEST HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "MOSALAKAE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "FRANCIS MOHAPANELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "ULCO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "DL JANSEN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "WARRENTON PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "REALEBOGA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "LAERSKOOL WARRENTON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "DEBEN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "SISHEN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "LAERSKOOL KATHU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "LAERSKOOL KURUMAN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "LAERSKOOL SEODIN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "WRENCHVILLE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "LAERSKOOL HARTSVAAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "LAERSKOOL HARTSWATER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "VOORSPOED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "VALSPAN INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "TAUDIARORA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "LAERSKOOL ANDALUSIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "LAERSKOOL ELANDSVLEI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "SWARTKOPSDAM VKK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "RIEMVASMAAK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "LAERSKOOL SAAMBOU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "SETSABELO PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "KOOPMANSFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "OLIERIVIER MARIANETTE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BLACKROCK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KITLANYANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "TSOE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "DUTTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BAREKI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MADIBENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "ETHEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MAKHUBUNG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "PERTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "SHALANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "LEKHADUNG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BOGOSIENG LEKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GOODHOPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "LONGHURST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GATLHOSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "THAE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GARAPOANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "EDIGANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "ITSHOKENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GAMOCWAEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MAIPHINICKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GALORE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "LEHIKENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BOJELAKGOMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "LOGOBATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MATHANTHANYANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MAIPEING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "ITEKELENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MARCH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "METSEMANTSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MARATADITSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MAREMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "RUSFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "SESHENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "TSINENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MAOKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MAKOLOKOMENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GAMORONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MAGONATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MAMPESTAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MADUO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GAKGATSANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "IKEMELENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BOTHETHELETSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GAAESI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "SENGAE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "PULELO PRIMARY SCHOOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "SIMOLOLANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "LERUMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "OMANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "NEW SNAUSWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BAITHAOPI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GAMASEGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "OBONTSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GLEN RED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KEATLHOLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BATSWELETSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "THAGANYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "LETLHAKAJANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BOGARE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KONING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KAREEPAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MANYEDING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MECWETSANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "NCWELENGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "SEGWANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BOITSHIRELETSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "CARDINGTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MMITSATSHIPI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "TT LEKALAKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MOHOLENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MORALADI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "ROBANYANE TOTO II PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GALATOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "INEELENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GAMOPEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GANTATELANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "REITEMOGETSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "REARATA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MAHIKANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MARUPING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "SEUPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "NCWENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "SEDIBENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KUDUMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "LARENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BADIHILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "RELEKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MAPOTENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "ISAGONTLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "SEGOYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "STEYNVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "ELIOR AKADEMIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "KAROO AKADEMIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "DOUGLAS LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GOODHOPE MIXED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KURUMAN TUITION CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DE DOORNS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "SANDVELD LS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "METANOIA SILVER OAK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ABIENCE ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "LAERSKOOL MOUNTVIEW"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "LIFE CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "EDUDEN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GAIA WALDORF SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ATLANTIC BEACH COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KNYSNA CHRISTIAN MISSION SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "EAGLE'S NEST MINISTRIES, SA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WESTLAKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "DISA PRIMARY SCHOOL (HOUT BAY)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "BEAUFORT WEST PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "GATEWAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ROUXVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "PRINGLE HOUSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "CHRISTMAS TINTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "CHRISTELIKE PRIVAATSKOOL LEIPOLDTVILLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SUNNINGDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "DESTINATUS PRIVAATSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "CONCORDIA PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "CAPELLA HOUSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "GENERATION SCHOOLS BLUE MOON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "IMHOFF WALDORF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "CARNEGIE HOUSE PREPARATORY (PAARL)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "JUBILEE MONTESSORI ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "YOUNG AMBASSADORS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "NOMZAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "THE SINAI ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GRACE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "PRINCIPIA INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "EL MARINE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "VAN WYKSVLEI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "JEQ PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "VISION AFRIKA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "RISING STARS ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "HIGHBURY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "FOREST VILLAGE LEADERSHIP ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "HAPPY VALLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "VRT PITT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PARLIAMENT STREET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KWANOKUTHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "MONTESSORI CONNECT-THE CHILDREN'S WORKS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "FYNBOS ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "HOOPLAND ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ITHEMBA LABANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "HEXRIVIER OPVOEDKUNDIGE SENTRUM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BLOUVLEI ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SILVERLEAF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ALTENA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BIZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "RAPHAELI WALDORF SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "TRINITY CHILDREN'S CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "BAHIA FORMOSA SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "LINGOMSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "THE SUSTAINABILITY INSTITUTE TRUST OPERATING AS SPARK LYNEDOCH"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "MIDDELPOS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SOLOMON MAHLANGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CHAMELEON JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ITHEMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "INKANINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "FALSE BAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ESSENHOUT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "THE KUSASA PROJECT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PERSERVERANCE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SPLENDID KIDS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "VREDEKLOOF PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GROWING MINDS LEARNING AND THERAPY CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "BRIGHT STUDENT LEARNING CENTRE - FISH HOEK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "EMITHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KIDS KINGDOM PRE AND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "PINELANDS MONTESSORI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "GENERATION SCHOOL - MELKBOS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "OAKDALE MONTESSORI SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "JUPITER STREET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "FAIRDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SANDAALHOUT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HOUT BAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HOUT BAY MONTESSORI SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "TABATHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "BETTER BEGINNINGS COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "LITTLE GREENIES PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "KINGS AND QUEENS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "EENDEKUIL LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GRASSROOTS PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "CALEO LEARNING CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "APEX PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "GORDON'S BAY COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KEC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "VOETSPOORTJIES KINDER AKADEMIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "OTTER'S CREEK JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "CAPRICCIO! ARTS POWERED PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SUNRIDGE CIRCLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WASHINGTON DRIVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "CURRO GEORGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "DELFT-NORTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "WITSAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "FISANTEKRAAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "CURRO BURGUNDY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "EDUSMART ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "OAKVIEW ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KOGNITI ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "LITTLE FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "GEREFORMEERDE LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "HOLY CROSS SISTERS' SCHOOL (B)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BELHAR ISLAMIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "HEBRON CHRISTENSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "RAINBOW MONTESSORI SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BELLVILLE PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "RENLYN'S MODERN MONTESORRI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "DURBANVILLE VOORBEREIDINGSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PAROW INKLUSIEWE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PAROWVALLEI PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "RUYTERWACHT VOORBEREIDINGSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ARISTEA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BELLPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BELLVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BELLVILLE-NOORD PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BOSTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "DE TYGER LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "DURBANVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "EVERSDAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "EXCELSIOR PRIMARY SCHOOL (BELLVILLE)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "FANIE THERON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "GENE LOUW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "KENRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "LABIANCE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PANORAMA LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PAROW-NOORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PAROW-WES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PAROW-OOS LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SAFFIER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SIMONSBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "TOTIUS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "VREDELUST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "WELGEMOED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "DE WAVEREN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "NORTHWAY PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BELLVILLE-SUID PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "GOEIE HOOP PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "NEBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "WEBNERSTRAAT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "KASSELSVLEI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PINEDENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "VORENTOE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "PARKDENE PRIMARY SCHOOL (BELLVILLE)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "CAVALLERIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "WINSLEY PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ERICA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BELHAR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "GARDENIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "EIKENDAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BELVUE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SYMPHONY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ACCORDIONSTRAAT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "WATSONIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MATROOSBERGWEG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "THE VALLEY PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "DR. VAN DER ROSS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "RIEBEECKSTRAAT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ST. AUGUSTINE'S RC PRIMARY SCHOOL PAROW"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "KRAAIFONTEIN AME PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "TREVOR MANUEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "VISSERSHOK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ATTIE VAN WYK VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "LOFDAL CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "AKASIAPARK LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "KING'S SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "HOPE OF AFRICA JUNIOR CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SIGCAWU PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "MOKONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "MOSHESH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SIYABULELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "THEMBANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "VRIJZEE VOORBEREIDINGSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BOSMANSDAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "DE VRIJE ZEE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "EDGEMEAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "GOODWOOD PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "KOOS SADIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MONTE VISTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "PINEHURST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "THE PINELANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "PINELANDS NORTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "THORNTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "WOLRAAD WOLTEMADE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "EURECON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ARCADIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BALVENIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BERGSIG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BERGVILLE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BISHOP LAVIS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BRAMBLE WAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BOUNDARY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CEDAR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CENTRAL PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "CLARKE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "C.L. WILMOT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "DISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "EDWARD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ELNOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ELSBURY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ELDENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ELSWOOD PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "EUREKA PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "GREENLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "HELDERBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "HILLSIDE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "J.S. KLOPPER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "KALKSTEENFONTEIN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "VALPARK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PARKVALE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "KLIPFONTEIN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "LAVISRYLAAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "LEONSDALE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MATROOSFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "MIMOSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "MONTANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "NERINA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "NOOITGEDACHT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "NORWOOD SENTRAAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "PROTEA PRIMARY SCHOOL (BONTEHEUWEL)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "RANGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "RIVERTON PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ROSEWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "TYGERSIG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "UITSIG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "VALHALLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "MONTEVIDEO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MATROOSBERG HOLY TRINITY RC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HERZLIA HIGHLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HILLCREST SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "HOLY CROSS CONVENT (BROOKLYN)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HERZLIA WEIZMANN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "STEPPING STONES MONTESSORI SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SOPHAKAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HIDAYATUL ISLAM COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "DU NOON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "WEST RIDING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "PHYLLIS JOWELL JEWISH DAY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ST. AGNES'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ST. MARY'S PRIMARY SCHOOL (GARDENS)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "YSTERPLAAT JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BLOUBERG RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CAMPS BAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ELLERTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GOOD HOPE SEMINARY JUNIOR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "JAN VAN RIEBEECK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MILNERTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "MOUNTAIN ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "OBSERVATORY JUNIOR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "KOEBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SEA POINT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SEAMOUNT PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "TABLE VIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "TAMBOERSKLOOF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "TYGERHOF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "YSTERPLAAT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "WOODBRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CHAPEL STREET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "PRESTWICH STREET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CECIL ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "DRYDEN STREET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "WALMER ESTATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ST. PAUL'S PRIMARY SCHOOL (BO-KAAP)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "RAHMANIYEH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HOLY CROSS RC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GARDEN VILLAGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SCHOTSCHEKLOOF MOS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "WESLEY METHODIST PRACTISING SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ZONNEBLOEM BOYS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ZONNEBLOEM GIRLS PRAC. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "FACTRETON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "H.J. KRONEBERG JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "KENMERE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SUNDERLAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "W.D. HENDRICKS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "WINDERMERE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "WINGFIELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MARCONI BEAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ST. JOHN'S RC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "UKHANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "STAR OF THE SEA CONVENT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "FISH HOEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "BAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "KOMMETJIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MUIZENBERG JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PAUL GREYLING PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SUN VALLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "KLEINBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MARINE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ST. JAMES RC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "CAPRICORN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "FORRES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "MICKLEFIELD SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "WESTERN PROVINCE PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "RIVERSIDE S.D.A SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "THE VINE SCHOOL NPC"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "AL-AZHAR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "THE ARK CITY OF REFUGE TRADING AS THE ARK CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "YESHUA CHRISTIAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "JUNIOR COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MADRASSATU TARBIYYAH"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "STARLING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "RYLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PELICAN PARK PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ST. JOSEPH'S MARIST JUNIOR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ST. ANNE'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PLUMSTEAD PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "WINDSOR PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "BERGVLIET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CLAREMONT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "FERNDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GOLDEN GROVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GREENFIELD GIRLS' PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GROOTE SCHUUR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GROVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "JOHN GRAHAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "KIRSTENHOF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "KRONENDAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "LLANDUDNO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "OAKHURST GIRLS' PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "RONDEBOSCH BOYS' PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "RONDEBOSCH EAST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ROSEBANK JUNIOR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "RUSTENBURG GIRLS' JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "S.A. COLLEGE JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SIMON VAN DER STEL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SOUTHFIELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SUNLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SWEET VALLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "TIMOUR HALL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WESTCOTT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "KENWYN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WYNBERG BOYS' JUNIOR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WYNBERG GIRLS' JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ZWAANSWYK ACADEMY/AKADEMIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ROSMEAD CENTRAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "CONSTANTIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "LOTUS RIVER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "DOUGLAS ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "STEENBERG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "THOMAS WILDSCHUTT JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HAZENDAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "HARMONY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "KANNEMEYER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SID G. RULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PARKWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SULLIVAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "DELTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PERIVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "FLOREAT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "LOURIER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SQUARE HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "THOMAS WILDSCHUTT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MONTAGU'S GIFT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "HEATHFIELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ATHWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BLOMVLEI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PLANTATION PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "HYDE PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "PARKFIELDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SUMMIT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "FAIRVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "VOORSPOED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "MORGENSON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "HILLWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "LEVANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BELMOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PRINCE GEORGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ZERILDA PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SENTINEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MUHAMMADEYAH MOS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ST. ANTHONY'S RC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "GRASSY PARK EC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ST. AUGUSTINE'S RC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "OTTERY ROAD (METH) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ST. MARY'S RC PRIMARY SCHOOL(RETREAT)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "CHRISTIAN DAVID MOR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ORANJEKLOOF MOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ST. CLEMENTS RC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "BATTSWOOD OEFEN NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ALICEDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ATHLONE NORTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BELTHORN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BLOSSOM STREET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BRIDGEVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CYPRESS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "DAGBREEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "DOWNEVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "EASTER PEAK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "EDENDALE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GARLANDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HEATHERDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HEIDEVELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "KEWTOWN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "MANENBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "NORMA ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "E. A. JANARI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "PORTIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "PRIMROSE PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "RED RIVER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "RIO GRANDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SAAMBOU PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "TALFALAH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SILVERLEA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SILVERSTREAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SONDEREND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SUNNYSIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SURREY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "THORNTONWEG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "TURFHALL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "VANGUARD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "WELCOME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "WILLOWS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "WOODLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "YORK ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "NEWFIELDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BOKMAKIERIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "PORTAVUE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HABIBIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "REGINA COELI RC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ST. RAPHAEL'S RC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ST. THERESA R.C. PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "BUCK ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "STEPHENWEG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ZEEKOEVLEI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "DIE DUINE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MVULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "STORMONT MADUBELA COMMUNITY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ENTSHONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "BONGOLETHU PRIMARY SCHOOL(NYANGA)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "IEGLAASI NIEYAH SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "NAL'UXULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WELTEVREDEN VALLEY CORE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MASIVUKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "VUKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MITCHELL HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "NOXOLO XAUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "LUDWE NGAMLANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "CENTRE FOR CREATIVE EDUCATION"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ST. MICHAELS PRIMARY SCHOOL (KHAYELITSHA)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "HOMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "INJONGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "KUKHANYILE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "LWANDLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SAKUMLANDELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SOBAMBISANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SOYISILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "UMMANGALISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "VUZAMANZI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "VUSELELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "IKHWEZI leSIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "YOMELELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ELUXOLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "CHUMISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "NTWASAHLOBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "IKHUSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SOSEBENZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "IMPENDULO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SIVILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MZAMOMHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "NOMSA MAPONGWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "CHUMA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "NKAZIMLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SIYAZAKHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "UMTHAWELANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "LULEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SIVUYISENI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "INTSHAYELELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "LWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "NOBANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SONWABO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "VUKUKHANYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BONGA LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "INTSHINGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "JOHN PAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "LEHLOHONOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "LINGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "MSEKI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SIYAZINGISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SOKHANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WALTER TEKA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ANDILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "LITHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "LIWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "LUZUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SIKELELA IMIZAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MKHANYISELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "VUYANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "XOLANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "KHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "HEINZ PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SAMORA MACHEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ISIKHOKELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ISIPHIWO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ENCOTSHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "KWA-FAKU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ZANEMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "KUYASA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "NOLUNGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "DIETRICH MOR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "EASTVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "CASCADE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "CARADALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "CARAVELLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "CORNFLOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "DUNESIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "EISLEBEN ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "HARVESTER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "HAZELDENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "HIGHLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "HILLSIDE PRIMARY SCHOOL (M/PLAIN)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "HUGUENOT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "HYACINTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "JAMAICAWEG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "LANTANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "LIESBEECK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MEADOWRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MERRYDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MITCHELL'S PLAIN PRIM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MONTAGU DRIVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "NORTHWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "TAFELSIG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PARKHURST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "PORTLAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "RIDGEVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ROCKLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SEAVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "YELLOWWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SPINE VIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SPRINGDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "LITTLEWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "STRANDFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WESPOORT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WAVECREST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WEST END PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WESTVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "WOODVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "IMPERIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "BEACON VIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ALPINE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "DENNEGEUR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "A.Z. BERMAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SEARIDGE PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MANDALAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ST. MARY'S (RC) PRIMARY (NYANGA)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "KLIPFONTEIN MET PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "GOOD HOPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SUNRAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "DELFT-SOUTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "HEBRON CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "OOSTENBERG GOOD HOPE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BLUE DOWNS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "WALLACEDENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "LEIDEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "LEIDEN AVENUE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "KALKFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ITSITSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "HINDLE ROAD WEST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ABEDARE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BARDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MFULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BASTION PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BRACKENFELL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "DE KUILEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MIKRO LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "WEST BANK NO.1 PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "KUILS RIVER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SAREPTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "R.R. FRANKS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SCOTTSVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MELTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "PETUNIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "IRISTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BLACKHEATH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "HELDERKRUIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "NORTHPINE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "FOREST HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "TUSCANY GLEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "DELFT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "STRATFORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "DENNEMERE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BEVERLEY PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "VERGENOEGD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ROSENDAL LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SPURWING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "EINDHOVEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SILVERSANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BROOKLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "THE HAGUE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ENKULULEKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "PALM PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MASONWABE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "EKUTHULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "IMVUMELWANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "KAIROS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "NYAMEKO PRIM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BOTTELARY PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BLOEKOMBOS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "RAINBOW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "HOOFWEG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "NAL'IKAMVA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "WELWITSCIHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MARY HELP OF CHRISTIANS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "GROENHEUWEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "IMBONISELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DALUBUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "NONDZAME PRIMARY SCHOOL (S.A.)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "LANGABUYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MBEKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "COURTRAI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DRAKENSTEIN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "GIMNASIUM PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "LA ROCHELLE GIRLS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "NOORD-EIND PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "PAARL BOYS' PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "W.A. JOUBERT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "SLOT VAN DIE PAARL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "NIEUWE DRIFT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ALFONS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "AMSTELHOF PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "EBENEZER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "GROENDAL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "KLAPMUTS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MAGNOLIA PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "NEDERBURG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "NEW ORLEANS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ORLEANSVALE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "PAARLZICHT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "PAULUS JOUBERT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "PNIEL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WEMMERSHOEK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WES-EIND PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WILLIAM LLOYD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "SONOP PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DALWEIDE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DAL JOSAPHAT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "JOOSTENBERG SSKV PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "KERSBOSLAAGTE SSKV PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "RONWE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "SIMONDIUM PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WINDMEUL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "A.F. LOUW LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "EIKESTAD LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "RHENISH PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "STELLENBOSCH LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "IDASVALLEI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BRUCKNER DE VILLIERS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "CLOETESVILLE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DEVONVALLEI PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "PIETER LANGEVELDT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ACADEMIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "VLOTTENBURG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "RIETENBOSCH PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "IKAYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "KAYAMANDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ST. PAUL'S PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "J.J. RHODE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ST. VINCENT RC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WEBER GEDENK NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ST. IDAS RK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "P.C. PETERSEN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "HELDERBERG LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SOMERSET HOUSE PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ST. PETER'S ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "TEREO PROJECT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "VERGEZICHT PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BEAUMONT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "DE HOOP LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SOMERSET-WES LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "DANIE ACKERMANN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MACASSAR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "OKLAHOMASTRAAT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MARVIN PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "RAITHBY PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "FIRGROVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SIR LOWRY'S PASS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SOMERSET-WES MET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MASIPHUMELELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "LORETO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "A.C.J. PHAKADE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SOLOMON QATYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "UMNQOPHISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "GORDONSBAAI LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "HENDRIK LOUW LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "LOCHNERHOF LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "TEMPERANCE TOWN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "RUSTHOF PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "DR. G.J. JOUBERT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "STRAND MOS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SILUKHANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "HUGENOTE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "HUGO RUST LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "NEWTON PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "PAUW GEDENK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "RONDEHEUWEL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WELLINGTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ST. ALBANS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "HILLCREST PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BERGRIVIER NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "GROENBERG NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "SOETENDAL NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WAGENMAKERSVALLEI NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "ZOETENDAL AKADEMIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "BREDASDORP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "RUENS KOLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "PROTEA PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "STRUISBAAI PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "DE HEIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "KLIPDALE EK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "WAGENHUISKRANTZ PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "OUPLAAS EK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "PROTEM NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "ELIM MOR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "APPLEWOOD PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "VYEBOOM CHRISTELIKE PRIVAATSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "UMYEZO WAMA APILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "DANIEL LE ROUX PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "DE VILLIERS GRAAFF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "JONGENSKLIP PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "OVERBERG LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "UITKYK LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "KLEINMOND LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "KATHLEEN MURRAY PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "SWARTBERG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "PINEVIEW PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "TESLAARSDAL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "GREYTON PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "KOSIE DE WET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "KLEINMOND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "ST. MICHAEL'S EK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "ELANDSRIVIER NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "ARIESKRAAL SSKV PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "BOONTJIESKRAAL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "THE GLEBE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "BEREA MOR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "L.R. SCHMIDT MOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "GLEN ELGIN MOR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "BLOEMENHOF NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "DENNEGEUR NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "MAXONIA NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "BOSKO CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "HERMANUS WALDORF SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "ZWELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "MASAKHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "LUKHANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "GANSBAAI LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "HERMANUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "OKKIE SMUTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "MOUNT PLEASANT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "HAWSTON PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "DIE BRON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "GANSBAAI PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "ST. PAUL'S LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "DE WAALVILLE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "VONDELING NAK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "BUFFELJAGSRIVIER LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "SWELLENDAM LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "BONTEBOK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BONNIEVALE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "MULLERSRUS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MIDDELRIVIER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "KLEINFONTEIN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "KLUITJIESKRAAL NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "UITVLUG VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "ST. JOHN'S EK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WELVILLE EK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "LEMOENSHOEK NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "VLEIPLAAS NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "AKKERBOOM PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "WELTEVREDE VGK PRIMÊRE SKOOL (BARRYDALE)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BOESMANSRIVIER NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MARAISDAL NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WABOOMSHEUWEL NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "GELUKSHOOP NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "NEW DAWN PARK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "M M MATEZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "TYHOLORA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "MZOXOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HOLY CROSS PRIMARY SCHOOL (GEORGE)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "GEORGE VOORBEREIDINGSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "BLANCO LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "DENNEOORD LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "GEORGE-SUID LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HOEKWIL LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "OUTENIQUA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "VAN DER HOVEN LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HEROLD LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "THEMBALETU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HEIDEDAL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "CONVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "PACALTSDORP PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "DELLVILLE PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "PARKDENE PRIMÊRE SKOOL (GEORGE)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "DIEPKLOOF VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "GEELHOUTBOOM VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HIBERNIA VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KRETZENSHOOP PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ST. PAUL'S EK PRIMÊRE SKOOL (GEORGE)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KLIPDRIFT EK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ST. MARY'S RK PRIMÊRE SKOOL (GEORGE)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "DIEPRIVIER VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "WABOOMSKRAAL VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "TOUWSRANTEN VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "LANCEWOOD PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HOOGEKRAAL SSKV PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "THEMBELITSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "PHAKAMISANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "RIVERWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KARATARA LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KNYSNA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "PLETTENBERG BAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "SEDGEFIELD LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "FRAAISIG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "FORMOSA PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "WITTEDRIF PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "RUIGTEVLEI PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HORNLEE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "THE CRAGS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "REDLANDS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "SEDGEFIELD PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "SUNRIDGE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HARKERVILLE EK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "BRACKEN HILL EK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KRANSHOEK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "CHRIS NISSEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "GLOBAL ACADEMY OF EDUCATION"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "IMEKHAYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ISALATHISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HARTENBOS LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HERBERTSDALE LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "MILKWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "PARK LAERSKOOL MOSSELBAAI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "RUITERBOS LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "VORENTOE LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "FRIEMERSHEIM PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "DIAZ PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "GROOT BRAKRIVIER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "RIDGEVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "DENNEPRAG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ERIKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "T.M. NDANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ST. LUKE'S (EC) SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "MOSSELBAAI EK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ST. BLAIZE RK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "GARDEN ROUTE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "BERTIE BARNARD LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "VOLSCHENK LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "PANORAMA PRIMÊRE SKOOL (RIVERSDAL)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "VOORWAARTS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "MOLENRIVIER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "BRAKFONTEIN EK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "GOEDGEGUN VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "GAMKA-OOS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KRUISRIVIER-WES UCC PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "DANKOORD VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HOEKO VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "VAN WYKSDORP PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "W.J. LE ROUX LB PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ZOAR EK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "AMALIENSTEIN LB PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "BONGOLETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "LAURUS PRIMERE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "VAN REEDE LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "WESBANK LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "BERGSIG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "DE VILLIERS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "DYSSELSDORP PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "COLRIDGE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "P.J. BADENHORST PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "SATURNUS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "MOOI UITSIG PRIMÊRE SKOOL NO.2"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "GROOTKRAAL UCC PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ROOIBERG SSKV PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "VLAKTEPLAAS UCC PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "SACRED HEART RK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ST. KONRAD RK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ROOIHEUWEL VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "VOLMOED PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ZEEKOEGAT VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "DE RUST PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "DE JAGER VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "RODEWAL UCC PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "VOORBEDAG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "LATEGANSVLEI SSKV PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "SCHEEPERSKRAAL SSKV PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "AVONTUUR LB PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ROOIRIVIER VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "BRITSEVLAKTE NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KOMMANDANTSDRIFT SSKV PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "NDULI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "F.D. CONRADIE LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "GERICKE LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "KOUE BOKKEVELD LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "CERES PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ST. MARK'S PRIMÊRE SKOOL (WORC)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MOOI-UITSIG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BELLA VISTA PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MATJIESRIVIER NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "NORTHRIDGE NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "KOELFONTEIN NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WELGEMOED NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "FAIRFIELD NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "AGTERWITZENBERG VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "EZELFONTEIN NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WELVAART NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BOPLAAS NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DE MEUL NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "PIET HUGO GEDENK NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "KROMLIN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "VOORSORG NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DRIEFONTEIN NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ACHTERTUIN AME PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WANGANELLA NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BRITSUM NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "RIETFONTEIN NGK PRIMÊRE SKOOL (WORC)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "TANDFONTEIN NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ASHTON LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "KOO LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MONTAGU LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "H. VENTER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "KEEROM SSKV PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BADEN NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "FRANSIE DU TOIT NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "A.F. KRIEL VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "RIETVLEI NR 1 EK PRIMÊRE SKOOL (MONTAGU)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "CONCORDIA NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "KEISIE VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "G.B. BATT NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "PIETERSFONTEIN NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WARDIA VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "STOCKWELL NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "RIETVLEI NR 2 NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "NKQUBELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ROBERTSON VOORBEREIDINGSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ROBERTSON LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DAGBREEK LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DE VILLIERS LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "VINKRIVIER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "KLAASVOOGDS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "TALANA NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "PROSPECT NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "UITNOOD NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WELTEVREDE NGK PRIMÊRE SKOOL (ROBERTSON)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "HUGUENOOT VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "EILANDIA NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WILLEM BUCHHOLZ NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WAKKERSTROOM-OOS NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BUFFELSKLOOF SSKV PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "RIJK TULBAGH PRIVAATSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WOLSELEY LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BAKERVILLE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "SARON PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "W.F. LOOTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WITZENBERG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ERRIE MOLLER NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "LA PLAISANTE NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MONTROUGE VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "TWEE JONGE GEZELLEN VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DROSTDY SSKV PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "AVIAN PARK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ALFRED STAMPER PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "P.J.B. CONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "SIBABALWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "SIYAFUNEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WINELANDS PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BREERIVIER LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "TOUWSRIVIER LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WORCESTER LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WORCESTER-NOORD PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WORCESTER-OOS LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ESSELENPARK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "STEENVLIET PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ROODEWAL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WYSERSDRIFT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "F.J. CONRADIE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BET-EL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "LEMOENPOORT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "VICTORIAPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "H.M. BEETS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "RAWSONVILLE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "RABIE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BONNE ESPERANCE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ORCHARD PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "HEXPARK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "STETTYN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "SLANGHOEK NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "LORRAINE NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "GOUDINI BAD NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WELTEVREDE NGK PRIMÊRE SKOOL (WORCESTER)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "GLEN HEATLIE AME PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WORCESTER MOSLEM PRIMÊR"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "SANDHILLS NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "AAN DE DOORNS NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "NIEUWE MORGEN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WORCESTER NGK OEFEN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BO-DOORNRIVIER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "RIVERVIEW PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "PETRA GEDENK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BOTHA'S HALTE NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "NUYSTASIE NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "OVERHEX NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BRANDWACHT NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "SCHERPENHEUWEL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "LEIPZIG SSKV PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "TOPOLINO PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "LANGEBAANWEG LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "HOLVLEI PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "LANGEBAAN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "DARLING KOLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "CHRISTELIKE PRIVAATSKOOL MALMESBURY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SAN MICHELL INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "DARLING LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "DIRKIE UYS LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PHILADELPHIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "RIEBEECK-KASTEEL LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "SWARTLAND LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "VAN RIEBEECKSTRAND LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MEULENHOF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "KLIPHEUWEL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "WELGEMEEND NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "AVONDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BERZELIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "GROSVENOR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "HERMESLAAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "KERRIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "KORINGBERG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "LIEBENBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "MEIRING PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PARKVIEW PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PROTEA PARK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "REYGERSDAL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SAXONSEA PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "WESFLEUR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "ST. THOMAS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "RIVERLANDS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MAMRE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "NAPHAKADE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "ANNE PIENAAR GEDENK NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "BLOEMENDAL NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "CHATSWORTH AME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "GOEDEHOOP PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "KORANRUG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "MORNING STAR NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "O.J. ERASMUS NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PELLA MOR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "RUSTSTASIE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "ST. MICHAEL'S PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "VAATJIE MOR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "WELTEVREDEN NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "GROENVLEI PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "STEYNVILLE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "BERGHOF NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "BRANDENBURG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "EENDEKUIL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "GOEDVERWACHT MOR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "KAROOKOP PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "MIDDELDEURVLEI NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "NUHOOP NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "CARL SCHREVE (MOR) PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "ENGELBRECHT NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "MASIPHATHISANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "SALDANHA LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "VREDENBURG LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "H.P. WILLIAMS LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "DIAZVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "EDEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "PANORAMA PRIMÊRE SKOOL (VREDENBURG)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "ST. ANDREW'S PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "ST. AUGUSTINE'S PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "STEENBERG'S COVE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "E.J. MALGARTE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "KLEINKARNMELKVLEI NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "OLIFANTSVALLEI PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "GROOTKLOOF PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "CITRUSDAL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "SEDERBERG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "BREEVLEI PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "ELIZABETHFONTEIN MOR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "ELANDSFONTEIN NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "GRAAFWATER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "HEXRIVIER NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "KWEEKKRAAL NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "LANGVLEI SSKV PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "LEIPOLDTVILLE NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "NOORDHOEK NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "PAARDEKOP NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "SANDBERG NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "KLAWER LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "MASKAM PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "BITTERFONTEIN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "NUWEFONTEIN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "NOUVEAU KOLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "VREDENDAL LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "DORINGBAAI PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "LUTZVILLE NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "KOEKENAAP VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "TRAWAL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "VERGENOEG RK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "VREDENDAL-NOORD PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "NAASTDRIFT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "KLEINRIVIER VGK LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "SPRUITDRIFT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "BOOYSENDAL NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "STEILHOOGTE NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "H.M. DLIKIDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "BEAUFORT WES VOORBEREIDINGSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "MERWEVILLE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "NIKO BRUMMER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "JOHN D CRAWFORD PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "A.H. BARNARD PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "TESKE GEDENK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "RESTVALE MET PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KLAWERVLEI PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ST. MATTHEWS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "BUFFELSRIVIER PRIVATE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ACACIA PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "MATJIESFONTEIN LB PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "BAARTMANSFONTEIN NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "MURRAYSBURG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "PRINS ALBERT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KLAARSTROOM PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "AARON LETSAPA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ABONTLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "AGELELANG THUTO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "AGISANANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Agonkitse Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "AKOFANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ALABAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "AMALIA PUBLIC PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ARE BOKENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ARE-FENYENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ARE IPELENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ARE-ITSHOKENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "AREAGANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ATAMELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "ATAMELANG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ATLARELANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "AVONDSTER PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BABUSENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BAGAMAIDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BAISITSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BAKANG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BAKANG - SELEBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bakgofa Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bakubung Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bakubung Intermediate School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Baleseng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BANABAKAE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BANABOTLHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BANCHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Baphalane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bapo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BARAKILE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Barelwanedi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Basadi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BATHABILE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BATHO BATHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Batlhalerwa Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Berseba Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BERT`S BRICKS PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bethanie Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "BF Morake Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BLOEMHOF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BLYDEVILLE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BM MOKITIME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bobuantswa Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BODIRI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bogatsu Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bogosi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BOIKHUTSO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BOIKUTLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BOINEELO PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BOITEKO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Boitemogelo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BOITIRELO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BOITUMELO INTERMEDIATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BOITUMELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bojating Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BONABONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bonolo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BONTLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bonwakgogo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BOPANANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BOPHEPA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BORAKALALO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BORESETSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BOROTHAMADI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bosabosele Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BOSUGAKOBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BOSWORTH PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Bothibello Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Botman Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BOTSHELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BOTSHELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BROEDERSPUT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BUFFELSVLEI INTERMEDIATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LAERSKOOL BURGERSDORP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "CARLISONIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "CHAENA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Chaneng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Charles Mamogale Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LAERSKOOL COLIGNY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "COLINDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THE CONNIE MINCHIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Laerskool David Brink"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "De Hy Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LAERSKOOL DELAREYVILLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Deutsche Schule Kroondal"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TROTSVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "DIATLENG INTERMEDIATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DIHATSHWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Dikgorwaneng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "DIKGATLHONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DIKHUDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DIKHUKHUNG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Dikweipi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Dikeledi Makapan Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Dimapo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DINGAKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DINGATENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Dinkwe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DIPATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Dipetlelwane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "DIPHETOGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DIPHETOGO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "DIPODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Dirang Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Disigwane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "DITAELONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Dithoteng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DITSOBOTLA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Dooka Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DOORNBULT INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DOORNHOEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "DOORNPLAAT INTERMEDIATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL DRIEFONTEINE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "DRYHARTS PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DUDFIELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "DUDUETSANG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DUIKERBOS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "E. H. MOGASE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "EJM Mahlabe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "EBENEZER CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "EBETSAMANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "ECKRON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "EDISANG PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "EDUCAR PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Edward Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Laerskool Elandskraal"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ennis Thabong Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "E.P. LEKHELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "ETEBARE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Fapha Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "FIKADIBENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "FLORADENE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "G.J. PODILE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GA ISRAEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "GAEGANE P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "GAEONALE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GAESEGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GAETSALWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "GALESHEWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "GANOKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "GANYESA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GAREOSENYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "GASEONANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "GATAOTE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "GELUKSOORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LAERSKOOL GERDAU"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Gilbert Motsepe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Glenwoods Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Goakganya Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "GOBOPAMANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Gobusamang Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Goitsemang Intermediate School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GOITSEONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GONTSEMONNAPULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GOO-MOLEFI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GOO-SELEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GOPANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL GOUDKOP"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "GOUE AREND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "THEA MORAFE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GREEN CENTRAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "GREYLINGSRUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MARICO AKADEMIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "HAKBOSLAAGTE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL HARTBEESFONTEIN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "HARTSFONTEIN PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "HARTSRIVIER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "HATA-BUTLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "HENRYVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "HIKANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "IKALAFENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "IKGOMOTSENG PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "IKHUTSENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Inkonjane Middle School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "INYATELO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "IPAAKANYENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "IPELEGENG BATLHARO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "IPELENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Isaac Mokoena Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "ITEKENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ITIRELE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ITHUSENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "ITLAMENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Itumeleng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "J.S. MASISI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "J.D Mosiah Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "J.M. MOSIANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "JATHOLIMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KABELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KAGISANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KAKANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KAKATLELA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kalkbank Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LAERSKOOL KAMEEL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KAMOGELO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KAMOGELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kana Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Karlien Park Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Katakane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KATLARELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kau Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KEAGILE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KEDIEMETSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KEEMEMANG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KEGAKILWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KEIKANAMANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KEIPATILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Keitumetse Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KELEBOGILE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KELERAYAMANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KEOBUSITSE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Keoagile Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KEOLEBOGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Keorapetse Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kgabalatsane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kgalagatsane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kgale Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kgetleng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KGOKGOLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kgolane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KGOSIKEEHE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KGOTLELELA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kgwanyape Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Khayakhulu Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KHAYALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Khibitswane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Khothalo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Khubamelo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Khulusa Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KHUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KHUNOTSWANE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KIBITWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kleinfontein Combined School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KLERKSDORP CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KLERKSDORP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KLIPPAN PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Klipvoor Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kloofwaters Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KOI-KOI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KOKOMENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KOLONG PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Komane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KONKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KOPANANG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KOPELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kosea Moeka Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kroondal Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KUDUNKGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KUNANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kutlwano Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kwa-Mocha Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KWALA-KITSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KWENA -THAKADU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL LA HOFF"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LABA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rustenburg-Noord Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LAERSKOOL SCHWEIZER-RENEKE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Boshoek Laerskool"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Brits Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "De Kroon Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Generaal Hendrik Schoeman Laerskool"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Olienpark Laerskool"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL P.A. THERON"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Pansdrif Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Laerskool Proteapark"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sanddrift Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Laerskool Sonop"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Laerskool Vastrap"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Voorwaarts Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "L. D Matshego Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Leema Secondary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL LEEUDORINGSTAD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lefaragatlhe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LEFOKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LEGAE THUTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lehabe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LEKANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lekgatle II Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lekgolo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LEKGOPHUNG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LEKOKO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LEKOLWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lekwakwa Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LEKWENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LELOKWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LENCOE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Leokeng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lepono Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lesedi Le Legolo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LESEGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lesetlheng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Letsibogo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lethabong Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LETLHAKANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LETSAPA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LETSHELEMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LETSOPA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LAERSKOOL LICHTENBURG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SHUKRAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LICHTENBURG PRIMARY SCHOOL {ENGLISH}"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LIGSTRAAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LOBATLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LOGAGA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LOGAGANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LOKALENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LOKGABENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LOKGENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LOMANYANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LONGANENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LOPORUNG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lorato Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LORE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LOSELONG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LOTLAMORENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LOUISDAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LOULA FOURIE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LOUWNA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL BAILLIE PARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LAERSKOOL BUHRMANNSDRIF"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL ML FICK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL MOOIRIVIER"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL PRESIDENT PRETORIUS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Luka Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LAERSKOOL WILDEHONDEPAN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LYKSO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAAMOGWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mabeskraal Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mabitse Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MABONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MABULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Machama Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MADIBENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MADIBOGO BATLHAPING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MADIBOGOGO-PAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Madidi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Madima Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MADIPELESA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MADITHAMAGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Madutle Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mafale Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mafenya Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAGAABUE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAGOKGWANE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Magong Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAHAHAKGETLWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MAHEELO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAIKAO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAIKETSO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAILAKGANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Maimane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAJABE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Majakaneng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAJEAKGORO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAKALAATHUTLWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAKAME PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Makapanstad Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Makekeng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Makgabetloane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Makgatlhanong Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAKGOBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Makgophaneng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Makgophe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAKGORI PRIMARY LEARNING SITE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAKGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Makoshong Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL MAKWASSIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Makweleng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MALEBELELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MALEBOGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mamodimakwana Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mamogale-Segale Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAMUSA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAMMUTLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MANAMOLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MANANA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MANNO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MANOANE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MANOGELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MANTHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MANTSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mantserre Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mantsho Intermediate School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAOKANENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Maologane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mapaputle Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAPHOITSILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAPITIKI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MARAMAGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MARANATHA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Marang Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "St Augustine Private Christian School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Marapo a Thutlwa Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LAERSKOOL MAREETSANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAREKWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Maretlwana Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Marikana Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAROPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAROTSE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Maruatona Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MASAMANE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MASEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MASEPHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mashilo-Matsho Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MASHWELWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MMASUTLHE P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MATEANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mathibestad Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mathopestad Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MATLHARE MOHOLO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MATLABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Matlametlo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MATLAPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MATLHAJANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MATLHONYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Matlhware Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MATLODING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MATSHENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Maudzibi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Maumong Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAEYAEYANE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mazista Intermediate School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Moemise Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MEDUPE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL MEIRINGSPARK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MELORANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Melotong Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MENWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Meriting Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MESEGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "METHUSELE II PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mfidikwe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MHAPHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MHELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Re-e-lwele Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "M. K MOETI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MMADISEBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmakau Moemise Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmakuba Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmamarumo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmamitlwa Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmammudu Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmamonwana Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MMAMOSWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmanjaakgora Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MMASEBODULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmasempane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MMATLAKITSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmatlhame Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmatope Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mmatsheko Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MMUAGABO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MMUSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOATLHODI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MODISAEMANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOCHWARE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MODIKO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Modikwe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Modimokwane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MODIMOLA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Modimong Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MODIREDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Modisakwano Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Modubyane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Module Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOETI LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Moetlo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOFUFUTSO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOGAWANE MOSHOETTE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mogobe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mogoditshane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mogogelo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOGOMOTSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mogono Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOGOPELA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mogotlhwana Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mohajane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mahobotle Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Moiletsoane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOITSEMANG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Moitshoki Mofenyi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mojabeng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Monakato Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOKAILA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOKAKANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOKALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mokalake Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOKASA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mokgalwana Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mokgaotsi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mokgatlha Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOKGOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOKGOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOKGOSI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOKGWEETSI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mokhine Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MOKOLOKOTOANE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOKOPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOKUTONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOLALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOLEKANE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOLELEMA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Molelwane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Molelwaneng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOLEMA MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOLEMOENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOLETSAMONGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Molorwe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Molotlegi Malebye Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Molotsi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MONAMALADI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Monato Intermediate School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MONCHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MONNAAMERE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MONNAAPHANG SEBOGODI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mononono Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MONTHUSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Montsamaisa Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Montsana Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOOIFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mookane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Morekolodi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Moremogolo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOREOTSILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Morogong Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Morokwa-Ditlou Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOROKWENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Morongwa Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MORWALELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MORWENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOSENOGI PRIMRY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mosetlha Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOSHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOSHOETTE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOSHOSHO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOSITA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mosome Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOSWANE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MOTAUNG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOTEU MAKABANYANYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mothle Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Motladi Kgoadigoadi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOTLHABANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Motlhabe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Motlhajoe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOTLHAKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOTLHAMARE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Motlhana Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOTLHATSWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Motsatsi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Motshabaesi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Motsisi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOTSITLANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Motsitle Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOTSWAISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mperebere Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mphebatho Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MPHOETSILE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mphuphuthe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MPONENG PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mpyatilo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MYRA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "NAGANASENTLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Naledi Ya Masa Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "NALETSANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "NANOGANG PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "NCHAWE POOE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ngobi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "NHOLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "NIETVERDIENT COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "NKAGISANG COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "NKHABANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Nkogolwe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Nkukime Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Nkukise Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "NKULULEKWENI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Nkutlweng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Noka Ya Lorato Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Nonceba Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL NOORDVAAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "NOZIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "NTATAISE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "NTHAPELANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "NTHEBE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Nthebe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "NTOKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "NCHELANG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "NTSWELETSOKU PRIMARY LEARNING SITE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Isang Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Nyakale Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "NYETSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Nyorwe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "OBAKENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Odi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ofentse Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Okomelang Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "OKETSANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "OLEBILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "OMEGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "ONALERONA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "OPADIATLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL ORKNEY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "OTHAILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LAERSKOOL OTTOSDAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "OURIEF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "PP PHALADI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Paardekraal Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "PADI INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "PELOKGALE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "PELONNGWE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "PELONOMI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "PEME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Phadi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "PHAKEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "PHAKISANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "PHALADI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "PHAPOSANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "PHATLHANYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "PHATSIMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "PHENYO BOTLHE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "PHERA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "PHETOGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "PHOGOLE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Pholokgolo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Photsaneng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Phutha Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Phuthanang Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LAERSKOOL PIET PLESSIS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Platinum Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "PLATVLEI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Poifo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "POLOKOETSILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Polonia Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "PONELOPELE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "POTCHEFSTROOM CENTRAL SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "POVAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL PRESIDENT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "PROMOSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "PUDULOGO PRIMARY PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "PUDULOGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Puso Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "R.B. DITHUPE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "RABANA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "RABODIGELO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RABOTSILE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "RADITSHIDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "RAGOGANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RAMABESA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RAMADIANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "RAMADILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ramaifala Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ramalebya Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ramashita Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ramatla Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LEBOGANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RAMOKGETHWA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ramokoka Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ramonotwana Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RAMOSADI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ramoshie Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ramotse Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rampa Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rankae Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rankelenyane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RANKUDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rantebeng II Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rantsou Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RAPOO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RAPULANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rasimone Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ratheo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "RETLAADIRA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RATLOU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "SKIETPAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Reagile Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "REAHOLA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REAITHUTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REALEBOGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "REDUETSWE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Refentse Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REGOMODITSWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REGOPOLENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REITSOSITSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REITUMETSE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REKOPANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Relebogile Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RENONOFILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Resebone Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Retief Intermediate School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Retlakgona Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RETLAKGONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "RETSHEGEDITSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Reuben Monareng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rooikoppies Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ROOSHEUWEL PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RRAPOO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ruskraal Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Laerskool Rustenburg"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rutanang Primary Enrichment Centre"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL SAAMTREK"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SAKU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SAMENYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "SAMUEL PHIRI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sanddrift Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LAERSKOOL SANNIESHOF"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Saron Primary"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "CHARON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "ROSHUNVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sebele Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SEDIBATHUTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "SEDIKO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sedumedi Primary school"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sedupe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SEETSELE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sefatanare Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SEFATLHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sefikile Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Segakwana Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Segwaelane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Segwetlhane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sehibidu Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SEICHOKELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SEILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SEITSANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sekgopi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SEKGORO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SEKHING PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SEKOLOPO PRIMARYSCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sekwati Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Selamodi Combined School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "SELANG - THUTO PUBLIC PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SELEKENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SELERI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Selly Park Primary"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sengana Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SENKGWE LEARNING SITE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SENSAKO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Senteng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "SENTLHAGA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SENWAMATSANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SENWELO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Seolong Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SERASENGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SERITE MOSHOETTE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SESAMOTHO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SESHUPO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SETLAGOLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SETLHABETSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SETSHWARAPELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SETUMO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Setumo Sephethe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "S.G. Ntuane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Shakung Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SHALENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SIGNAL-HILL-PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SINAI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sjambok Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Skeerpoort Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SLURRY PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SOL PLAATJE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Solomon Lion Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "St. Catherine Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "ST MARY`S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "St. Michaels Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "ST PAUL`S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "STADT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LAERSKOOL STELLALAND PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL STILFONTEIN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "STINKHOUTBOOM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "STRATHVAAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SUPING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Swarisanang Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Syferbult Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tantana Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TAOLELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tapos Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TAU PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tebogo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THABA-SIONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "THAGAMOSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "THAKADU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Thakadu Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "THAMAGANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Thari Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Thebenare Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THEBEYAME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THELESHO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "THEMBA`LIDANISI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "THIBOGANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THIPANYANE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Thipe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Thoko-zibi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tholo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Thornhill Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tiisetso Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Thulwe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "THUSANG INTERMEDIATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "THUSO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THUTLWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "THUTO-NEO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "THUTO LESEDI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "THUTO-LESEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THUTONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TIANG INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TIGANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TIRELO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tladistad Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TLALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlapa Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlapa La Thuto Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TLAPENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlaseng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlhaalapitse Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TLHABOLOGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlhage Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlhagele Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlhageng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TLHAKAJENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TLHALEFANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlhaloganyo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlhapi-Moruwe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TLHARESENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlhasedi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlhoafalo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlholoe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TLHOMESO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlhophane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlhotlheletsang Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TOEVLUG PRIMERE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tolamo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TOSCA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LAERSKOOL TOSCA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TREASURE TROVE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lerutlhware Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TSELAKGOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tsewe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TSHABELANG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TSHANAKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TSHANENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TSHEDIMOSO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tshefoge Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tshenolo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TSHENOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TSHEPANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TSHEPO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TSHIAMELO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TSHIDILAMOLOMO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TSHING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TSHIPITOTA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TSHIPO MANGWEGAPE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TSHIROLOGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tshirologang Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TSHOLOFELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tshose Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TSHUPANE PUBLIC PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tshwaraodire Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TSHWARAGANANG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TSHWARAGANELO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TSHWARAGANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TSHWARANGTHATA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tsitsing Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TSOGANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tsogwe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tsunyane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TUKISANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tumagole Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TUMISANG PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tumo Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "UITSCHOT INTERMEDIATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "UITSPAN INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL UNIE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "UNITED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "UPPER SETLAGOLE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "VAAL REEFS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REFETHUTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Viva Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "VLAKPAN PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "VOORBEREIDINGSKOOL VRYBURG"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Vuka Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "VYFHOEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "WESTERN REEFS PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "LAERSKOOL WOLMARANSSTAD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ZAMUKULUNGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "ZEERUST LAERSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "ZEERUST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ZIMELE-GEQE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "ZOOIHUIS PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MODISA-DINKU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "D. P. KGOTLENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "JANE LETSAPA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BAHENTSWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SKUINSDRIF PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "POTCHEFSTROOM PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DANVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "NTIKANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "TSWANA TSATSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAHUBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DIKAKANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KGALALELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "LESANG KASIENYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "GAMONCHONYANE PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Abana Primary"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "GONTSE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KLERKSDORP METHODIST PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Seroophata Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DOORNLAAGTE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Osaletseng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Borite Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rustenburg Gereformeerde Akademie"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THUTO-METSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "DISIPI INTERMEDIATE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Matiki Mooeketsi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAFIKENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Motlhake Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KABELANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SACRED HEARTS PRIVATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THUTO-MMELEGI P.S"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "NOAH`S ARK INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "NALEDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAGGIES MILLENNIUM PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Banapele Primary school"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOLAPISI LEARNING SITE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAKGABANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "SAINTS CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KEOTSHEPILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "VENTERSDORP CVO"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lot Phalatse Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Madiba Utlwa Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Vukuzenzele Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "IQRA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KGATONTLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "DAN TLOOME PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GEORGE MADODA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SHUPU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "PITSO TOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MATHATENG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TSHEPANG-THUTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THUTO BOSWA PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Comcy Park Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mount Sera Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Boikagong Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kloof View Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BOTSALANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "WELGEVONDEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "VICTORY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Relebogile Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "TK Mokonyane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "BK GUMA Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BOITUMELONG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THUTO BOTSHELO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "YUSUF DADOO MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KOKETSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "New Covenant Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Assembly Of God"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Tlhabane West Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Madinyane Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Mokgobola-Setshedi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LIVING WATER CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Noble Palms Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Sunrise View Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Riverside Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "REATLEGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "M.K. RAMPINE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Silver Creek Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "G.R SETSETSE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Meridian Rustenburg Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "GOITSEONE MANKUROANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOJAMORAGO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Central Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Holy Family Primary"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOSIAMI MILDRED MOGAPI"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "CURRO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TABERNACLE OF GLORY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Maledu-Molepe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TSWELOPELE INDEPENDENT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "GOODWILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "B.M CHOABI PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Laerskool Silverrand"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "DARUL ARQAM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "GROWING IN GRACE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Da Silva Academy"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "WE CAN EDUCARE CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "PHAKELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MANZIL PARK PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MOHADIN PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "EXCELSIORS PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Corner Stone Academy"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SOLOMON SEOPOSENGWE LEARNING CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TSHOGANYETSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "ST Athanasius Christian School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Kid'z College Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "GLENLY PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Fly Eagle Primary"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MAKGETLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Platinum Village Primary"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "STUDY XPRESS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rebone Lesedi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THABO MPEMPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Itse Jehova Christian College Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Faith Intergrity Christian College Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Oukasi Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "AFLAME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "HAMAKOM PRIVAAT SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOTHUSI MARUMOLWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "MARIKANA II PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KANANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ramochana Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rustenburg Educational College Primary"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ontlametse Phalatse Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "GEREFOMEERDE SKOOL WOLMARANSTADT"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "FAIRVIEW COMBINED PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "GS Technical College Primary"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Seraleng Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "PROSPERITY TUTOR CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KINGSTON PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "HIGHVIEW COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "ASHTON JOHN'S PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MAQUASSI HILLS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RETSOGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BOIKHUTSONG PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOLEHABANGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MORNING STAR ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BRIGNT BEGINNINGS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "WATERKLOOF HILLS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "TSHITE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "SPECTRIUM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "ST MICHAEL`S SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "NEW MOUNT ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "A.I. KAJEE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "AYS MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ABAMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ABATHWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ACACIAVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ACTON HOMES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ADAMS SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ADDINGTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ALDINVILLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ALENCON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ALIPORE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ALLANDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ALLINGHAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ALOE PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ALPHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ALSTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ALTONA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "AMABUTHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "AMAGCINO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "AMAHLAYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "AMAHLONGWA JUNIOUR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "AMAHOBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "AMAHUKU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "AMAKHEMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "AMANDAWE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "AMANCAMAKAZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "AMANDLAKAPHELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "AMANDLESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "AMANDOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "AMANDUS HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "AMANGANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "AMANZABOMVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "AMANZASHISAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "AMANZIMTOTI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "AMAOTI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "AMAQADI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "AMAQHAWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SIYAPHUMELELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "AMATHULI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "AMATIKULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "AMATIKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "AMATIMOFU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "AMAYESE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "AMAZIBU COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ICHTHUS CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ANNANDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EMADEKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ANNIEVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THE KINGSWAY T/A MARITZBURG PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "APPELSBOSCH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ARBOR PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "Primere Skool Arboretum Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ARDEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ASAMUKELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ASHDOWN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ASHLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ASHVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ASIBAMBISANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ASIQHUBEKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ASIZENZELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ASSEGAI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ASTRA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ATHLONE PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ATHLONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ATHOLL HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ATHOLTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "AUSTERVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "AVOCA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "AVON JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BABANANGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BABAZANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BABONGILE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BADELILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BAJABULILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "BALCOMB'S HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BALDASKRAAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BAMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BAMBISANDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BANGAMAYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ANDANTE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BANGIBIZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BANGIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BANGNEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BANGUBUKHOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BANGUMUZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BANJANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BAPAUME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BAPHUMILE COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BAQAQE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BAQOQE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BARKSTON ASH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BARRACUDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BASHISE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BASHOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BATHATHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BATHENGI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BATSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BATTERSEA PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BAVUMILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BAXOLELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BAYABONGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BAZAMILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BAZANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BAZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BEACON RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BEAULAH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BEDLANE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BHEJANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Bellair Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BELVEDERE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BENJAMIN PINE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BEREA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BEREA WEST PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BEREA WEST SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BERG STREET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BERGSIG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BERGVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BERGVLIET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BERNICA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BESTERSPRUIT SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BETHANGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BHADENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BHAMBATHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BHAQA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BHEDLANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "BHEKAMAFA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BHEKAMAKHOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BHEKAMANGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BHEKAMATSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BHEKAPHAMBILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BHEKILANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BHEKIMPILO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BHEKINDODA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BHEKINKOSI FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BHEKITHEMBA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BHEKIZIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BHEKIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BHEKOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BHEKUKUPHIWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BHEKULWANDLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BHEKUMTHETHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BHEKUMUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BHEKUZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BHEKUZULU PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BHELEBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BHENSELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "BHIDAKHONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BHIDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BHILIYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BHOKOZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BHOKWENI P.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BHONGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BHOSIKI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BHUBHUBHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIMUNYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "Biggarsberg Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BILANYONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BINGOMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BIRDSPRUIT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "Bisley Park Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "BLAAUWBOSCH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "BLACKBANK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BLESSED LUANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BLUE BANK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "BHOVUNGANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BOGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BONAMUVA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BONELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BONELOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BONGASPOORT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "BONGIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BONGINDAWO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BONGINDUNA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BONGUBUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BONGUMBHELE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KHULANGOLWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BONGUMUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BONISANANI S.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BONOMUNYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BOSCHBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BOSCOMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BOTATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BOTHAS HILL SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BRACKENHAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BRAEMAR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "AMAVENYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BRAILSFORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAZIKHONELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BRIARDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BRIARDENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BRIDGEMAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Brighton Beach School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BROOKDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BROOKLYN HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BROTENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BRUNTVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BRUYNSHILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BUFFELSDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BUHLALU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "BUHLE BE - ALLEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BUHLEBAMANGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BUHLEBELANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BUHLEBEMVELO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BUHLEBETHU PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BUHLEBEZWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BUHLEBEZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BUHLEBUZILE LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BUHLEBUZOVAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BUKELAKITHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BULAWAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BULWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BURFORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BUSHLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BUTHANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BUYANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "CACA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CALUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "CAMANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "CANAAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "CARISBROOKE INCLUSIVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CARRINGTON HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "CASSINO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CASTLEHILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "CATHULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CAVENDISH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GEM-NTSHEBE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "CEBEKHULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "CEBELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CEDARA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "CEKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "CELIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "CELIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "CELOKUHLE HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CELUBUHLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "CENGESI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "CEREMONY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "CEZA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "CEZWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CHARLES HUGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "CHARLES JOHNSON MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CHARLES MEMORIAL C.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "CHARLTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CHELSEA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "CHIBINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CHIEF DLIVANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CHIEF LOKOTHWAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "CHIEVELEY ISLAMIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CHRISTIANENBURG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CHRISTOPHER NXUMALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "COSH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "CHWEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "CIBILILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CLAIRWOOD BOYS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CLARENCE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "Clarendon Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CLAREVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "CLAVIS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CLAYHAVEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CLAYHEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CLAYRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CLAYTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CLERMONT PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CLERNAVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CLIFFDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "COEDMORE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "COLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NOMZAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "COLENSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "COLLEGEVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "COLLESSIE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "COLLINGWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "COLUMBIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "CONISTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "COOPER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "COPESVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "COPHELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "CORNFIELDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "COROVOCA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CORRIE LYNN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "OLWAZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "COSMOORE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "COWAN HOUSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "CRANBURN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CRANHAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "CREIGHTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CRESCENTRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CRESTVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CROSSMEAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "CROWFIELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CRYSTAL SPRINGS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "CUNGCWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "CURRAGH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CURRYS POST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "CWAKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "CWAYISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CWEBEZELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "CWEMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CYGNET PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DABULIZIZWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DALALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DALIBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DALMENY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "DALTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DALUXOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DANGANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "DANINVA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "DANNHAUSER PRIMARY FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "DARGLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "Darnall Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DAWEDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DAWNCREST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DAWNRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DAWNVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "DAYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DAYISWAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DEWAAR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "DECCAN ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DEDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DELIHLAZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DENDETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DENVER ZOAR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DEPOT ROAD MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DEYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DIANTHUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "DIBASE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DIBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DIKWAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DIMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "DINABANYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "DINDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DINGETON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DINGEZWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SISEKELO HIGH SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "DINUNTULI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Primêre Skool Dirkie Uys Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "DIVAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DLABAZANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "DLABE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "DLAKUSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DLAMBULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "DLOKWAKHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "DLOLWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "DLOMODLOMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "DLOZEYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DLUDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DLUKULWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DOKODWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "DOKOLWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DOMREMY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "DONNYBROOK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "DONSINTABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DOON HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DOUGLAS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "DOWDLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DR MACKEN MISTRY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DR MADE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "DRAKENSBERG PRIMERE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "Drakensview Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DUBULEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DUDUDU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "DUDUSINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DUDUZANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DUFFS ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DUKEMINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "DUKUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "DULIKHULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DULUMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "DUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DUMAKUDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "DUMANGOBUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DUMANI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DUMAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "DUMELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "DUMENKUNGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DUMEZWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "DUMILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DUMISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DUMUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DUNDEE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "Dundee Junior School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "DUNDULUZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DUNGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DUNYWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Durban East Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Durban Preparatory High School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DURBAN SOUTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DURWEST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DUZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DWESHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EASTVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EASTWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EBASWAZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EBENDLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EBHETHANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EBOMVANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EBOMVINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EBOYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EBUHLEBEMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EBUHLENIBENKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EBUKHALINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EBUKHOSINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EBUMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EBUSINGATHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ECANCANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ECHAMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ECHIBINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ECHWEBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EDAMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EDENDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EDILINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EDULINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EFAYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EFEFE C.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EFFINGHAM HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EFUYENI .PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "UBUHLEBEZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EGCEKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EGERTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EGOLI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EGQUMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EGUGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EGUJINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EHLANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EHLEZENI C.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EJOKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EKHAMANZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EKHANYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EKHATHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EKHOKHWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EKHOMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EKHOMBELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EKHOTHONGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EKHUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "EKUBONGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EKUBUSISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EKUDEYENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EKUDILIKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EKUDONSENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EKUFUNDENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EKUHLEHLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EKUJABULENI P.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EKUJULUKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EKULINGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EKUNQOBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EKUPHILENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EKUPHINDISENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EKUPHUMULENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EKUSENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EKUTHOKOZENI FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EKUTHULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EKUVELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EKUVUKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EKUZAMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EKUZWANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EKWAKHENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EKWENAMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EKWETHEMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ELANDSBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ELANGABINI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ELOMOYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ELORA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ELUDIMBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ELUPHEPHENI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EMABHELENI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMACABAZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EMACHOBENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EMACHUNWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ISULETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMADOLOBHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMADRESINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EMADUNDUBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EMAFAKATHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EMAFEZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMAFOHLA PRIMAY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMAFUSINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMAGCAKINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMAGOVINI PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMAHHASHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMAHLEKWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EMAKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EMAKHABELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EMAKHASINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EMAKHENI PRIMRY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMAKHUZENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMAKHWABE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMALAHLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMALANGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMANDLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EMANGADINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMANGWANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMANJOKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMANQAYINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMANYISENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EMANYONINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMAPHAYINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMASAKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMASANGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMASUNDWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EMASWAZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EMAXULWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMAZABEKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMAZIZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "EMBABANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMBABE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMBADLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EMBOKODWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EMBONINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMBUDLE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMBUKISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EMBUSWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EMBUYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMBUYISELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMCHAKWENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMFANELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EMFENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMFIHLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMFULAMTHATHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EMGAGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EMHLANGANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMHLANGENI S.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EMHLONHLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EMHLUBULWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMHLUNGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EMJALISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EMKHAMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMKHANDLWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EMKHATHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMKHINDINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EMKHUPHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMKHIWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMLAMBONGWENYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EMLANDELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMLILWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMMANUEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMMAUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMNGQOBELWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EMOLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EMONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMOYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMPAKAMA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMPANGENI PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MATSHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMPHAYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMPHALWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EMPHISE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EMPILWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EMPISINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EMPOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMPUCUKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMPUMELELWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EMPUNGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EMPHUSHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EMSENGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EMSENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EMTATENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EMTHALENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EMTHANDENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EMTHETHWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EMTHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EMTHOMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMTHONJENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMTHUNZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMTSHAWAZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EMTULWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMVUNYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMVUTSHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMWANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EMZINHLANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ENATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENCANYINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ENCUNTSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENDABENHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ENDABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ENDANDATHWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ENDLONDLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENDLOVINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ENDLOZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ENDOMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ENDUBAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ENDUMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ENDUNDUMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ENDWEBU COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ENEMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ENGCAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ENGCONGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ENGCUBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ENGOBHIYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ENGOLELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ENGONWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ENGONYAMENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ENGUDUMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ENGUDWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ENGUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ENGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ENGWENYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENHLABABO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENHLABOSINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENHLANZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENHLISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ENHLOKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ENHLONIPHWENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ENHLOSWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENHLUBE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EHLWATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENJABULWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ENKANINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ENKATHWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ENKELABANTWANA FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ENKEMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ENKONENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ENKONJENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ENKOTHWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ENKOVUKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "CELULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ENKUKWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ENKULISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ENKULULEKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ENKUMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ENKUMBENI HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ENKUNGWINI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ENKWAMBASE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENQOLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ENSIKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ENSIMBINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENSINGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ENSUKANGIHLALE C.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ENTABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ENTEMBISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ENTENDELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENTENJANE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENTSHIZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENTUMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ENTUNGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ENTUTHUKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ENTUTHUKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ENTWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENUNGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ENXOLOBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ENYANDENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ENYANISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ENYATHI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENYAWOSHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENYEZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ELUNGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ENYOSINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ENZONDWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EPHANGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EQINISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ERICA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ERASMUSFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Escombe Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ESESE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ESETHEMBISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ESHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "Eshowe Junior School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ESIBANINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ESIBILA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ESIBOMVINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ESIBONISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ESIDAKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ESIDIDINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ESIDINSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ESIDUMBINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ESIFUBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ESIGAGANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ESIGODINI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ESIGWACENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ESIHONQENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ESIKHOTHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ESIKHUTHWANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ESIKHWEBEZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ESIMANYAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ESIMOZOMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ESINQENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ESINYAMBOTHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ESIPHAHLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ESIPHETHWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ESIPHIVA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ESIPHUKWINI J.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ESIQANDULWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ESIQHINGINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ESIQHOMANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ESIQWAQWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ESIVIVANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ESIWOYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ESKHULULIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ESSELEN HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ESTCOURT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ESTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ESUSWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ESWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ESWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ETETE S.A. PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ETHAFENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ETHAKASANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ETHALANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ETHEKWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ETHULWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ETSHELIHLE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ETSHENIPRIMARYSCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ETSHENILIKASHOBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EVEREST HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EVEREST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EVERGREEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EVULEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EVUTHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EWELA P.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EWUBWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EXCELSIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EXHAPHOZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EZAMUKUTHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EZIBAYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EZIBOMVINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EZIJIBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EZILOZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EZIMAMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EZIMBIDLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EZIMPAKANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EZIMPONDWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "EZINCWADINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EZINDLOVINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EZIQUNGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EZINYONYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EZWELETHU LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EZWELIHLE COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "FABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "FAHLAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "FAIRBREEZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "FAIRHAVEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "FAIRLEIGH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "FAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "FAKU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "FALCON PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "FALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "FANGELAKHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "FERDINAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "FEZOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "FISOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "FLAMBEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "FLORATON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "FOLESHILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "FORBESDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "FORDERVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "Forest View Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "FORT LOUIS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "FORTMANNSPRUIT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "FORTUIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "FRANKLAND COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "FREDVILLE S.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "FREIBURG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "FUKULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "FUNDAKAHLE P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "FUNDANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "FUNDEDUZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "FUNDUKHUPHUKE J P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "FUNDULWAZI HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "FUNOKWAKHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "FUNULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "FYNNLAND SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "GABADELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GABANGAYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "GABANGEMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GABANGENKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GABHAMANZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GAMALAKHE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GAMELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MAQAKALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "GANGEYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GARTMORE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "GASELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GAYIGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "GAYISANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "GAZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GCILIMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GCINA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GCININHLIZIYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GCINUKUTHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "GCIZELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GCOTSHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "GCWALAMOYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "GEDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "GELYKWATER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "GEM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GEMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "GEORGE CATO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "GEORGEDALE FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "PRIMêRE SKOOL GERT MARITZ"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GEZAHLALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GEZAMEHLO PP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GEZANGANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GIBINDLALA C P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GIJIMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GEBERS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "GILLITTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KHOLWANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GINGINDLOVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GITANJALI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GLEN HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GLEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GLENARDLE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Glenashley Junior Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GLENASHLEY PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "GLENCOE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "GLENCOE PRIMARY SCHOOL (VIOLET)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "GLENDALE STATE AIDED FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "GLENHILLS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "GLENMAIZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Glenmore Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "GLEN PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GLENRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "GLENRUST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GLENVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Glenwood Junior Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "GLOECKNER MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GLÜCKSTADT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GOBAMAHLAMVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GOBANDLOVU PRIMARY SCHOOL SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GOBHELA PRIMARY FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "GOBHOGOBHO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GOBIHLAHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "GOGOVUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GOJE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GOKUL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GOLOKODO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GOMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GOMONDO C.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GONZAGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "GOODHOPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GOQO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Gordon Road Girls' School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "GOURTON BRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "GOXHILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "GQAMA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GQUGQUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "GQUMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "GRANDMORE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "Grantham Park Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GREEN HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "GREENBURY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "GREENHEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "GREENOCK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GREENVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GREENWOOD PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "GREYTOWN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "GREYTOWN JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "GREYTOWN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GUBAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GUBHELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GUBHUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "GUBUZELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "GUDLINTABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "GUGULETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "GULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GULUBE CP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "GUNJANENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "GWADU-ZENEX PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "GWALIWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GWAZINYATHI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "GWEGWEDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "GWIJA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "GXALINGENWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "HABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "HABIYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "HALADU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HALALA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HALALISA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "HALAMBU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "HAMBAYEDWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "HAMBROOK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "HARDING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "HARDING STATE-AIDED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "HARRY BODASING PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "HATTINGSHOPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "HAWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HAWKSTONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "HAYINYAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "HEAVITREE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "HEMFANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HEMU HEMU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HENLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HENRYVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HIGHBURY PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "HIGHFLATS INTERMEDIATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "HIGHLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HIGHSTONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HILDA MAKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "HILL 70 PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Hillary Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CURRO HILLCREST CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HILLCREST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "HILLGROVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "HILLTOP COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HILLVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "HLABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "HLABANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "HLABISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "HLALAKAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "HLALELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "HLAMBANYATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HLANGANAKAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "HLANGANANI PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "HLANGANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HLANZENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HLATHINGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "HLAZAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "HLAZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "HLEHLELEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HLELINGOMUSO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HLELOLUSHA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HLENGIMPILO FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HLENGINGQONDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "HLENGISIZWE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "HLIMBITHWA PRIAMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "HLINZEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HLOBANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HLOBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "HLOKOHLOKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "HLOKOMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "HLOMAKANCANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "HLOMISA PRIMAY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HLONGOMIYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HLOPHEKHULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "HLUHLUWE PRIMARY SCHOOL (IMPALA ST)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "HLULABANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HLUNGULWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "HLUNGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "HLUPHIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "HLUTHANKUNGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "IMBALENHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "HLWATHIKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HLWEMINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "HOFFENTHAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HOLINYOKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "HOLY FAMILY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HOLOMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "HOLWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "HOLY CHILDHOOD SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "HHOMOYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HOPE VALLEY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HOPEVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HOPEWELL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "HORSESHOE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HOWICK PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "COSMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HOWICK WEST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "H.P. NGWENYA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "HUBHUSHE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "HULSUG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "HUNTLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "HURSLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "HUTTENPARK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "HYMAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ICABHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "IDAMU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "IDIDIMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "IDLEBE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SBONOKUHLE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "IFAFA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "IGUGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "IGUGULABANGUNI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SAKHIKUSASA PRIMARY SCHOOL (IHLATHI)"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "IKAHENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "IKHAKHAMA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HLUSHWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "IKHOHLWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "IKHWEZI LAMACHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "IKHWEZILOKUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ILENGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ILLOVONEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ILLOVO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "IMBALENCANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "IMBALIYAMAZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "IMBALIYEZWE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "IMBEWENHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "IMBIZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "IMBOYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "IMBUBU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "IMFANELO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "IMFIHLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "IMFULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "IMFUME SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "IMISEBE COMBINE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "IMIZIKAYIFANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "IMPANDWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "IMPAPHALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "IMPUPHUSI CP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "IMUSHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "IMVULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ZUZOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THEMBALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INANDA DAY SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INCABHELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INCHANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "INCOPHELELO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INCWABA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INDABIKHULUNYWAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INDALENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INDANYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "INDATSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INDIKINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "INDLOVANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INDLULAMITHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INDLUYAMANDLA CP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "INDONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INDUDUZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "INDUKEBANDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INDULWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "INDUMAKUDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INDUNDUMA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "INGAQA FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INGCEBOYESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INGCINDEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INGCUKWINI HP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INGEDE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "INGELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "INGOGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INGOMEZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "INGQUBEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INGWENI-PHAPHAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "INGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INGWEMNYAMA SP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INGWENYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "INHLANGANISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INHLANGANO S.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "WONDERBOOM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INHLASANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INHLAZUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "INHLWATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INJABULO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "INJABULOYESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SENZAKAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "INKANYEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INKANYEZI YAMACHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INKANYEZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKANYISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PHEMBUKUKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INKAZIMULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INKOMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "INKONGOZELO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "INKONKONI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INKOSENTSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INKULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INKULULEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKUNZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKUTHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INKWALI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "INQABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INQANULA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INQOLAYOLWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EMZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INQUBEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INSEBENZWENHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "INSELELE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "INSELENYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INSIMANGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INSINGIZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "INSIZWAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INSONGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INSUKANGIHLALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "INSUZE-GCWENSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INTABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "INTAKAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INTANDO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "INTAPHUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "INTINYANE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INTONGELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "INTOYETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "INTUKU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INTUMBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INTUTHUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "INTUTHUKOYAMAZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INTUZUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "INVERNESS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INYAMAZWE FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INYANDEZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "INYANGANYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INYANINGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "INYATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INYAVWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INZINGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "IPHUNGUPHUNGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "IPHUPHUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "IQABAVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ISAMBULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ISANDLWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ISANGCWABA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ISANGOYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ISANGQU COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ISAVIYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ISIBANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ISIBANKWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ISIBONGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ISIBUKOSABASHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ISIDINGO C.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ISIGCINO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ISIGODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ISIGUDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ISIHLANGUSABASHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ISIHLANGUSIKAZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ISIHLANGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ISIKHUMBUZO FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ISIKHUTHALI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ISIKHWELO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ISILUTSHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ISINKONTSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ISIPHETHU-SEMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ISIPHINGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ISIPINGO HILLS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ISIPINGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ISIQALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ISIQOPHAMITHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ISIQULWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ISISEKELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ISITHINTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ISITHOKOZISO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ISONTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ISULABASHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ISULETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ISULOMNDENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ITHAKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ITHENJANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ITHONGASI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ITHONJENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ITHWELENYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ITSHEHLOPHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ITSHELEJUBA LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ITSHODO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "IVANHOE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "IVUKAYIBAMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "IWAHLANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "IWANGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "IWETANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "IXOPO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "IXOPO STATE AIDED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "IZIBUKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "IZINHLENDLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "IZIKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "IZINESHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "IZINGOLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "IZINTAMBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "IZINYOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "IZOTSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "JABAVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "JABULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "JAI HIND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "JAJA MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "JANGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "IGUGULAMANYONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "JANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "PANORAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "JHUGROO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "JINGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "JOBSTOWN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "JOJOSINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "JONGIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "JONONOSKOP HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "JOZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "JUBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "JUBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "JUBILEE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "JULUKANDODA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "JUNAGARTH ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KAINON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KALENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KAMALINEE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KAMEEL HOEK FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "",
      "School_Name": "KAMMALAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KANDASPUNT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KANGIKHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KEATE STREET PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KEATES DRIFT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KENTERTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KENVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KHAKHAMELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KHALANYONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KHALAWEMUKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "KHALIMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KHALIPHA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KHANDANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KHANDISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KHANGELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KHANYAKHWEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KHANYANGODUMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KHANYANJALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KHANYISANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "DAVID MKHIZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "KHASELIHLE FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KHATHAZILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KHAWULEZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KHAYALEMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KHAZIMULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KHETHAMAHLE SP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KHETHELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KHETHIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KHETHINDLELENHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KHETHOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KHETHUKUTHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KHETHWAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KHIPHULWAZI H.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KHIPHUNYAWO H.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KHOBONGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KHOFI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KHOLOKAZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KHOMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KHOMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KHONGELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KHONYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KHONZINDABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KHUKHULELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "KHULAKAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KHULANGOLWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KHULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KHULANJALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KHULEKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KHULUBONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KHULULEKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KHULUMA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KHUMBULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KHUMBUZA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KHUMOLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KHUPHUKANI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KHUTHALA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KHUTHALANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KHWEZI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KIKIZANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "KILBARCHAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "KILKEEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KINTAIL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KIRKINTULLOCH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KLAARWATER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KLEINFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIQHOSHANGEMFUNDO ( KLIPWAL) PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "Kloof Junior Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KLOOF SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KLWAYISI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KNOOPAAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "KOENIGSBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KOHLOKOLO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KOKSTAD JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KOKSTAD PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KOKSTAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KOMBUZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KONGOLANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KONINGSDAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KOPLEEGTE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KORTNEK LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KOTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KRANSDRAAI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KRANSKLOOF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KRUISFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KUBHUDLU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KUHLEKWETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KUJABULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KUKHOBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SINOTHILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KUMKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KUSAKUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KWAGENCE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWA-HLOMULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWAMQADI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KWA NGQULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWANJEKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWA-MNGOTHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWASOKOYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWABIYELA SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWABOMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KWACUTSHWAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KHULUGQAME PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KWADLADLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWADONSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KWADOPHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAFUZOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWA-GAMAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWAGCONGCO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KWAGINGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWAGUGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KWAGUMBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KWAGWEGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWAHLONGWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWAJAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KWAJESSOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWAJAKOBE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWA-KHANGELA CP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KWAKHETHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWALAMLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWALUHLAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWA-MADAMU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KWAMADLALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAMADUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWAMAGWAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KWAMAJOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWA-MAKHONYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAMAME FULL - SERVICE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWAMANANDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWAMANGQWASHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWAMANQONDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KWAMANZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KWAMAPHUMULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWAMAQUZA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWAMASONDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWAMAZAMBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KWAMBINGELELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWA-MBOMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWAMBONAMBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAMDOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAMFUNDENI HP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "LIONS RIVER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKOSI MGABO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWAMISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KWAMIYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KWAMLAMULI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAMLIMISI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KWAMNYANDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWAMONDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWAMPHELELWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWAMPHIKWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWAMPOFU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KWA-MPUNGOSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAMPUNZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWAMQOBELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWAMSHAYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWAMSHUDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KWA-MSINGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWAMTHOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWAMTSHWILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAMUSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KWAMYEZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWANDABEZINHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KWA-NGEDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KWANGQUNGQUSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KWANGUBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWANGUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWANGWENDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWANKULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWA - NOGCOYI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KWANOKUSHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KWANOMPANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KWANONGQANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KWANOSHEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWANQOKOTHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KWANYEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWANZIMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWAPHAWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWAPHUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWA-QUMBU COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWASANTI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KWASENGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KWASHANGASE P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KWASHANGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWASIBONDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KWASIKHUNYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KWASIMAMANE J.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KWASOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWASONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWASONTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KWA-THAMBO C.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KWATIMOTHY INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWANYONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWAZAMOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWAZIBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWA-ZIBONELE P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KWAZIBUSELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAZIHLAKANIPHELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWELENTABA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KWELIFUPHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "KWETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "L BODASING PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "LA LUCIA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "LABOURE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "Laddsworth Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LAKESIDE PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LALELA HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "LALELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "LAMULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LANDULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LANGALESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "LANGALETHU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "LANGALIBALELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "LANGKLOOF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LATHA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PRINCE LAYUKONA FULL-SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LELIESHOEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MNYWANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "LENHAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LENJANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "LENNOXTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "LETHOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LETHUKUKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "LETHUKUTHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "LIBUYILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LILANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LINDAKAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "LINDELANI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "LINDELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LINDIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "LINDOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LINDOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LINDUMTHETHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "LINGANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "LINWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ST. DAVIDS DIOCESAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "LITTLE FLOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LIVANGELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "LLOYD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "LOKOTHWAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "LONGCROFT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "LONGMARKET GIRLS SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LOOTSHOEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "LOTHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LOTTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "LOTUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "LOTUSVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "LOUISIANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LOUWSBURG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LOUWSBURG PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "LOWER TUGELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "LUBAMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "LUBANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "LUBELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "LUBISANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LUBOVANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "LUCAS MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LUCAS MEYER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "LUDAKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LUDLIKI LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LUFAFA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LUHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "LUHLANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LUIPAARDSKOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LUJOJWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "LUKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "LUNDINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LUNEBURG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "LUNGELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "LUNGELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "LUNGISILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LUSIBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "LUSITANIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "LUTHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LUVISI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "LUZINDELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "LYNDHURST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "Lyndhurst Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "M PADAVATAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "M.L SULTAN ESTCOURT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "M L SULTAN KRANTZKLOOF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "M L SULTAN LADYSMITH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "M.L. SULTAN COLENSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "M.L. SULTAN ST MARYS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MABANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MABASO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MABEDLANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MABEKA C.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MABHENSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MABHILA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MABHUMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MABIBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MABULULWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MACABUZELA PRIMARY FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MACALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MACAMBINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MACEBO COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MACEKANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MACELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MACHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MACHIBINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MUZI THUSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MACHOTSHANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MACHWETSHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MACONGCO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MADAKA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MADAKANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MADELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MADIDIMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MADLALA FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MADLANGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MADLOKOVU HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MADLOZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MADONELA FULL SERVICE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MADULADULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MADUNA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MADUNDUBALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAFA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAFITLENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MAFUKUZELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MAGABENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAGADLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAGANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MAGAYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAGCEKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAGENGEBULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAGENQEZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MAGENWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MAGIDIGIDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAGOBHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MAGODA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MAGOG FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAGOGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MAGONGOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAGUDUBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAGUGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAGUMBOMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MAGUYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MAHAFANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MAHATHMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MAHAWULE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MAHEHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAHLABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAHLABANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAHLABATHINI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MAHLALINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MAHLASHANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MAHLEKEHLATHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAHLOKOMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAHLOMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAHLONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MAHLUBIMANGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MAHLUTSHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAHOLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MAIDSTONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MAIZELANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MAJOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAJOZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAKABONGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAKHAMBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAKHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAKHANDANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAKHANYEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAKHASANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAKHATHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MAKHAWULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAKHEME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MAKHONZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAKHOSINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MAKHOWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAKHOWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MALALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MALAMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MLALAZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MALANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MALEZULU COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MALIPHUME CP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MALIYAMAKHANDA P P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MALIZAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MALOTTASKRAAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MALUKHAKHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MALUNGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MALUSI OMUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MALVERN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MALVERN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MAMBHONGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAMBUKA ABC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MAMBULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAMFENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MANABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MANDENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MANDLAKAYISE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MANDLAKAZULU SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MANDLALATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MANDLASONKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MANDLENDODA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MANDLENYOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MANDLETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MANDULUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "IMPUMELELO YETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MANGETE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MANGETHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MANGOMUNTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MANGQAKAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MANGQASHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MANGQWASHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MANGUZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MANHLANHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MANKONJANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMANKWATHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Manor Gardens Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MANQINDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MANQOBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MANQONDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MANSFIELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MANTIGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MANTSHOLWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MANTULELA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MANYALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MANYAMPISI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MANYANDENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MANYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MANYONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MANYUSWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MANZAMNANDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MANZAMNYAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MANZAMNYAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MANZAMPOFU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MANZENGWENYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MANZIBOMVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MANZIMAKHULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MANZIMPOFU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MANZOLWANDLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAPHAYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAPHINDELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MAPHOLOBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAPHOPHOMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MAMPONJWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAPHUKANQOLA PRMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MAPHUMUZANA C.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAPUTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MAQADINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAQHAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAQHUBANDABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MAQOKOMELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MAQONGQO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAQWABE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAQHWAKAZI C P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MARAISKOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MARBURG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MARGATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MARIA MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MARIAM PATEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MARIANNHILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MARIANNPARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "Mariannridge Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MARIS STELLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MARLBOROUGH PARK JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MARSHMOUNT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MARY GRAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MARYHELP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MASHAYILANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MASHESHISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MASHESHISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MASHIWASE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MASHIYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MASHIZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MASHOBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MASHUMI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MASHUNKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MASIHAMBISANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MASIHLANGANE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MASITHOKOZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MASOKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MASOTSHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MASUKU PRIMARYSCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MASULUMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKOSI MASUMPA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MATA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MATHABATHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MATHAFENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MATHAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MATHANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MATHEBETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MATHIBELANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MATHINTA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MATHIYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MATHONSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MATHUNGELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MATIMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MATIMATOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MAQUMBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MATIWANESKOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MATSHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MATSHANGULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MATSHANHLOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MATSHEKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAVANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MAVIVANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MAVUNDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAWALANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAWANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAYAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAYALUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MAYELESWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MAYETHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MAYIKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAYIME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MAZISI NTULI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MAZONGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MBALANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MBALASI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MBALENHLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MBAMBALALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MBAMBUYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MBANGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MBANGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MBANJWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MBASELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MBATHANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MBAVA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MBAZWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MBEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MBELENI PRIMARY FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MBEWUNYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MBHANANA ZENEX PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MBHASOBHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MBILANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MBITANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MBIZIMBELWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MBODLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MBOKO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MBOLOBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MBONDWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MBONGOLWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MBONISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MBOZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MBOZAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MBUDE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MBUKENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MBULWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MBUSOMUSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MBUTHISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MBUTHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MBUYAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MCCARTHY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "M C VARMAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MCAKWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MCATHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MCATSHANGELWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MCEBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MCELENI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MCETSHWA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MCITSHENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MCOPHELELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MCUTHUNGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MDANSANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MDLAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MDLELANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MDLENEVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MDOMBOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MDUDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MDUMEZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MDUNA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MDUTSHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MDUTSHULWA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MEHLOMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MEHLOMNYAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MEHLWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MEHLWENKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ETHUBALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MELVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MEME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MEMELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MENDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MENGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MENZIWA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MEPHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "Merchiston Preparatory School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Gardenia Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MERRY HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MESENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MEYERSHOEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MEYIWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MFABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MFAKUBHEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MFANAWENDLELA P P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MFANEFILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MFEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MFEKAYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MFENEBUDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MFENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MFIHLELWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MFINGOSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MFONGOSI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MFUNDABASHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MFUNDWENHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MGABADELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MGABHANYONGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MGADA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MGAI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MGANGATHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MGANKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MGATSHELWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MGAWULANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MGAZINI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MGEBISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MGEDULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MGIGIMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MGOMBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MGOVUZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MGQWABAGQWABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MGULWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MGWAGWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MGWAYINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MGXANYINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MHAWU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MHAWUKELWA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MHLABANGULEPRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MHLABULUNGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MHLANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MHLANGAMKHULU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MHLUNGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UMHLATHUZE DAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MHLUMAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MHLUMBA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MHLUMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "HLUHLUWE PRIVAATSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MHONGOZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "M.I. PARUK JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MICHAEL M SHELEMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MICHAELIS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MID-ILLOVO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MIDDELRUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MIDDLEDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MIDDLEFIELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MILLVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MIMTAMS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MINYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EKUKHANYISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MITCHFORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MJIKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MJILA P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MJOJI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKOSI MJWAYELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MKHABELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MKHANDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MPANZAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MKHAYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MKHAZANE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MKHAZENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MKHOBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MKHOBOSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MKHOMAZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MKHONJANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MKHONJENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MKHULUNYELWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MKHUNJINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MKHUPHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MKHUZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MKHWANTSHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MKLOMELO J.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MKUZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MLAMLELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MLAMULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MLIMELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MLINGANISWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MLOLI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MLONDOLOZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MLOVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MNAFU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MNAMATHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MNAMBITHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MNDENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MNGAMPONDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKOSI MNGAYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MNOTHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MNQAGAYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MNQAKWE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MNQOBOKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MNTIMANDE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MNTUNGWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MNYAMANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MNYAME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MNYAYIZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MOFU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MOMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MOME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MONDISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Montclair Junior Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Montclair Senior Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MONTEBELLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MONTFORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MONUMENT School / Skool"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MANYONGA LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MONZI ULOA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MOOI RIVER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MOORLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MOORTON HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MOPHELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MORESON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MORNING STAR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Morningside Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MORTON ESTATES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MOSSDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MOUNT NGWIBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MOUNTAIN HOME JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MOUNTAIN RISE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MOUNTAIN VIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MOUNTHAVEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MOWBRAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MOY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MOYAMUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MOYAMUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MOZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MPALAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MPHAYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MPELENYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MPEMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MPEMVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MPENGWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MPHAKATHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MPHATHISWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MPHAZIMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MPHENDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MPHEPHETHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MPHONDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MPHOTHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MPILONDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INTUTHUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MPOFANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MPOFANYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MPOFINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MPOLIMPOLINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MPOMPOLWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MPOTHOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MPUCUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MPUKUNYONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MPULULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MPUMALANGA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MPUMAZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MPUMLWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MPUMUZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MQAMU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MQANGQALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MQEDI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MQHATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MQHIYAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MQOLOMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MSAYINA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MSEBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MSELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MSENTELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MSHIYWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MSHOBASHOBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MSHWATHI MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MSITHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MSIZI DUBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MSIZIWAMAKRISTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MSUSHWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MTAKAYISE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MTHAWENGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MTHETHOMUSHA S P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MTHINTENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MTHOLI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MTHOMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MTHOMBOTHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MTHOMBOWOLWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MTHUBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MTHUKUTHELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MTHUKWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MTHWADLANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MTHWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MTIKINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MTIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MTUBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MTUBATUBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MTWALUME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MTHWALUME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MUHLEKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MUKELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MUMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MUNGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MUNTUZA FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MUNYU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MUNYWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MURCHISON COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MUSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MUTHIDLWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MUZIKAYISE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MUZIWABANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MUZOMUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MUZUVUKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MUZUYAQOKWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MVAYIZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MVINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MVUBU STATE AIDED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MVULAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MVUYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MVUZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MWELASE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MZIKI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MZILA FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MZIMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MZINGAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MZINGELWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MZINGWENYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MZINYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MZIWENKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MZIYONKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MZOMUSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MZONDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MZUKELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MZWENDABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MZWILILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NADI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NAGARI PRACHARNI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NAIDOO MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NAIDOOVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NAMAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NANSIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NANSINDLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NARDINI CONVENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NATEST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NCAKUBANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NCECENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MEHLATHATHANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NCEMANENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NCEPHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NCIBIDWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NCINCI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NCOTSHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NCWABAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NCWADI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "NDABANHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NDABAYAKHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NDABAZEZWE LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NDABENHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NDABENHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NDABEZITHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NDABOMUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NDABIKHONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NDATSHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NDAYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NDEBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NDELESHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NDIKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NDIMOSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NDINDINDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NDLANDLAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NDLELAYABASHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NDLOKOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NDLONDLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NDODEMBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NDONDWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NDONGANDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NDONGENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "INDOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NDUKUYAKHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NDULINDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NDUNAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NDUNDULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NDUNGE C.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NDWANGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NDWEDWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NEW GERMANY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NEW HANOVER PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NEW PATANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NEWARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "BUSY BEE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "NEWCASTLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NEWHOLME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NEWTONVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NGABAYENA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGADUMBILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NGALEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGANGAYIPHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NGAYIPHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NGAZANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NGCEDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NGCESHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NGEDLESI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGENGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGETHULE C.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NGIDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NGILANDELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NGILANYONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NGILOSI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NGOGODO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGOLOTSHA C P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NGOMANKULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NGOME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NGONGOLO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGONGOMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGOZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NGQAMZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NGQAYIZIVELE J.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGQOLOTHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NGUBEVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NGUDWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NGUNJINI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "INGUTSHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGWABI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKOSI NGWADI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NGWEBINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NGWEGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NGWELEZANA HOSP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NGWEMNYAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NGXOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGXONGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NHLABAMKHOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NHLABAMKHOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NHLABANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NHLAKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NHLALAKAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NHLALWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NHLAMBAMASOKA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NHLANGAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NHLANGENYUKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NHLANGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NHLANHLENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NHLAYENZA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NHLAZATSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NHLIZIYONHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NHLOKOMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ITHEMBALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NHLONHLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NHLOPHENKULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NHLOSHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NIBELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NICHOLS JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NIKELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NINGIZIMU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NIZAM ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NJAKAZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NJENGABANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NJOJO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NJOMELWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "NKABANE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NKABANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NKABINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NKAMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NKAMELWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NKANDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NKANGALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NKANYEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NKANYEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NKEHLAMANDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NKIWANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NKIYANKIYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NKOLOKOTHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NKOMBABANTU COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NKOMIDLI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NKONGOLWANA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NKONINGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NKONISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NKONJANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EKUKHOSELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NKONYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NKONZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NKOSAZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NKOSIYETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NKUKHU LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NKULISABANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NKUME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NKUNGUMATHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NKUNGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NKUNYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NKUNZEMALUNDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NKUNZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NKWAMBAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NKWELETSHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NKWEME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NKWEZELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NOBANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NOBANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NOBUZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NODWENGU PP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NOGAGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NOGAJUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NOGASELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NOGAWU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NOGOBHOZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NOGQAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NOKOPELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NOKUBUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "NOKUKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NOKWEJA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NOMAGAGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NOMAGANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NOMAMGEJE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NOMAHAYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NOMAKHANZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NOMANDLA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PRINCE NOMATIYELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NOMBAYINGANA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NOMFIHLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NOMFOMELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NOMGIDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NOMPONDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NOMTSHILO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NOMUWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NONDABULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NONDWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NONGENGANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NONIKELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NONOTI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NONQANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NONTSHUNTSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NONZILA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NOODSBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NOQOMFELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NORTH CREST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NORTHDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NORTHDENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Northdene Preparatory School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NORTHERN PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NORTHLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NORTHLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NORTHLEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NORTHVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NOSITHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NOTHWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NOTTINGHAM ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NOVIMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NOVUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NOVUNULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NOVUNYWA S. P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NOYIBEWU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NQABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NQAMBOSHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NGQUNGQU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NQIWANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NQOBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NQOBIZIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NQULWANE FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NQUNQA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NQUTU LUTHERAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NQUTSHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NQUTHU PLACE OF SAFETY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NSABALELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NSEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NTSHONGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NSIKAYEZWE SP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NSIMBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NSIMBINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NSINGABANTU C.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NSIWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NSOMBOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NSONGANSONGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NSONGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NSUKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NSUNDUKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NSUNGULU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NSUNGUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NSUZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NSWELAMANZIVELA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NTABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NTABAMAKHABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NTABAMHLOPHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTABASIBAHLE C.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NTABASKOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NTABAYENGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NTAMBANANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NTANDABANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NTANDAKUWELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NTANDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTANYANDLOVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTANYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTANYEZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NTATHAKUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTATSHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NTENDENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTENESHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NTENGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NTENGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NTILINGWE H.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTINGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTININI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NTINTISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "NTOBEKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTOBOZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NTOKOZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTOLWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NTOMBEMHLOPHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NTONTONTO COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTSHANGASE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NTSHELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NTSHIBANTSHIBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTSHIDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTSHISHILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NTSHIYABANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NTSHIYANGIBONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKOSI NTSHOSHO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NTSWALAKAHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NTUKUSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTUMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTUMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTUTHUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTUTHUNGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NTOKOZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NTWEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NTWELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NUNGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NUWE REPUBLIEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NXENJANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NXUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NYAKAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NYALAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NYAMAZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NYAMBAYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NYANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NYANISWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "NYANYADU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NYATHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NYAWOSHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NYEMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NYONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NYONYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NYUSWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NZALABANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NZAMANGAMANDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NZOBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "OBANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "OBANJENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "OBISINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "OBONJANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "OCEAN VIEW HOUSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "OCEANVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "OCHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "OCILWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "THEMBELIHLE FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ODEKE COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ODIDINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ODLAMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "OGADE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "OGAGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "OGAZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "OGEDLENI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "OGUNJINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "OHLAHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NHLONIPHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "OHLANGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "OKHALWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "OKHALWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "OKHAYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "OKHOMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "OKHUKHO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "OLWAMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "OLYMPIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "OMBIMBINI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ONDINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ONGOYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ONINGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ONTINGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "OPHATHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "OPHANSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "OPHAPHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "OPHONDWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "OPHUZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "OQAQENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "OQONDWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "OQUNGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ORIENT HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ORIENT HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ORISSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "OSCARSBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "OSHABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "OSINGISINGINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "OSIZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "OTHANDWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "OTHIYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "OTHOBOTHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "OTHUNGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "OTHWEBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "OTIMATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "OTTAWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "OURLADY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CONVENT SCHOOL OF OUR LADY of NATAL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "OUTFALL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "OVERPORT S.R.S. PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "OVERTOUN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "OVICENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "OVUKUKANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "OXOLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "OYEMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "OZABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "OZWATHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "OZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PADDOCK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PALMCROFT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PALMIET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "",
      "School_Name": "PANDORA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GLENWOOD PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PARKGATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PARKLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Parkside Primary School Natal"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PARKVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PARKVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PARLOCK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PARSEE RUSTOMJEE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "PARUKABAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "PATSOANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PAUL SYKES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PAULPIETERSBURG PRIMERE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PAULPIETERSBURG PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "PEACETOWN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PEACEVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "Pelham Senior Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "PELLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PEMARY RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PENZANCE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PETERGATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "PETEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PHAKAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PHALANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PHALANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "PHAMBELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "PHAMBILI J.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PHANGANDAWO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "PHANGINDAWO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PHANGISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "PHASIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "PHASULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "PHATHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PHEMBUKUTHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PHEMBUMUZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "PHEPHA J.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PHEPHILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "PHESHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PHESHEYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "PHIKELELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PHIKISWAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PHILA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "PHILANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "PHILANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PHINDELA SP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PHOENIX HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PHOENIX PIONEER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "PHOHLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "PHOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PHONDWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "PHONSIMPI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PHOPHOMENI C.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PHOSHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PHOZIPHOZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PHUCUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "PHUMALANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "PHUMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PHUMELELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "PHUMELELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "PHUMOWAKHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PHUMUZUZULU PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PHUMZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PHUNGULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "PHUNYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PHUPHUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "PHUZEMTHONJENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "PIET RETIEF PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "Pinetown Junior Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "",
      "School_Name": "PINOCCHIO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "PISGAH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "Pitlochry Senior Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PLANT MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "POMEROY STATE-AIDED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PORT SHEPSTONE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PORT SHEPSTONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PORT SHEPSTONE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "POTSPRUIT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "POWERSCOURT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "PRESTBURY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "HEUWELLAND PRIMERE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PRIMROSE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PRINCE DABULAMANZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PRINCE THEMBITSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "PROSPECT FARM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PROTES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PUMULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PUTELLOS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "QALAKANCANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "QALANGOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "QALIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "QALUKUVUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "QAMBOKWETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "QAMBUSHILO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "QANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "QAPHELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "QEDIPHIKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "QEDIZABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "QEDUKOMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "QEDUMONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "QEDUSIZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "QHAMUKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "QHOQHOZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "QHOSHANGANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "QHOSHEYIPHETHE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "QHUBAKAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "QHUBANDABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "QHUBEKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "QHUBIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "QHUDENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "QILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "QINELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "QINISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "QINISELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "QINISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "QOMUKUPHILA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "QONDISANI PIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "QONDOKUHLE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "QONDUKWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "QONGWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "QOPHUMLANDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "QOYINTABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "QUBUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "QUNWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "QWASHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "QWEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "R A ENGAR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "R.A. PADAYACHEE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "RADHA ROOPSINGH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "FOREST HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "RAMATHA ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "RAMLAKAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "RANTJIESVLAKTE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "RATANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "REDCLIFFE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "REDFERN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "REGINA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "REICHENAU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "REMINGTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "RESMOUNT PRIMARY SCHOOLS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "RHEIBOKSPRUIT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "RICHARDIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "Richards Bay Primary SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "RICHLEA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "RICHMOND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "RIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "RIDGE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "RIDGE VIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Rippon Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "RIVERDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "RIVERSBEND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "RIVERVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ROBIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ROCKFORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ROOIHOEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ROOKDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ROSE HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ROSEFERN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ROSEHILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ROSELAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ROSETTENSTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ROSETTENVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "RUSSELL JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "RUSTFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "RUSTIC MANOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "RYDALVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "S.E.VAWDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "S. M. JHAVARY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SABHUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SABOKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "OAKFORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SAFARI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SAILORS GIFT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SAKHAYEDWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SAKHESETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SAKHESETHU PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SAKHILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SAKHUMUZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SALEM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SALIGNA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SALPINE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SAMBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SAMUNGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SANDAKAHLE C.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SANDANEZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SANDANOLWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SANDASONKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SANDFIELDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SANDRIVER VALLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SANELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SANELISIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SANGOYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SANGQULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SONKABI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SANKONTSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SANSIKANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SANZWILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SAPEKOE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SAPHINDA C.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SAPHUMELELA FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SARASVATI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "Sarnia Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SARON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SAVELA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SAVUYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SAWELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SAWOTI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SAWPITS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SCHITSDRIFT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SCHURWEBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SCOTTBURGH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SCOTTSFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SCOTTSVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SEA VIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SEAFORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SEBENZANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SEKELANI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SELINDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SENZOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SENZOKWETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SENZWESIHLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SESIFIKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SESIKHONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "UMBULWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SETHABE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SETHABILE HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SETHEMBINKOSI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SETTLERS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SEVEN FOUNTAINS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SEVEN HILLS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SEVEN OAKS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SEWULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PENNINGTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SEZELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "S.H GUMEDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SHAKASKRAAAL SA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SHAKASKRAAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SHALLCROSS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SHALOM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SHANGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SHAYAMOYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SHAYAMOYA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SHEBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SHELEZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SHEMBE MEMORIAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SHEMULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SHERWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SHESHANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SHESHISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SHESHISAMSAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SHIBASE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SHIKISHELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SHONKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SHRI VISHNU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SHUKUMISA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SHWASHWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIBAMBISENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SIBANISETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SBAVANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIBHANGWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIBHEKULWANDLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIBHUDENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIBIYANGANKOMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIBOMVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIBONGAMANDLA JUNIOR PRIMARY SCHOOL."
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIBONGILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SIBONISE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIBONOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SIBUKEYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIBULULWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SIBUMBA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SIBUYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SICELULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SIDIYA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIDUBELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIDUMILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIDUMUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIDUNGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIFISESIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SIFISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIFISOSETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SIFUNIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIGANANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SIGEDLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIGIDISABATHEMBU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIGISI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIGUBUDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIHANGWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIKELELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIKHONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SIKHONYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIKHUKHUKHU C.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIKOTHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SILANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SILIMELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SILINDEKAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SILINDELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SILINDELE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SILINDOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SILOKOMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SILVERDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SILVERGLEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SILVERTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SILWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SILWANETSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIMANDLANGENTSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIMANGANYAWO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIMANJALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SIMLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SINAMUVA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SINATHING JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SINAYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SINDAWONYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SINEGUGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SINEKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SINENHLANHLA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SINENHLANHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SINGANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ST PHILLIPS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SINOTHANDOJUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SION PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SIPHAHLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIPHAKAMILE COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIPHALAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SIPHAMANDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIPHAMBANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIPHANDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIPHELELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIPHENDUKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIPHENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIPHEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIPHIWESAMANGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SIPHOSETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SIPHOSETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIPHUMELELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIQAKATHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIQHAKAZILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SIQONDOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SISHONGANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SISISIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SISIZAKELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SITHANDENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SITHANDIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SITHEBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SITHELOSETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SITHEMBILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SITHILO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SITHOBELUMTHETHO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SITHOLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SITHOLINHLANHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SITHUNJWANA FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIVANANDA H.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIVULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIVULINDLELA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIWELILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIYABATHWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SIYABUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SIYABUSWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SIYACATHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SIYACOTHOZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIYAKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIYAKHANYISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIYAKHONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIYAMU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SIYANDAMAZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIYAQHUBEKA L PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SIYATHOKOZA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIYATHUTHUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIYAVUNA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIYAWELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIYAZENZELA HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIYAZIQEQESHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIYEPHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIYETHEMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIYEZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIYOKOMANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIZAKALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIZAKANCANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIZAMILE LOWER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIZANOTHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SIZIMISELE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIZOFIKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIZUZULU PRIMAY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SIZWAKELE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIZWAYINKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIZWELABANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SKEYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SKYLARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SLAGVELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SLANGSPRUIT PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SLAVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SOGIDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SOJUBA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SOKHELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SOKHULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SOMANGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SOMBONGANGANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SOMHLOSHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SOMKHELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SOMOPHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SOMOTHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SOMTSEWU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SONDABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SONDELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SONDELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SONDODA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SONDOKHULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SONGOZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SONGOZIMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SONKESHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SONQOBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SONTSHENGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SOPHIE PHEWA CP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SOPHUNGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SOSINDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SOSUKWANA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SOUL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SOUTH COAST MADRESSA SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SOVANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SOVIYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SOYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SPEARMAN ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SPOOKMILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SPRINGFIELD HINDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SPRINGFIELD MODEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SPRINGHAVEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SPRINGVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ST ALEXIS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ST ANNE'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ST ANTHONYS CATHOLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ST. AUGUSTINE'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BERNARD MIZEKI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ST.BERNARD'S JOLWAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ST CHADS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ST.CHRISTOPHERS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ST CYPRIANS INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ST FRANCIS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ST JOSEPH S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ST LAWRENCE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ST LEO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ST MICHAELS SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ST MICHAELS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ST MICHAELS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ST. NICHOLAUS COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ST. NIVARD'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ST ODILO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ST PAULS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ST PAUL'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ST TERESA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ST.THERESAS R.C. PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ST. THOMAS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BAHLEBONKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "STAFFORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "STANGER HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ASHRAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "STANGER MANOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KWA DUKUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NORTH COAST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "STANGER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "STANMORE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "STAR OF THE SEA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DURBAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "STEPMORE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "STERNGROVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SITHUMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "STOFFELTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "STONEBRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "STONEY HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SUID-NATAL PRIMERE SKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SUKUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SUMMERFIELD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SUMMIT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SUNBEAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SUNCREST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SUNDUMBILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SUNFORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DURBAN NORTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SUNNYVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GREYVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SURYAVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SUTTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SWANVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SWEBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SWEETWATERS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SYDENHAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "T.P.A FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "TABLE MOUNTAIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "TAFELIKOPO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "TAFELKOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "TAYLORS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "TAYSIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "TETELEGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THABANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "THAFAMASI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THAKAZELA P.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "THALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "THAMELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THAMSANQA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "THANDANANI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THANDIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "THANDINKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "THANDIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THANDOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "THANDOKWETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THANDOLWABASHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THANDUKWAZI SP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "THANDUXOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "THANGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THAPHOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THE GRANGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "THELAMAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THELEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THEMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "THEMBALESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THEMBALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "THEMBALIMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "THEMBAMANDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "THEMBEKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "THEMBELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "THEMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THEMBOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "THETHANDABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THIMUNI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "THIYASIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "THOBANI SP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THOBEZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THOBILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THOBISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THOKAZI C.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THOLAKELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THOLAMANDLA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THOLATHEMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THOLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "THOLIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "THOLINHLANHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "THOLISU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THOLULWAZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "THOLUMUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THOMBOTHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THORNER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THORNVILLE STATE AIDED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THORNVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "THRELFALL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "THUKEYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "THULASIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "THULINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "THULUBHEKE COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THUMBELA PRIMARY SCHOOL."
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "THUNZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THUSANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "TIGERVLEI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "TIMONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "TINLEY MANOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "",
      "School_Name": "TINY TOTS PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "TLOKWENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "TOBI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UTHONGATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "TONGAAT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Tree Tops School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "TRENANCE PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ACACIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "TRIANDRA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "TROUTWATERS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "TRUBEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "TSHANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "TSHANYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "TSHEKHULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "TSHENDLOVU PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "TSHENILOKWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "TSHENKOMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "TSHONGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "THAMBOLINI HIGH SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "TWASANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "TYBURN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UBHEDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UBIZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "UBOMBO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "UBUCUBOBUHLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "UBUHLEBEMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "UBUHLEBEMVELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "UBUMBANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "UBUNYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UBUQHAWEBETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UDUMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "UELZEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UFASIMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "UGEDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UKUKHANYA KWELANGA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "UKUKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UKUKHANYAKOKUSA FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "UKWENZAKWETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ULUNDI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "UMALUSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "UMBIKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Umbogintwini Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UMBONAMBI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "UMFOLOZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "UMFULUMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "UMGABABA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "UMGIJIMI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "UMGODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "UMHLABASHANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "UMHLABASHANA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "Umhlali Preparatory School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UMHLATHUZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "UMHLATUZANAPRIMARYSCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UMHLOTI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "UMKHATHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UMKHUKHUZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "UMKOMAAS DRIFT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Umkomaas Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UMLALAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Umlazi JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "UMLWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "UMNDENIWOXOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UMNGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "UMNINI MEMORIAL SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "UMOYA OMUSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UMPHUMELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "UMPHUMULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "UMQATSHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "UMQONQGOTHO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "UMSIKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "UMSILINGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "UMSINSINI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "UMSUNDUZE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "UMSWILILI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UMTHALA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UMTHUNZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "UMVOLOZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "UMVOZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "UMVULO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "UMZINTO PRIMARY SCHOOL - MAIN ROAD"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "UMZINTOVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UMZINYATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "UMZOKHANYAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "UMZOKHULAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "UMZUMBE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "UNDERBERG SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "UNION PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "UNTUNJAMBILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "UPHANDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "UPHAPHAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UPHISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UPPER MHLATHUZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "USIZOLWETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "USUTHU C.P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UTHANDO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "UTRECHT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "VAN REENEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "VAN RIEBEECK PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "VAVULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "VEGKOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "VELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "VELAKUKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VELANKOSI FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "VELDENVLEI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "VELIMEMEZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VELOBALA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "VERDRIET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "VERULAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "VEYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "VEYISI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "VEZAMAFA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "VEZOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "VEZUKUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "VICTORIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "VIKINDLALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "VIKINDUKU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DR B.W. VILAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "VILLA MARIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VIMBEMSHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "VIMBUKHALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "VIRGINIA PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "VOGELVLEI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "VONDLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VOORKEUR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VRYHEID PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "VRYSTAAT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "VUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "VUKANI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "VUKAPHANSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "VUKAPHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "VUKUFUNDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "VUKUZENZELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "VUKUZIPHATHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "VULAMEHLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "VULEKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "VULELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "VULINDLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "VULINGQONDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "VULULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VUMABAKUSHOYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "VUMANHLAMVU FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "VUMELANI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "VUMOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "VUMUKUKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "VUMUTHANDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "VUSINDABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "VUSISIZWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "VUSUKUKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "VUSUMUZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VUTHELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "W A LEWITT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "WAAIHOEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "WANGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "",
      "School_Name": "WANSBECK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "WARNER BEACH JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "WARNER BEACH SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "WASBANK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "WATERHOEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WATERLOO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "WATERSHED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "WATERSMEET HIGHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "WEENEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "WEENEN PRIMÊRE/WEENEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "WELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "WELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "WELCOME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "WELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WEMBLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Wentworth Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Queensburg Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "WESTLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WESTVILLE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "Westville Senior PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "WEWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "WHEBEDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WHETSTONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "WILDER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WILIWILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "WILLIAM BOOTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "WILLOW PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "WILLOWDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "WINDY HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "WINDYHILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "Winston Park Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "WINTERTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "WITTEKLEINFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "WOLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "WOMBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "WOOD AND RAW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "WOODFORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "WOODGRANGE-ON-SEA-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "WOODHURST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "WOODLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Woodlands Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WOODVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "WOZANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "WOZOBONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WYEBANK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "WYKOM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "THEKELIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "XASANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "XHONYWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "XIMBA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "XOLO XOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Yellowwood Park Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "YIBONI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "YIKUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ZAAIFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ZAKHELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZAKHELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZALIZWI PP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZAMAFUTHI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZAMANI C P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ZAMAZAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ZAMAZISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ZAMELISIZWE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ZAMIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ZAMINDLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ZAMINHLANHLA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ZAMOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ZAMOKUHLE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ZAMUKUZAKHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ZAMUKWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ZAMUTHULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ZAMUXOLO COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ZANDILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZASENGWA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ZEMBENI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ZENZELE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ZENZELENI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ZIBONE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZICABANGELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTANDOKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZIHLALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ZIJUBEZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ZIKHALI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZILULWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ZILUNGISELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZIMELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ZIMEMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ZIMISELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ZIMISELE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZINQUNYANENI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZIQALELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ZISIZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ZISUKUMELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ZITHUTHUKISE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ZITIKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ZIZUZELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ZOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZONDELA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MPONTSHINI FULL SERVICE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "JAMENGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ZUNGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ZUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ZUZIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ZWAKELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ZWANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ZWARTKOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ZWELESITHEMBISO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ZWELIBOMVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ZWELINYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZWELITHULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ZWELIYAZUZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "THENGANI FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PALMVIEW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NDLELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CARRINGTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EKUTHULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "WOZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "EMBONQENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MAYVILLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DUBEYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ZUBANE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THEKWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PHUNGELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NHLOMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ISIKHALISETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MNYANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "IMPOPHOMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "OKHULANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIZAMOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NEW CANAAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "DALTON BRIDGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "CHOTHWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MTHANDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PORT EDWARD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EMNGCWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GRATTON SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MOUNT CARMEL CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PINETOWN SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "JOSEPHINE MAKHANYA PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MARIANNHILL JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BANIYENA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NGOLOSHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ENKANYISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UKUSAKWABASHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UMZAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CAMPERDOWN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EPHUSHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "INKOSENHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KHIPHINKUNZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWANYAMAZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MANDLAZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MBILINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MLAMULI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MNTOKHONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MUNTUYEDWA C P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MVAMANZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MZABALAZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NCOMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NKOMBANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "UBUHLEBESUNDUMBILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UMHLATHUZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "YETHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "QWEMBE COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MTHEKELEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MAKHOSO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KHUPHUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "DINGIMBIZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "AMANDLALATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "FIKESUTHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LINGELETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "PHUMOBALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MAGEBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "UMZIMKHULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NQOBANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SINQUMA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MNDUNDUZELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIBAHLENGEMVELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIKHALELUMUZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAQIYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INKOSI GODLUMKHONTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SICOCO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIBUSISILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "IZINGWELEVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MANZAWAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NHLAMVU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIHOLWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MALANGABI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MFULAWEZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MBALEKELWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MNANDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MDINWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAHLAKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MSHOKOBEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMUNYWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NJINJI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "PHAKAMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EKUTHUKUZENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "JABULISANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KEITSLEIGH SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAMFEMFENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BHANGANOMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "FERNDALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DEUTSCHE SCHULE DURBAN"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "IZULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ZAKHELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MANDLANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GENGESHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MANYONYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MPANGELE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NCULWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTANDOYETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KWA PITELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INHLANGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MALANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NGOTWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIKHETHIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "JULUKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SANQOBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "VELABUSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MVUZEMVUZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ENGALANGALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "INGULULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KHISHWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "Mtunzini Primary School"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MATHUBU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "STABO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LYNFORD SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MPHUNDUMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTABANKULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BHEKABELUNGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "HLUHLUWE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BHEKIZIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MLINDAZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MADLANKALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SILETHIMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ZICABANGELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MABHODLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EZISHABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "QALINDLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MANDAWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DR B. W. VILAKAZI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "IZIPHOZETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "LEE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIYATHOKOZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SUNDUZA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "OLWASINI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIZUMPHAKATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NTOMBAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NKALANENI JONIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MHLABAMUNI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MANZEZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INTATHAKUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "INKUTHAZELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SAGEWOOD PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MARIATROST JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "GEZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "UMCEBOWOLWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTOKOZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ISIKHALISANAMUHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "IMFUNDWENHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ZAMUKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ZAMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MZIMELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MANZAMHLOPHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KHULAMBEDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "INKOLOVUZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MLAMULANKUNZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MANKAYIYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NOBENGELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MAGOJOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "JOEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MNAWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MANGONGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "HARTLEY ROAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "COTTONLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MASWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIBONILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "DUMAZINKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "DLOZILESIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWAQONDILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BHEKIMKHONTO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NONTSHWILIZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BUYANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NEW ERA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NHLAMVANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGUQE P P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NSIKAYEMPILO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KUSAKUSA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LETHITHEMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAQHASHIYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMPUMELELWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ZAKHELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NTSONYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "QUEENKAMATHATHELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "IMPUMELELO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "QUEEN KAMSWELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "IZWILESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MNKUNZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "QALOKUSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "CELIMPILO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "IMVELOYAMASWAZI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIHAMBAKAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAJAJI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MHLAZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGWENYABEYIGWINYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MASOKANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "IMBALIKHONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "OHLALWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MBOPHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MPUNGANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BEN JOBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "DIYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BHOBHOBHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ESIYALWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMADULINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZOMBODE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GWAVUMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ISLAMIA MUSLIM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NKOMO FULL SERVICE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THENGISANGAYE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "HAMBANGOMTHETHO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "RISEN SON ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "OZWELENI PP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NTULUFAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWA-GOQO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SIYABONGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKOSI MBIZOYAMASWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKOSI MBELEBELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INKOSI NHLANGANISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MAKHOYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NODADA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIQALOKUSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THOLULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BAMBISANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MSESHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "GEORGE CALTEX PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VUKUZAME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MFUSHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NDABENHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "FUNDANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIZAKAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SOGODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MGEZENGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MBUSWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MANANJALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SENZELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "JIKANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NSONYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NHLAMBAMASOKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THUTHUKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SANDOKUVELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SISHISHILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NSIMBINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "PHOWANE LP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NGUBUKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SIFULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "HOLLYWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MASHABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWAGASA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ZWANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "THEMBALIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NAZARETH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PLATT DRIVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DURBAN CHRISTIAN CENTRE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "WIGGINS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "QUEEN NANDI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "HIBBERDENE ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EKUPHAKAMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZWELISHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ASIBUYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "LETHIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MANZOLWANDLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIYAPHAMBILI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MASIMDUMISE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CATO CREST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SHANGELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THEMBOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THEMBUMZAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NHLAWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THANDANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "EMTHUNZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BUHLEBUYEZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "BONGINKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GUBHETHUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "",
      "School_Name": "UMMANGALISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BHEKAMAZIMELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MZIMELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIGODO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PRINCE VELESHOWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PHEMBOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NONJINJIKAZI FULL SERVICE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MVULELENI PP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KHANYISANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EYETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GLENWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Al Azhar School of Durban"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MOHAMED EBRAHIM ISLAMIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MOUNT PLEASANT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WESTVILLE HINDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ULUNDI INDEPENDENT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NCEKUYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "JOHN WESLEY SCHOOL - ESHOWE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "AMANDLAKHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NGWENYA MSOMI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ST WENDOLINS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MMOYENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MBANGOMUNI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMAGUQENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SAKHUMUZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MQUBULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EKLOLWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PHUZAMANZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MYEKENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SILETHUKUKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VULAMEHLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EZIBINDINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NOMASHAKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "UBUHLEBEPHUPHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ZWELINJANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIYATHUTHUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "VULINDLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "JABULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MAYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MHLOSHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MYENDANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MELUSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BETHULO P.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KWAVULAMEHLO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MMANGALISO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LANDULWAZI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAHEDENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "WESTBURY PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "JOHN WESLEY KOSI BAY COMBINED PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "LOZI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "LUSIZOLWETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KWENZOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NOPHUNGWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "VUSISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MBONOMUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "UGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "LITTLE DARLINGS EDUCARE CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ASIPHEPHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KWAZIKWAKHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAGUQU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "FINGQINDLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SIPHUMELELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ROCKY'S DRIFT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MATABETULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ULUSDA CHRISTIAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "WESTGATE CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAGUT PRIVAATSKOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NONGWINYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MAGUGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ST FAITHS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIBONGUJEZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "IMBALIYETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MANDATHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MSINDAZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIZANEMPI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGOME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MGOBHOZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ZIBAMBELE CP SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NSUKUMBILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NOMAKHALADI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "TEHILLAH CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ST GREGORY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SINENZUZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NSIMBINI PRIMARY FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DLANGAMANDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SEKUSILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MEHLWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "VS ZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "EZAMAKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIPHESIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ENHLANHLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "HLALUNOLWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SISONKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BAMBANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MZOCHITHWAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SHAYAMOYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THEMBISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIYAPHAMBILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ENJABULWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ZAMOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KING MAGEBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KASTURBA GANDHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "BONGINKOSI CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SUNSHINE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BLOEMFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BONGINCEBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BUHLEBEZWE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "CETYWAYO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EASTLANDS JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "JIRAH SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KAYEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KHAYELITSHA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LENFORD BALENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LUPHONGOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MARANJANA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MASAKHANE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NOKHWEZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NOMEVA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NYENYEZI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "POLANYONI SINIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "QONDOKUHLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SIZAKANCANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ST AUGUSTINE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "STRAALHOEK SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "TEEKLOOF SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "THORNBUSH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "VEZUKHANYO SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "VULINDLELA JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZAKHELE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZAMANI S P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZAMAZELA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZAMOKUHLE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZAMUKULUNGISA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZIBUKELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZIZAMELE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "GRIFFENDORE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "JUST JUNIORS ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DAYLEE INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "QHAWELESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "UMZILA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ELANGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EZIHLABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "FISOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LANDELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MATHENDEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MSAWENKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NKAYISHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NOMAQHULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTABAMHLOPHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTANYANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTUNJENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "OSUTHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "PHUMELA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SIYAMTHANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EGOQWANENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MATHUTSHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "XONGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MOUNT ROYAL COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "FAITH MLABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EMPUMELELWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PHEMBISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ANJUMAN ISLAM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KWANDABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DULINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SICELIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NTABAKHATHAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "UNYAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ITSHELENCWADI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NGQEKWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SINCINTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SOBETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "QAMBOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWASHODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NQUTSHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ZIPHOSHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NGUNGUNYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NONDABUYA PRMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "IKHWEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MANKUNZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MDUMISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "LUHLANGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THULASIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BUZULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SHIYAMPAHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MLINDELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MADWALENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SENZOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "COTHOZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MNKANGALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "",
      "School_Name": "PIETERMARITZ PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ANDREW ZONDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ADVENT HOPE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "HAMILTON PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ZIMELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SAYIZI- NTULI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "TSHELIMNYAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UKUKHANYA KWEAFRIKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "QUARRY HEIGHTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DINUPHOZO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ESIQHINGINI FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "INZUZWENHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "",
      "School_Name": "SODWANA BAY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ROYAL DRAKENSBERG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NONKQUBELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NEW LIFE SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIDINGULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIBONGINTUTHUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMPOLOMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NHLOLAMVULA PRIMARYSCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NYENDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HARPO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "TWINKLE STAR JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAGCEKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VEZUKUKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "VIMBUKHALO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NCUNJANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MBANDLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAWEZULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ELOMO P.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EKUJABULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MTHIYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "PHUMLANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "QALAKAHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAJINDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "GADOKUWAYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EKUWELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GCINUXOLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HLANGANANI P SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PHILIBANA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIYATHUTHUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VALLEYSIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KUBUYAKWEZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTABENDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KHULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ZIZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "JOJINGWENYA P.P. SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "HOLISIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTOMBIYODUMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MNJANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MPUNGANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MZAMOYETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BAMBANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DUMABEMSOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NTENESHANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "CEBELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "W MTSHILO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "NZIMENDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "KHETHOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ITHAMSANQA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "KHANYAKUFIKILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAPHAMBILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CRAWFORD PREPARATORY LA LUCIA"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LELELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SUNRISE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KING CYPRIAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ZIMINGAYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NXAMALALA ISLAMIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "HILLDROP HERITAGE SCHOOL PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ST JAMES SCHOOL FOR GIRLS AND BOYS"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NTOMBOKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NTIKILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "PHANDAPHANSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SHEPSTONE LAKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "CELANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ZENZO JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EKWANDENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MALANDELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "NOMZAMO MANDELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KINGSBURGH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "TERRIE ANN BRIDGING SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "THEMBINKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SAWOMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ITHUBALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "VEZULWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIPHIWAYINKOSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NGULUZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SICELIMPUMELELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "JENS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SHEKINAH CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MAWELEWELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EMAYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "FERNHAM"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INCHANGA MUSLIM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KHETHANI CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THEMBELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HAYFIELDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "WISDOM GATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "CORDWALL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ST MARY'S CATHOLIC SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "IMPUMELELO VICTORY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MORNING SUN ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MZWAMANDLA KHANYILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SOMANTIYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MAQOTHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ENSELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PRINCESS PHUMZILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BUYAFUTHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ITHUBALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "INKOSI JIYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "STEVE DAVISON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MKHAMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NETHEZEKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PRINCE SOMCUBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "HIBISCUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MAKHANYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SOLOMON MAHLANGU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ISIBONGOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "INKOSI NOGOTSHWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MAHLABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NDLONDLOBALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ISEMUKELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SONTO ZIKHALI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "TREE TOPS JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ROSE OF SHARON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMPANGENI EDUCARE CENTRE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SUSAN NGCOBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "LIFE CHANGING CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "INDAWANA EDUCATIONAL INSTITUTE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SINGAYO-IMFUNDO PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "POWER OF LOVE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "JENS SENIOR PRIMARY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MUDEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "THE LEARNING TREE ACADEMY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GMCI SCHOOL OF EXCELLENCE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ISIFISOSIKAYISE PRMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HAMPTONS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SIBONGINHLANHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MIRACLE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "KWANZIMAKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "QUEEN THOMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MANKULUMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MBONGELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SICELIMPILO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VICTORIOUS INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ANGELS ACADEMY NEWCASTLE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "HIS GRACE AND MERCY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "",
      "School_Name": "ST ANDREWS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "JOHN WESLEY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIYAPHEMBA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HILTON PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MOUNT CARMEL CHRISTIAN SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CORDWALLES PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "PRINCE ALFRED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EPWORTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NEW HANOVER PREPATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ELANGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GATEWAY CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THREE OAKS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "LITTLE AMBASSADORS COLLEGE"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CLIFTON PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KING'S SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "TREVERTON PREPARATORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KING'S KIDZ SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "CAPSTONE CHRISTIAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "PHAROS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MARJORIE PARRISH SANTA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "P E MUSEUM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "LIVINGSTONE HOSPITAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ST ANDREW'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "VICTORY J-BAY CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "KLOOF COTTAGE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KOWIE FOUNDATION PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NOMVUME JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "Dreamland Primary"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MXESIBE HOSPITAL SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "OR TAMBO COASTAL",
      "School_Name": "TINY TOTS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KAT RIVER VALLEY MONTESORY"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BEDFORD COUNTRY SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ST LAWRENCE ENGLISH MEDIUM SCHOOL"
    },
    {
      "Phase_PED": "PRIMARY SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ROHOBOTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LERALLA IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BODIKELA I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "CLARENS I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KHANYENG I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TSHEPANO III I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LK NTLABATHI I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KGOTSOFALO IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ACCELERATED CHRISTIAN COLLEGE II/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LEGAE I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MABEOANA I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "NTEBALENG I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KATAMELO I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MMULAKGORO I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MONOKOTSWAI I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "NTEBOHENG P/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "PROSPECT IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "MATSHEDISO I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "SEKGWENG IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "VETRIVIER IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LAMBERTINA IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LEA MANOR IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "TSWELAPELE KA THUTHO I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "RAMAFUTSANA IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TSHEBEDISANO IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "HAMMONIA IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "FOURIESBURG I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "INTABAZWE I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MPHOPHOMO C/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "NHLAKANIPHO I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "EERAM IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "ROOIKOP IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KOPANANG-HLANGANANI"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ONS ANKER IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "HOLPAN I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "OPPERMANS I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "EDENVILLE I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KOPANO ITHUTENG II/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "SCHONKENVILLE I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "TUMELANO IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "BERGMANSHOOGTE I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "REATILE I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "NALEDI I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TUTUBOLOHA I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "REHOTSE I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "PAUL ROUX I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MASERONA I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KEIKELAME I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "VIERHOEK IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "VENTERSBURG I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "EKWALUSENI CATHOLIC II/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "UITZIEN IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "CHRIS VAN NIEKERK I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KOREA IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "GELUKWAARTS IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "EBENHAESERHOOGTE I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SEANAKWENA I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "HLATSENG I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KGOTSONG P/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KARABELO I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAMOSA I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MONONTSHA I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LESAOANA I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "DITHOTANENG I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MOHALE P/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "PHIRI I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "THIBELLA I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TSHWARA-THEBE I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KOOS MOTA I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "PHETA I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAPEKA I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MATSWAKENG I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAKWANE I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TSWELANGPELE I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "QHOLAQHWE I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "DIQHOBONG P/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MANGAUNG I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAKONG I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MABELA C/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MADIBOHO I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MPHATLALATSANE P/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MANTSHATLALA I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "TEBANG I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "AKOFANG I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MAFUBE I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "PHAHAMENG I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "QWAQWA C/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BOLATA I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KHOTHALANG C/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BOITSEBELO JUNIOR TECHNICAL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "THAROLLO I/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "BOKAMOSO/IKAMVA IF/S"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BETH JACOBS GIRLS' HIGH SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "THE JAPANESE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "YESHIVA COLLEGE OF SOUTH AFRICA"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ST MARY'S COLLEGE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "THE WALDORF SCHOOL AT ROSEMARY HILLS"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "VILLAGE MONTESSORI HIGH SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRO-ED PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "ALTHEA INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MAGALIESBURG GROUP OF SCHOOLS"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "JOHN MARTIN CATHOLIC SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "H.I.S. SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "DIDASKOS CHRISTELIKE PRIVATE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MATIWANE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "SINQOBILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "HOPE CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "NEW GENERATION PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "PHAKAMANI EDUCATIONAL CENTRE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "THE JOHANNESBURG CHEDER"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "EDUPLEX COMBINED SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PIERRE VAN RYNEVELD CHRISTIAN ACADEMY INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "EXCEL CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KHAYALAMI INDEPENDENT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "EAGLE HOUSE LEARNING CENTRE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "AFRICAN UNION INTERNATIONAL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "EVELINE INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "NOOITGEDACHT AKADEMIE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "EASTRIDGE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "ST JOHN'S CONVENT SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "CURRO ROODEPLAAT"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "RANDFONTEIN CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "GRACE TRINITY SCHOOL FOR GIRLS"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "WATERSHED TECHNICAL SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MIDRAND CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "EDU EXCELLENCE PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "STAR COLLEGE PRETORIA"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LEARNWRITE CC INDEPENDENT ASSISTED LEARNING"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "NEW HARVARD ACADEMY"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "NIZAMIYE PRIMARY & HIGH SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "REDDAM HOUSE WATERFALL ESTATE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "EDU-CLINIC LEARNING CENTRE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "DIOS LOS NINOS"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BELLEVUE PRIMARY AND HIGH SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "KHAIROS PRIVAAT SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ZEROWA CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "EXCELSIOR LEARNING CENTRE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "SEKGWENG"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MYAKAYAKA"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "PHYUPHYANI"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MAGEZA"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SERARE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NTOTA"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SEGOLOKWANE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KOLOFANE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "F.K. TJIANE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TLOU-KWENA"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "FAWCETT MATHEBE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RAMAGOHU"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BUHLEBUZILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "DIKGABO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "DIKOTELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ELUKHANYISWENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EMTFONJENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "FUNDUKHUPHUKE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "GOODWIN MALOKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "IKAGENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "CHRIS HANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LIBANGENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAPALA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAQHAWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MARIDILI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MBEDLWANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MBUDUMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOLEBYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOLOTO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MORWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MPOKO MALOKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MZAMO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NDABEZITHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NDEDEMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NGAZANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PHANAGELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIBAMBISENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIBUSISO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIKHULISIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SILINDILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SINDAWONYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIPHIWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIPHUMELELE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SITHOBELANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIZAMAKWETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SOKAPHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SOTHEMBANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THABANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THOKOZANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "UKUKHANYA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VEZUBUHLE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VUKANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VULAMEHLO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ITSOSENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EDWALENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ALEX BENJAMIN SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MKHONDO HOUSE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CURRO SECUNDA SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NEW - DAWN PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "PRESTIGE SCIENCE AND COMMERCE ACADEMY"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "BONGANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "ULCO ACADEMY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "IKAGENG INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "SCHMIDTSDRIFT BATHLAPING INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "FUTURUM AKADEMIE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "HOËRSKOOL RIVERSIDE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "LOUISVALE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "SHILOAH ACADEMY"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "DANIËLSKUIL INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "CVO KALAHARI SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "OLEHILE MANCHWE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "REITLAMILE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "AB KOLWANE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "PORT NOLLOTH (RK) INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "MATJIESKLOOF RK INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "ST PHILOMENA INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "PELLA (RK) INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "VICTORIA-WES INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "LOWRYVILLE INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "EUREKA INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "NORVALSPONT INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "UMTHOMBO WOLWAZI INTERMEDIATE FARM SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "VLUGFONTEIN INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "VAN WYKSVLEI INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "SONSKYN INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "MÔRESON INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "AALWYN INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "GRIQUATOWN INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "PLOOYSBURG INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "JJ ADAMS INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "AUGRABIES INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "CILLIE (NGK) PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "BLAAUWSKOP (RC) INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "KEIMOES (RK) INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "MÔRELIG INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "NEILERSDRIFT INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "KENHARDT INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "LUTZBURG (SSKV) INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "FRANK BIGGS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "KAROS INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "KALKSLOOT INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "LEERKRANS INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "VOORUITSIG INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "FRANCISCUS INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "ORANJE-OEWER INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "ROSENDAL INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "KEIDEBEES INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "TOPLINE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "JG JANSEN INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "BRANDBOOM INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "GROOTDRINK INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "STERNHAM INTERMEDIËRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "DIE KUIL INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "ZINGISA NO 1 INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "BARKLY WEST HIGH SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "DELPORTSHOOP INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "STILLWATER INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "GN PRESSLY INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "TLHATLOGANG INTERMEDIATE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "ROLIHLAHLA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "SISHEN INTERMEDIATE MINE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "MOTSWEDITHUTO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "REAIPELA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "CW KIES INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "TADCASTER INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "ER MOCWALEDI INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "VOLOP INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "SAAMSTAAN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "VAN ZYLSRUS INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MAMASILO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GATA-LWA-TLOU INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "JUMBOLANI INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "REEBONE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "OARABILE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GADIBOE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KHUIS INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BOSHENG INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "REAITEKA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "THUSEGO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "DITSHIPENG INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "RAPELANG INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MATSHANENG INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MONOKETSI INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KOPANO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "COLSTON INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MOTSHWARAKGOLE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "TSELANCHO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GAHOHUWE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "OLEBOGENG INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "TONGWANE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "BOSELE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GASEBONWE JANTJIE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "TSAELENGWE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MAMORATWA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "GAMOHANA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "TSHIMOLOGO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "VLAKFONTEIN INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "MAIKAELELO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "IKETLELETSO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "CRESCENT PRIMARY SCHOOL NPC"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "CARNEGIE HOUSE PREPARATORY"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "AL-HIDAAYAH COLLEGE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "CURRO BRACKENFELL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "JUNIOR CAMPUS PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "LOVE WALK CHRISTIAN ACADEMY PRIMARY"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "EKUKHANYISELWENI CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "SLIMKOPPIES PRIVAATSKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "CLEVER KIDS LEARNING HUB"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "THE PEBBLES PROJECT TRUST"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "LAWRENCIA PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ALPHA PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ABEILLE RUCHE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ZIMASA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "AUBURN HOUSE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "KUYAKHANYA PRIMARY"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "HOPOLANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "NOMLINGANISELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "HLENGISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "IMBASA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MZAMOMTSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "ALOE JUNIOR HIGH SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "GIHON CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WELLINGTON PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "L.K. ZEEMAN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "CHARLESTON HILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BERGENDAL SSKV PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "GREYTON HOUSE INDEPENDENT VILLAGE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "BOTRIVIER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "RIVIERSONDEREND PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "BISSETSDRIFT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "SLANGRIVIER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "B.F. OOSTHUIZEN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "SUURBRAAK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ROSEMOOR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "FRANKEN VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "RHEENENDAL PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "OKER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "MELKHOUTFONTEIN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "EXCELSIOR VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "TOWERKOP PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ZOAR R.P. BOTHA VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "DIRK BOSHOFF PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MORRISDALE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BOY MULLER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DIE EIKE VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "PAARDEKLOOF NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "LAASTEDRIF NGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "W.A. ROSSOUW PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ASHBURY PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "VERGESIG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WAKKERSTROOM-WES PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MCGREGOR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "LE CHASSEUR VGK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "LANNER HOUSE"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "DE TUINEN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WORCESTER RK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "HOPEFIELD PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "RIEBEECK-WES PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "VOORUITSIG PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "AURORA HOËRSKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "PORTERVILLE PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "STAWELKLIP MOR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "NOORDHOEK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "ST. HELENABAAI INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "JURIE HAYES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "LAURIE HUGO PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "P.W. DE BRUIN PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "WUPPERTHAL MOR PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "NIEUWOUDT PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "RIETPOORT RK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "ST. BONIFACE (RK) PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "EBENHAESER PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "UITKYK PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "GEORGE FREDERICKS PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "LEEU GAMKA PRIMÊRE SKOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "A.G MALEBE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BANOGENG MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BOSKUIL COMBINED SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MOGOSANE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Moubanamotsei Primary School"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "ZAKHELENI INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BONGUCELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ILEMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIKHULANGEMFUNDO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SOMPUKWANE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "IKHANDLELA HIGH SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GWEJOBOMVU S.S. SCHOOL"
    },
    {
      "Phase_PED": "INTERMEDIATE SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MASAKHANE GIRLS' SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KATE VAN DER MERWE PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HAPPY HOURS PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "CONVENT PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KLEUTERLAND PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HEIDI PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ROSARAY PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "FANIE THERON PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "WALMER PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SUNRIDGE PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NEWTON PARK PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "LINKSIDE PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "KABEGA PARK PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "HAAS DAS PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "GATEWAYS PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DOLFYNTJIE PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BEACHWOOD PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "SEEMEEU PRE-PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "ECD",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "DOROTHY TOMLINSON PRESCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "RETIEF C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BETHLEHEM C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "PELLISSIER C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "CALCULUS BLOEMFONTEIN CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "OUR FATHER'S ACADEMY CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "MARYVALE CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "RIDGEFIELD ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ADLAUDEM CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "DR VILJOEN C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "CASTLEBRIDGE CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "BAINSVLEI C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "PRESIDENT STEYN C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ST ANDREW'S C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "ST MICHAEL'S C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "CHRISTIAN BROTHERS COLLEGE CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "DANKBAAR CVO CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ARAMELA C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "BOSHOF C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "SENZILE C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "BOVAAL C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "SETJHABA-SE-MAKETSE C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "KAGISANO C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "REFIHLETSE C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "STAATSPRES. SWART C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "HANOVER CF/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "BULTFONTEIN C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "CHRISTIAAN DE WET C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "EDENBURG C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TWEESPRUIT C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "EXCELSIOR C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "LUCKHOFF C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "KING'S CHRISTIAN II/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "BREDA CF/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "TWEELING C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "VILLIERS C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "WILGERIVIER C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "SIBONAKALISO CF/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "DIRKIE UYS C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "HARRISTON CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "HARRISMITH CHRISTIAN ACADEMY CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "SANDERSVILLE C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "HEILBRON C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "HOOPSTAD C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "IKANYEGENG C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "PANORAMA C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "BOARAMELO C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "JAGERSFONTEIN C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "KOFFIEFONTEIN C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "DIAMANTHOOGTE C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "SAREL CILLIERS C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "CALCULUS KOLLEGE CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "KROONSTAD AKADEMIE CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LADYBRAND ACADEMY CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "YESHUA COLLEGE CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "EZEKIEL CHRISTIAN CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "STEYNSRUS C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "DIKAIOS CHRISTIAN (ACE) CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "MARQUARD C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "AJC JOOSTE C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "PETRUSBURG CHRISTIAN ACADEMY CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "ORANJEKRAG C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LEIFO IZIKO C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "REITZ C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "REITZ CHRISTIAN ACADEMY CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "VAAL CHRISTIAN CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "SCHOOL OF DESTINY CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "LIBERTAS CF/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "CARITAS COLLEGE CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "DIEPFONTEIN CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "RELEBOHILE SIBULELE C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "TLOTLANANG C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "THEUNISSEN C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "PT SANDERS C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ELKANAH CHRISTIAN CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "SALOMON SENEKAL C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "VREDE C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "GLODEL ACADEMY II/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "DUNAMIS CHRISTIAN CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ED-U-COLLEGE Welkom CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ST DOMINIC'S COLLEGE CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ST ANDREW'S CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "RHEEDERPARK C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "KINGDOM ACADEMY CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "WELKOM ISLAMIC CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "EDMUND RICE CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "LOUW WEPENER C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "ITOKISETSENG CF/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "SANDVELD C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "LEJWELEPUTSWA",
      "School_Name": "WINBURG C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "XHARIEP",
      "School_Name": "ZASTRON C/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "CURRO BLOEMFONTEIN CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "NOTRE DAME ST PETER'S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "DEVINE CHRISTIAN ACADEMY CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "KYRIOS CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "MOTHEO",
      "School_Name": "AURUM SEVENTH-DAY ADVENTIST ACADEMY CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "FOUNTAIN OF KNOWLEDGE ACADEMY CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "THABO MOFUTSANYANA",
      "School_Name": "NEW HORIZON COLLEGE CI/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Free State",
      "District": "FEZILE DABI",
      "School_Name": "JCS IC/S"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ADELAIDE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "AL-AZHAR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ALEXANDRIA HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ARCHIE MBOLEKWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "BEDFORD JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "HAPPY HOME ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "BLUELILIES BUSH PUBLIC JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "URBAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "CLARKSON JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "COLDSTREAM JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "COLLEEN GLEN FARM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "VICTORY LEADERSHIP ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "EL SHADDAI CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ED-U-COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GCINUBUZWE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "EDUPLANET INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "GRAEME COLLEGE BOYS HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "HARVEST CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HENDRIK KANISE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HOëRSKOOL JANSENVILLE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HOëRSKOOL McLACHLAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "WINGS DISCOVERY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "JOUBERTINA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KAREEDOUW JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "IKAMVA LESIZWE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KIRKWOOD HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KRAKEELRIVIER JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KUYASA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LOERIEHEUWEL JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LOUTERWATER JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "LUXOLO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "MISGUND (DRC) JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "MUIR COLLEGE BOYS HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "NEWTON (UCC) JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "NOMPUCUKO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "CVO OMEGA AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HOëRSKOOL P J OLIVIER"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "PORT ALFRED HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "PORT ALFRED JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "RIEBEEK COLLEGE GIRLS HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "RIEBEECK EAST COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ROCKLANDS INTERMEDIATE FARM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "SHAW PARK COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ST ALBANS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ST JOSEPH'S JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "TEMPLETON HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "THORNHILL COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ST DOMINIC'S PRIORY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "UNION HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "VUKANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "WESTON JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "WILLOW ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "YELLOWWOODS FARM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ZUNEY INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "THEODOR HERZL HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "HOëRSKOOL PAUL SAUER"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "FOUNTAIN OF LIFE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BRYLIN LEARNING CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ST MARKS COMMUNITY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "ELSEN BRIDGING SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "AMADEUS INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "INSIGHT LEARNING CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "NASRUDDIN ISLAMIC HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ALICE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BEACONHURST SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "CHARLES MORGAN PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ADVANCE LIFE CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "DAVIDSON PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "EAST LONDON SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "GERMAN VILLAGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "GWABA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "HEBRON JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "HOëRSKOOL DE VOS MALAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KINGSRIDGE HIGH SCHOOL FOR GIRLS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KEI ROAD COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "HOPE SCHOOLS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "KOMGA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "KUBUSIE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "LILYFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ARISTON CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BEN COX ENGLISH MEDIUM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "AMITEC BUSINESS COLLEGE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BELLAFIDES PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MZAMOWETHU PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "NONCEDO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "QWALASELA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SIBONELELO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "ISIHOBOTI PUBLIC COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SMILING VALLEY COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "SOTO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "STUTTERHEIM HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "WEST BANK HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "WILLOW PARK JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "BAY CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ALTHORPE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "REDWOOD COLLEGE GONUBIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "MERRIFIELD PREPARATORY SCHOOL AND COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ST CHRISTOPHERS PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "WESTBANK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ABBOTSFORD CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "FAITH REVIVAL CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "CENTRE OF EXCELLENCE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "TELEIOS CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BEECHAMWOOD JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "EBENEZA CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "CAFUTWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "CALEY JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "CEBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "COLLYWOBBLES JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "COLOSA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "CUNGCWINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DABULAMANZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DALE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DALUXOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DALUXOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DAVIES JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DIVINE MASTER ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "EMPUMALANGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "EMQHAPHINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ESINQUMENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "FALAKAHLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "FORT BOWKER JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GAQA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GCINA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GEM JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GQUNQE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GXOJANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "HLABIZULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "IBIKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "IDUTYWA RIVER JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "PENTECOST GENIUS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JAMES NGUZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JEKEZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JOJWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JONGINTABA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KETI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KHULILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KOBONQABA MOUTH JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KUNENE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "KUYASA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LANGALETHU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LAZA MAKHAKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LENGENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LINGELIHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LOTA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LOWER NQAMAKWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LOWER NQANCULE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LUDONDOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LUKHANYISO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LUNDI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LUZIPO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MADAKANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAGALAKANGQA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAHLIWANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAKI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAMFENENI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MANQOBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAPASA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAVATA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MBASA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MFEZANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MGCWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MHLABENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MNANDI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MNDUNDU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MPIKWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MTOMBOTI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MTYAMDE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MUNYU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MZAMOMHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MZIMKULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NAKI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NCAPAI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NDABAKAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGONYAMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGQAQINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGUBETOLE BAM JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGUDLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NO-HOLLAND JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOBANDA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NQAMAKWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NQUBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UKHOZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NYUKILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "PATRICIA NOAH JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QEQE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SANGO NTSALUBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "S W MBANGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SEZELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SIHLABENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SIJADU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SITUNZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SIZINI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SOBEKWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TALENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TEMBISA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "THOMPSON JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "THORNVILLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TIYO SOGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TOBOTSHANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TOBOYI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TSHONGWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER CEGCUWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER FALAKAHLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER MTWAKU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER NGCULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "UPPER NOFOTYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "UPPER QUTSA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VUKUKHANYE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VULINDLELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VULINDLELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VULITHUBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "XABAJIYANA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "XOBO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZAKHELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZALU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZANOKHANYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZIWUNDWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZIZAMELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ZWELAKHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MAYEKISO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TYEKELEBENDE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TSHWATI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TEKO SPRINGS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOTINARA TECHNICAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MNGEKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GOVAN JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NTLAHLANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QOLORA BY SEA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BUTTERWORTH HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "UPPER MBULUKWEZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MPOTULO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GCIBALA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGUNDUZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BONGWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BLUE-SKY JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "FLOWER JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BUSY BEES JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LITTLE ANGELS SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "RAINBOW PREPARATORY ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MIDA SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BETHEL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "EMMANUEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "CANAAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KWASA ENGLISH MEDIUM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "HIGHVIEW COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GOOD HOPE COMMUNITY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "FIRST STEP MONTESSORI BUTTERWORTH"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "AMAMBALU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BACELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BAFAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BAJONGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BANTINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BANTWANANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BASHEE JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BEKABANTU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BEKISIZWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BENSILE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SAKHISIZWE (BIJOLO) SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BIZANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BOLENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BOLOTWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BONGWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BUCULA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BUJE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BUNTINGVILLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BUTO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BUTULO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BUWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BUZONGOMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "CAGUBA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "CENTULI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "CHIZELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "COZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "CWEBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "CWEBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DALAGUBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DALIBUNGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DALIGQILI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DARABE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DEEP LEVEL JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DIDI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DIKELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DIKELA SPRINGS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DIKISHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DIKO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DILIKILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DININKOSI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DINIZULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DOKODELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DUKATOLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DUMANENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "DYABA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "J TYALI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "ELLIOTDALE VILLAGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ELUCWECWE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ELUDIKIDI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ELUHEWINI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ELUNYAWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "EMPA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "EMVILO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ENDUKU PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ESIKWAYINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ETYENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "FAMENI JUNIOR SECONDARY & TECHNICAL SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "FRANK MOSHESH JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "FUTYE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GABAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GADUKA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GASA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GAVIN JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GCUWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GEYA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GOBIDOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GOBINDLOVU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GOBOTI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GODINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GONYA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GQUBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GUBENXA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GULANDODA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GUNGQWANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GUNGUBELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GUQAZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GUSI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "GWEBINDLALA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GXIDIDI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GXULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "HLAMVANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "HOBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ISILIMELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ITOMBO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "JALISA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "JOKWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "JONGIBANDLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "JONGINTABA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "JONGISIZWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "JONGULWANDLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "JONGUXOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KALALO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "KANGISA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "KASA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KAULA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KHANYISA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "KHOHLOPONG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KUBUSIE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KWAAIMAN JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KWELERANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "KWEZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LIBODE VILLAGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LOWER BOLOTWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LOWER ESINXAKU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LOWER GODINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LOWER GQOBONCO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LOWER MNYOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "Mdunyelwa Ngwityi Primary School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LOWER NGQWARA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LOWER QEBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "LUBANZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUDAKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LUGXOGXO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LUKHANYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUPAPASI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUTATWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUTAWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUTHOLI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUTSHEKO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUTUBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LUTUTU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUVELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "LUXENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LWANDILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MABANDLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MABEHANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MABETSHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MACLEAR HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MADONISI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MADOTYENI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MADWALENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAGADLELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAGANISE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAGCAKINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MAGOPENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MAJIJA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAJOLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAKAZIWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAMFENGWINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MANCAM JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MANDLENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MANDLOVINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MANGANYELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MANGQOBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MANZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MANZIBOMVU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MANZIMDAKA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MAQANDA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MASIKULENATHI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MATANDELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MATOKAZINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAXAKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAYIBENYE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MAYNARD SIGIDI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MBANGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MBANYANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MBENENGENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MBOLENI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MBOLOMPO COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MBONISWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MBOZISA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MDABUKWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MDEDELENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MDENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MDIKANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MDLANKOMO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MDUMAZULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DE LA RAY MKATSHWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MEVANA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MFABANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MGUNGUNDLOVU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MHLABUZIMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MHLWAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MILLER JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MJOBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MKANKATO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MKANZINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MKATAZO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MKUNDLU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MLAMLI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MNDWAKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MNGAZANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MNGAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MNGCIBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MNQABE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MONTGOMERY STATE AIDED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MOYAKE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MPAFANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MPAKAMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MPAKO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MPAME JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MPANGANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MPIKELELI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MPINDWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MQAKAMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MQANDULI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MQANDULI VILLAGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MQELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MQOBISO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MQOKOLWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MQONCI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MSINTSANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MSINTSINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MTAKATYE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MTAWELANGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MTETELELI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MTHOMDE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "MTSOTSO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MTYU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MZIMKHULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MZOMHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MZONGWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NDLUNKULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NCAMBEDLANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NCIHANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NCIPIZENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDEVU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDIMAKUDE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDINDIMENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDLUMBINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGANGENYATI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGAVUNGAVU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGCACU PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGCANASINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGCATARU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NGCELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGCENDUNA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGCWANGUBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGIDINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGQAKAYI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGQATYANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGQELENI VILLAGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGQONGWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGQUNGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGQUQA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGQUTURA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NGQWANGELE JUNIOR SECONDARY & TECHNICAL SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGQWANGI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGUBECHANTI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NGXAKOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGXANGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NGXAZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGXEBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NJIVENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NJONGOZABANTU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NKALANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NKAUKAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NKONDLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NKUNYANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NKWENKWANA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NOHLUTHA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOHOKOZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOMADOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOMANDI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOMANDLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOMCAMBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NONESI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NONTSWABU PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NOTHINTSI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOTINTSILA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NOWONGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NQAYIYA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NQWATI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NTABA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NTABASIGOGO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NTABODULI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTAPANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NTEKELELO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NTIBANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NTIBANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTILINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NTILINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTLAMBELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTLAZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NTLELELENGWANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTSHILINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTSHONGWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTSIMBINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NTSINGIZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTSONYINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTSUNDWANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NTYWENKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NXAMAGELE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NXELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NXUKWEBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NYANDENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "NYANGILIZWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NYIBIBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NZWAKAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "OLD BUNTING JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "PANGINDLELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "PATISANANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "PATO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "PAZIMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "PAKAMISA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "PONDOMISENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "PORT ST JOHNS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "POSWAYO PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "PUTUMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "QANDA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "QANQISO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QATYWA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "QEBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "QITI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "QOKAMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "QOTA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "QOTONGO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "QUMBU VILLAGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "QURANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "QUTUBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "RAINY JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ROMAN CATHOLIC JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ROSEDALE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "RUZE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "RYNO STATE AIDED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SAKELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SANDILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SHINIRA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SHOLORA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SHUKUNXA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SICAMBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SIGOYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SIKOMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "SIRUNU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SITANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SITONGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SITOLENI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SIZANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SOMERVILLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MHLONTLO COMMUNITY COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TAKATA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TEKWINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "TONGANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "TSHAPILE PS SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TSOLO RESIDENCY JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TUNGWANA PS SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TUNGWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TWALIKULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TYALARA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "UGIE HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UMTATA COMMUNITY JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UMTENTU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "UPPER ESINXAKU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "UPPER GQAGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "UPPER MATANZIMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UPPER MPAKO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UPPER NGQUNGQU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UPPER NGQWARA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "VINISH JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "VUKANDLULE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VULINDABA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "VULINDLELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "VULINGCOBO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "VULISANGO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "WELESE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "XORA MOUTH JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "XUBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZAMDOLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZAMUKANYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ZANDISE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZANENGQELE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZANOKHANYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZANOKHANYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZINKAWU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZINKUMBINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZINTONGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LANGALITSHONI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZWELAKHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZWELAKE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZWELIDUMILE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZWELILUNGILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZWELINZIMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZWELIXOLILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAGOZENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UPPER ZIMBANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NGXOTO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAFINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MSELENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MOYENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ZANCI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GWEBINKUNDLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "PHEZUKWEWILO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "CIBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ENKALWENI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MJALISWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NTABELIZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "WHEATLANDS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "EXCELSIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "INXU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "BAMBANANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MPANDELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "CHOLAPHANTSI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "DALUBUHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "CIBINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TANTSEKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "kwaNTSHUNQE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "DALIBANGO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ELLIOT HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "THWALUPHAHLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "GLADYS KING JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UMTATA CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "MODEL PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "KHANYA PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "WONDERLAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SIVIWE BUSO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "HOLY CROSS KIDDIELAND"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "SIYALAKHA CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "TYLDON SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "UMTATA INTERNATIONAL SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MT FRERE COMMUNITY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ST JUDES PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LIBODE PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "VICTORY CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BAGQOZINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BAKALENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "BALENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BATLOKOA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BETHEL JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BIKITSHA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BISANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BLORWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BODWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BOMVINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "IKHWEZI LOMSO EDUCARE CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BUFFALO NEK JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BUHLAMBO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BUNGENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "BUSHULA'S JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "BUTTVILLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "CABA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "CABAZANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "CACADU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "CANHAMS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "CETSHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "CETYWAYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "CHEVY CHASE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "CLARKVILLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "COLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DEDELO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "DIAMOND JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DILIZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DINWAYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "DUDUMENI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DUMELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "DUMEZWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "DUNGU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "DUTYINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "DYIFANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "EBENEZER JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "EBUCHELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "EBUHLANYANGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "EDWARD'S HOPE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "EKUPUMLENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ELITYENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ELUKHANYISWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "EMABHEKUTENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "EMANGQUZU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "EMANTLANENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "STELLA SIGCAU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "EMDENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "EMDIKISWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "EMTAMVUNA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "EMYEZWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "EMZENGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "EMZINTLAVA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ESIGODLWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ESIGUBUDWINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ETHRIDGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "EZIZITYANENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "FLETCHERVILLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GABAJANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "GALATYENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GCINILIFU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GEORGE NTANTA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GINGA'S JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GOQWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GOSO FOREST JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GULENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GWEBINKUMBI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "HARDENBERG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "HERTZOGVILLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "HILLSIDE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NOMATHEBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "HLABATHI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "HLOMENDLINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "HLWAHLWAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "HOMBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "IMFOLOZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "INTSINGIZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "IXOPO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "JONGIKHAYA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "KANTOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "KANYAYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "KETEKETE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "KHETANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "KHASHULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "KHOTSO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "KHUMBUZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "KUEBUNG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "kwaDICK JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "kwaDIKO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "kwaMSIKWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "kwaNIKWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "kwaZIZAMELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LAMEKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LINDOKUHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LIPHAKOENG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LOWER MNCEBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LOWER MZENGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LOWER NXOTSHANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LOWER THOKOANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LOWER TSITSANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LUCWABA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LUDEKE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUDEKE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUDIWANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUGELWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LUGWIJINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUJECWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUKHANYISWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUNDZWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUNGELO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUQOQWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUSIKISIKI VILLAGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "LUSIZINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUTSHAYA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUVUYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LUZIE DRIFT JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUZUPU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MABOFU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MABUTO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MADWAKAZANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MAGEDLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAGOBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MAHAHA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAHAMANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MAHEMENG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MAHANYANENG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAKHAOLA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MAKUATLANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MALANGENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MALI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MALIWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MALUBALUBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MALUTI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MALUTI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MAMONTOELI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAMPONDO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MANGOLOANENG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MANGOLONG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MANGUZELA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAPFONTEIN JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MAPHELENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MARWAQA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MATAFANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MATEKO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MATHOLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MATSHONA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAZENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MBAYI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MBOKAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MBONGWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MBOTYI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MCELU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MCETENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MCUBHANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MDABUKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MDELWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MDINGI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MDLANKALA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MECHAELING JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MEYIWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MFINIZWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MFUNDISWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MGANO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MGEZWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MGWEDE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MHLABI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MHLELENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MHLONTLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MJANYELWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MKANKOMO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MKETENGENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MKHUHLANE-KOP JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MKHUMBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MKHONQO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MKUMBI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MNDELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MNEKETSHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MNGUNGU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOMBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MOROKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MOSANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MPUMAZE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MQENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MSWAKAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOUNT AYLIFF HOSPITAL SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ROSELAND PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MT ZION JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MTAMBALALA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MTIMDE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MTUKUKAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MVALWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MVIMVANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MWELO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MXOKOZWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "MZAMBA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MZIZANGWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MZWAKAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NALEDI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NCINIBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "NCUMBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDABANKULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NDAKENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NDAYINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NDILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NDUNGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NELSON SIGCAU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NGCABHELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGCAKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NGOLILOE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NGUSE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGWENYENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGXAMBANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NJOMBELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NKODUSWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NKOZO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NKQUBELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NKUNGWINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOMATHEMBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOMVALO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOMZAMO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NONKONYANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NONTLANGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOQHEKWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NORATSHAZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NOBUHLALI SIGCAU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NGQWABENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NTABAZIJONGENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTABEZWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTAFUFU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NTLAKWE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NTLALONTSHA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NTLAMVUKAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NTLANGANO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NTLENGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NTLOZELO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NTSIMBINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "NTSIZWA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "HLANGANISA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NYAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NYOSANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "NZAKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "PAKAMANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "PALMERTON JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "PHAHAMANG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "PHAMOTSE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "PHIRINTSU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "PLANGENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "POLOKONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "PONTSENG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "QAKATISA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "QANDASHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAMJOLI SIGCAU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "QEBEDU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "QUKANCA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "RED HILL JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ROCHDALE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SACRED HEART JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SEMENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SETAKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SICHWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIKHEMANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIPETU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SIRHOQOBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SIWALI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SOLOMZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SPRINGSIDE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ST ANDREWS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ST DENIS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ST THOMAS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "SWANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TANDIZULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "TAUKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TEMBELITSHA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TONTI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "TSAWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "TSOELIKE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "TSOLOBENG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "UMFANTA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "UPPER TSITSANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "VALINGOZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "VANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "VELLEM JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "VUVU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "VUYISILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "WAYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "XAKANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "XHAKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "XOLOBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "XOPOZO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "XURA VIEW JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "XURANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZAKHELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "ZAMOKUHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZAMOKUHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZAMOKUHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ZANYENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZWELITSHA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ZWELIVUMILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "NGCINGO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "EMCETENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LOWER KETE-KETE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MAMPELAZWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "ENDULINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LUPILISWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MOUNT AYLIFF JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BROOKSNEK JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "SUPERKIDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "HOLY ANGELS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "LITTLE EDEN JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ZANOKHANYO BAPTIST SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "ROSELAND PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "ST MONICAS DIOCESAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "BERGVIEW COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "CEDARVILLE PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "KHANYA-NALEDI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "KING EDWARD HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "MATATIELE PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "FOCUSED COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO WEST",
      "School_Name": "SUNSHINE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "LUSIKISIKI CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "GEORGE HAMILTON"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "SUNNY-SIDE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "ALFRED NZO EAST",
      "School_Name": "BIZANA CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "B B MDLEDLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BAMBOESPRUIT JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BANGILIZWE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BANKIES JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "BAZINDLOVU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BHONGOLETHU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BIKIZANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "PLUMBLINE CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BOMENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BOQO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BOZWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BRAKKLOOF JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BUFFALO THORNS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "BURGERSDORP JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "BUYOKOYOKO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HIS GRACE CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "CATHCART HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DALUBUHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "DIBINKONZO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "DORDRECHT HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "DULI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "EMAQWATINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "EMZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ENTSIMEKWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ESILINDINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "FEZEKILE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "FOREST RANGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "GCINA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "GLEN ADELAIDE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "GOVERNOR'S DRIFT JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "GQEBENYA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GQOBOZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MATSHONA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "HLOMENDLINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "HOëRSKOOL BARKLY EAST"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HOFMEYER JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "HOLI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "HOTA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "HOWARD BEN MAZWI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "IDA HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "INDWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "JAHO'S GLEN JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "JOZANA'S HOEK JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "JOZANA'S NEK JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "KHIBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "KUNDULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "KWABO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LADY FRERE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LOWER NCORA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "LUZUKO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MAGWIJI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MAHEDI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MAHLUBINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MAKUMSHA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MANXEBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "JACKSON COLLEGE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MAPOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MAQWATINI JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "GET AHEAD PROJECT (WHITTELSEA)"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MATYANTYA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MBAXA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MBENGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MBINZANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MBOBO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MBUDLU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MCUMNGCO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MCWANGELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MGCAWEZULU PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MKULULI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MNCUNUBENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MNIKINA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MNQANQENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MOKHESI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MOLTENO HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MOUNT ARTHUR JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MTYINTYINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MUSONG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MVUZO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MZAMOMHLE-JOJO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MZIMKHULU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NCORA FLATS JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NDOFELA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NDONGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NGANGOMHLABA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGCACA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NGCUKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NGQUBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGXABANGU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NKONKOBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "NKOPANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NOBUHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NOLUTHANDO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NONKANYISO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NQUQU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "PAPASI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "PELANDABA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "QHOBOSHANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "QOQODALA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "QUGQWARU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "R V MANELI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "RHODES JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SAKAKUDE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SEPLAN JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SIDUBI POORT JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SIGANGENI PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SITOROMO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SIXISHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SKISAZANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "SOBANTU JUNIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "THOBILE DYANTYI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "STERKSPRUIT COMMUNITY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "OLIVET PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "STERKSPRUIT JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "STEYNSBURG COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "SUNDUZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "TAPOLENG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "TARKASTAD HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "TELLE JUNCTION JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "THABA LESOBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "THEMBALETHU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "TIENBANK JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "TOISEKRAAL PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "UPPER NGONYAMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "THEMBISILE MARTIN HANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "VAALBANK PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "VALELO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "WALAZA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "WITTEBERGEN JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "XONXA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "YONNA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZAMUXOLO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZANEMVULA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "ZINGXENGELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "ZOTE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "ZWELIBANGILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LUNGISANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "STERKSTROOM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "LADY GREY ARTS ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MPUNGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "KOLONGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "MABELE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE WEST",
      "School_Name": "SOPHAKAMA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "EDENDALE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NONIBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MCKAYSNEK JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NGQWARU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GANDO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "MHLOBO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NKQWILISO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NTLONZE PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "NOWETHU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "GUDWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "NOKWAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "KANYISA PRIMARY JUNIOR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MKONJANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "MPOTULO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "SENTILE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "JOE GQABI",
      "School_Name": "STERKSPRUIT CHRISTIAN PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI EAST",
      "School_Name": "STEP AHEAD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "CHRIS HANI WEST",
      "School_Name": "LUKHANYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "RIVERSIDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "VALLEY DAWN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "VELA PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "ALEXANDRIA CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "ST THOMAS PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO INLAND",
      "School_Name": "HOLY MOTHERS ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "O R TAMBO COASTAL",
      "School_Name": "MARILLIER'S LEARNING ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "COVENANT COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ZAKARIYYA PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LENASIA MUSLIM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "NUR-UL-ISLAM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "S B S M PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "CALVARY CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ELETHU THEMBA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "GIBSON PILLAY LEARNING ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MARIST BROTHERS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ST MARTIN'S SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "VERNEY COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "AFRICA HOUSE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "JOHANNESBURG POLYTECH INSTITUTE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ALPHA AND OMEGA CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CONVENT OF THE HOLY FAMILY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "DEUTSCHE SCHULE JOHANNESBURG"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "DOMINICAN CONVENT SCHOOL (BELGRAVIA)"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "HIRSCH LYONS SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MARYVALE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MCAULEY HOUSE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "RAND TUTORIAL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ROEDEAN SCHOOL (SA)"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SACRED HEART COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SHA-AREI TORAH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SHEIKH ANTA DIOP COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "THE TORAH ACADEMY PRIMARY AND HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "AFRO-KOMBS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "BASA TUTORIAL INSTITUTE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "BETHANY COMBINED"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BOPHELO-IMPILO PRIVATE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CENTURION COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "DUNCTONWOOD PROGRESSIVE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "EDUCATION ALIVE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "EDUCATIONAL PROGRAMMES CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "BASA FREEDOM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "JOB RATHEBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "KWA-NTSIKANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "LIBERTY COMMUNITY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MAHLASEDI HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "NEW MODEL PRIVATE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "PHOENIX COLLEGE OF JOHANNESBURG"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "PROVIDENCE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "RAND PREPARATORY AND COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SIR ISAAC NEWTON HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "SUPREME EDUCATIONAL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "UNITED CHURCH PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ZIFUNELENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NEW NATION SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BEYHAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BLUE HILLS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "JOHANNESBURG MUSLIM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "EDEN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ESIYALWINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "RADLEY COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "THE METROPOLITAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "JOHANNESBURG CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "YESHIVA MAHARSH BESH AHARON COMMUNITY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "EKUTHULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "INDONI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "INKONJANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "KHINDLIMUKANI JUNIOR SECONARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "VULAMAZIBUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BOSMONT MUSLIM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "AL-AZHAR INSTITUTE-JOHANNESBURG"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MARLBORO GARDENS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SUMMERHILL COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BRESCIA HOUSE URSULINE CONVENT"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SANDTONVIEW COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "DE LA SALLE HOLY CROSS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KINGSMEAD COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MICHAEL MOUNT WALDORF SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "REDHILL SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "RHEMA CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CURRO MIDRAND SAGEWOOD CAMPUS COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ST DAVID'S MARIST COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ST MARY'S SCHOOL FOR GIRLS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ST STITHIANS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ST TERESA'S MERCY SENIOR PRIMARY AND HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "THE KING'S SCHOOL (ROBIN HILLS)"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "THE KING'S SCHOOL LINBRO"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "THE KING'S SCHOOL BRYANSTON"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "LYCEE FRANCAIS JULES VERNE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "PHOLOSHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "Q-HOUSE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "THE AMERICAN INTERNATIONAL SCHOOL OF JOHANNESBURG"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SUMMIT COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "DAINFERN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "RABASOTHO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ASSUMPTION CONVENT"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "CHRISTIAN BROTHERS' COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "EAST RAND CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "HOLY ROSARY CONVENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "HERITAGE CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SAHETI SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ST ANDREWS SCHOOL FOR GIRLS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ST BENEDICT'S COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ST CATHERINE'S DOMINICAN CONVENT"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ST DOMINIC'S SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LEEUHOF AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "GRACELAND EDUCATION CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "INSTITUTE STATUS ACRES SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "CVO SKOOL PRETORIA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "HATFIELD CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRETORIA CHINESE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ST MARY'S DIOCESAN SCHOOL FOR GIRLS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "DOXA DEO EDENVALE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "STAR OF HOPE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "MARAGON PRIVATE SCHOOL OLYMPUS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "CORNWALL HILL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "CRESTA COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "THE WAY CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "CENTURION CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "QUEENSWOOD CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "CHRISTIAN BROTHERS' COLLEGE MOUNT EDMUND"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "DEUTSCHE SCHULE PRETORIA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "GEREFORMEERDE GEKOMBINEERDE SKOOL DIRK POSTMA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "CORNERSTONE COLLEGE SEC. SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LOMPEC INDEPENDENT PRIMARY AND SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "CRAWFORD PREPARATORY PRETORIA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "IONA CONVENT"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LORETO CONVENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "CENTRAL ISLAMIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "GREENWOOD COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRETORIA MUSLIM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRINCESS PARK SECONDARY SCHOOL AND COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "SA COLLEGE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "DANSA INTERNATIONAL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "CHRISTIAN PROGRESSIVE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "AMITY INTERNATIONAL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ELMAR INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ANCHOR CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRETORIA MUSLIM TRUST SUNNI SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "BALESENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "BOEPATHUTSE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "DC MARIVATE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "ECHIBINE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "FUNEKILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "M.J. MGIDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "KONDELELANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "NTSAKO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "PRESTIGE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "RETHOMILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "RHULANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "SEMPHATO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "SIYOKHELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "THAKGALANG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "THUTONG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "TSHWANE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "BABINAPHUTI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "CHARIS CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "CHARLTON VOS COLLEGE OF EDUCATION"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LA SALLE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ST CATHERINE'S CONVENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "ST URSULA'S SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "THE KING'S COLLEGE WEST RAND"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "UNIFIED PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MATLA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "SCHAUMBURG COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "SWARTKOP VALLEY PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "TULIP COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "CURRO AURORA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "AZAADVILLE MUSLIM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "THE KINGS SCHOOL DISCOVERY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "GRACE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "VICTORY HOUSE PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "WISE-UP EDUCATION CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SUPERO PRIVATE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "TERSIA KING LEARING ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MADIBATLOU MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "OOS-RAND AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SHANGRI-LA ACADEMY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MARANATHA CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SONRISE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LAERSKOOL GLENHARVIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "BARACHEL CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "KAMOHELO PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "LETSATSING PRIMARY MINE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MBULELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "PHORORONG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "ROOIPOORT PRIMARY FARM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "IZANOKHANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "TSITSIBOGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "WESTERN AREA PRIMARY MINE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "ZUURBEKOM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ASHBURY PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "GEKOMBINEERDE SKOOL NOORDERLIG"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "KATHSTAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "SHANAN CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ST DUNSTAN'S MEMORIAL DIOCESAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SONNEVELD AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ST FRANCIS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BENONI MUSLIM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ASHTON INTERNATIONAL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BENONI CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "EL SHADDAI SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "CHRYSTAL SPRINGS PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "EMMANUEL PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "THREE RIVERS CHRISTIAN ACDEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "IMBALI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "JOHWETO PRIVATE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "ED-U-COLLEGE (VAAL)"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "HENLEY HIGH AND PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "ASSEMBLIES OF GOD COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "ROSHNEE ISLAMIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "THULA-MNTWANA INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MASIBAMBANE PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "WORD OF LIFE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ALBERTON CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "SPARROWS PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "PHUMELELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "LIFE MINISTRIES CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "NIGEL SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "SPRINGS MUSLIM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "VERITAS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "JAMESON JUNIOR AND HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "NEW MILLENIUM COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRINCEFIELD TRUST SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "FOUNDERS COMMUNITY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "DIEPSLOOT COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "BALMORAL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "ALMA MATER AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MARAGON SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "COURTNEY HOUSE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "WOODHILL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "SUNWARD CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "JACARANDA ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BETHARRY ENGLISH PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "OXFORD COMBINED COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "DIE HEUWEL CHRISTIAN SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "HERON BRIDGE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CHRIST CHURCH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "DALPARK LEARNING ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "AL-ASR EDUCATIONAL INSTITUTE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "TOMORROW'S PEOPLE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "CAPITAL CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "GLOBAL COMBINED COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "AL GHAZALI INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NIZAMIYE SCHOOL MAYFAIR"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "REVIVAL CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "BOKSBURG CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "WOODLANDS INTERNATIONAL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "MONTESSORI ACADEMY AND COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MIDSTREAM COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "BOPHELONG COMMUNITY INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "EL TABERNACLE CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ARMOUR FOUNDATION LEARNING INSTITUTE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "GIDEON RAMBUWANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "WATERSTONE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "EDUMORE CHRISTRIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "WHITESTONE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ST ATHANASIUS ORTHODOX CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LINKS COMBINED COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ITHUBA COMUNITY COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "SOUTHDOWNS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "HOPE FOUNTAIN COMBINED COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "JEPPE EDUCATION CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "OUR LADY OF WISDOM"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "THE TRAINING ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "WATERSRAND COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "MARTHIE DE BRUIN SENTRUM"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "TYGER VALLEY COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "LAMBTON CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "BRAKPAN OPVOEDKUNDIGE SENTRUM"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "THE KEEP LEARNING CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "PRIDE LEARNING ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "QUEENS PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "JW SAINTS TECHNICAL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "CRAIGHALL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "RAND VIEW COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ST AQUINAS-PRETORIA CAMPUS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "RAND HILLS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "COLLEGE FOCUS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CITYRAND COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "DUZEK CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ST AQUINAS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "PHUMELELA INSTITUTE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "WATERSHED PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "AMAZING GRACE PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ABUNDANT LIFE CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "JAHARI CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "GRACE CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "TEACH THEM CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "CURRO HELDERWYK"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "AFRICA INTERNATIONAL PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LOERIE LAND INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SEDCO COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "NATIONWIDE SCHOOL FOR ACADEMIC EXCELLENCE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "SOUTHRAND COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "DUKES PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "GALALETSANG PRIMARY AND HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "OCEANS PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ST JEFF COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "CROYDON HOUSE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "WIERDA INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LEADERS CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "TAAL-NET TRAINING INSTITUTE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "KUBE SCHOOLS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ENTHEOS CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "KINGS HIGHWAY ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ZWARTKOP CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "EMPRO ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "HAWK ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "QUEENS PARK SCHOOLS-ROODEPOORT"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "SEEKER'S TOWER MATHS AND SCIENCE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ABDULLAH BIN SALAAM ISLAMIC CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ALLIED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "HOPE RESTORATION COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ALPHA TUTORIAL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "VICTORIOUS G & B PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "SPACE AGE INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LE-AMEN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "TOTUS TUUS INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "SUCCESS KATLEGO ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "WIGGLES AND SQUIGGLES SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "DELCOM TRAINING INSTITUTION"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "BRONBERG AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "AUCKLAND PARK ACADEMY OF EXCELLENCE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "WESTWOOD INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "EL ZERA PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "HOUGHTON MUSLIM ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "CITYRAND COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "VINE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "CURRO SERENGETI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ROYAL KINGS SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ZEE'S ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "OXFORD TRAINING CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MAGIC COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "GALLAGHER COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "WISDOM AND KNOWLEDGE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "BESEK COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ATLAS COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "BET'OR CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "AFRICAN SCHOOL FOR EXCELLENCE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "NEW GENERATION ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MIDRAND PRIMARY AND HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ALHUDA ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "WHITE HOUSE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "HENPRO SOLUTIONS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ITHEMBA STUDY CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "THE SAMIT CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "CURRO PRIVATE SCHOOL-KRUGERSDORP"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "TAAL-NET INTERNATIONAL SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "VERITAS ACADEMICS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "MOLEPI RISING STARS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SKYLINE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "RAND HILLS ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "EDUCATION INCORPORATED FOURWAYS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "PRIME UNIQUE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "RHODES TECHNICAL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "LIGNO VITAE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "CURRO THATCHFIELD"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "DESTINY CHARTER SCHOOLS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "EKUKHANYISELWENI CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "BEMSSEL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "DUZEK CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "CRAWFORD PREPARATORY ITALIA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "TRINITY HOUSE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "NOVA PIONEER ORMONDE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "RIDGEWAY MUSLIM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "POPLAR ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "ACUDEO COLLEGE THORNVIEW"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "WESLEYAN CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LIVING WORD KINGSWOOD SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "GLOBAL LINK COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "BASA PROTEA GLEN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ST DECLAN SCHOOL FOR BOYS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "PLG WILLOW VIEW ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "CURRO ACADEMY SOSHANGUVE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MERIDIAN COSMO CITY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRETIUM PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "REDDFORD HOUSE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "KINGSWOOD ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "TAALNET ST.JOHNS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "MEL INTERNATIONAL SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ACTS HOUSE OF EDUCATION"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "HOËRSKOOL BERGVESTING"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "NOVA PIONEER MIDRAND"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NORTHRIDING COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ENDERUN COLLEGE SPRINGS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "BUSY BEE LEARNING ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "DIXON ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "MULTY CAREERS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ROYAL SCHOOLS ALBERTON"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "THUTO KE LESEDI COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "REDWOOD ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "GAUTENG CENTRAL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "RAMAPHOSA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ROYAL KINGS SCHOOL-CROWN MINES"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "PLG MELLOW OAKS ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "LOTUS SCHOOL OF EXCELLENCE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "JEPPE PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "RUIMSIG MONTESSORI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "DOORNFONTEIN GIRLS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG EAST",
      "School_Name": "ST. AMBROSE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "GAUTENG CITY COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "TAALNET GLEN AUSTIN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "HM HIGH DENSITY ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "FUTURE NATION SCHOOLS LYNDHURST"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ACUDEO COLLEGE CRYSTAL PARK"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "TAAL NET BEULA PARK"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "STENHAM PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "REVIVAL CITY COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "FUTURE NATIONS SCHOOLS FLEURHOF"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MARANATHA COMBINED PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "MARAGON PRIVATE SCHOOL AVIANTO"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CURRO WATERFALL COMBINED"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "CURRO RIVONIA COMBINED"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "CURRO ACADEMY CLAYVILLE COMBINED"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BAKEN AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ADVTECH COPPERLEAF ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "REDDAM HOUSE HELDERFONTEIN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ROYAL SCHOOLS SKY CITY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "REDDFORD HOUSE BLUE HILLS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "REDDFORD HOUSE NORTHCLIFF"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "CURRO ACADEMY WILGEHEUWEL COMBINED"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "ACUDEO COLLEGE THORNVIEW FOUNDATION"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "ACUDEO COLLEGE PROTEA GLEN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "STEYN CITY PREPARATORY AND COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "ASAMATHS INSTITUTE OF LEARNING-PRETORIA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "ACUDEO COLLEGE KIRKNEY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ESCA WANDERERS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ADVTECH ACADEMY THE BRIDGE ASSISTED LEARNING SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "YATAL PRIMARY & HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ASAMATHS INSTITUTE OF LEARNING"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "DESTINY INDEPENDENT SCHOOL-KEMPTON PARK"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "BENHALE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "ROYAL KINGS SCHOOL-KRUGERSDORP"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "UNIVERSAL MINDS ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SOUTH-HILLS COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "GRACEHILL CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "MARAGON MOOIKLOOF"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "BOWEN INTERNATIONAL SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "RANDFIELD EDUCATIONAL FOUNDATION"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "AMBERFIELD COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "BATHO PELE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MAYFAIR ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "ZAMBEZI ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ADVANCED COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG WEST",
      "School_Name": "CURRO VANDERBIJLPARK COMBINED"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "SION PRIVAAT ACADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "SOUTHAMPTON PRIVATE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "AMBULANTE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "QURTUBA ISLAMIC ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "ASTER ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "GLENMARK CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "NORTH AMERICAN INTERNATIONAL SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BOIPUSO PRIMARY AND HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "MY TUTOR & TRAINING CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "EDUCATIONAL STLYED INTERGRATION"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG WEST",
      "School_Name": "GREENLIGHT ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "SEREN HOUSE COTTAGE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "CHARTWELL HOUSE MONTESSORI ECO SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "THE PRESIDENT PARK GOSPEL GARDEN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "THE BEEHILL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG CENTRAL",
      "School_Name": "CURRO ACADEMY PROTEA GLEN COMBINED"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ROYAL KINGS SCHOOL-MULBARTON"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "TAALNET ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "DISCOVERY INTERNATIONAL SCHOOLS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "TAAL-NET ROODEPOORT"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "BRISTOL TRAINING COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "MIDDAWN SCIENCE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "ADVANCED COLLEGE BROOKLYN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "DESTINY HOUSE UNIVERSAL SCHOOLS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "WOODWARD PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "EXPLOERER PIONEERS SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "FALCON LEARNING ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "NORTH ANGELOS CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "CURRO SAVANNA CITY COMBINED"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "TOPHILL ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "AL IMANI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "GAUTENG NORTH",
      "School_Name": "CURRO THE BLYDE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "JW SAINTS TECHNICAL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "HAPPY HOURS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "DESTINY CHATER SCHOOLS-HOUGHTON"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "SEDIBENG EAST",
      "School_Name": "THE ORANGE CROFT HOUSE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "DERONA ACADEMY-AKADEMIE NPC"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "ANITA'S COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "PINNACLE COLLEGE WATERFALL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "ST PEACE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "TRINITYHOUSE GLENVISTA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "MUDI LEARNING CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "CURRO EDENVALE COMBINED"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "MODDERFONTEIN ACADEMY OF ARTS, SPORTS AND CULTURE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ACACIA SCHOOL PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "CURRO ACADEMY RIVERSIDE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "EAGLES CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "DAYBRIDGE INTERNATIONAL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "CURRO ACADEMY MAMELODI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "TRINITYHOUSE HERITAGE HILL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "HOPE FOUNTAIN COMBINED SCHOOL-HILLBROW"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "PINNACLE COLLEGE FOUNDERS HILL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ALPHA STUDY CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "RIFT HOUSE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "PINNACLE COLLEGE LINDEN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "SEREN HOUSE COTTAGE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "ROYAL KINGS SCHOOL-ROODEPOORT"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "LAMBANO ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "THINKINC ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "CURRO ACADEMY PARKDENE COMBINED"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "CORAM DEO CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "NEWTON HOUSE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "GREENVALE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG EAST",
      "School_Name": "WORD OF LIGHT ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "LITTLE OAKS AND OAKS PRIVATE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "TUTOR THE FUTURE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "RANDFIELD EDUCATION CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG WEST",
      "School_Name": "SKYE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "ASPIRATION ACADEMIC"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "FAITH ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI SOUTH",
      "School_Name": "SPARROWS PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ODYSSEY ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "ABNAH ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "EKURHULENI NORTH",
      "School_Name": "THE ALMOND TREE CHILDREN OF PROMISE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE SOUTH",
      "School_Name": "PRETORIA LIBYAN ARABIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "ROYAL PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG NORTH",
      "School_Name": "BUHLEBEMFUNDO PRE COMBINED"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "CRESCENT ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "JOHANNESBURG SOUTH",
      "School_Name": "EMMANUEL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "RAMABELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "THULAGANYO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE NORTH",
      "School_Name": "TSEBE NTLHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "TSIBOGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Gauteng",
      "District": "TSHWANE WEST",
      "School_Name": "LUCAS MOTSHABANOSI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SASELEMANI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "CARPE DIEM CHRISTIAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "TLHALEFA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "SCHUITDRIFT"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MOPANE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NEHEMIAH CHRISTIAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAROI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "DOREEN-BRIDGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MERIDIAN COLLEGE PHALABORWA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "HOEDSPRUIT CHRISTIAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "PEPPS POLOKWANE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MITCHELL HOUSE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MILLENNIUM COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "HAPPY DAY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "JABEZ CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "AKADEMIE REFORMIA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "SEBOTSI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "APPEL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MARA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "EMMANUEL CHRISTIAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "LTT MURUNWA SCHOOL OF EXCELLENCE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "BOITHUTO"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "CVO-SKOOL POTGIETERSRUS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "SEKHUNG"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "HEBRON MODEL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LETAMONG"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "WEENEN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "ROEDTAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "LEREKHURENG"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "KINGS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "NALETSANA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "ULANDO"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "EDEN CHRISTIAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "NTSHUXI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MERIDIAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HONOKA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KHANYISA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "PRIESKA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "SHAMIRIRI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MOTLOBONI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "THE KING'S COURT"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "MOHLAKENG"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NKEKETHLALWA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN NORTH",
      "School_Name": "SEKURUWE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MYNGENOEGEN ENGLISH PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "NORTHERN MUSLIM"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "ST. FRANCIS CATHOLIC ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "CHIDI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOKGALABJE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LIVING WATERS MPUDULLE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "TSHEPO CHRISTIAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "RAINBOW"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MADAHENI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "GONDOLIKHETHWA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "HILLSIDE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "ST. AUGUSTINE RESIDENTIAL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "VISION"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "SHAYANDIMA SCHOOL OF TOMORROW"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "TSHIKEVHA CHRISTIAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "LIIVHA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HAGGAI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NAZARENE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MUKULA INTEGRATED"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "EAGLES NEST CHRISTIAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "NORTH CREST ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MOKOPANE ENGLISH COMBINED"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOGALAKWENA",
      "School_Name": "MOKOPANE DESTINY ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "WATERBERGSKOOL VIR CVO"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "THABAZIMBI CHRISTIAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "WATERBERG ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "WATERBERG",
      "School_Name": "ACADEMIA PRIVATE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "CHRIST THE KING"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "RUSPLAAS CHRISTIAN MODEL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "CURRO HEUWELKRUIN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "HADASHAH LEARNING CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "ENDERUN BOYS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "MASEALA PROGRESSIVE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "KINGDOM LIGHT OF GOD"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "LUTHULI PARK"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "CAPRICORN SOUTH",
      "School_Name": "GRACELAND"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "HOLY ROSARY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NEW ERA COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "MAHLAHLE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "RISIMA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "AMARIA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "BONO CHRISTIAN LEARNING CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "COMPREHENSIVE TRINITY ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "PARADISE MANAME"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "TALIFHANI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "MAHONISI LEARNING CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "CVO SKOOL ZOUTPANSBERG"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "WILMARY CHRISTIAN LEARNING CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "CVO SKOOL VIVO"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "BENNYS SPORTS DEVELOPMENT AND ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "NEW GENERATION GIRLS ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE EAST",
      "School_Name": "JUMBO PROGRESS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "DIVINE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "CENTAURI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "HIGH QUALITY SCIENCE AND BUSINESS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "NKWANGULATILO"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "RIVONINGO"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "MUHLURI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "KINGFISHER"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "ALL SAINTS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "FRANCIS ENGLISH MEDIUM"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "SOUTHERN CROSS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "VHEMBE WEST",
      "School_Name": "THEOCENTRIC CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "ST GEORGE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI EAST",
      "School_Name": "STRAUSBURG COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "HOPE COMBINED ENGLISH MEDIUM"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "MOPANI WEST",
      "School_Name": "MATSEUTSEU MAROPENG"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "ST PETERS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "NTLHATLOLE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "ST THOMAS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "WEM"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "CALVIN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MAFADI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "GOOD SHEPHERD"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "COMPREHENSIVE RIVERSIDE TECHNICAL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "THE FUTURE COMPREHENSIVE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "JANE FURSE COMPREHENSIVE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAPOGHS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "STEELPOORT ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "MMAHLAGARE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE EAST",
      "School_Name": "EXCELSUS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "GROBLERSDAL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SIZANI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NEW HORIZON"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SANGO"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "GROBLERSDAL CHRISTIAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MAKHUMA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOOSRIVIER"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "ELSHADAI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LAERSDRIF LAERSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATHAKGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "DE WAGENDRIFT"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "EMBHOKODWENI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "BUFFELSVALLEI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "ST GREGORIES COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "AQUAVILLE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "GOOD SHEPHERD"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "GROMAR LANDBOU AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LIVING WATERS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "PHUTIKWENA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "LEHWELERE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "TADIMANE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "HOSIA APHANE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "RAMOKHUTLWANE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MATSHIPHE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "KAITSWE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "JESUS IS LORD"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "NYAKHOROANA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOROATHEBE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "BLOMPOORT"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "MOTHIBEDI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Limpopo",
      "District": "SEKHUKHUNE SOUTH",
      "School_Name": "SEREME"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THUBELIHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "AZALEA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BAADJIESBULT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BABUTHENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "YOUNG HARVEST CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BAMBANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BANKFONTEIN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BARBERTON COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "BONGANIVEN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BONGIDUVHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "FAKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BUYANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CALVARY CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CAMDEN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CANA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CAROLINA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "C V O SKOOL CAROLINA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "COTHOZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "DAVEL COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CROMATI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "DINGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "DIGWALE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "DRIEKOPPIES COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EARLY BIRD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EASTDENE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ED-U-COLLEGE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EKUKHANYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EKUPHAKAMENI SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EKUPHILENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EKUPHUMULENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EMATHOLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EMDIBINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EMOYENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "EMTFUNTINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EMTHUNZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ENGELSEDRAAI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ENKUNDLENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ENTABAMHLOPHE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ERMELO CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ERMELO INDIAN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ESIBUSISWENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ETIMBONDVWENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EVULINGQONDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "FUNDISISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "GEKOMBINEERDE SKOOL BALFOUR"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "BELFAST AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CAROLINA AKADEMIESE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "GEKOMBINEERDE SKOOL HENDRINA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MORGENZON LANDBOU AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "GLEN ELAND COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "GLENTHORPE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CHIEF K J MALAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "GREENDALE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "GATEWAY CHRISTIAN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LYDENBURG CHRISTIAN PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HLALANI SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "LYDENBURG AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HLOBANE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "IMISEBEYELANGA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "IMPUMELELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "INGWENYAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ISIBANISESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ISIYALU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "IZITHANDANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KEMP SIDING COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KHAYALETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KHONZIMFUNDO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KHULA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KHULA-MSHIKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIPHAKAMILE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KWANDEBELE SCIENCE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "KWASIKHOVA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "GEKOMBINEERDE SKOOL KLIPSPRUIT"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "KOMATIPOORT AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LAMLILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LANDAU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LEHLAKA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LEKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LESELI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LUNDANDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "LUNGELO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MD COOVADIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MADI SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAGUBHA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAGUDU COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAKAUSE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAKHATHINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAKHOSANA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MALOMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAPULE SINDANE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MAQHAWUZELA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MASAKHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MASIHAMBISANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MASOYI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MAZIYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MBANGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MBOMBO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MC ZITHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MGANDUZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MGOBODI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MGUBHO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MGWEZANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MHLABA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MIDDELBURG COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MKHULU COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MLILO COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MMAGOBANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MMS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MOLAPALAMA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MONIWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MOOLMAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MORELIG COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MPUNZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MSHENGU INCLUSIVE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MIDDELBURG MUSLIM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MTIMBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "MUSI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NDAWONYE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NDINDANE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NEDERLAND COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NELSVILLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NGWANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NKONJANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NTITHANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "NYABELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "GEKOMBINEERDE SKOOL OGIES"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "OSIZWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PENRYN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PHAKAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PHAPHAMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "PIET RETIEF COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "PINE RIDGE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "PROF S S REPINGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "QHUBULWAZI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "RONDAVEL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ROODEBANK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SALEM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SCHOEMANSDAL SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SEBENTA SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SEKEMISA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SELE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SHAYAZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SHONGWE BOARDING SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SHUKUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIBONELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIHLANGENE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIMTFOLILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SIMUYEMBIWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SIPHUMELELE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SKOONUITSIG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SOPHUNGANE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SOZILANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SPRINGBOK COLLIERY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "STANWEST COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SWARTKLIP COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "TEGWANS NEST PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THABANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THANDANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THE BROOK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THE GEM COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "THE KING'S SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THISTLE GROVE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "THOKOZANI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "THUSHANANG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MHLANGAZANE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "TISITENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "TRICHARDSFONTEIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TSEMBANANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "TSHEPEHA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "UBUHLEBETHU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "UMFUDLANA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "UMZIMVELO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "VALENCIA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "VICTORY PARK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "VUKANINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "VUKEKUSENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "VUKUZENZELE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "VULEMEHLO SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "VULINGCONDVO SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "VUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "WARBURTON COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "WEM PRIVATE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "WITBANK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ZAKHELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ZAMOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ZENDELINGSPOST COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NTOKOZO SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "C V O SKOOL MIDDELBURG"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "JOUBERTSVLEI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HIGHVELD MUSLIM COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "HAZYVIEW COMPREHENSIVE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ADULLAM CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "TRICHARDT CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "SIKHUTSELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "LANGALIBALELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "NOAH'S ARK PRIVATE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ALL NATIONS CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ST PETER'S INTERNATIONAL COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "SECUNDA CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "ARK CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ACCELERATED ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "CHAZON TEKNA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TRINITY COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "NEW ERMELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "INJABULO SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MARANATHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "METROPOLITAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MAQHAWE EDUCATION CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "LOUIEVILLE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KGANTSHO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ST MARKS SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "CUM LAUDE AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HARMONY PARK SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ANGELS PARK ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SIBOYIYE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MODUPING COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "WEM MKHUHLU SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "DUMPHIES COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "MPITHI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "KHAYIMANI SCIENCE AND TECHNOLOGY COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "TWIN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "T.C. COLLEGE ELUKWATINI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BEACON COLLEGE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "AUDEAMUS PRIVATE SCHOOL & ACTIVITY CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "EZAKHENI COMBINED BOARDING SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "CURRO BANKENVELD SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "DESTINY ACADEMY GATEWAY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ELDAMAH ACADEMY COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CURRO NELSPRUIT"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "SAINT PETER CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "IZIMBALI COMBINED BOARDING SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "MOUNTAIN VALLEY COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "EMAKHAZENI COMBINED BOARDING SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "HEROES ACADEMY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "MERIDIAN KARINO SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "STEVE TSHWETE BOARDING SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "WEM SCHOOL BUSHBUCKRIGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "CANSAS PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "THABA CHWEU BOARDING SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "WITBANK COMBINED CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "BUCKRIDGE PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "HORIZON ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "ST THOMAS AQUINAS COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "DEGANIA HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "KIMBERLEY CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "VOLKSKOOL ORANIA GEKOMBINEERD"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "SPRINGBOK CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "AGGENEYS INTERNATIONAL ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "LION OF JUDAH"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KURUMAN CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "CURRO KATHU"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KATHU REHOBOTH CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "FJ SMIT (NGK) INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "NAMAKWA (NMK)",
      "School_Name": "KHARKAMS GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "VICTORIA-WES GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "COLESBERG GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "NOUPOORT GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "HOPETOWN GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "ORANIA CVO GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "STRYDENBURG GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "PRIESKA GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "PIXLEY KA SEME (PXL)",
      "School_Name": "DOUGLAS GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "!XUNKHWESA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "RIETFONTEIN GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "FRIERSDALE (RK) INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "KEIMOES GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "ZF MGCAWU (ZFM)",
      "School_Name": "DANIËLSKUIL COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "ST PATRICKS CBC COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "VAALRIVIER HOëRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "DELPORTSHOOP GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "WARRENVALE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "VAALHARTS GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "LAERSKOOL HOTAZEL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "HOTAZEL COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "FRANCES BAARD (FB)",
      "School_Name": "EENDRAG (CVO) INTERMEDIÊRE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Northern Cape",
      "District": "JOHN TAOLO GAETSEWE (JTG)",
      "School_Name": "KATHU COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "EDUBLOX DURBANVILLE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "LONDON VILLAGE CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "DARUN NA'IM ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "ACADEMY PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "REDDAM HOUSE ATLANTIC SEABOARD"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "IES INTERNATIONAL HELDEBERG SCHOOL (PTY) LTD"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "LYCEE FRANCAIS DU CAP FRANCOIS LE VAILLANT"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "HOPE AND LIGHT COMMUNITY WELFARE (NPC) TRADING AS HOPE AND LIGHT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "HYDE PARK COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MOUNT VIEW EDUCATION CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "CURRO HERMANUS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ALBERT COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "LONGACRES PRIVAATSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "KEY TO EDUCATION TRADING AS FOCUS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MERIDIAN PINEHURST PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "CURRO CENTURY CITY PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "POMARIO PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "RUNDLE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "REDDAM HOUSE DURBANVILLE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "CROSSPOINT ACADEMY - STRAND"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KINGSLEY PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "BOSASA CLANWILLIAM YOUTH DEVELOPMENT CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CAPE TOWN TORAH HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BIG BAY ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "STAR COLLEGE - BRIDGETOWN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "THE ROCK ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "GENERATION SCHOOLS SOMERSET WEST"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "HERITAGE HOUSE INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "GENERATION SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "GENERATION SCHOOLS - HOUTBAY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "RENAISSANCE PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "MCKINLAY REID INTERNATIONAL ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "CURRO SITARI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "LIGHTHOUSE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "DANIEL ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MONTGOMERY AND MILLER ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "LA VIGNE EDUCATIONAL HOUSE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "UBUNTU FOOTBALL ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "CURRO UITZICHT INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "STUDY HOUSE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "OAKLAND ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "FUTURE'S ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KWEEKVALLEI KOLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "VUURVLIEGIE AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "LAKESIDE EDUCATION ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "2 OCEANS EDUCATION OPERATIONS COMPANY (RF) NPC"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MOLO MHLABA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "CURRO ACADEMY SANDOWN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "CHRISTEN AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BOOST ACADEMY CAPE TOWN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "GENERATION SCHOOLS - IMHOFF"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "RALLIM PREPARATORY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "SAVVY COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "EDEN SHINE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MONTESSORI @ HOME INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "KIDS ACADEMY SSW & K-ACADEMY LEARNING CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "NEW HAVEN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "THE OAKS ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "GREEN SCHOOL SOUTH AFRICA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "EL SHADDAI CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BOSTON PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "CURRO DURBANVILLE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "CHRIST GEN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SHILOH CENTRE OF LEARNING"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "NATURAL LEARNING ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "BELLVILLE CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CANNONS CREEK SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "EMMANUEL CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MOUNTAIN VIEW ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "CRAVENBY SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "CBC ST. JOHN'S PARKLANDS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "DEUTSCHE INTERNATIONALE SCHULE KAPSTADT"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HERZLIA HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ST. CYPRIAN'S SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ST. GEORGE'S GRAMMAR SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "WEST COAST CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "PARKLANDS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "ELKANAH HOUSE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "SUNNINGDALE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "INTERNATIONAL SCHOOL OF HOUT BAY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "BLOUBERG INTERNATIONAL ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "RIVERSIDE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "EASTRIDGE CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SIMON'S TOWN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "MICHAEL OAK WALDORF SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "CONSTANTIA WALDORF SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "HERSCHEL GIRLS SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "BISHOPS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SPRINGFIELD CONVENT OF THE HOLY ROSARY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "AMBLESIDE SCHOOL OF HOUT BAY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "ISLAMIA COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "DARUL ISLAM ISLAMIC HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "CEDAR HOUSE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "INTERNATIONAL SCHOOL CAPE TOWN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "STAR COLLEGE CAPE TOWN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "REDDAM HOUSE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "SHILOAH CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "AMERICAN INTERNATIONAL SCHOOL OF CAPE TOWN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "CITY MISSION EDUCATIONAL SERVICES"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "CHRISTEL HOUSE SOUTH AFRICA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO CENTRAL",
      "School_Name": "THE LEADERSHIP COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO SOUTH",
      "School_Name": "DARUL ARQAM ISLAMIC HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "GOOD HOPE HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "YOUNG EAGLES CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BRIDGE HOUSE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "SIMOND PRIVAATSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "AL-AZHAR INSTITUTE OF PAARL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "NOUVEAU - PAARL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "FRANSCHHOEK HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "PAARL GIRLS HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "STELLENBOSCH WALDORF SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SOMERSET COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "SOMERSET WEST PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "NEWBERRY HOUSE MONTESSORI PRIMARY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO EAST",
      "School_Name": "MONDEOR ECO SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WELLINGTON PREPARATORY SCHOOL AND COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "KINGSWAY SCHOOL NPC TRADING AS KINGSWAY CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "GRABOUW HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "RIVIERSONDEREND HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "DE RUST FUTURA AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "GENERATION SCHOOL - HERMANUS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "HERMANUS CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "NORTHCLIFF HOUSE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HEIDELBERG CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HEIDELBERG HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "OLYFKRANS COLLEGE."
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "OVERBERG",
      "School_Name": "BARRYDALE HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "BONNIEVALE HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "THE VINE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "OAKHILL SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "PLETTENBERG BAY CHRISTIAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KNYSNA MONTESSORI SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "KEURBOSCH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ASHFORD CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "GREENWOOD BAY COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "WITTEDRIFT HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "CURRO MOSSEL BAY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "GLENWOOD HOUSE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "GROOT-BRAKRIVIER SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "CHRISTLIKE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "ALBERTINIA HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "CALITZDORP HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "SHALOM AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "LADISMITH HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "UNIONDALE HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "EDEN AND CENTRAL KAROO",
      "School_Name": "HAARLEM SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "SKURWEBERG SEKONDÊRE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ASHTON PUBLIC COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "ROBERTSON LOGOS CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MASAKHEKE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "TULBAGH HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "WAVEREN HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "LIFESTYLE CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "MCGREGOR WALDORF SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "VAN CUTSEM COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "GOUDINI HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "CAPE WINELANDS",
      "School_Name": "HEXVALLEI HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "CURRO LANGEBAAN PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "HOPEFIELD HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "FELLOWSHIP COLLEGE TRUST"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "METRO NORTH",
      "School_Name": "MELKBOSSTRAND PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "PIKETBERG CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "PIKETBERG HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "PORTERVILLE HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "VELDDRIF HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "AUGSBURG LANDBOUGIMNASIUM"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "MORESTER AKADEMIE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "NUWERUS HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "VANRHYNSDORP HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Western Cape",
      "District": "WEST COAST",
      "School_Name": "LUTZVILLE HOËRSKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "AGAPE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "BAKANG INTERMEDIATE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BOKAMOSO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "BOLOPAPELO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Boons Secondary School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "BOSANE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Botlhale Intermediate School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "DAUMAS MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "DEVONDALE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "REBONE-SEDIBA INTERMEDIATE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "I.B Damons Combined School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "IKETLEETSENG MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "IKHUTSENG INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "IPELAFATSENG MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "IPOKENG MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KEBINELANG MIDDLE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KEJAKILE MIDDLE SCOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KERETETSE MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "KESEOKILE MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "KGOLOLOSEGO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KHUMOSEJO MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "KINGS WAY CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Koster Intermediate School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "KOSTER SKOOL GEKOMBINEERD"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Letlopi Middle School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MAKGETHE MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MALEPE MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Maotwe Middle School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Marema Primary School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "MARUMOLOA MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MOGODIRI INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MOHITLHI MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "OBUSITSE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "OPANG-DIATLA INTERMEDIATE FARM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Oskraal Intermediate School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "PELOTSHWEU MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Ramoroko Secondary School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rantlaka Middle School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RATSELA MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "REITSHOKILE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "RENALERONA MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Rethusitwe Combined School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "S. J. Ramutloa Middle School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "SEBEGILWE MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Seboaneng Secondary School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SHUDINTLHE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SIONE MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "CURRO PRIVATE SCHOOL (ST CONRAD'S COLLEGE)"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Swartruggens Intermediate School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "THUKA INTERMEDIATE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THUSANO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "TSOSELETSO INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "LOKALENG MIDDLE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "MODISAKOMA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Lebone II College"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THE INTERNATIONAL SCHOOL OF SA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "PINNNACLE PRIMARY AND SECONDARY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Deo Gloria Christian Academy"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "B Mpoza Christian College"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Pecanwood College"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "Harmony Christian School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "VENTERSDORP GEKOMBINEERDE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR RUTH S MOMPATI",
      "School_Name": "CHRISTELIKE VOLKSKOOL VRYBURG"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "PLG HAARTEBEESPOORT ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "DURBAN NORTH COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ALBERT FALLS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ALVA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "AMABUYE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "HOËRSKOOL AMAJUBA HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "AMAKHWATHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "AMAOTI NO. 3 COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "AMATSHENSIKAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "AMOIBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "AS-SALAAM COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ASHBURTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ASITHUTHUKE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BANTUVUKANI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BAQULUSINI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BARNHILL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KINGDOM HERITAGE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BERGVILLE CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SYCAMORE CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BHEKABANTU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BHEKAMEVA HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BHEKUNDI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "BIVA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BIVANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "BLUE MOUNTAIN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BOMBOLO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BONGELA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BOSCHKLOOF INTERMEDIATE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "BOTHA'S PASS FARM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MABHEDLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BRAKWAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BRECHER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BROODSPRUIT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BROOKFIELD COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "BRYNBELLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BUBU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BUCKLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "BUHLEBENTUTHUKO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BURNWOOD SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "BUZUBONA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "EDEN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "CECILIA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "CELA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "CELUKWAZI C. P SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "CHELMSFORD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CHIBELIHLE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CLIFTON SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "COLENSO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "COOL AIR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "COTTLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "DABULAMANZI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "DANNHAUSER SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DEUTSCHE SCHULE HERMANNSBURG"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "DINGIZWE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DLENYANE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "DNC COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DOLO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DOMINO SERVITE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "DONGOTHULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "DOORNKLOOF COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "DOROTHEA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "DOVER COMBINED FARM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "DRAKENSBERG BOYS CHOIR"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "DUMISA PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "DUNDEE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "Durban Girls' College"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "DWARSRAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EDAKENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "EDAMINI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EGQUMAWENI INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EHLANZENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EINSIEDELN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EKWANDENI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ELSIE MTSHALI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMABHEKAZI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EMACITYANA INTERMEDIATE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMAFA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "EMALAHLENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMANGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "EMAWELENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MPUMELELO PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EMNGWENYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EMKHAMO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "EMNGCELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMNQUNDEKWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMPANGENI CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EMPATHE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "EMPEMBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EMSIZINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "EMXHAKENI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ENDOMUKA INTERMEDIATE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ENHLANGANISWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ENHLANGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ENHLANHLENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ENHLOPHENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ENQABENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ENYANYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ENZIMANE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "EQHWENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ESETHU HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ESHOWE CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ESIBANINI PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "ESIBHOWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ESIHLUSHWANENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ESIKHAWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ESINDI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ESIPHETHWINI SENDEZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ETHULENI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ETONGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "EVANE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SOUTHCITY CHRISTIAN SCHOOLS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "EZULWINI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "FAIRBREEZE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "Faith-Way Christian School t/a FAITHWAY COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "FERNDALE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "FLORENCE BOOTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "FUMANA HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "FUNIZWE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GABANGOLWAZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "GADELENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "GANNAHOEK PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "GARDENS COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "INJULA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GEGEDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "GELOFTE SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "GEORGENAU COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "GIJIMANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PRINCESS NOKWENZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "GLEDHOW PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "GLEN EDWARD SECODARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "GLENHILLS SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GOBENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GQAMNJENGELANGA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "GROENVLEI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "IKUSASA ELIHLE HIGH SCHOOL(GROOTSPRUIT)"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "HAIG COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "HALALISANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HARBURG INTERMEDIATE FARM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "HARDING SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "HERMANNSBURG COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HIGHWAY COLLEGE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "HIMMELBERG INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "HLABENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HLANGUZA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SHALOM PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "HLONIPHA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "HLUMA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "HOMELEIGH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "HOPE HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "HULETT COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "HWANQANA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "HYDESWOOD COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "IKHUSANA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "IMBUTHUMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "IMPACT CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "INDLELENHLE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INDONDOKAZULU COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "INIWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INKANYEZI YESIZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "INTAKEMAZOLO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "INTATHAKUSA COMB SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "INUNGI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "IQHAWELESIZWE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ISIPINGO BEACH INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ISITHUNDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ISLAMIC COLLEGE NEWCASTLE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ISNEMBE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ITHEMBANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "IXOPO VILLAGE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "JABULA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "JIKAZA PUBLIC PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "JOYLANDS COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KHAMBULA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "KHIPHOKUHLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KHUME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KHUTHALANI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "KINGSLEY SIVANANDA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KLEIN - EDEN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KONFOOR COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KRANSKOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "KROMELLENBOOG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KUKHANYAKWEZWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KUSWAG SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "KWADINABAKUBO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWADINGANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWABANAKILE P.P. SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KWADINDA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWA GWEBU COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "KWAMAGIDELA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KWA-MKHUMBUZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWANSELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KWAPHINDAVELE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KWASHUKELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LACONCO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "LAMBOTHI HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LEMBETHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LANGENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "LANGGEWACHT COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "LANGSYDE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "LEMBE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LEWIS COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "LIMIT HILL COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LITTLE FLOWER COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "AL-FALAAH COLLEGE DURBAN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "LOKOTHWAYO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "LUTHILUNYE C SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MABIYA SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MABOMVINI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MADEYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MADILIKA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MANDLAMASHA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAGABENG SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MAGAMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAHLAHLAMELA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAKATEESKOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAKHANKANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MAKHAPHA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAKHOTI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAKHWELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAMPUNGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "KEARSNEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MANDINI ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MANDLENI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MANDLEZULU C.P. SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MANDOSI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MANQAKULANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MANZAMHLOPHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MAPHUMULO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MAQULUSINI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MARIANNRIDGE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MARIATHAL COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MARITZBURG CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MASANGAZANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MASHAKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MASHESHELENG PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MASIWELA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MAWELE HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MBEKAMUZI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MBHOBHO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MEADOWSWEET COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MEHLAHLAMASHA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "Melmoth Combined School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MELOKUHLE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MERLEWOOD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MERTOUN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "METZELFONTEIN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MFEMFE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MFUNZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MGWEMPISI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MHLATHUZE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MKHIZE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MKHOLOMBE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MKHUPHULANGWENYA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MLONYENII COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "MNGOMENI HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NOMDUMO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MORNINGSIDE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MOTALA HEIGHTS COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MOUNT ERNESTINA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MPEMVAAN PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MQWABE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MSENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "NTENDEKA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "MTWAZI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MUDEN SECONDARYSCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "MVUMASE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MXOSHENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MZOMUSHA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "NANSINDLELA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ROSEWAYWALDORF SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "NCANDU COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NCOME COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NDABAMBI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NDABANKULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NDEMA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NDENGEZI INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "NDWAKAZANA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NELSRUS COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NEW GUELDERLAND SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NEW MARKET PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NEW RIVER COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "NGAWU JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "NGCAKA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NGWANE J S SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "NHLAZADOLO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NHLENGILE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NHLOYA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NIZAMIA ISLAMIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NJIKINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NKASENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "NKAYISHANA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NKLANGOZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NKOSENYE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NOCOMBOSHE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NONGOMA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NONOPHA SENI0R PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SHEA O CONNOR COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NQOBILE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NQUNDU COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NSETHENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NSIKAYEZWE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NSONONO COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NSUNGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NTSIMBINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NYAKANA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "NYANDU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NYONEBOMVU SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "OBIVANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ODOLAND PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "OEBISFELDE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "OHLELO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "OKHOZINI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SENZOKUHLE (ONVERWAG) COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "OPPERMANSKRAAL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PADDAFONTEIN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "PANORAMA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PHENYANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "PHAKADE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PHAKATHI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "PHAKWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PHELELANI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "PHENDUKA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PHOENIX TECHNICAL SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PIVAAN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "POMEROY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PONGOLA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "PONGOLA AKADEMIE GEKOMBINEERD"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "PORT NATAL SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "PORT SHEPSTONE ISLAMIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SINQOBILE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "QONQO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "QUARME PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "QUDENI PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "QUEENSBURGH CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "QULASHE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "RICHARDS BAY CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "RICHMOND COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "RIETVALLEI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "RUTLAND COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SAMPOFU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SANGWENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIBONGUJEKE SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "SEATIDES COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SEHOLE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SGODIPHOLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SHEKELELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SHONGOLOLO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIBHAKABHAKA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "SIBONGUMBOMVU COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SICELIMFUNDO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIFISOKUHLE FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIHLENGENI COMBINED SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIKHANYISELENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SILAMBO FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SILWENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SINETHEZEKILE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SINOKUBONGA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SINQOBILE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIPHUTHANDO PUBLIC COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIRAATUL HAQ ISLAMIC SCHOOL AND MADRASAH"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SISTER JOAN'S HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SIYAKHULA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SIYAVIKELWA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "SIZAMELENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "SIZAMINQUBEKO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIZANA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SIZANI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "H.MANTSHINGA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIZODELA COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SIZWE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SONGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SONKELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ST CATHERINE'S EMPANGENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ST CHARLES COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ST DOMINICS NEWCASTLE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ST MARY'S DSG KLOOF COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "STOCKTON COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "HOËRSKOOL SUID NATAL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "TAFENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "TARR'S VALLEY PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "TAURICUS COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "TENDELA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "THANDOKWAKHE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THANDOLWESIZWE HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THE GROVE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THE WYKEHAM COLLEGIATE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "THEMANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THEMBALIHLE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "THIBANE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "THIBANI COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "THOMAS MORE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "TILONGO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "TONYELANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "TRUSTFEED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "TSHELABANTU COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UGOME JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "UKUPHUMULA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "UMGABHI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "UMGNAMA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UMTHOMBOMUHLE INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "ST PATRICKS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "UPPER UMVOTI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "CRAWFORD NORTH COAST"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "UTRECHT HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VERDRUKT PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "VEZINHLANHLA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "VICKLANDS PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "VICTORY CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "VUKUZITHATHELE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "WARTBURG-KIRCHDORF SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "WATERFALL COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "WEBBSTOWN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "WEENEN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "WERDA SKOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "WESSELSNEK COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "WILLOWFOUNTAIN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "WIT-UMFOLOZI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "YARROW INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "YISE HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ZABALAZA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ZAMOKWAKHE SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ZUNGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ZWELINJANI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MARIS STELLA SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MAPHEPHETHA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "BHEKANI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "ONGANE COMBINE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MYAYIZA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KWANDWALANE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MTHONJENI INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SINQUMENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MBOMVU COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "KLWANA COMBINED PUBLIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "SIKHULILE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "KWAMPUNZI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "LOBETHAL INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "MARION HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "C21 PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SAVANNAH PARK SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "FELIXTON COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "IFALETHU COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "CRESTON COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "BHANOYI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "SIZWESONKE HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "GOLELA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "ETHANGENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "KWA CUBELA INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "KIA-ORA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "ZAKARIYYA MUSLIM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ISLAMIC EDUCATIONAL CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MHLANGANYELWA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "CELUKUPHIWA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "WEMBLEY COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NGWANYA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EBUSI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "HIS CHURCH COMBINED ACHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CRESCENT GIRLS HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "MOUNT EDGECOMBE PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MANDLAKAYISE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ESTCOURT CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CHRISTIAN LIFE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "UMZINTO ISLAMIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "VERULAM ISLAMIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MBIZENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "PANO SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "MABEDLANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CURRO EMBURY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GRANTLEIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "GLENWOOD CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "IZIMBUTHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "VERULAM INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "PHOENIX MUSLIM SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "ENHLANGWINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "MTHANIYA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "INGWE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SATHYA SAI SCHOOL CHATSWORTH"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CEBOLESIZWE COBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "SIPHAKEME COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "SATHYA SAI SCHOOL NEWCASTLE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "LINDAYIPHI INTERMEDIATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "OXFORD INTERNATIONAL HIGH SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "SOUTH COAST ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MBANGAYIYA SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MISSION FOR CHRIST CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "BLUFF CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KINGSWORD ACADEMY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "RIVERMEAD PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EKUTHUTHUKENI SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ISIBONELESIHLE COMBINED PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "NHLAKANIPHO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "TOC EDUCARE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "VUSISIZWE INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "MELMOTH CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "IXOPO MONTESSORI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "STAR COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WATERFALL COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "EKUKHANYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "BETESDA INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "IHSAAN GIRLS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "IHSAAN BOYS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ST BARNABAS INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "AMAWUSHE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ANTIOCH JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BAMBANANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BOMBASI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BOMVINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BONTRAND JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BRANDWOOD JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "BUNGENDE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "CABANE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "CLYDESDALE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "COMMON'SVALLEY JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "CORINTH PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "DEEPDALE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "DELAMUZI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "INZUZWENTLE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "DOVEDALE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "D.R.C JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "DRIEFONTEIN JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "DULATI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "DUMISA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EBUTA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EDGERTON PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EGUGWINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ELUKHOLWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMAUS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMBUZWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMFUNDWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EMVUBUKAZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ENGUNJINI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ENGWAQA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ENTSIKENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ENYANISWENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ESIHLONTLWENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ETEMBENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "EZIMPUNGENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "FOUNTAINS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "GCWENTSA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "GLENGARRY JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "GLOUCESTER PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "GQWALU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SANDILE METHULA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "HAMBANATHI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "HIGHLANDS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "HILLTOP PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "HOPEWELL PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "IBISI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "INDAWANA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "JERICHO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KESWA'S PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KROMHOEK COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KUKHANYENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "L,MTIMKULU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LONGKLOOF COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LUKHASINI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MAGOGO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MAHOBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MALENGE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MANDLAZI J.S SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MBUMBULWANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MFULAMHLE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MHLABA COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MKHATSHANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MLOZANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MNCEBA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MOYENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MOUNT HOREB JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MT SHEBA PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MYEMBE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "MZOKHANYO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NDLOZANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NGQUMARENI COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NGUSE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NOBILA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NOMBEWU FULL SERVICE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NTLABENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NTLAMBAMASOKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NTSHONGO JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "NYAKA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "PETROS JOZANA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "READSDALE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "RIETVLEI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SAMARIA JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ST. ALOIS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ST BARNABAS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ST BERNARD PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ST. FAITH'S JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ST MICHAEL'S SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ST PATRICKS JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ST PAUL'S JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "STRANGERS' REST JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SUMMERFIELD JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SYRIA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "TEXNYBERG JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "THEMBALIHLE SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "TONJENI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "TSAWULE PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "KHANYOLWETHU PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "UMGANO PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "UMZIMKULU J.S.SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "UPPER IBISI JUNIOR SECONDAY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "VICTORY JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "VIERKANT JUNIOR SECONDARY SCHOOL."
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "VUKANI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "VULAMEHLO COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "VUMAZONKE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "WASHBANK JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZADUNGENI PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZIMEMA SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZWELIBANZI JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ZWELONKE JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "LOURDES JUNIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "SINGISI SENIOR PRIMARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "WENDON ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "NEW LIFE CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "SEASONS ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "ALETHEIA CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "THUTHUKANI SENIOR SECONDARY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "NORTH COAST CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "UMDONI CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "KINGDOM CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Zululand",
      "School_Name": "MARTHA BEYERS ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ST THOMAS RESIDENTIAL SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MADRASSAH ISLAHUL MUSLIMEEN"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "LUNGISISA INDLELA VILLAGE COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ugu",
      "School_Name": "CHRISTIAN FAMILY COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ROCK OF CHRIST CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "ANCYRA CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "GLOBAL CHRISTAIN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "HARVEST ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "King Cetshwayo",
      "School_Name": "NEW GENERATION SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umkhanyakude",
      "School_Name": "JOYHOUSE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "CANAAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Uthukela",
      "School_Name": "DARUL HIKMA ISLAMIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umzinyathi",
      "School_Name": "CURRO MOUNT RICHMORE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "THORNHILL CHRISTIAN COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "MERIDIAN NEWCASTLE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ST JUDE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "DANNY HOUSE UMHLANGA COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "NEW HOPE CHRISTIAN COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "UMHLANGA JEWISH DAY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Pinetown",
      "School_Name": "ST BENEDICT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "CAPULUM COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "OASIS PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "ST JOHNS COMBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "HERITAGE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "St Nicholas Diocesan School"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "BETHEL CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umgungundlovu",
      "School_Name": "COMMUNITY OF LOVE COBINED SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "MADRASSA SHOUKATUL ISLAM EDUCATIONAL INSTITUTE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ORIENT ISLAMIC SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "OUR LADY OF FATIMA DOMINICAN CONVENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "HOLY FAMILY COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "ST HENRY'S MARIST COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Umlazi",
      "School_Name": "KINGDOM HERITAGE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Amajuba",
      "School_Name": "GRACE MISSION SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Harry Gwala",
      "School_Name": "ST PATRICKS COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "REDDAM HOUSE BALLITO"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "Ilembe",
      "School_Name": "SEAFORTH COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "CURRO WESTBROOK PRIVATE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "DIOCESAN SCHOOL FOR GIRLS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "JOHAN CARINUS ART CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "KINGSWOOD COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "TEHILLAH CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "NELSON MANDELA",
      "School_Name": "WOODRIDGE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "SARAH BAARTMAN",
      "School_Name": "PORT ALFRED CHRISTIAN EDUCATION SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "BUFFALO CITY",
      "School_Name": "BELGRAVIA ART CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Eastern Cape",
      "District": "AMATHOLE EAST",
      "School_Name": "BUTTERWORTH REVIVAL CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "WOODLANDS PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "RIVERVIEW PREPARATORY SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "BOHLABELA",
      "School_Name": "SHALOM CHRISTIAN SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "BEACON COLLEGE NKOMAZI"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "NKANGALA",
      "School_Name": "KLEINWATER COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "GERT SIBANDE",
      "School_Name": "HADASSAH ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "CURRO ACADEMY MBOMBELA"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "Mpumalanga",
      "District": "EHLANZENI",
      "School_Name": "ABC PRESTIGE SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "EBENEZER EXCELLENCE ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "TRAILBLAZERS CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "SWEETPEA LEARNING CENTRE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "NGAKA MODIRI MOLEMA",
      "School_Name": "THUTO LEGACY HILLS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "AGA-THUTO INDEPENDENT SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "PROSPERITY TUTOR CENTRE SECONDARY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "NALEDI CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "BOJANALA",
      "School_Name": "ST MARTINS PRIVATE CHRISTIANS SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "North West",
      "District": "DR KENNETH KAUNDA",
      "School_Name": "MARCELYN PRIVATE COLLEGE"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "",
      "School_Name": "CHISTLEHURST ACADEMICS AND ARTS"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "",
      "School_Name": "MTUBA CHRISTIAN ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "",
      "School_Name": "TOYBOX SCHOOL"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "",
      "School_Name": "HSBP INSTITUTE OF LEARNING (PTY) LTD"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "",
      "School_Name": "LITTLE PEOPLE'S ACADEMY"
    },
    {
      "Phase_PED": "COMBINED SCHOOL",
      "Province": "KwaZulu-Natal",
      "District": "",
      "School_Name": "REV JACOB DLAMINI CHRISTIAN SCHOOL"
    }
  ];

  export const getUniqueProvinces = () => {
  return [...new Set(SCHOOLS_DATA.map(school => school.Province))].sort();
};

export const getDistrictsByProvince = (province) => {
  return [...new Set(
    SCHOOLS_DATA
      .filter(school => school.Province === province)
      .map(school => school.District)
  )].sort();
};

export const getSchoolPhases = () => {
  return [...new Set(SCHOOLS_DATA.map(school => school.Phase_PED))].sort();
};

export const getSchoolsByFilters = (phase = null, province = null, district = null) => {
  return SCHOOLS_DATA.filter(school => {
    return (!phase || school.Phase_PED === phase) &&
           (!province || school.Province === province) &&
           (!district || school.District === district);
  }).map(school => school.School_Name).sort();
};

// Convert Phase_PED to user-friendly format
export const formatSchoolPhase = (phasePED) => {
  switch(phasePED) {
    case 'PRIMARY SCHOOL':
      return 'Primary';
    case 'SECONDARY SCHOOL':
      return 'Secondary';
    case 'COMBINED SCHOOL':
      return 'Combined';
    default:
      return phasePED;
  }
};

// Convert user-friendly format back to Phase_PED
export const toPhasePED = (phase) => {
  switch(phase) {
    case 'Primary':
      return 'PRIMARY SCHOOL';
    case 'Secondary':
      return 'SECONDARY SCHOOL';
    case 'Combined':
      return 'COMBINED SCHOOL';
    default:
      return phase;
  }
};